let polygonCoords_Itaocara = [
  {
    lng: -42.2370801,
    lat: -21.6972095
  },
  {
    lng: -42.2272514,
    lat: -21.7251375
  },
  {
    lng: -42.2272184,
    lat: -21.7252313
  },
  {
    lng: -42.2263448,
    lat: -21.7277137
  },
  {
    lng: -42.2214956,
    lat: -21.7414925
  },
  {
    lng: -42.2198567,
    lat: -21.7463256
  },
  {
    lng: -42.2183089,
    lat: -21.7505367
  },
  {
    lng: -42.2150326,
    lat: -21.7600827
  },
  {
    lng: -42.2069011,
    lat: -21.783775
  },
  {
    lng: -42.2029915,
    lat: -21.7911691
  },
  {
    lng: -42.1926405,
    lat: -21.8107242
  },
  {
    lng: -42.1819826,
    lat: -21.8308591
  },
  {
    lng: -42.1672494,
    lat: -21.8586929
  },
  {
    lng: -42.1672661,
    lat: -21.8586053
  },
  {
    lng: -42.1672581,
    lat: -21.8585634
  },
  {
    lng: -42.167243,
    lat: -21.8585233
  },
  {
    lng: -42.1672167,
    lat: -21.8584918
  },
  {
    lng: -42.1671851,
    lat: -21.8584621
  },
  {
    lng: -42.1671526,
    lat: -21.8584324
  },
  {
    lng: -42.1671098,
    lat: -21.8584162
  },
  {
    lng: -42.1670636,
    lat: -21.8584086
  },
  {
    lng: -42.1670167,
    lat: -21.8584094
  },
  {
    lng: -42.1669708,
    lat: -21.8584101
  },
  {
    lng: -42.1669277,
    lat: -21.8584226
  },
  {
    lng: -42.1668874,
    lat: -21.85844
  },
  {
    lng: -42.1668445,
    lat: -21.8584558
  },
  {
    lng: -42.166806,
    lat: -21.8584749
  },
  {
    lng: -42.1667685,
    lat: -21.8584974
  },
  {
    lng: -42.1667329,
    lat: -21.8585265
  },
  {
    lng: -42.1667025,
    lat: -21.8585539
  },
  {
    lng: -42.1666777,
    lat: -21.8585879
  },
  {
    lng: -42.1666582,
    lat: -21.8586252
  },
  {
    lng: -42.1666476,
    lat: -21.8586657
  },
  {
    lng: -42.1666388,
    lat: -21.8587078
  },
  {
    lng: -42.1666354,
    lat: -21.8587515
  },
  {
    lng: -42.1666362,
    lat: -21.8587885
  },
  {
    lng: -42.1666396,
    lat: -21.8588237
  },
  {
    lng: -42.1666431,
    lat: -21.8588589
  },
  {
    lng: -42.1666475,
    lat: -21.8588991
  },
  {
    lng: -42.1666511,
    lat: -21.8589394
  },
  {
    lng: -42.1666538,
    lat: -21.858983
  },
  {
    lng: -42.1666538,
    lat: -21.8590216
  },
  {
    lng: -42.1666459,
    lat: -21.8590654
  },
  {
    lng: -42.166638,
    lat: -21.8591058
  },
  {
    lng: -42.1666274,
    lat: -21.8591446
  },
  {
    lng: -42.1666142,
    lat: -21.8591868
  },
  {
    lng: -42.1665974,
    lat: -21.8592274
  },
  {
    lng: -42.1665735,
    lat: -21.8592647
  },
  {
    lng: -42.1665442,
    lat: -21.8592987
  },
  {
    lng: -42.1665194,
    lat: -21.8593327
  },
  {
    lng: -42.1665099,
    lat: -21.8593446
  },
  {
    lng: -42.1664776,
    lat: -21.8594005
  },
  {
    lng: -42.1663859,
    lat: -21.8594876
  },
  {
    lng: -42.1663154,
    lat: -21.8595374
  },
  {
    lng: -42.1662329,
    lat: -21.8595605
  },
  {
    lng: -42.1661437,
    lat: -21.8595602
  },
  {
    lng: -42.1660415,
    lat: -21.8595333
  },
  {
    lng: -42.1659462,
    lat: -21.8594996
  },
  {
    lng: -42.1658673,
    lat: -21.8594505
  },
  {
    lng: -42.165805,
    lat: -21.8593911
  },
  {
    lng: -42.1657839,
    lat: -21.8593562
  },
  {
    lng: -42.1657689,
    lat: -21.8593178
  },
  {
    lng: -42.1657593,
    lat: -21.859281
  },
  {
    lng: -42.1657559,
    lat: -21.8592492
  },
  {
    lng: -42.1657523,
    lat: -21.8592073
  },
  {
    lng: -42.1657496,
    lat: -21.859167
  },
  {
    lng: -42.1657434,
    lat: -21.8591252
  },
  {
    lng: -42.1657274,
    lat: -21.8590835
  },
  {
    lng: -42.165709,
    lat: -21.8590502
  },
  {
    lng: -42.165688,
    lat: -21.8590237
  },
  {
    lng: -42.1656698,
    lat: -21.8590004
  },
  {
    lng: -42.1655994,
    lat: -21.8589334
  },
  {
    lng: -42.1654947,
    lat: -21.8588337
  },
  {
    lng: -42.1653976,
    lat: -21.8587966
  },
  {
    lng: -42.1653532,
    lat: -21.8587873
  },
  {
    lng: -42.1653117,
    lat: -21.858788
  },
  {
    lng: -42.1652675,
    lat: -21.8587887
  },
  {
    lng: -42.1652208,
    lat: -21.8587928
  },
  {
    lng: -42.1651789,
    lat: -21.8588136
  },
  {
    lng: -42.1651555,
    lat: -21.8588324
  },
  {
    lng: -42.1650858,
    lat: -21.8589246
  },
  {
    lng: -42.1650533,
    lat: -21.859009
  },
  {
    lng: -42.165049,
    lat: -21.8590527
  },
  {
    lng: -42.1650481,
    lat: -21.8590897
  },
  {
    lng: -42.1650499,
    lat: -21.8591299
  },
  {
    lng: -42.1650541,
    lat: -21.8591584
  },
  {
    lng: -42.1650629,
    lat: -21.8591952
  },
  {
    lng: -42.1650716,
    lat: -21.8592286
  },
  {
    lng: -42.1650821,
    lat: -21.859262
  },
  {
    lng: -42.1650926,
    lat: -21.8592954
  },
  {
    lng: -42.1651038,
    lat: -21.8593221
  },
  {
    lng: -42.1651187,
    lat: -21.8593571
  },
  {
    lng: -42.1651363,
    lat: -21.859392
  },
  {
    lng: -42.1651575,
    lat: -21.859432
  },
  {
    lng: -42.165183,
    lat: -21.8594651
  },
  {
    lng: -42.1652067,
    lat: -21.8594966
  },
  {
    lng: -42.1652285,
    lat: -21.8595248
  },
  {
    lng: -42.1652549,
    lat: -21.8595579
  },
  {
    lng: -42.1652785,
    lat: -21.8595861
  },
  {
    lng: -42.1652966,
    lat: -21.8596059
  },
  {
    lng: -42.1653103,
    lat: -21.8596225
  },
  {
    lng: -42.1653357,
    lat: -21.8596557
  },
  {
    lng: -42.1653629,
    lat: -21.8596838
  },
  {
    lng: -42.165391,
    lat: -21.8597169
  },
  {
    lng: -42.1654086,
    lat: -21.8597518
  },
  {
    lng: -42.1654095,
    lat: -21.8597921
  },
  {
    lng: -42.1653847,
    lat: -21.8598277
  },
  {
    lng: -42.1653489,
    lat: -21.8598467
  },
  {
    lng: -42.1653163,
    lat: -21.8598489
  },
  {
    lng: -42.1652722,
    lat: -21.8598479
  },
  {
    lng: -42.1652286,
    lat: -21.8598352
  },
  {
    lng: -42.1651843,
    lat: -21.8598258
  },
  {
    lng: -42.1651461,
    lat: -21.859818
  },
  {
    lng: -42.1651017,
    lat: -21.859807
  },
  {
    lng: -42.1650591,
    lat: -21.8597959
  },
  {
    lng: -42.1650201,
    lat: -21.8597881
  },
  {
    lng: -42.1649756,
    lat: -21.8597754
  },
  {
    lng: -42.1649305,
    lat: -21.8597694
  },
  {
    lng: -42.1648896,
    lat: -21.8597567
  },
  {
    lng: -42.1648478,
    lat: -21.8597456
  },
  {
    lng: -42.1648025,
    lat: -21.8597312
  },
  {
    lng: -42.1647606,
    lat: -21.8597134
  },
  {
    lng: -42.1647163,
    lat: -21.8597074
  },
  {
    lng: -42.1646748,
    lat: -21.859703
  },
  {
    lng: -42.1646314,
    lat: -21.859697
  },
  {
    lng: -42.1646066,
    lat: -21.8596957
  },
  {
    lng: -42.1645208,
    lat: -21.8596836
  },
  {
    lng: -42.164313,
    lat: -21.8595918
  },
  {
    lng: -42.1642239,
    lat: -21.8595525
  },
  {
    lng: -42.1639328,
    lat: -21.8594044
  },
  {
    lng: -42.1638405,
    lat: -21.8593841
  },
  {
    lng: -42.1637565,
    lat: -21.8593754
  },
  {
    lng: -42.1636856,
    lat: -21.8593983
  },
  {
    lng: -42.1636193,
    lat: -21.8594295
  },
  {
    lng: -42.1635408,
    lat: -21.8594677
  },
  {
    lng: -42.1634775,
    lat: -21.8594737
  },
  {
    lng: -42.1634287,
    lat: -21.8594611
  },
  {
    lng: -42.1634197,
    lat: -21.8594562
  },
  {
    lng: -42.163384,
    lat: -21.859435
  },
  {
    lng: -42.1633493,
    lat: -21.85935
  },
  {
    lng: -42.1632218,
    lat: -21.8590669
  },
  {
    lng: -42.1631333,
    lat: -21.8589794
  },
  {
    lng: -42.1630982,
    lat: -21.8589514
  },
  {
    lng: -42.1630607,
    lat: -21.8589319
  },
  {
    lng: -42.1630205,
    lat: -21.8589107
  },
  {
    lng: -42.1629804,
    lat: -21.8588929
  },
  {
    lng: -42.162938,
    lat: -21.8588869
  },
  {
    lng: -42.162893,
    lat: -21.8588876
  },
  {
    lng: -42.1628492,
    lat: -21.8589001
  },
  {
    lng: -42.1628082,
    lat: -21.8589192
  },
  {
    lng: -42.16277,
    lat: -21.8589433
  },
  {
    lng: -42.1627399,
    lat: -21.858974
  },
  {
    lng: -42.1627143,
    lat: -21.8590113
  },
  {
    lng: -42.1626957,
    lat: -21.8590434
  },
  {
    lng: -42.1626762,
    lat: -21.8590756
  },
  {
    lng: -42.1626039,
    lat: -21.8592964
  },
  {
    lng: -42.1626072,
    lat: -21.8594322
  },
  {
    lng: -42.162609,
    lat: -21.8594724
  },
  {
    lng: -42.1626125,
    lat: -21.8595076
  },
  {
    lng: -42.1626178,
    lat: -21.8595444
  },
  {
    lng: -42.1626229,
    lat: -21.8595728
  },
  {
    lng: -42.16263,
    lat: -21.8596112
  },
  {
    lng: -42.162636,
    lat: -21.859643
  },
  {
    lng: -42.1626467,
    lat: -21.859683
  },
  {
    lng: -42.1626538,
    lat: -21.8597248
  },
  {
    lng: -42.1626549,
    lat: -21.8597684
  },
  {
    lng: -42.1626461,
    lat: -21.8598071
  },
  {
    lng: -42.1626285,
    lat: -21.8598426
  },
  {
    lng: -42.1626028,
    lat: -21.8598748
  },
  {
    lng: -42.1625796,
    lat: -21.8599003
  },
  {
    lng: -42.1625487,
    lat: -21.8599343
  },
  {
    lng: -42.1625214,
    lat: -21.85997
  },
  {
    lng: -42.162501,
    lat: -21.8600038
  },
  {
    lng: -42.1624798,
    lat: -21.8600376
  },
  {
    lng: -42.1624561,
    lat: -21.8600766
  },
  {
    lng: -42.1624441,
    lat: -21.8600935
  },
  {
    lng: -42.1623527,
    lat: -21.8601737
  },
  {
    lng: -42.1623231,
    lat: -21.8601892
  },
  {
    lng: -42.1622487,
    lat: -21.8602105
  },
  {
    lng: -42.1621676,
    lat: -21.8602067
  },
  {
    lng: -42.1620895,
    lat: -21.8601811
  },
  {
    lng: -42.1620038,
    lat: -21.8601339
  },
  {
    lng: -42.1619468,
    lat: -21.8600745
  },
  {
    lng: -42.161917,
    lat: -21.8600062
  },
  {
    lng: -42.1618799,
    lat: -21.8598946
  },
  {
    lng: -42.1618742,
    lat: -21.8597673
  },
  {
    lng: -42.1618785,
    lat: -21.8596533
  },
  {
    lng: -42.1618778,
    lat: -21.8596248
  },
  {
    lng: -42.1618764,
    lat: -21.859603
  },
  {
    lng: -42.1618345,
    lat: -21.8594042
  },
  {
    lng: -42.1617858,
    lat: -21.8593212
  },
  {
    lng: -42.1617586,
    lat: -21.8592864
  },
  {
    lng: -42.1617269,
    lat: -21.8592534
  },
  {
    lng: -42.1616893,
    lat: -21.8592272
  },
  {
    lng: -42.1616561,
    lat: -21.8592026
  },
  {
    lng: -42.1616195,
    lat: -21.8591814
  },
  {
    lng: -42.161576,
    lat: -21.8591686
  },
  {
    lng: -42.1615283,
    lat: -21.8591644
  },
  {
    lng: -42.1614852,
    lat: -21.8591651
  },
  {
    lng: -42.1614387,
    lat: -21.8591759
  },
  {
    lng: -42.1613969,
    lat: -21.8591916
  },
  {
    lng: -42.161363,
    lat: -21.859214
  },
  {
    lng: -42.1613275,
    lat: -21.8592363
  },
  {
    lng: -42.1612963,
    lat: -21.8592569
  },
  {
    lng: -42.1612643,
    lat: -21.8592809
  },
  {
    lng: -42.1612342,
    lat: -21.8593099
  },
  {
    lng: -42.1612086,
    lat: -21.8593455
  },
  {
    lng: -42.1611866,
    lat: -21.8593793
  },
  {
    lng: -42.16117,
    lat: -21.8594215
  },
  {
    lng: -42.1611613,
    lat: -21.8594635
  },
  {
    lng: -42.1611579,
    lat: -21.8595021
  },
  {
    lng: -42.161157,
    lat: -21.859539
  },
  {
    lng: -42.1611597,
    lat: -21.8595775
  },
  {
    lng: -42.1611686,
    lat: -21.8596176
  },
  {
    lng: -42.1611793,
    lat: -21.8596576
  },
  {
    lng: -42.1611883,
    lat: -21.859701
  },
  {
    lng: -42.1611961,
    lat: -21.8597311
  },
  {
    lng: -42.1613281,
    lat: -21.8599803
  },
  {
    lng: -42.1613999,
    lat: -21.8600713
  },
  {
    lng: -42.1614315,
    lat: -21.8601043
  },
  {
    lng: -42.1614639,
    lat: -21.860134
  },
  {
    lng: -42.1614909,
    lat: -21.860157
  },
  {
    lng: -42.1615259,
    lat: -21.8601832
  },
  {
    lng: -42.1615616,
    lat: -21.8602061
  },
  {
    lng: -42.1615949,
    lat: -21.8602324
  },
  {
    lng: -42.161628,
    lat: -21.8602537
  },
  {
    lng: -42.1616594,
    lat: -21.86028
  },
  {
    lng: -42.1616935,
    lat: -21.8603046
  },
  {
    lng: -42.1617242,
    lat: -21.8603376
  },
  {
    lng: -42.161741,
    lat: -21.8603759
  },
  {
    lng: -42.1617463,
    lat: -21.8604126
  },
  {
    lng: -42.1617428,
    lat: -21.8604478
  },
  {
    lng: -42.161726,
    lat: -21.8604833
  },
  {
    lng: -42.1616933,
    lat: -21.8605139
  },
  {
    lng: -42.1616497,
    lat: -21.8605297
  },
  {
    lng: -42.1616302,
    lat: -21.860525
  },
  {
    lng: -42.1612194,
    lat: -21.8603974
  },
  {
    lng: -42.1608973,
    lat: -21.860217
  },
  {
    lng: -42.1606816,
    lat: -21.8600952
  },
  {
    lng: -42.1605863,
    lat: -21.8600071
  },
  {
    lng: -42.1605134,
    lat: -21.8599119
  },
  {
    lng: -42.1604709,
    lat: -21.8598129
  },
  {
    lng: -42.1604088,
    lat: -21.8595875
  },
  {
    lng: -42.1603954,
    lat: -21.8594542
  },
  {
    lng: -42.1603949,
    lat: -21.8594171
  },
  {
    lng: -42.1604015,
    lat: -21.8593747
  },
  {
    lng: -42.1604091,
    lat: -21.8593391
  },
  {
    lng: -42.1604194,
    lat: -21.8593018
  },
  {
    lng: -42.1604322,
    lat: -21.8592593
  },
  {
    lng: -42.1604523,
    lat: -21.8592202
  },
  {
    lng: -42.1604743,
    lat: -21.8591843
  },
  {
    lng: -42.1605025,
    lat: -21.8591484
  },
  {
    lng: -42.1605307,
    lat: -21.8591176
  },
  {
    lng: -42.1605572,
    lat: -21.8590851
  },
  {
    lng: -42.1605818,
    lat: -21.8590475
  },
  {
    lng: -42.1605983,
    lat: -21.8590067
  },
  {
    lng: -42.1606121,
    lat: -21.8589642
  },
  {
    lng: -42.1606133,
    lat: -21.8589202
  },
  {
    lng: -42.1605957,
    lat: -21.8588782
  },
  {
    lng: -42.1605639,
    lat: -21.8588466
  },
  {
    lng: -42.1605242,
    lat: -21.8588219
  },
  {
    lng: -42.1604801,
    lat: -21.858809
  },
  {
    lng: -42.1604343,
    lat: -21.8588047
  },
  {
    lng: -42.1603931,
    lat: -21.8588053
  },
  {
    lng: -42.1603483,
    lat: -21.858806
  },
  {
    lng: -42.1603081,
    lat: -21.858815
  },
  {
    lng: -42.1602643,
    lat: -21.8588275
  },
  {
    lng: -42.1602188,
    lat: -21.8588418
  },
  {
    lng: -42.1601832,
    lat: -21.8588558
  },
  {
    lng: -42.1601663,
    lat: -21.8588662
  },
  {
    lng: -42.1600302,
    lat: -21.8589461
  },
  {
    lng: -42.1596926,
    lat: -21.8591506
  },
  {
    lng: -42.1595627,
    lat: -21.8592185
  },
  {
    lng: -42.1594689,
    lat: -21.8592334
  },
  {
    lng: -42.1593442,
    lat: -21.8592167
  },
  {
    lng: -42.1591564,
    lat: -21.8591706
  },
  {
    lng: -42.1590151,
    lat: -21.8591778
  },
  {
    lng: -42.1588819,
    lat: -21.8591917
  },
  {
    lng: -42.1588045,
    lat: -21.8591658
  },
  {
    lng: -42.1587413,
    lat: -21.8591229
  },
  {
    lng: -42.158575,
    lat: -21.8590072
  },
  {
    lng: -42.1584795,
    lat: -21.8588955
  },
  {
    lng: -42.1584432,
    lat: -21.8588656
  },
  {
    lng: -42.1584036,
    lat: -21.8588477
  },
  {
    lng: -42.1583623,
    lat: -21.8588365
  },
  {
    lng: -42.1583174,
    lat: -21.8588253
  },
  {
    lng: -42.1582718,
    lat: -21.858826
  },
  {
    lng: -42.158227,
    lat: -21.8588267
  },
  {
    lng: -42.1581805,
    lat: -21.8588274
  },
  {
    lng: -42.1581367,
    lat: -21.8588281
  },
  {
    lng: -42.1580893,
    lat: -21.8588322
  },
  {
    lng: -42.1580483,
    lat: -21.8588447
  },
  {
    lng: -42.1580047,
    lat: -21.8588605
  },
  {
    lng: -42.1579657,
    lat: -21.8588848
  },
  {
    lng: -42.157933,
    lat: -21.858914
  },
  {
    lng: -42.1579075,
    lat: -21.8589481
  },
  {
    lng: -42.1578875,
    lat: -21.8589856
  },
  {
    lng: -42.1578845,
    lat: -21.8590296
  },
  {
    lng: -42.1578868,
    lat: -21.8590684
  },
  {
    lng: -42.1578944,
    lat: -21.8590986
  },
  {
    lng: -42.1579058,
    lat: -21.8591424
  },
  {
    lng: -42.1580583,
    lat: -21.8596229
  },
  {
    lng: -42.1581365,
    lat: -21.8597787
  },
  {
    lng: -42.1581603,
    lat: -21.8598172
  },
  {
    lng: -42.1581903,
    lat: -21.8598471
  },
  {
    lng: -42.1582202,
    lat: -21.8598771
  },
  {
    lng: -42.1582493,
    lat: -21.8599087
  },
  {
    lng: -42.1582881,
    lat: -21.8599334
  },
  {
    lng: -42.1583286,
    lat: -21.8599531
  },
  {
    lng: -42.1583583,
    lat: -21.8599661
  },
  {
    lng: -42.1584033,
    lat: -21.8599807
  },
  {
    lng: -42.1584401,
    lat: -21.8599953
  },
  {
    lng: -42.1584788,
    lat: -21.8600099
  },
  {
    lng: -42.1585228,
    lat: -21.8600228
  },
  {
    lng: -42.1585652,
    lat: -21.8600424
  },
  {
    lng: -42.1586011,
    lat: -21.8600537
  },
  {
    lng: -42.1586415,
    lat: -21.8600649
  },
  {
    lng: -42.1586864,
    lat: -21.860076
  },
  {
    lng: -42.158724,
    lat: -21.8600788
  },
  {
    lng: -42.1587723,
    lat: -21.8600781
  },
  {
    lng: -42.1588127,
    lat: -21.8600859
  },
  {
    lng: -42.1588594,
    lat: -21.8600954
  },
  {
    lng: -42.1589007,
    lat: -21.8601083
  },
  {
    lng: -42.1589428,
    lat: -21.860111
  },
  {
    lng: -42.1589849,
    lat: -21.8601104
  },
  {
    lng: -42.1590251,
    lat: -21.8601098
  },
  {
    lng: -42.1590679,
    lat: -21.8600973
  },
  {
    lng: -42.1591098,
    lat: -21.8600849
  },
  {
    lng: -42.15915,
    lat: -21.8600759
  },
  {
    lng: -42.1591956,
    lat: -21.8600752
  },
  {
    lng: -42.1592397,
    lat: -21.860088
  },
  {
    lng: -42.1592758,
    lat: -21.8601111
  },
  {
    lng: -42.1592888,
    lat: -21.8601514
  },
  {
    lng: -42.1592876,
    lat: -21.8601903
  },
  {
    lng: -42.1592792,
    lat: -21.8602343
  },
  {
    lng: -42.1592671,
    lat: -21.8602665
  },
  {
    lng: -42.1592408,
    lat: -21.8603041
  },
  {
    lng: -42.1592054,
    lat: -21.8603299
  },
  {
    lng: -42.1591708,
    lat: -21.8603524
  },
  {
    lng: -42.1591351,
    lat: -21.8603647
  },
  {
    lng: -42.1590994,
    lat: -21.860372
  },
  {
    lng: -42.1590583,
    lat: -21.8603726
  },
  {
    lng: -42.1590234,
    lat: -21.8603731
  },
  {
    lng: -42.1589805,
    lat: -21.8603754
  },
  {
    lng: -42.1589402,
    lat: -21.8603794
  },
  {
    lng: -42.1589063,
    lat: -21.8603816
  },
  {
    lng: -42.1588696,
    lat: -21.8603821
  },
  {
    lng: -42.1588383,
    lat: -21.860386
  },
  {
    lng: -42.1588008,
    lat: -21.8603865
  },
  {
    lng: -42.1587534,
    lat: -21.8603889
  },
  {
    lng: -42.158706,
    lat: -21.8603896
  },
  {
    lng: -42.1586702,
    lat: -21.8603902
  },
  {
    lng: -42.1586236,
    lat: -21.8603892
  },
  {
    lng: -42.1585806,
    lat: -21.8603797
  },
  {
    lng: -42.1585393,
    lat: -21.8603735
  },
  {
    lng: -42.1584945,
    lat: -21.8603675
  },
  {
    lng: -42.1584587,
    lat: -21.860368
  },
  {
    lng: -42.1584158,
    lat: -21.8603669
  },
  {
    lng: -42.1583782,
    lat: -21.8603675
  },
  {
    lng: -42.1583612,
    lat: -21.8603677
  },
  {
    lng: -42.1583129,
    lat: -21.8603685
  },
  {
    lng: -42.1581034,
    lat: -21.8603496
  },
  {
    lng: -42.1577657,
    lat: -21.8603074
  },
  {
    lng: -42.157638,
    lat: -21.8602587
  },
  {
    lng: -42.1575995,
    lat: -21.8602525
  },
  {
    lng: -42.1575609,
    lat: -21.8602429
  },
  {
    lng: -42.157516,
    lat: -21.8602284
  },
  {
    lng: -42.15748,
    lat: -21.860207
  },
  {
    lng: -42.1574447,
    lat: -21.8601823
  },
  {
    lng: -42.1574176,
    lat: -21.860159
  },
  {
    lng: -42.1573867,
    lat: -21.8601274
  },
  {
    lng: -42.1573568,
    lat: -21.8600941
  },
  {
    lng: -42.157326,
    lat: -21.8600659
  },
  {
    lng: -42.1572933,
    lat: -21.8600344
  },
  {
    lng: -42.1572625,
    lat: -21.8600045
  },
  {
    lng: -42.1572362,
    lat: -21.8599795
  },
  {
    lng: -42.1572063,
    lat: -21.8599513
  },
  {
    lng: -42.1571711,
    lat: -21.8599231
  },
  {
    lng: -42.1571297,
    lat: -21.8599035
  },
  {
    lng: -42.1570848,
    lat: -21.8598907
  },
  {
    lng: -42.1570409,
    lat: -21.8598863
  },
  {
    lng: -42.1569962,
    lat: -21.8598853
  },
  {
    lng: -42.1569533,
    lat: -21.8598859
  },
  {
    lng: -42.1569087,
    lat: -21.8598866
  },
  {
    lng: -42.1568675,
    lat: -21.8598872
  },
  {
    lng: -42.1568229,
    lat: -21.8598879
  },
  {
    lng: -42.1567811,
    lat: -21.8599003
  },
  {
    lng: -42.1567412,
    lat: -21.8599245
  },
  {
    lng: -42.1567058,
    lat: -21.859947
  },
  {
    lng: -42.1566775,
    lat: -21.8599693
  },
  {
    lng: -42.1566467,
    lat: -21.8600018
  },
  {
    lng: -42.1566149,
    lat: -21.8600293
  },
  {
    lng: -42.1565831,
    lat: -21.8600534
  },
  {
    lng: -42.1565459,
    lat: -21.8600742
  },
  {
    lng: -42.1565096,
    lat: -21.860095
  },
  {
    lng: -42.1564936,
    lat: -21.8601019
  },
  {
    lng: -42.1563769,
    lat: -21.8601256
  },
  {
    lng: -42.1563286,
    lat: -21.8601246
  },
  {
    lng: -42.1562864,
    lat: -21.860105
  },
  {
    lng: -42.1562538,
    lat: -21.8600752
  },
  {
    lng: -42.1562222,
    lat: -21.860052
  },
  {
    lng: -42.156186,
    lat: -21.8600239
  },
  {
    lng: -42.156149,
    lat: -21.8599958
  },
  {
    lng: -42.1561077,
    lat: -21.8599812
  },
  {
    lng: -42.1560605,
    lat: -21.8599887
  },
  {
    lng: -42.1560405,
    lat: -21.8600278
  },
  {
    lng: -42.1560402,
    lat: -21.8600716
  },
  {
    lng: -42.1560506,
    lat: -21.8601069
  },
  {
    lng: -42.1560628,
    lat: -21.8601472
  },
  {
    lng: -42.156067,
    lat: -21.8601876
  },
  {
    lng: -42.1560675,
    lat: -21.8602263
  },
  {
    lng: -42.1560663,
    lat: -21.8602668
  },
  {
    lng: -42.1560642,
    lat: -21.8603056
  },
  {
    lng: -42.156064,
    lat: -21.8603478
  },
  {
    lng: -42.1560583,
    lat: -21.8603883
  },
  {
    lng: -42.1560482,
    lat: -21.8604306
  },
  {
    lng: -42.156031,
    lat: -21.8604714
  },
  {
    lng: -42.1560055,
    lat: -21.8605038
  },
  {
    lng: -42.1559638,
    lat: -21.8605212
  },
  {
    lng: -42.1559225,
    lat: -21.8605016
  },
  {
    lng: -42.1558961,
    lat: -21.8604683
  },
  {
    lng: -42.1558644,
    lat: -21.8604384
  },
  {
    lng: -42.1558212,
    lat: -21.8604188
  },
  {
    lng: -42.1557782,
    lat: -21.860406
  },
  {
    lng: -42.1555936,
    lat: -21.8604205
  },
  {
    lng: -42.1554903,
    lat: -21.8604406
  },
  {
    lng: -42.1554475,
    lat: -21.8604412
  },
  {
    lng: -42.1554038,
    lat: -21.8604418
  },
  {
    lng: -42.1553582,
    lat: -21.8604425
  },
  {
    lng: -42.1553143,
    lat: -21.8604297
  },
  {
    lng: -42.155273,
    lat: -21.8604151
  },
  {
    lng: -42.1552327,
    lat: -21.8604056
  },
  {
    lng: -42.1551924,
    lat: -21.8603961
  },
  {
    lng: -42.1551477,
    lat: -21.8603883
  },
  {
    lng: -42.1551075,
    lat: -21.8603889
  },
  {
    lng: -42.1550602,
    lat: -21.8603896
  },
  {
    lng: -42.155013,
    lat: -21.8603903
  },
  {
    lng: -42.1549675,
    lat: -21.860391
  },
  {
    lng: -42.1549193,
    lat: -21.8603917
  },
  {
    lng: -42.1548801,
    lat: -21.8603973
  },
  {
    lng: -42.1548384,
    lat: -21.8604131
  },
  {
    lng: -42.1547986,
    lat: -21.8604339
  },
  {
    lng: -42.1547678,
    lat: -21.860463
  },
  {
    lng: -42.1547433,
    lat: -21.8604937
  },
  {
    lng: -42.1547179,
    lat: -21.8605278
  },
  {
    lng: -42.1546853,
    lat: -21.8605553
  },
  {
    lng: -42.1546409,
    lat: -21.8605677
  },
  {
    lng: -42.1545964,
    lat: -21.8605751
  },
  {
    lng: -42.1545491,
    lat: -21.8605758
  },
  {
    lng: -42.1545018,
    lat: -21.8605714
  },
  {
    lng: -42.154466,
    lat: -21.8605669
  },
  {
    lng: -42.1544221,
    lat: -21.8605507
  },
  {
    lng: -42.1543791,
    lat: -21.8605379
  },
  {
    lng: -42.1543423,
    lat: -21.8605249
  },
  {
    lng: -42.1543204,
    lat: -21.8605219
  },
  {
    lng: -42.1542985,
    lat: -21.8605188
  },
  {
    lng: -42.1542716,
    lat: -21.8605091
  },
  {
    lng: -42.1542491,
    lat: -21.8604977
  },
  {
    lng: -42.1541039,
    lat: -21.8603937
  },
  {
    lng: -42.1537106,
    lat: -21.8599901
  },
  {
    lng: -42.1534619,
    lat: -21.8597612
  },
  {
    lng: -42.1531449,
    lat: -21.8594475
  },
  {
    lng: -42.1529365,
    lat: -21.8592382
  },
  {
    lng: -42.1527556,
    lat: -21.8591297
  },
  {
    lng: -42.1525686,
    lat: -21.8590315
  },
  {
    lng: -42.1524594,
    lat: -21.8589977
  },
  {
    lng: -42.1523158,
    lat: -21.8589915
  },
  {
    lng: -42.152208,
    lat: -21.8589931
  },
  {
    lng: -42.1521042,
    lat: -21.8590234
  },
  {
    lng: -42.1520237,
    lat: -21.85906
  },
  {
    lng: -42.1519269,
    lat: -21.8591323
  },
  {
    lng: -42.1518982,
    lat: -21.8591765
  },
  {
    lng: -42.1518869,
    lat: -21.8591986
  },
  {
    lng: -42.1518407,
    lat: -21.8593661
  },
  {
    lng: -42.1518289,
    lat: -21.8594067
  },
  {
    lng: -42.1518162,
    lat: -21.859449
  },
  {
    lng: -42.1518053,
    lat: -21.859493
  },
  {
    lng: -42.1517952,
    lat: -21.8595285
  },
  {
    lng: -42.1517834,
    lat: -21.8595674
  },
  {
    lng: -42.1517707,
    lat: -21.8596097
  },
  {
    lng: -42.15175,
    lat: -21.8596505
  },
  {
    lng: -42.1517317,
    lat: -21.8596794
  },
  {
    lng: -42.1517038,
    lat: -21.8597118
  },
  {
    lng: -42.1516757,
    lat: -21.8597358
  },
  {
    lng: -42.1516441,
    lat: -21.8597666
  },
  {
    lng: -42.151457,
    lat: -21.859926
  },
  {
    lng: -42.1513345,
    lat: -21.860002
  },
  {
    lng: -42.1512388,
    lat: -21.8600303
  },
  {
    lng: -42.1511196,
    lat: -21.8600304
  },
  {
    lng: -42.1509473,
    lat: -21.859988
  },
  {
    lng: -42.150939,
    lat: -21.859986
  },
  {
    lng: -42.1506007,
    lat: -21.8598698
  },
  {
    lng: -42.1504614,
    lat: -21.8598382
  },
  {
    lng: -42.1503777,
    lat: -21.8598395
  },
  {
    lng: -42.1502962,
    lat: -21.8598592
  },
  {
    lng: -42.1502187,
    lat: -21.8599025
  },
  {
    lng: -42.1501556,
    lat: -21.859964
  },
  {
    lng: -42.1500089,
    lat: -21.8601766
  },
  {
    lng: -42.1499473,
    lat: -21.8603147
  },
  {
    lng: -42.1499487,
    lat: -21.8603955
  },
  {
    lng: -42.149952,
    lat: -21.8604358
  },
  {
    lng: -42.1499733,
    lat: -21.860486
  },
  {
    lng: -42.1500159,
    lat: -21.8605308
  },
  {
    lng: -42.1500591,
    lat: -21.8605621
  },
  {
    lng: -42.1503095,
    lat: -21.8606964
  },
  {
    lng: -42.1505829,
    lat: -21.8608724
  },
  {
    lng: -42.1505998,
    lat: -21.860926
  },
  {
    lng: -42.1505826,
    lat: -21.8609633
  },
  {
    lng: -42.1505502,
    lat: -21.8609923
  },
  {
    lng: -42.1505069,
    lat: -21.8610098
  },
  {
    lng: -42.1504679,
    lat: -21.8610188
  },
  {
    lng: -42.1502184,
    lat: -21.8610443
  },
  {
    lng: -42.150075,
    lat: -21.8610296
  },
  {
    lng: -42.1499454,
    lat: -21.8609894
  },
  {
    lng: -42.1498421,
    lat: -21.8609303
  },
  {
    lng: -42.1495076,
    lat: -21.8607099
  },
  {
    lng: -42.149294,
    lat: -21.8605936
  },
  {
    lng: -42.1491758,
    lat: -21.8604877
  },
  {
    lng: -42.1490663,
    lat: -21.8603782
  },
  {
    lng: -42.1490044,
    lat: -21.8602883
  },
  {
    lng: -42.1489806,
    lat: -21.8601995
  },
  {
    lng: -42.1489704,
    lat: -21.860124
  },
  {
    lng: -42.1489485,
    lat: -21.8597793
  },
  {
    lng: -42.1489348,
    lat: -21.8596079
  },
  {
    lng: -42.1489441,
    lat: -21.8595253
  },
  {
    lng: -42.1489756,
    lat: -21.8594423
  },
  {
    lng: -42.1490277,
    lat: -21.8593708
  },
  {
    lng: -42.1490643,
    lat: -21.8593315
  },
  {
    lng: -42.1490896,
    lat: -21.8592992
  },
  {
    lng: -42.1491057,
    lat: -21.8592568
  },
  {
    lng: -42.1490927,
    lat: -21.8592217
  },
  {
    lng: -42.1490683,
    lat: -21.8592018
  },
  {
    lng: -42.148974,
    lat: -21.8591949
  },
  {
    lng: -42.1489254,
    lat: -21.8592124
  },
  {
    lng: -42.1487857,
    lat: -21.8592583
  },
  {
    lng: -42.1486678,
    lat: -21.8592803
  },
  {
    lng: -42.1485589,
    lat: -21.8593039
  },
  {
    lng: -42.1482489,
    lat: -21.8594407
  },
  {
    lng: -42.1478106,
    lat: -21.8598326
  },
  {
    lng: -42.1476564,
    lat: -21.8599526
  },
  {
    lng: -42.1475245,
    lat: -21.8600286
  },
  {
    lng: -42.1473294,
    lat: -21.8601391
  },
  {
    lng: -42.1471734,
    lat: -21.8602558
  },
  {
    lng: -42.147067,
    lat: -21.8603616
  },
  {
    lng: -42.1469822,
    lat: -21.8604839
  },
  {
    lng: -42.1469395,
    lat: -21.8605753
  },
  {
    lng: -42.1468502,
    lat: -21.8606472
  },
  {
    lng: -42.1467301,
    lat: -21.8606758
  },
  {
    lng: -42.1465032,
    lat: -21.8606926
  },
  {
    lng: -42.1463307,
    lat: -21.8606716
  },
  {
    lng: -42.1461824,
    lat: -21.8606133
  },
  {
    lng: -42.1461403,
    lat: -21.8605824
  },
  {
    lng: -42.1460925,
    lat: -21.8605474
  },
  {
    lng: -42.146034,
    lat: -21.8604508
  },
  {
    lng: -42.1456792,
    lat: -21.8592929
  },
  {
    lng: -42.145593,
    lat: -21.8591395
  },
  {
    lng: -42.1454597,
    lat: -21.8589329
  },
  {
    lng: -42.1453838,
    lat: -21.8587625
  },
  {
    lng: -42.14538,
    lat: -21.858554
  },
  {
    lng: -42.1453322,
    lat: -21.8581779
  },
  {
    lng: -42.1452426,
    lat: -21.8579403
  },
  {
    lng: -42.1451054,
    lat: -21.8574341
  },
  {
    lng: -42.1450697,
    lat: -21.8572292
  },
  {
    lng: -42.1450687,
    lat: -21.8570811
  },
  {
    lng: -42.1450751,
    lat: -21.8569496
  },
  {
    lng: -42.1451084,
    lat: -21.8568278
  },
  {
    lng: -42.1452349,
    lat: -21.8566641
  },
  {
    lng: -42.1452585,
    lat: -21.8565929
  },
  {
    lng: -42.1452545,
    lat: -21.8564717
  },
  {
    lng: -42.1451456,
    lat: -21.8561567
  },
  {
    lng: -42.1450968,
    lat: -21.8561103
  },
  {
    lng: -42.145052,
    lat: -21.8560874
  },
  {
    lng: -42.1450165,
    lat: -21.8560846
  },
  {
    lng: -42.1449917,
    lat: -21.8560884
  },
  {
    lng: -42.1449423,
    lat: -21.8561094
  },
  {
    lng: -42.1448435,
    lat: -21.8561414
  },
  {
    lng: -42.1446803,
    lat: -21.8562418
  },
  {
    lng: -42.1444829,
    lat: -21.8563157
  },
  {
    lng: -42.1443121,
    lat: -21.8563859
  },
  {
    lng: -42.1442212,
    lat: -21.8564614
  },
  {
    lng: -42.1441692,
    lat: -21.8565263
  },
  {
    lng: -42.1441405,
    lat: -21.8566009
  },
  {
    lng: -42.144121,
    lat: -21.8566988
  },
  {
    lng: -42.1441492,
    lat: -21.8569712
  },
  {
    lng: -42.1441265,
    lat: -21.8570793
  },
  {
    lng: -42.1440648,
    lat: -21.8571947
  },
  {
    lng: -42.1440026,
    lat: -21.8572832
  },
  {
    lng: -42.1439697,
    lat: -21.8573241
  },
  {
    lng: -42.1439368,
    lat: -21.8573684
  },
  {
    lng: -42.1439005,
    lat: -21.8574161
  },
  {
    lng: -42.1438608,
    lat: -21.8574706
  },
  {
    lng: -42.1437932,
    lat: -21.85765
  },
  {
    lng: -42.1437399,
    lat: -21.8578258
  },
  {
    lng: -42.1437074,
    lat: -21.8579811
  },
  {
    lng: -42.1436988,
    lat: -21.8580923
  },
  {
    lng: -42.1437003,
    lat: -21.8581662
  },
  {
    lng: -42.1437162,
    lat: -21.8582568
  },
  {
    lng: -42.1437406,
    lat: -21.8583304
  },
  {
    lng: -42.1438052,
    lat: -21.8584579
  },
  {
    lng: -42.1439411,
    lat: -21.8585164
  },
  {
    lng: -42.1439754,
    lat: -21.8585495
  },
  {
    lng: -42.1439885,
    lat: -21.8585829
  },
  {
    lng: -42.144,
    lat: -21.8586298
  },
  {
    lng: -42.143991,
    lat: -21.8587174
  },
  {
    lng: -42.1439637,
    lat: -21.8587716
  },
  {
    lng: -42.1439377,
    lat: -21.8588023
  },
  {
    lng: -42.1438736,
    lat: -21.858884
  },
  {
    lng: -42.1435888,
    lat: -21.8591001
  },
  {
    lng: -42.1434501,
    lat: -21.8591628
  },
  {
    lng: -42.1433225,
    lat: -21.8591614
  },
  {
    lng: -42.1432443,
    lat: -21.8591491
  },
  {
    lng: -42.1431309,
    lat: -21.8590601
  },
  {
    lng: -42.1430284,
    lat: -21.8588868
  },
  {
    lng: -42.1429401,
    lat: -21.8588075
  },
  {
    lng: -42.1428597,
    lat: -21.8587718
  },
  {
    lng: -42.1427286,
    lat: -21.8587738
  },
  {
    lng: -42.1425144,
    lat: -21.8587804
  },
  {
    lng: -42.1423493,
    lat: -21.8587561
  },
  {
    lng: -42.1422192,
    lat: -21.8587177
  },
  {
    lng: -42.1421111,
    lat: -21.8586219
  },
  {
    lng: -42.1420347,
    lat: -21.8585189
  },
  {
    lng: -42.1420051,
    lat: -21.8584521
  },
  {
    lng: -42.1420007,
    lat: -21.8584085
  },
  {
    lng: -42.1420015,
    lat: -21.8583581
  },
  {
    lng: -42.1420095,
    lat: -21.8583142
  },
  {
    lng: -42.1420195,
    lat: -21.8582838
  },
  {
    lng: -42.1420383,
    lat: -21.8582499
  },
  {
    lng: -42.1420555,
    lat: -21.8582261
  },
  {
    lng: -42.1421063,
    lat: -21.8581951
  },
  {
    lng: -42.1421784,
    lat: -21.858167
  },
  {
    lng: -42.1423517,
    lat: -21.8580668
  },
  {
    lng: -42.142602,
    lat: -21.8579082
  },
  {
    lng: -42.1426726,
    lat: -21.8578028
  },
  {
    lng: -42.1426834,
    lat: -21.8577219
  },
  {
    lng: -42.1426738,
    lat: -21.8576851
  },
  {
    lng: -42.1426554,
    lat: -21.8576483
  },
  {
    lng: -42.1426175,
    lat: -21.8576119
  },
  {
    lng: -42.1420475,
    lat: -21.8572744
  },
  {
    lng: -42.141585,
    lat: -21.8569049
  },
  {
    lng: -42.1413647,
    lat: -21.8567806
  },
  {
    lng: -42.1409898,
    lat: -21.8566285
  },
  {
    lng: -42.1408014,
    lat: -21.8565911
  },
  {
    lng: -42.1407147,
    lat: -21.8565959
  },
  {
    lng: -42.1406301,
    lat: -21.8566141
  },
  {
    lng: -42.1405524,
    lat: -21.8566221
  },
  {
    lng: -42.1404454,
    lat: -21.8565834
  },
  {
    lng: -42.1403434,
    lat: -21.8565245
  },
  {
    lng: -42.1402891,
    lat: -21.8564682
  },
  {
    lng: -42.140249,
    lat: -21.8564083
  },
  {
    lng: -42.1402411,
    lat: -21.856368
  },
  {
    lng: -42.1402386,
    lat: -21.8563344
  },
  {
    lng: -42.1402413,
    lat: -21.8562906
  },
  {
    lng: -42.1402561,
    lat: -21.8562366
  },
  {
    lng: -42.1402645,
    lat: -21.8562129
  },
  {
    lng: -42.1403225,
    lat: -21.8561042
  },
  {
    lng: -42.140387,
    lat: -21.8560561
  },
  {
    lng: -42.1405451,
    lat: -21.8559963
  },
  {
    lng: -42.1407233,
    lat: -21.8558756
  },
  {
    lng: -42.140761,
    lat: -21.8558143
  },
  {
    lng: -42.140772,
    lat: -21.8557468
  },
  {
    lng: -42.1407686,
    lat: -21.8556627
  },
  {
    lng: -42.1407476,
    lat: -21.855589
  },
  {
    lng: -42.1406945,
    lat: -21.8554989
  },
  {
    lng: -42.1406387,
    lat: -21.8554561
  },
  {
    lng: -42.1405623,
    lat: -21.8554439
  },
  {
    lng: -42.1402703,
    lat: -21.8554658
  },
  {
    lng: -42.1400091,
    lat: -21.8555038
  },
  {
    lng: -42.1399254,
    lat: -21.8554816
  },
  {
    lng: -42.13963,
    lat: -21.8554023
  },
  {
    lng: -42.1394455,
    lat: -21.8553818
  },
  {
    lng: -42.1392543,
    lat: -21.8553782
  },
  {
    lng: -42.139108,
    lat: -21.8554076
  },
  {
    lng: -42.1388355,
    lat: -21.8555166
  },
  {
    lng: -42.1387839,
    lat: -21.855516
  },
  {
    lng: -42.1387544,
    lat: -21.8554913
  },
  {
    lng: -42.1387494,
    lat: -21.8554871
  },
  {
    lng: -42.1387254,
    lat: -21.8554519
  },
  {
    lng: -42.1387086,
    lat: -21.8554171
  },
  {
    lng: -42.1386992,
    lat: -21.8553945
  },
  {
    lng: -42.1386924,
    lat: -21.855372
  },
  {
    lng: -42.1386841,
    lat: -21.855346
  },
  {
    lng: -42.1386746,
    lat: -21.8553115
  },
  {
    lng: -42.1386653,
    lat: -21.8552719
  },
  {
    lng: -42.1386577,
    lat: -21.8552357
  },
  {
    lng: -42.1386513,
    lat: -21.8551945
  },
  {
    lng: -42.1386469,
    lat: -21.85515
  },
  {
    lng: -42.1386405,
    lat: -21.8551088
  },
  {
    lng: -42.138632,
    lat: -21.8550709
  },
  {
    lng: -42.1386194,
    lat: -21.8550277
  },
  {
    lng: -42.1386135,
    lat: -21.8550069
  },
  {
    lng: -42.1386033,
    lat: -21.8549673
  },
  {
    lng: -42.1385928,
    lat: -21.8549327
  },
  {
    lng: -42.1385837,
    lat: -21.8548914
  },
  {
    lng: -42.1385808,
    lat: -21.8548657
  },
  {
    lng: -42.1385803,
    lat: -21.8548452
  },
  {
    lng: -42.1385633,
    lat: -21.8546314
  },
  {
    lng: -42.138577,
    lat: -21.8545315
  },
  {
    lng: -42.1385874,
    lat: -21.8544962
  },
  {
    lng: -42.1385976,
    lat: -21.8544643
  },
  {
    lng: -42.1386129,
    lat: -21.8544241
  },
  {
    lng: -42.1386308,
    lat: -21.8543857
  },
  {
    lng: -42.1386521,
    lat: -21.8543509
  },
  {
    lng: -42.1386788,
    lat: -21.8543164
  },
  {
    lng: -42.1387071,
    lat: -21.8542853
  },
  {
    lng: -42.138739,
    lat: -21.8542544
  },
  {
    lng: -42.138776,
    lat: -21.8542289
  },
  {
    lng: -42.1388134,
    lat: -21.8542119
  },
  {
    lng: -42.1388561,
    lat: -21.8541952
  },
  {
    lng: -42.138899,
    lat: -21.8541767
  },
  {
    lng: -42.138945,
    lat: -21.8541669
  },
  {
    lng: -42.1389921,
    lat: -21.8541674
  },
  {
    lng: -42.1390346,
    lat: -21.8541694
  },
  {
    lng: -42.1390758,
    lat: -21.8541764
  },
  {
    lng: -42.139114,
    lat: -21.8541884
  },
  {
    lng: -42.1391603,
    lat: -21.8542008
  },
  {
    lng: -42.1392019,
    lat: -21.8542027
  },
  {
    lng: -42.1392487,
    lat: -21.8541929
  },
  {
    lng: -42.1392795,
    lat: -21.854179
  },
  {
    lng: -42.1393532,
    lat: -21.8541284
  },
  {
    lng: -42.1393648,
    lat: -21.8541017
  },
  {
    lng: -42.139372,
    lat: -21.8540748
  },
  {
    lng: -42.1393677,
    lat: -21.8540422
  },
  {
    lng: -42.1393577,
    lat: -21.8540145
  },
  {
    lng: -42.1392676,
    lat: -21.8539081
  },
  {
    lng: -42.1392001,
    lat: -21.8538164
  },
  {
    lng: -42.139178,
    lat: -21.8537796
  },
  {
    lng: -42.1391583,
    lat: -21.8537464
  },
  {
    lng: -42.1391363,
    lat: -21.8537079
  },
  {
    lng: -42.1391148,
    lat: -21.8536762
  },
  {
    lng: -42.139088,
    lat: -21.8536426
  },
  {
    lng: -42.1390593,
    lat: -21.8536089
  },
  {
    lng: -42.1390333,
    lat: -21.8535771
  },
  {
    lng: -42.1389087,
    lat: -21.8534708
  },
  {
    lng: -42.1387996,
    lat: -21.8534044
  },
  {
    lng: -42.1387686,
    lat: -21.8533791
  },
  {
    lng: -42.1387303,
    lat: -21.8533552
  },
  {
    lng: -42.1386927,
    lat: -21.853333
  },
  {
    lng: -42.1386526,
    lat: -21.853309
  },
  {
    lng: -42.1386194,
    lat: -21.8532887
  },
  {
    lng: -42.1385843,
    lat: -21.85327
  },
  {
    lng: -42.1385504,
    lat: -21.853248
  },
  {
    lng: -42.1385128,
    lat: -21.8532258
  },
  {
    lng: -42.1384779,
    lat: -21.8532054
  },
  {
    lng: -42.1384431,
    lat: -21.8531817
  },
  {
    lng: -42.1384108,
    lat: -21.8531495
  },
  {
    lng: -42.1383734,
    lat: -21.8531239
  },
  {
    lng: -42.1383292,
    lat: -21.8531201
  },
  {
    lng: -42.1382894,
    lat: -21.8531183
  },
  {
    lng: -42.1382506,
    lat: -21.8531164
  },
  {
    lng: -42.1382144,
    lat: -21.8531147
  },
  {
    lng: -42.1381801,
    lat: -21.8531114
  },
  {
    lng: -42.1381361,
    lat: -21.853106
  },
  {
    lng: -42.138094,
    lat: -21.8530972
  },
  {
    lng: -42.138055,
    lat: -21.8530834
  },
  {
    lng: -42.1380257,
    lat: -21.8530599
  },
  {
    lng: -42.1380165,
    lat: -21.8530476
  },
  {
    lng: -42.1379451,
    lat: -21.8529863
  },
  {
    lng: -42.1378898,
    lat: -21.8528458
  },
  {
    lng: -42.1378837,
    lat: -21.8528148
  },
  {
    lng: -42.1378799,
    lat: -21.8527755
  },
  {
    lng: -42.1378797,
    lat: -21.8527363
  },
  {
    lng: -42.137881,
    lat: -21.8527023
  },
  {
    lng: -42.137889,
    lat: -21.8526618
  },
  {
    lng: -42.1379026,
    lat: -21.8526199
  },
  {
    lng: -42.1379186,
    lat: -21.8525832
  },
  {
    lng: -42.1379418,
    lat: -21.8525469
  },
  {
    lng: -42.1379743,
    lat: -21.8525212
  },
  {
    lng: -42.1380173,
    lat: -21.8525028
  },
  {
    lng: -42.1380577,
    lat: -21.8524945
  },
  {
    lng: -42.1380953,
    lat: -21.8524877
  },
  {
    lng: -42.1381389,
    lat: -21.8524864
  },
  {
    lng: -42.1381805,
    lat: -21.8524883
  },
  {
    lng: -42.1382067,
    lat: -21.8524896
  },
  {
    lng: -42.1386814,
    lat: -21.8525103
  },
  {
    lng: -42.1390793,
    lat: -21.8525359
  },
  {
    lng: -42.1392233,
    lat: -21.8525086
  },
  {
    lng: -42.1393169,
    lat: -21.852462
  },
  {
    lng: -42.1393765,
    lat: -21.8524087
  },
  {
    lng: -42.1394028,
    lat: -21.8523657
  },
  {
    lng: -42.1394187,
    lat: -21.8523291
  },
  {
    lng: -42.1394227,
    lat: -21.8523089
  },
  {
    lng: -42.1394247,
    lat: -21.8522647
  },
  {
    lng: -42.1394222,
    lat: -21.8522459
  },
  {
    lng: -42.1394145,
    lat: -21.8522115
  },
  {
    lng: -42.1393918,
    lat: -21.852156
  },
  {
    lng: -42.1393495,
    lat: -21.8520945
  },
  {
    lng: -42.1392609,
    lat: -21.8520359
  },
  {
    lng: -42.1391526,
    lat: -21.8519882
  },
  {
    lng: -42.1390327,
    lat: -21.8518669
  },
  {
    lng: -42.139028,
    lat: -21.8518548
  },
  {
    lng: -42.138983,
    lat: -21.8517795
  },
  {
    lng: -42.1389777,
    lat: -21.8516653
  },
  {
    lng: -42.1389863,
    lat: -21.85163
  },
  {
    lng: -42.1390011,
    lat: -21.8515967
  },
  {
    lng: -42.1390217,
    lat: -21.8515586
  },
  {
    lng: -42.1390458,
    lat: -21.8515223
  },
  {
    lng: -42.1390786,
    lat: -21.8514899
  },
  {
    lng: -42.1391208,
    lat: -21.8514681
  },
  {
    lng: -42.1391599,
    lat: -21.8514513
  },
  {
    lng: -42.1392066,
    lat: -21.8514433
  },
  {
    lng: -42.1392546,
    lat: -21.8514439
  },
  {
    lng: -42.1392952,
    lat: -21.8514458
  },
  {
    lng: -42.1393421,
    lat: -21.8514481
  },
  {
    lng: -42.1393864,
    lat: -21.8514638
  },
  {
    lng: -42.139428,
    lat: -21.8514794
  },
  {
    lng: -42.1394731,
    lat: -21.8514951
  },
  {
    lng: -42.139507,
    lat: -21.8515171
  },
  {
    lng: -42.1395435,
    lat: -21.851541
  },
  {
    lng: -42.1395748,
    lat: -21.8515748
  },
  {
    lng: -42.1396026,
    lat: -21.8516084
  },
  {
    lng: -42.1396267,
    lat: -21.8516418
  },
  {
    lng: -42.1396458,
    lat: -21.8516818
  },
  {
    lng: -42.1396581,
    lat: -21.8517164
  },
  {
    lng: -42.1396681,
    lat: -21.8517577
  },
  {
    lng: -42.1396721,
    lat: -21.8517664
  },
  {
    lng: -42.1396974,
    lat: -21.8518798
  },
  {
    lng: -42.1397521,
    lat: -21.852015
  },
  {
    lng: -42.1397672,
    lat: -21.852048
  },
  {
    lng: -42.139792,
    lat: -21.8520849
  },
  {
    lng: -42.1398115,
    lat: -21.8521198
  },
  {
    lng: -42.1398337,
    lat: -21.8521549
  },
  {
    lng: -42.1398587,
    lat: -21.8521883
  },
  {
    lng: -42.1398859,
    lat: -21.8522168
  },
  {
    lng: -42.1399224,
    lat: -21.8522407
  },
  {
    lng: -42.139961,
    lat: -21.8522595
  },
  {
    lng: -42.1399973,
    lat: -21.8522714
  },
  {
    lng: -42.1400405,
    lat: -21.8522752
  },
  {
    lng: -42.1400829,
    lat: -21.8522772
  },
  {
    lng: -42.1401263,
    lat: -21.8522792
  },
  {
    lng: -42.1401675,
    lat: -21.8522574
  },
  {
    lng: -42.1402052,
    lat: -21.8522337
  },
  {
    lng: -42.1402385,
    lat: -21.852208
  },
  {
    lng: -42.1402736,
    lat: -21.8521825
  },
  {
    lng: -42.1403081,
    lat: -21.8521518
  },
  {
    lng: -42.1403381,
    lat: -21.852121
  },
  {
    lng: -42.1403572,
    lat: -21.8520913
  },
  {
    lng: -42.1403823,
    lat: -21.8520534
  },
  {
    lng: -42.1404037,
    lat: -21.8520153
  },
  {
    lng: -42.1404215,
    lat: -21.8519771
  },
  {
    lng: -42.1404395,
    lat: -21.8519354
  },
  {
    lng: -42.1404528,
    lat: -21.851897
  },
  {
    lng: -42.1404611,
    lat: -21.8518532
  },
  {
    lng: -42.140463,
    lat: -21.8518227
  },
  {
    lng: -42.1404575,
    lat: -21.8517816
  },
  {
    lng: -42.1404516,
    lat: -21.8517457
  },
  {
    lng: -42.1404482,
    lat: -21.8517149
  },
  {
    lng: -42.1403942,
    lat: -21.8515113
  },
  {
    lng: -42.1403445,
    lat: -21.8514392
  },
  {
    lng: -42.1402236,
    lat: -21.8513485
  },
  {
    lng: -42.1400868,
    lat: -21.8513021
  },
  {
    lng: -42.1400281,
    lat: -21.8512585
  },
  {
    lng: -42.1400136,
    lat: -21.8512306
  },
  {
    lng: -42.1399833,
    lat: -21.8511952
  },
  {
    lng: -42.1399845,
    lat: -21.8511476
  },
  {
    lng: -42.1399999,
    lat: -21.8511042
  },
  {
    lng: -42.1400303,
    lat: -21.8510819
  },
  {
    lng: -42.1400742,
    lat: -21.8510466
  },
  {
    lng: -42.1401667,
    lat: -21.8510137
  },
  {
    lng: -42.1403798,
    lat: -21.8509356
  },
  {
    lng: -42.1404848,
    lat: -21.8508489
  },
  {
    lng: -42.1406362,
    lat: -21.8507713
  },
  {
    lng: -42.1407346,
    lat: -21.850759
  },
  {
    lng: -42.1410083,
    lat: -21.8507484
  },
  {
    lng: -42.1411642,
    lat: -21.8507619
  },
  {
    lng: -42.1412695,
    lat: -21.8507975
  },
  {
    lng: -42.1413069,
    lat: -21.8508213
  },
  {
    lng: -42.1413434,
    lat: -21.8508435
  },
  {
    lng: -42.1413817,
    lat: -21.8508657
  },
  {
    lng: -42.1414192,
    lat: -21.8508878
  },
  {
    lng: -42.1414475,
    lat: -21.8509113
  },
  {
    lng: -42.1414736,
    lat: -21.8509278
  },
  {
    lng: -42.1415046,
    lat: -21.8509514
  },
  {
    lng: -42.1415383,
    lat: -21.850975
  },
  {
    lng: -42.1415713,
    lat: -21.850997
  },
  {
    lng: -42.1416067,
    lat: -21.8510224
  },
  {
    lng: -42.1416393,
    lat: -21.8510495
  },
  {
    lng: -42.1416744,
    lat: -21.85108
  },
  {
    lng: -42.1417026,
    lat: -21.8511068
  },
  {
    lng: -42.141736,
    lat: -21.8511356
  },
  {
    lng: -42.1417641,
    lat: -21.8511624
  },
  {
    lng: -42.1417923,
    lat: -21.8511875
  },
  {
    lng: -42.1418232,
    lat: -21.8512127
  },
  {
    lng: -42.1418526,
    lat: -21.8512345
  },
  {
    lng: -42.1418892,
    lat: -21.8512549
  },
  {
    lng: -42.1418997,
    lat: -21.8512605
  },
  {
    lng: -42.1420269,
    lat: -21.8513192
  },
  {
    lng: -42.1421168,
    lat: -21.8513117
  },
  {
    lng: -42.142158,
    lat: -21.8512882
  },
  {
    lng: -42.1421824,
    lat: -21.8512588
  },
  {
    lng: -42.1422065,
    lat: -21.8512209
  },
  {
    lng: -42.1422231,
    lat: -21.8511861
  },
  {
    lng: -42.1422335,
    lat: -21.8511509
  },
  {
    lng: -42.1422431,
    lat: -21.8511124
  },
  {
    lng: -42.1422513,
    lat: -21.8510686
  },
  {
    lng: -42.1422502,
    lat: -21.8510296
  },
  {
    lng: -42.1422411,
    lat: -21.8509867
  },
  {
    lng: -42.1422238,
    lat: -21.8509468
  },
  {
    lng: -42.1422016,
    lat: -21.8509118
  },
  {
    lng: -42.1421727,
    lat: -21.8508833
  },
  {
    lng: -42.1421422,
    lat: -21.8508513
  },
  {
    lng: -42.1421128,
    lat: -21.8508176
  },
  {
    lng: -42.1420898,
    lat: -21.8507945
  },
  {
    lng: -42.1420696,
    lat: -21.8507715
  },
  {
    lng: -42.1420468,
    lat: -21.8507466
  },
  {
    lng: -42.1420143,
    lat: -21.8507179
  },
  {
    lng: -42.1419887,
    lat: -21.8506946
  },
  {
    lng: -42.1419603,
    lat: -21.8506729
  },
  {
    lng: -42.1419267,
    lat: -21.8506475
  },
  {
    lng: -42.1418944,
    lat: -21.850629
  },
  {
    lng: -42.1418596,
    lat: -21.8506086
  },
  {
    lng: -42.1418312,
    lat: -21.8505869
  },
  {
    lng: -42.1418048,
    lat: -21.8505602
  },
  {
    lng: -42.1417794,
    lat: -21.8505335
  },
  {
    lng: -42.141766,
    lat: -21.8505176
  },
  {
    lng: -42.1417273,
    lat: -21.8504581
  },
  {
    lng: -42.1417236,
    lat: -21.8504172
  },
  {
    lng: -42.1417377,
    lat: -21.8503788
  },
  {
    lng: -42.1417592,
    lat: -21.8503392
  },
  {
    lng: -42.1417807,
    lat: -21.8502995
  },
  {
    lng: -42.1417853,
    lat: -21.8502556
  },
  {
    lng: -42.1417772,
    lat: -21.8502111
  },
  {
    lng: -42.1417525,
    lat: -21.8501743
  },
  {
    lng: -42.1417217,
    lat: -21.8501474
  },
  {
    lng: -42.141691,
    lat: -21.8501187
  },
  {
    lng: -42.1416628,
    lat: -21.8500936
  },
  {
    lng: -42.1416309,
    lat: -21.85007
  },
  {
    lng: -42.1415943,
    lat: -21.8500479
  },
  {
    lng: -42.1415543,
    lat: -21.8500239
  },
  {
    lng: -42.1415153,
    lat: -21.8499983
  },
  {
    lng: -42.1414917,
    lat: -21.8499717
  },
  {
    lng: -42.141474,
    lat: -21.8499369
  },
  {
    lng: -42.1414711,
    lat: -21.8498978
  },
  {
    lng: -42.1414762,
    lat: -21.849859
  },
  {
    lng: -42.1414895,
    lat: -21.8498206
  },
  {
    lng: -42.1414919,
    lat: -21.8498123
  },
  {
    lng: -42.1415568,
    lat: -21.849706
  },
  {
    lng: -42.1416952,
    lat: -21.8495737
  },
  {
    lng: -42.1417345,
    lat: -21.8495519
  },
  {
    lng: -42.1417738,
    lat: -21.8495301
  },
  {
    lng: -42.1418129,
    lat: -21.8495116
  },
  {
    lng: -42.14185,
    lat: -21.8494965
  },
  {
    lng: -42.1418872,
    lat: -21.849478
  },
  {
    lng: -42.1419313,
    lat: -21.8494665
  },
  {
    lng: -42.1419625,
    lat: -21.8494579
  },
  {
    lng: -42.1419994,
    lat: -21.8494461
  },
  {
    lng: -42.1420468,
    lat: -21.8494383
  },
  {
    lng: -42.1420816,
    lat: -21.8494298
  },
  {
    lng: -42.14212,
    lat: -21.8494215
  },
  {
    lng: -42.1421623,
    lat: -21.84941
  },
  {
    lng: -42.1421989,
    lat: -21.8494016
  },
  {
    lng: -42.1422447,
    lat: -21.8493903
  },
  {
    lng: -42.1422867,
    lat: -21.8493822
  },
  {
    lng: -42.1423288,
    lat: -21.849374
  },
  {
    lng: -42.1423654,
    lat: -21.8493657
  },
  {
    lng: -42.1424076,
    lat: -21.8493542
  },
  {
    lng: -42.142455,
    lat: -21.8493463
  },
  {
    lng: -42.1424932,
    lat: -21.8493414
  },
  {
    lng: -42.1425332,
    lat: -21.8493366
  },
  {
    lng: -42.1425658,
    lat: -21.8493348
  },
  {
    lng: -42.1426098,
    lat: -21.8493234
  },
  {
    lng: -42.1426482,
    lat: -21.8493151
  },
  {
    lng: -42.1426754,
    lat: -21.849313
  },
  {
    lng: -42.142719,
    lat: -21.8493084
  },
  {
    lng: -42.1427621,
    lat: -21.8493105
  },
  {
    lng: -42.1428053,
    lat: -21.8493126
  },
  {
    lng: -42.1428358,
    lat: -21.8493141
  },
  {
    lng: -42.142879,
    lat: -21.8493162
  },
  {
    lng: -42.1429095,
    lat: -21.8493177
  },
  {
    lng: -42.1429473,
    lat: -21.8493195
  },
  {
    lng: -42.1429869,
    lat: -21.8493214
  },
  {
    lng: -42.143034,
    lat: -21.8493169
  },
  {
    lng: -42.1430652,
    lat: -21.8493083
  },
  {
    lng: -42.1431074,
    lat: -21.8492968
  },
  {
    lng: -42.1431422,
    lat: -21.8492883
  },
  {
    lng: -42.1431788,
    lat: -21.84928
  },
  {
    lng: -42.1432176,
    lat: -21.8492649
  },
  {
    lng: -42.143238,
    lat: -21.8492558
  },
  {
    lng: -42.1433,
    lat: -21.8492148
  },
  {
    lng: -42.1433521,
    lat: -21.8491597
  },
  {
    lng: -42.1433779,
    lat: -21.8490932
  },
  {
    lng: -42.1434037,
    lat: -21.8489692
  },
  {
    lng: -42.1433811,
    lat: -21.8488699
  },
  {
    lng: -42.1433484,
    lat: -21.8488446
  },
  {
    lng: -42.1433084,
    lat: -21.8488223
  },
  {
    lng: -42.1432733,
    lat: -21.848807
  },
  {
    lng: -42.1432344,
    lat: -21.848795
  },
  {
    lng: -42.1431939,
    lat: -21.8487794
  },
  {
    lng: -42.1431532,
    lat: -21.8487673
  },
  {
    lng: -42.1431145,
    lat: -21.8487518
  },
  {
    lng: -42.1430781,
    lat: -21.8487297
  },
  {
    lng: -42.14306,
    lat: -21.8487153
  },
  {
    lng: -42.143042,
    lat: -21.8487009
  },
  {
    lng: -42.143021,
    lat: -21.8486626
  },
  {
    lng: -42.1430056,
    lat: -21.8486212
  },
  {
    lng: -42.1429955,
    lat: -21.8485801
  },
  {
    lng: -42.1429927,
    lat: -21.8485393
  },
  {
    lng: -42.1429936,
    lat: -21.8484953
  },
  {
    lng: -42.1429982,
    lat: -21.8484515
  },
  {
    lng: -42.1430081,
    lat: -21.848408
  },
  {
    lng: -42.143023,
    lat: -21.8483715
  },
  {
    lng: -42.1430415,
    lat: -21.8483352
  },
  {
    lng: -42.1430636,
    lat: -21.848299
  },
  {
    lng: -42.1430945,
    lat: -21.8482667
  },
  {
    lng: -42.1431351,
    lat: -21.8482517
  },
  {
    lng: -42.14318,
    lat: -21.848254
  },
  {
    lng: -42.1432243,
    lat: -21.8482663
  },
  {
    lng: -42.1432665,
    lat: -21.8482819
  },
  {
    lng: -42.1433108,
    lat: -21.8482943
  },
  {
    lng: -42.1433539,
    lat: -21.8482964
  },
  {
    lng: -42.1433935,
    lat: -21.8482983
  },
  {
    lng: -42.1434326,
    lat: -21.8483003
  },
  {
    lng: -42.1434366,
    lat: -21.8483005
  },
  {
    lng: -42.1434817,
    lat: -21.8482993
  },
  {
    lng: -42.1435236,
    lat: -21.8482912
  },
  {
    lng: -42.1435622,
    lat: -21.8482796
  },
  {
    lng: -42.1436028,
    lat: -21.8482646
  },
  {
    lng: -42.1436393,
    lat: -21.8482563
  },
  {
    lng: -42.1436812,
    lat: -21.8482482
  },
  {
    lng: -42.143727,
    lat: -21.8482369
  },
  {
    lng: -42.1437581,
    lat: -21.8482283
  },
  {
    lng: -42.1437953,
    lat: -21.8482098
  },
  {
    lng: -42.1438379,
    lat: -21.8481916
  },
  {
    lng: -42.1438473,
    lat: -21.8481853
  },
  {
    lng: -42.1440626,
    lat: -21.8481114
  },
  {
    lng: -42.1441386,
    lat: -21.8480474
  },
  {
    lng: -42.1442146,
    lat: -21.8479836
  },
  {
    lng: -42.1442418,
    lat: -21.8479511
  },
  {
    lng: -42.144267,
    lat: -21.8479219
  },
  {
    lng: -42.1442873,
    lat: -21.8478857
  },
  {
    lng: -42.1442965,
    lat: -21.8478523
  },
  {
    lng: -42.1443026,
    lat: -21.8478121
  },
  {
    lng: -42.1443054,
    lat: -21.8477682
  },
  {
    lng: -42.1443023,
    lat: -21.8477309
  },
  {
    lng: -42.144297,
    lat: -21.8477002
  },
  {
    lng: -42.1442865,
    lat: -21.8476658
  },
  {
    lng: -42.1442671,
    lat: -21.8476311
  },
  {
    lng: -42.1442439,
    lat: -21.8475995
  },
  {
    lng: -42.1442155,
    lat: -21.8475642
  },
  {
    lng: -42.1441902,
    lat: -21.8475359
  },
  {
    lng: -42.1441632,
    lat: -21.8475075
  },
  {
    lng: -42.1441328,
    lat: -21.8474756
  },
  {
    lng: -42.1441042,
    lat: -21.8474437
  },
  {
    lng: -42.1440734,
    lat: -21.8474185
  },
  {
    lng: -42.1440333,
    lat: -21.8473963
  },
  {
    lng: -42.1439981,
    lat: -21.8473844
  },
  {
    lng: -42.1439556,
    lat: -21.8473721
  },
  {
    lng: -42.143909,
    lat: -21.8473698
  },
  {
    lng: -42.1438749,
    lat: -21.8473681
  },
  {
    lng: -42.1438318,
    lat: -21.847366
  },
  {
    lng: -42.1437876,
    lat: -21.8473536
  },
  {
    lng: -42.1437646,
    lat: -21.8473457
  },
  {
    lng: -42.1437246,
    lat: -21.8473234
  },
  {
    lng: -42.1436987,
    lat: -21.8473052
  },
  {
    lng: -42.1436717,
    lat: -21.8472768
  },
  {
    lng: -42.1436507,
    lat: -21.8472386
  },
  {
    lng: -42.143642,
    lat: -21.8472043
  },
  {
    lng: -42.1436388,
    lat: -21.8471704
  },
  {
    lng: -42.1436391,
    lat: -21.8471366
  },
  {
    lng: -42.1436436,
    lat: -21.8470928
  },
  {
    lng: -42.1436565,
    lat: -21.8470597
  },
  {
    lng: -42.1436694,
    lat: -21.8470265
  },
  {
    lng: -42.1436876,
    lat: -21.8469936
  },
  {
    lng: -42.1437169,
    lat: -21.8469579
  },
  {
    lng: -42.1437495,
    lat: -21.8469257
  },
  {
    lng: -42.1437821,
    lat: -21.8468935
  },
  {
    lng: -42.1438197,
    lat: -21.8468683
  },
  {
    lng: -42.1438537,
    lat: -21.846843
  },
  {
    lng: -42.1438912,
    lat: -21.8468178
  },
  {
    lng: -42.1439218,
    lat: -21.8467889
  },
  {
    lng: -42.143945,
    lat: -21.846763
  },
  {
    lng: -42.1439703,
    lat: -21.8467339
  },
  {
    lng: -42.1440783,
    lat: -21.8466176
  },
  {
    lng: -42.1441229,
    lat: -21.8465084
  },
  {
    lng: -42.1441274,
    lat: -21.8464647
  },
  {
    lng: -42.1441192,
    lat: -21.8464237
  },
  {
    lng: -42.1440924,
    lat: -21.8463919
  },
  {
    lng: -42.1440658,
    lat: -21.8463568
  },
  {
    lng: -42.144041,
    lat: -21.8463218
  },
  {
    lng: -42.1440122,
    lat: -21.8462933
  },
  {
    lng: -42.1439704,
    lat: -21.8462709
  },
  {
    lng: -42.1439279,
    lat: -21.8462587
  },
  {
    lng: -42.1438889,
    lat: -21.8462499
  },
  {
    lng: -42.1438443,
    lat: -21.8462443
  },
  {
    lng: -42.1438066,
    lat: -21.8462424
  },
  {
    lng: -42.1437707,
    lat: -21.8462406
  },
  {
    lng: -42.1437276,
    lat: -21.8462385
  },
  {
    lng: -42.1436042,
    lat: -21.8462878
  },
  {
    lng: -42.1434943,
    lat: -21.8463465
  },
  {
    lng: -42.1434472,
    lat: -21.8463509
  },
  {
    lng: -42.1434245,
    lat: -21.8463396
  },
  {
    lng: -42.1432598,
    lat: -21.8462097
  },
  {
    lng: -42.1429586,
    lat: -21.8459004
  },
  {
    lng: -42.1428617,
    lat: -21.8457502
  },
  {
    lng: -42.1428484,
    lat: -21.8456912
  },
  {
    lng: -42.1428293,
    lat: -21.8456066
  },
  {
    lng: -42.1428247,
    lat: -21.8455658
  },
  {
    lng: -42.1428293,
    lat: -21.8455221
  },
  {
    lng: -42.1428462,
    lat: -21.8454825
  },
  {
    lng: -42.1428685,
    lat: -21.845443
  },
  {
    lng: -42.1428989,
    lat: -21.8454175
  },
  {
    lng: -42.1429313,
    lat: -21.8453888
  },
  {
    lng: -42.1429633,
    lat: -21.8453667
  },
  {
    lng: -42.1429973,
    lat: -21.8453414
  },
  {
    lng: -42.1430363,
    lat: -21.8453231
  },
  {
    lng: -42.1430735,
    lat: -21.8453048
  },
  {
    lng: -42.143114,
    lat: -21.8452899
  },
  {
    lng: -42.1431566,
    lat: -21.8452718
  },
  {
    lng: -42.1431863,
    lat: -21.8452564
  },
  {
    lng: -42.1432271,
    lat: -21.8452382
  },
  {
    lng: -42.14326,
    lat: -21.8452298
  },
  {
    lng: -42.1432972,
    lat: -21.8452114
  },
  {
    lng: -42.1433395,
    lat: -21.8451966
  },
  {
    lng: -42.143382,
    lat: -21.8451785
  },
  {
    lng: -42.1434278,
    lat: -21.8451674
  },
  {
    lng: -42.1434717,
    lat: -21.8451561
  },
  {
    lng: -42.1435154,
    lat: -21.8451482
  },
  {
    lng: -42.143555,
    lat: -21.8451468
  },
  {
    lng: -42.1435999,
    lat: -21.8451491
  },
  {
    lng: -42.1436429,
    lat: -21.8451513
  },
  {
    lng: -42.143686,
    lat: -21.8451534
  },
  {
    lng: -42.1437326,
    lat: -21.8451558
  },
  {
    lng: -42.1437649,
    lat: -21.8451575
  },
  {
    lng: -42.1438098,
    lat: -21.8451597
  },
  {
    lng: -42.1438456,
    lat: -21.8451616
  },
  {
    lng: -42.1438815,
    lat: -21.8451634
  },
  {
    lng: -42.143925,
    lat: -21.8451588
  },
  {
    lng: -42.1439605,
    lat: -21.845137
  },
  {
    lng: -42.1439829,
    lat: -21.8451246
  },
  {
    lng: -42.1440068,
    lat: -21.8451157
  },
  {
    lng: -42.1441333,
    lat: -21.8449331
  },
  {
    lng: -42.144195,
    lat: -21.844781
  },
  {
    lng: -42.1441993,
    lat: -21.8447407
  },
  {
    lng: -42.1441998,
    lat: -21.8447036
  },
  {
    lng: -42.1441914,
    lat: -21.8446661
  },
  {
    lng: -42.1441791,
    lat: -21.8446317
  },
  {
    lng: -42.1441653,
    lat: -21.8445939
  },
  {
    lng: -42.1441538,
    lat: -21.8445764
  },
  {
    lng: -42.1441389,
    lat: -21.8445554
  },
  {
    lng: -42.144013,
    lat: -21.8443262
  },
  {
    lng: -42.1439709,
    lat: -21.8441925
  },
  {
    lng: -42.1439719,
    lat: -21.8441487
  },
  {
    lng: -42.143978,
    lat: -21.8441085
  },
  {
    lng: -42.1439873,
    lat: -21.8440753
  },
  {
    lng: -42.1440057,
    lat: -21.8440391
  },
  {
    lng: -42.1440161,
    lat: -21.844016
  },
  {
    lng: -42.1441498,
    lat: -21.8438913
  },
  {
    lng: -42.1444162,
    lat: -21.8437128
  },
  {
    lng: -42.1445563,
    lat: -21.843656
  },
  {
    lng: -42.144678,
    lat: -21.8436352
  },
  {
    lng: -42.1448046,
    lat: -21.8436215
  },
  {
    lng: -42.1448447,
    lat: -21.8436135
  },
  {
    lng: -42.1448887,
    lat: -21.8435989
  },
  {
    lng: -42.1449275,
    lat: -21.8435807
  },
  {
    lng: -42.1449612,
    lat: -21.8435588
  },
  {
    lng: -42.1450021,
    lat: -21.8435373
  },
  {
    lng: -42.1450306,
    lat: -21.8435118
  },
  {
    lng: -42.1450627,
    lat: -21.8434865
  },
  {
    lng: -42.1450883,
    lat: -21.8434508
  },
  {
    lng: -42.1451013,
    lat: -21.8434144
  },
  {
    lng: -42.1451092,
    lat: -21.8433744
  },
  {
    lng: -42.1451047,
    lat: -21.8433303
  },
  {
    lng: -42.1450965,
    lat: -21.8432895
  },
  {
    lng: -42.1450934,
    lat: -21.8432522
  },
  {
    lng: -42.1450937,
    lat: -21.8432186
  },
  {
    lng: -42.1450962,
    lat: -21.8431783
  },
  {
    lng: -42.1450989,
    lat: -21.8431346
  },
  {
    lng: -42.145105,
    lat: -21.8430945
  },
  {
    lng: -42.145118,
    lat: -21.8430581
  },
  {
    lng: -42.1451366,
    lat: -21.8430186
  },
  {
    lng: -42.1451602,
    lat: -21.8429862
  },
  {
    lng: -42.1451857,
    lat: -21.8429504
  },
  {
    lng: -42.1452097,
    lat: -21.8429112
  },
  {
    lng: -42.1452364,
    lat: -21.8428857
  },
  {
    lng: -42.1452687,
    lat: -21.842857
  },
  {
    lng: -42.1452964,
    lat: -21.842845
  },
  {
    lng: -42.1453357,
    lat: -21.8428201
  },
  {
    lng: -42.1453671,
    lat: -21.8428049
  },
  {
    lng: -42.1454024,
    lat: -21.8427865
  },
  {
    lng: -42.1454267,
    lat: -21.8427709
  },
  {
    lng: -42.1454619,
    lat: -21.8427526
  },
  {
    lng: -42.1455007,
    lat: -21.8427344
  },
  {
    lng: -42.1455382,
    lat: -21.8427094
  },
  {
    lng: -42.1455702,
    lat: -21.8426841
  },
  {
    lng: -42.1456005,
    lat: -21.8426587
  },
  {
    lng: -42.145633,
    lat: -21.8426268
  },
  {
    lng: -42.1456637,
    lat: -21.8425947
  },
  {
    lng: -42.145691,
    lat: -21.8425591
  },
  {
    lng: -42.1457161,
    lat: -21.8425301
  },
  {
    lng: -42.1457379,
    lat: -21.8424975
  },
  {
    lng: -42.1457578,
    lat: -21.8424649
  },
  {
    lng: -42.1457778,
    lat: -21.8424323
  },
  {
    lng: -42.1457982,
    lat: -21.842393
  },
  {
    lng: -42.1458116,
    lat: -21.8423499
  },
  {
    lng: -42.1458214,
    lat: -21.8423067
  },
  {
    lng: -42.1458313,
    lat: -21.8422634
  },
  {
    lng: -42.1458411,
    lat: -21.8422202
  },
  {
    lng: -42.1458504,
    lat: -21.842187
  },
  {
    lng: -42.1458582,
    lat: -21.842147
  },
  {
    lng: -42.1458625,
    lat: -21.8421069
  },
  {
    lng: -42.1458648,
    lat: -21.84207
  },
  {
    lng: -42.1458621,
    lat: -21.8420261
  },
  {
    lng: -42.1458503,
    lat: -21.8419851
  },
  {
    lng: -42.1458291,
    lat: -21.8419503
  },
  {
    lng: -42.1458043,
    lat: -21.8419154
  },
  {
    lng: -42.145774,
    lat: -21.8418835
  },
  {
    lng: -42.1457399,
    lat: -21.8418548
  },
  {
    lng: -42.1457038,
    lat: -21.8418293
  },
  {
    lng: -42.1456639,
    lat: -21.8418071
  },
  {
    lng: -42.1456346,
    lat: -21.8417887
  },
  {
    lng: -42.1454651,
    lat: -21.8417235
  },
  {
    lng: -42.1452837,
    lat: -21.8416971
  },
  {
    lng: -42.1451176,
    lat: -21.841712
  },
  {
    lng: -42.1449984,
    lat: -21.8417529
  },
  {
    lng: -42.1448167,
    lat: -21.8418443
  },
  {
    lng: -42.1446319,
    lat: -21.841929
  },
  {
    lng: -42.1443735,
    lat: -21.8420097
  },
  {
    lng: -42.144115,
    lat: -21.8420636
  },
  {
    lng: -42.1439719,
    lat: -21.8420528
  },
  {
    lng: -42.1439129,
    lat: -21.8420193
  },
  {
    lng: -42.1438665,
    lat: -21.8419563
  },
  {
    lng: -42.1438322,
    lat: -21.8417288
  },
  {
    lng: -42.1437617,
    lat: -21.8416207
  },
  {
    lng: -42.1437258,
    lat: -21.8415918
  },
  {
    lng: -42.1436874,
    lat: -21.841573
  },
  {
    lng: -42.1436504,
    lat: -21.8415609
  },
  {
    lng: -42.143606,
    lat: -21.8415519
  },
  {
    lng: -42.1435632,
    lat: -21.8415463
  },
  {
    lng: -42.143522,
    lat: -21.8415441
  },
  {
    lng: -42.1434996,
    lat: -21.8415429
  },
  {
    lng: -42.1434772,
    lat: -21.8415417
  },
  {
    lng: -42.1434408,
    lat: -21.8415499
  },
  {
    lng: -42.1434005,
    lat: -21.8415613
  },
  {
    lng: -42.1433652,
    lat: -21.8415797
  },
  {
    lng: -42.1433281,
    lat: -21.8415979
  },
  {
    lng: -42.1432921,
    lat: -21.8416264
  },
  {
    lng: -42.1432619,
    lat: -21.8416484
  },
  {
    lng: -42.1432354,
    lat: -21.8416706
  },
  {
    lng: -42.1432146,
    lat: -21.8416863
  },
  {
    lng: -42.1431771,
    lat: -21.8417113
  },
  {
    lng: -42.1431433,
    lat: -21.8417331
  },
  {
    lng: -42.143104,
    lat: -21.841758
  },
  {
    lng: -42.1430664,
    lat: -21.841783
  },
  {
    lng: -42.1430383,
    lat: -21.8418018
  },
  {
    lng: -42.1430081,
    lat: -21.8418238
  },
  {
    lng: -42.1429784,
    lat: -21.8418391
  },
  {
    lng: -42.1429446,
    lat: -21.8418609
  },
  {
    lng: -42.1429164,
    lat: -21.8418796
  },
  {
    lng: -42.1428833,
    lat: -21.8418914
  },
  {
    lng: -42.1428518,
    lat: -21.8419066
  },
  {
    lng: -42.1428182,
    lat: -21.8419251
  },
  {
    lng: -42.1427789,
    lat: -21.84195
  },
  {
    lng: -42.1427449,
    lat: -21.8419751
  },
  {
    lng: -42.1427089,
    lat: -21.8420036
  },
  {
    lng: -42.1426783,
    lat: -21.8420323
  },
  {
    lng: -42.1426571,
    lat: -21.8420548
  },
  {
    lng: -42.1426247,
    lat: -21.8420835
  },
  {
    lng: -42.1425938,
    lat: -21.8421156
  },
  {
    lng: -42.1425648,
    lat: -21.8421478
  },
  {
    lng: -42.142534,
    lat: -21.8421799
  },
  {
    lng: -42.1425146,
    lat: -21.8422025
  },
  {
    lng: -42.1424925,
    lat: -21.8422384
  },
  {
    lng: -42.1424722,
    lat: -21.8422745
  },
  {
    lng: -42.1424593,
    lat: -21.8423075
  },
  {
    lng: -42.1424424,
    lat: -21.8423471
  },
  {
    lng: -42.1424309,
    lat: -21.842387
  },
  {
    lng: -42.142421,
    lat: -21.8424303
  },
  {
    lng: -42.1424191,
    lat: -21.8424606
  },
  {
    lng: -42.1424167,
    lat: -21.8424975
  },
  {
    lng: -42.1424155,
    lat: -21.8425177
  },
  {
    lng: -42.1424173,
    lat: -21.8425448
  },
  {
    lng: -42.1424222,
    lat: -21.8425821
  },
  {
    lng: -42.1424326,
    lat: -21.8426164
  },
  {
    lng: -42.142437,
    lat: -21.8426335
  },
  {
    lng: -42.1425157,
    lat: -21.8427556
  },
  {
    lng: -42.1425494,
    lat: -21.8428485
  },
  {
    lng: -42.1425481,
    lat: -21.8428687
  },
  {
    lng: -42.1425335,
    lat: -21.8429016
  },
  {
    lng: -42.1425178,
    lat: -21.8429211
  },
  {
    lng: -42.142499,
    lat: -21.8429336
  },
  {
    lng: -42.1424609,
    lat: -21.8429384
  },
  {
    lng: -42.1423889,
    lat: -21.842938
  },
  {
    lng: -42.1423572,
    lat: -21.8429262
  },
  {
    lng: -42.1422889,
    lat: -21.8428957
  },
  {
    lng: -42.1420965,
    lat: -21.8427204
  },
  {
    lng: -42.1419516,
    lat: -21.8424767
  },
  {
    lng: -42.1418347,
    lat: -21.842275
  },
  {
    lng: -42.1418063,
    lat: -21.8421554
  },
  {
    lng: -42.1418108,
    lat: -21.8420275
  },
  {
    lng: -42.1418325,
    lat: -21.8414015
  },
  {
    lng: -42.1418666,
    lat: -21.8412044
  },
  {
    lng: -42.1418745,
    lat: -21.8411644
  },
  {
    lng: -42.1418823,
    lat: -21.8411277
  },
  {
    lng: -42.1418862,
    lat: -21.8410942
  },
  {
    lng: -42.1418885,
    lat: -21.8410573
  },
  {
    lng: -42.1418911,
    lat: -21.841017
  },
  {
    lng: -42.141892,
    lat: -21.8409732
  },
  {
    lng: -42.1418908,
    lat: -21.8409361
  },
  {
    lng: -42.1418896,
    lat: -21.8408989
  },
  {
    lng: -42.1418847,
    lat: -21.8408616
  },
  {
    lng: -42.1418803,
    lat: -21.8408176
  },
  {
    lng: -42.1418775,
    lat: -21.840777
  },
  {
    lng: -42.1418731,
    lat: -21.840733
  },
  {
    lng: -42.1418738,
    lat: -21.8406926
  },
  {
    lng: -42.141873,
    lat: -21.8406487
  },
  {
    lng: -42.1418722,
    lat: -21.8406049
  },
  {
    lng: -42.1418712,
    lat: -21.8405644
  },
  {
    lng: -42.1418663,
    lat: -21.8405271
  },
  {
    lng: -42.1418629,
    lat: -21.8404966
  },
  {
    lng: -42.1418582,
    lat: -21.8404559
  },
  {
    lng: -42.1418534,
    lat: -21.8404186
  },
  {
    lng: -42.1418488,
    lat: -21.8403779
  },
  {
    lng: -42.1418406,
    lat: -21.8403371
  },
  {
    lng: -42.1418306,
    lat: -21.8402961
  },
  {
    lng: -42.1418206,
    lat: -21.8402552
  },
  {
    lng: -42.1417514,
    lat: -21.8400966
  },
  {
    lng: -42.1416542,
    lat: -21.8399264
  },
  {
    lng: -42.1416328,
    lat: -21.8398949
  },
  {
    lng: -42.1416098,
    lat: -21.8398601
  },
  {
    lng: -42.1415828,
    lat: -21.8398317
  },
  {
    lng: -42.1415543,
    lat: -21.8397998
  },
  {
    lng: -42.1415237,
    lat: -21.8397713
  },
  {
    lng: -42.1414893,
    lat: -21.8397459
  },
  {
    lng: -42.1414567,
    lat: -21.8397206
  },
  {
    lng: -42.1414468,
    lat: -21.839715
  },
  {
    lng: -42.1414237,
    lat: -21.839702
  },
  {
    lng: -42.1413837,
    lat: -21.8396796
  },
  {
    lng: -42.1413484,
    lat: -21.8396676
  },
  {
    lng: -42.1413096,
    lat: -21.8396555
  },
  {
    lng: -42.1412708,
    lat: -21.8396433
  },
  {
    lng: -42.1412299,
    lat: -21.8396344
  },
  {
    lng: -42.141187,
    lat: -21.8396287
  },
  {
    lng: -42.1411512,
    lat: -21.8396268
  },
  {
    lng: -42.1411081,
    lat: -21.8396245
  },
  {
    lng: -42.1410654,
    lat: -21.8396155
  },
  {
    lng: -42.1410259,
    lat: -21.8396134
  },
  {
    lng: -42.1409865,
    lat: -21.8396113
  },
  {
    lng: -42.1409548,
    lat: -21.8395995
  },
  {
    lng: -42.1409314,
    lat: -21.8395982
  },
  {
    lng: -42.1408854,
    lat: -21.8395857
  },
  {
    lng: -42.1403725,
    lat: -21.839464
  },
  {
    lng: -42.1401742,
    lat: -21.8393944
  },
  {
    lng: -42.1399759,
    lat: -21.8393249
  },
  {
    lng: -42.1397063,
    lat: -21.8392835
  },
  {
    lng: -42.1394711,
    lat: -21.8392676
  },
  {
    lng: -42.139277,
    lat: -21.8392841
  },
  {
    lng: -42.1391984,
    lat: -21.8393002
  },
  {
    lng: -42.1390455,
    lat: -21.8393493
  },
  {
    lng: -42.1389321,
    lat: -21.8394275
  },
  {
    lng: -42.1388625,
    lat: -21.8395553
  },
  {
    lng: -42.1387879,
    lat: -21.839676
  },
  {
    lng: -42.1387496,
    lat: -21.8397381
  },
  {
    lng: -42.1387125,
    lat: -21.839753
  },
  {
    lng: -42.138677,
    lat: -21.8397443
  },
  {
    lng: -42.1386635,
    lat: -21.8397301
  },
  {
    lng: -42.1386506,
    lat: -21.8397058
  },
  {
    lng: -42.1386097,
    lat: -21.8396126
  },
  {
    lng: -42.1385137,
    lat: -21.8392838
  },
  {
    lng: -42.1384454,
    lat: -21.8390003
  },
  {
    lng: -42.1384399,
    lat: -21.8389731
  },
  {
    lng: -42.138434,
    lat: -21.8389525
  },
  {
    lng: -42.1384259,
    lat: -21.8389116
  },
  {
    lng: -42.1384193,
    lat: -21.8388742
  },
  {
    lng: -42.1384143,
    lat: -21.8388402
  },
  {
    lng: -42.1384077,
    lat: -21.8388028
  },
  {
    lng: -42.138399,
    lat: -21.8387686
  },
  {
    lng: -42.1383936,
    lat: -21.8387414
  },
  {
    lng: -42.138385,
    lat: -21.8387072
  },
  {
    lng: -42.1383827,
    lat: -21.8386869
  },
  {
    lng: -42.1383736,
    lat: -21.8386594
  },
  {
    lng: -42.1383652,
    lat: -21.8386219
  },
  {
    lng: -42.1383564,
    lat: -21.8385911
  },
  {
    lng: -42.1383444,
    lat: -21.8385534
  },
  {
    lng: -42.1383308,
    lat: -21.8385122
  },
  {
    lng: -42.1383234,
    lat: -21.8384882
  },
  {
    lng: -42.1383175,
    lat: -21.8384677
  },
  {
    lng: -42.13831,
    lat: -21.8384437
  },
  {
    lng: -42.1382994,
    lat: -21.8384128
  },
  {
    lng: -42.1382917,
    lat: -21.8383922
  },
  {
    lng: -42.1382824,
    lat: -21.8383681
  },
  {
    lng: -42.1382752,
    lat: -21.8383407
  },
  {
    lng: -42.1382675,
    lat: -21.8383201
  },
  {
    lng: -42.1382582,
    lat: -21.838296
  },
  {
    lng: -42.1382465,
    lat: -21.838255
  },
  {
    lng: -42.1382345,
    lat: -21.8382172
  },
  {
    lng: -42.1382225,
    lat: -21.8381795
  },
  {
    lng: -42.1382103,
    lat: -21.8381452
  },
  {
    lng: -42.1382001,
    lat: -21.8381076
  },
  {
    lng: -42.1381915,
    lat: -21.8380734
  },
  {
    lng: -42.1381833,
    lat: -21.8380326
  },
  {
    lng: -42.1381765,
    lat: -21.8379985
  },
  {
    lng: -42.1381733,
    lat: -21.8379646
  },
  {
    lng: -42.1381633,
    lat: -21.8379237
  },
  {
    lng: -42.138156,
    lat: -21.8378963
  },
  {
    lng: -42.1381474,
    lat: -21.8378622
  },
  {
    lng: -42.1381348,
    lat: -21.8378345
  },
  {
    lng: -42.1381257,
    lat: -21.8378071
  },
  {
    lng: -42.138112,
    lat: -21.8377693
  },
  {
    lng: -42.1380905,
    lat: -21.8377378
  },
  {
    lng: -42.1380793,
    lat: -21.837717
  },
  {
    lng: -42.1378578,
    lat: -21.8374224
  },
  {
    lng: -42.1375949,
    lat: -21.8371255
  },
  {
    lng: -42.1374675,
    lat: -21.8369737
  },
  {
    lng: -42.1374208,
    lat: -21.83686
  },
  {
    lng: -42.1373786,
    lat: -21.836787
  },
  {
    lng: -42.1373333,
    lat: -21.836761
  },
  {
    lng: -42.1372719,
    lat: -21.836734
  },
  {
    lng: -42.1371859,
    lat: -21.8367226
  },
  {
    lng: -42.1371535,
    lat: -21.8367208
  },
  {
    lng: -42.1371276,
    lat: -21.8367295
  },
  {
    lng: -42.1370775,
    lat: -21.8367503
  },
  {
    lng: -42.1370303,
    lat: -21.8367815
  },
  {
    lng: -42.1369712,
    lat: -21.8368288
  },
  {
    lng: -42.1368021,
    lat: -21.8371194
  },
  {
    lng: -42.1365402,
    lat: -21.837776
  },
  {
    lng: -42.1364015,
    lat: -21.8379877
  },
  {
    lng: -42.1363766,
    lat: -21.83801
  },
  {
    lng: -42.1363478,
    lat: -21.8380354
  },
  {
    lng: -42.1363192,
    lat: -21.8380575
  },
  {
    lng: -42.1362854,
    lat: -21.8380759
  },
  {
    lng: -42.1362482,
    lat: -21.8380907
  },
  {
    lng: -42.1362095,
    lat: -21.8381021
  },
  {
    lng: -42.1361683,
    lat: -21.8381235
  },
  {
    lng: -42.1361341,
    lat: -21.8381487
  },
  {
    lng: -42.1361012,
    lat: -21.8381806
  },
  {
    lng: -42.1360686,
    lat: -21.8382092
  },
  {
    lng: -42.1360429,
    lat: -21.8382416
  },
  {
    lng: -42.1360229,
    lat: -21.8382709
  },
  {
    lng: -42.1360011,
    lat: -21.8383001
  },
  {
    lng: -42.1359788,
    lat: -21.838336
  },
  {
    lng: -42.1359603,
    lat: -21.8383687
  },
  {
    lng: -42.1359421,
    lat: -21.8383981
  },
  {
    lng: -42.135911,
    lat: -21.8384302
  },
  {
    lng: -42.1358806,
    lat: -21.8384522
  },
  {
    lng: -42.1358597,
    lat: -21.8384679
  },
  {
    lng: -42.1358234,
    lat: -21.8384964
  },
  {
    lng: -42.135786,
    lat: -21.8385146
  },
  {
    lng: -42.1357509,
    lat: -21.8385262
  },
  {
    lng: -42.1357229,
    lat: -21.8385382
  },
  {
    lng: -42.1356968,
    lat: -21.8385503
  },
  {
    lng: -42.1356632,
    lat: -21.8385654
  },
  {
    lng: -42.1356314,
    lat: -21.8385805
  },
  {
    lng: -42.1355978,
    lat: -21.8385956
  },
  {
    lng: -42.135564,
    lat: -21.838614
  },
  {
    lng: -42.135525,
    lat: -21.8386288
  },
  {
    lng: -42.1354887,
    lat: -21.8386573
  },
  {
    lng: -42.1354542,
    lat: -21.8386858
  },
  {
    lng: -42.1354236,
    lat: -21.8387112
  },
  {
    lng: -42.1353943,
    lat: -21.8387434
  },
  {
    lng: -42.1353648,
    lat: -21.8387789
  },
  {
    lng: -42.1353459,
    lat: -21.8388184
  },
  {
    lng: -42.1353328,
    lat: -21.8388515
  },
  {
    lng: -42.1353195,
    lat: -21.8388879
  },
  {
    lng: -42.1353042,
    lat: -21.8389276
  },
  {
    lng: -42.1352914,
    lat: -21.8389573
  },
  {
    lng: -42.1352725,
    lat: -21.8389968
  },
  {
    lng: -42.1352499,
    lat: -21.8390362
  },
  {
    lng: -42.1352204,
    lat: -21.8390717
  },
  {
    lng: -42.1351916,
    lat: -21.8390972
  },
  {
    lng: -42.1351573,
    lat: -21.8391224
  },
  {
    lng: -42.1351307,
    lat: -21.8391412
  },
  {
    lng: -42.1350932,
    lat: -21.8391595
  },
  {
    lng: -42.1350576,
    lat: -21.8391779
  },
  {
    lng: -42.1350172,
    lat: -21.8391858
  },
  {
    lng: -42.134984,
    lat: -21.8391942
  },
  {
    lng: -42.1344474,
    lat: -21.839223
  },
  {
    lng: -42.1339894,
    lat: -21.8392661
  },
  {
    lng: -42.1334771,
    lat: -21.839303
  },
  {
    lng: -42.1332662,
    lat: -21.8392816
  },
  {
    lng: -42.1330281,
    lat: -21.8392046
  },
  {
    lng: -42.1329412,
    lat: -21.8392
  },
  {
    lng: -42.1328071,
    lat: -21.8392233
  },
  {
    lng: -42.1326947,
    lat: -21.8392748
  },
  {
    lng: -42.1326004,
    lat: -21.8393543
  },
  {
    lng: -42.132527,
    lat: -21.8394451
  },
  {
    lng: -42.1324759,
    lat: -21.8395574
  },
  {
    lng: -42.1324553,
    lat: -21.8396477
  },
  {
    lng: -42.1324562,
    lat: -21.8397425
  },
  {
    lng: -42.1325321,
    lat: -21.8400714
  },
  {
    lng: -42.1326991,
    lat: -21.8404526
  },
  {
    lng: -42.1327181,
    lat: -21.8405213
  },
  {
    lng: -42.1327152,
    lat: -21.8405652
  },
  {
    lng: -42.1326936,
    lat: -21.8407502
  },
  {
    lng: -42.1326848,
    lat: -21.8408006
  },
  {
    lng: -42.1326957,
    lat: -21.8408553
  },
  {
    lng: -42.1327181,
    lat: -21.8408734
  },
  {
    lng: -42.1327391,
    lat: -21.8408847
  },
  {
    lng: -42.1327712,
    lat: -21.8408932
  },
  {
    lng: -42.1328197,
    lat: -21.8409025
  },
  {
    lng: -42.1329573,
    lat: -21.8409368
  },
  {
    lng: -42.1331231,
    lat: -21.841064
  },
  {
    lng: -42.1334809,
    lat: -21.8415535
  },
  {
    lng: -42.1335162,
    lat: -21.8416502
  },
  {
    lng: -42.1335201,
    lat: -21.8417012
  },
  {
    lng: -42.1335149,
    lat: -21.8417517
  },
  {
    lng: -42.1334984,
    lat: -21.8418084
  },
  {
    lng: -42.1334663,
    lat: -21.8418813
  },
  {
    lng: -42.133428,
    lat: -21.8419369
  },
  {
    lng: -42.1333577,
    lat: -21.8420382
  },
  {
    lng: -42.1332601,
    lat: -21.8422195
  },
  {
    lng: -42.1330802,
    lat: -21.8426
  },
  {
    lng: -42.1329842,
    lat: -21.8429205
  },
  {
    lng: -42.1329758,
    lat: -21.8429642
  },
  {
    lng: -42.1329659,
    lat: -21.8430043
  },
  {
    lng: -42.1329559,
    lat: -21.8430445
  },
  {
    lng: -42.1329461,
    lat: -21.8430813
  },
  {
    lng: -42.1329344,
    lat: -21.8431214
  },
  {
    lng: -42.1329228,
    lat: -21.8431581
  },
  {
    lng: -42.132911,
    lat: -21.8431982
  },
  {
    lng: -42.1329029,
    lat: -21.8432385
  },
  {
    lng: -42.1328995,
    lat: -21.8432621
  },
  {
    lng: -42.1328902,
    lat: -21.8432921
  },
  {
    lng: -42.13288,
    lat: -21.8433357
  },
  {
    lng: -42.1328705,
    lat: -21.8433691
  },
  {
    lng: -42.1328623,
    lat: -21.8434094
  },
  {
    lng: -42.1328549,
    lat: -21.8434396
  },
  {
    lng: -42.1328469,
    lat: -21.8434765
  },
  {
    lng: -42.1328372,
    lat: -21.8435133
  },
  {
    lng: -42.1328274,
    lat: -21.8435501
  },
  {
    lng: -42.1328143,
    lat: -21.8435834
  },
  {
    lng: -42.1327991,
    lat: -21.8436199
  },
  {
    lng: -42.1327857,
    lat: -21.8436566
  },
  {
    lng: -42.1325756,
    lat: -21.8440768
  },
  {
    lng: -42.1324181,
    lat: -21.8442555
  },
  {
    lng: -42.1323872,
    lat: -21.8442811
  },
  {
    lng: -42.1323602,
    lat: -21.8443035
  },
  {
    lng: -42.132331,
    lat: -21.8443326
  },
  {
    lng: -42.1322929,
    lat: -21.8443578
  },
  {
    lng: -42.1322623,
    lat: -21.84438
  },
  {
    lng: -42.1322264,
    lat: -21.8443986
  },
  {
    lng: -42.1322022,
    lat: -21.8444075
  },
  {
    lng: -42.1321663,
    lat: -21.8444261
  },
  {
    lng: -42.1321276,
    lat: -21.8444343
  },
  {
    lng: -42.1320831,
    lat: -21.8444456
  },
  {
    lng: -42.1320432,
    lat: -21.8444436
  },
  {
    lng: -42.1320087,
    lat: -21.8444418
  },
  {
    lng: -42.1319779,
    lat: -21.8444403
  },
  {
    lng: -42.131975,
    lat: -21.8444401
  },
  {
    lng: -42.1319307,
    lat: -21.8444379
  },
  {
    lng: -42.1318835,
    lat: -21.8444355
  },
  {
    lng: -42.1313914,
    lat: -21.8444138
  },
  {
    lng: -42.1310403,
    lat: -21.8443517
  },
  {
    lng: -42.1306281,
    lat: -21.844222
  },
  {
    lng: -42.1304249,
    lat: -21.8441857
  },
  {
    lng: -42.1302368,
    lat: -21.8441626
  },
  {
    lng: -42.1301425,
    lat: -21.8441272
  },
  {
    lng: -42.1300885,
    lat: -21.8440632
  },
  {
    lng: -42.1300394,
    lat: -21.8439553
  },
  {
    lng: -42.1300048,
    lat: -21.8437938
  },
  {
    lng: -42.1300109,
    lat: -21.843597
  },
  {
    lng: -42.1300393,
    lat: -21.8433674
  },
  {
    lng: -42.1300355,
    lat: -21.8431022
  },
  {
    lng: -42.1299952,
    lat: -21.842971
  },
  {
    lng: -42.1299583,
    lat: -21.8428978
  },
  {
    lng: -42.1299124,
    lat: -21.8428751
  },
  {
    lng: -42.1298691,
    lat: -21.8428694
  },
  {
    lng: -42.12982,
    lat: -21.8428669
  },
  {
    lng: -42.1297478,
    lat: -21.8428564
  },
  {
    lng: -42.1295563,
    lat: -21.8428023
  },
  {
    lng: -42.1293279,
    lat: -21.8427532
  },
  {
    lng: -42.1285706,
    lat: -21.8426189
  },
  {
    lng: -42.1282989,
    lat: -21.8425335
  },
  {
    lng: -42.128172,
    lat: -21.8424929
  },
  {
    lng: -42.1281154,
    lat: -21.8424934
  },
  {
    lng: -42.1280552,
    lat: -21.8425175
  },
  {
    lng: -42.1280204,
    lat: -21.8425462
  },
  {
    lng: -42.127985,
    lat: -21.8425818
  },
  {
    lng: -42.1279741,
    lat: -21.8426084
  },
  {
    lng: -42.1279715,
    lat: -21.8426457
  },
  {
    lng: -42.1279691,
    lat: -21.8426796
  },
  {
    lng: -42.12798,
    lat: -21.8427345
  },
  {
    lng: -42.1281416,
    lat: -21.8431713
  },
  {
    lng: -42.1282952,
    lat: -21.8434614
  },
  {
    lng: -42.1283086,
    lat: -21.8434791
  },
  {
    lng: -42.1283317,
    lat: -21.8435143
  },
  {
    lng: -42.1283499,
    lat: -21.8435424
  },
  {
    lng: -42.1283715,
    lat: -21.8435742
  },
  {
    lng: -42.1283944,
    lat: -21.8436127
  },
  {
    lng: -42.1284091,
    lat: -21.8436373
  },
  {
    lng: -42.1284302,
    lat: -21.8436758
  },
  {
    lng: -42.1284461,
    lat: -21.8437106
  },
  {
    lng: -42.1284606,
    lat: -21.8437386
  },
  {
    lng: -42.1284726,
    lat: -21.8437766
  },
  {
    lng: -42.1284828,
    lat: -21.8438145
  },
  {
    lng: -42.1284873,
    lat: -21.8438556
  },
  {
    lng: -42.128486,
    lat: -21.8438998
  },
  {
    lng: -42.128483,
    lat: -21.8439438
  },
  {
    lng: -42.1284718,
    lat: -21.8439739
  },
  {
    lng: -42.1284588,
    lat: -21.8440038
  },
  {
    lng: -42.1284326,
    lat: -21.8440399
  },
  {
    lng: -42.1284034,
    lat: -21.8440656
  },
  {
    lng: -42.1283674,
    lat: -21.8440842
  },
  {
    lng: -42.1283262,
    lat: -21.8440991
  },
  {
    lng: -42.1282872,
    lat: -21.8441073
  },
  {
    lng: -42.1282472,
    lat: -21.8441053
  },
  {
    lng: -42.1282071,
    lat: -21.8441033
  },
  {
    lng: -42.1281623,
    lat: -21.8440908
  },
  {
    lng: -42.1281288,
    lat: -21.844072
  },
  {
    lng: -42.1280956,
    lat: -21.8440499
  },
  {
    lng: -42.1280638,
    lat: -21.8440347
  },
  {
    lng: -42.1280376,
    lat: -21.8440163
  },
  {
    lng: -42.1280006,
    lat: -21.8439974
  },
  {
    lng: -42.1279694,
    lat: -21.843972
  },
  {
    lng: -42.1279383,
    lat: -21.8439466
  },
  {
    lng: -42.1279074,
    lat: -21.8439178
  },
  {
    lng: -42.1278799,
    lat: -21.8438926
  },
  {
    lng: -42.127856,
    lat: -21.8438676
  },
  {
    lng: -42.1278324,
    lat: -21.8438391
  },
  {
    lng: -42.1278035,
    lat: -21.843807
  },
  {
    lng: -42.1277726,
    lat: -21.8437782
  },
  {
    lng: -42.1277537,
    lat: -21.8437602
  },
  {
    lng: -42.1277385,
    lat: -21.8437425
  },
  {
    lng: -42.1277178,
    lat: -21.8437244
  },
  {
    lng: -42.1276794,
    lat: -21.8436986
  },
  {
    lng: -42.1276421,
    lat: -21.8436831
  },
  {
    lng: -42.1276061,
    lat: -21.8436744
  },
  {
    lng: -42.1275751,
    lat: -21.8436728
  },
  {
    lng: -42.1275369,
    lat: -21.8436709
  },
  {
    lng: -42.1274968,
    lat: -21.8436688
  },
  {
    lng: -42.1274512,
    lat: -21.8436665
  },
  {
    lng: -42.1274146,
    lat: -21.843668
  },
  {
    lng: -42.1273719,
    lat: -21.8436761
  },
  {
    lng: -42.1273457,
    lat: -21.8436849
  },
  {
    lng: -42.1273172,
    lat: -21.8437005
  },
  {
    lng: -42.1272853,
    lat: -21.8437125
  },
  {
    lng: -42.12725,
    lat: -21.8437209
  },
  {
    lng: -42.1272258,
    lat: -21.8437264
  },
  {
    lng: -42.1272048,
    lat: -21.843739
  },
  {
    lng: -42.1271822,
    lat: -21.843748
  },
  {
    lng: -42.1271389,
    lat: -21.8437662
  },
  {
    lng: -42.1271122,
    lat: -21.8437819
  },
  {
    lng: -42.1270782,
    lat: -21.8437972
  },
  {
    lng: -42.1270399,
    lat: -21.8438224
  },
  {
    lng: -42.1270125,
    lat: -21.8438483
  },
  {
    lng: -42.1269775,
    lat: -21.8438771
  },
  {
    lng: -42.12696,
    lat: -21.8438933
  },
  {
    lng: -42.1269419,
    lat: -21.8439162
  },
  {
    lng: -42.1269241,
    lat: -21.8439357
  },
  {
    lng: -42.1269001,
    lat: -21.8439651
  },
  {
    lng: -42.1268795,
    lat: -21.8439981
  },
  {
    lng: -42.1268573,
    lat: -21.8440276
  },
  {
    lng: -42.126842,
    lat: -21.8440643
  },
  {
    lng: -42.1268227,
    lat: -21.8441042
  },
  {
    lng: -42.1268092,
    lat: -21.8441409
  },
  {
    lng: -42.1267954,
    lat: -21.8441811
  },
  {
    lng: -42.1267803,
    lat: -21.8442144
  },
  {
    lng: -42.1267631,
    lat: -21.844251
  },
  {
    lng: -42.126755,
    lat: -21.844288
  },
  {
    lng: -42.1267522,
    lat: -21.8443287
  },
  {
    lng: -42.1267571,
    lat: -21.844363
  },
  {
    lng: -42.1267641,
    lat: -21.844394
  },
  {
    lng: -42.1267805,
    lat: -21.8444221
  },
  {
    lng: -42.1268091,
    lat: -21.8444576
  },
  {
    lng: -42.1268328,
    lat: -21.8444861
  },
  {
    lng: -42.1268569,
    lat: -21.8445078
  },
  {
    lng: -42.1268844,
    lat: -21.844533
  },
  {
    lng: -42.1269085,
    lat: -21.8445547
  },
  {
    lng: -42.1269329,
    lat: -21.8445729
  },
  {
    lng: -42.1269588,
    lat: -21.8445947
  },
  {
    lng: -42.1269916,
    lat: -21.8446236
  },
  {
    lng: -42.1270232,
    lat: -21.8446422
  },
  {
    lng: -42.1270583,
    lat: -21.8446644
  },
  {
    lng: -42.1270897,
    lat: -21.8446865
  },
  {
    lng: -42.1271174,
    lat: -21.8447083
  },
  {
    lng: -42.1271331,
    lat: -21.8447466
  },
  {
    lng: -42.1271323,
    lat: -21.844784
  },
  {
    lng: -42.1271243,
    lat: -21.8448211
  },
  {
    lng: -42.1270966,
    lat: -21.8448503
  },
  {
    lng: -42.1270619,
    lat: -21.8448758
  },
  {
    lng: -42.1270297,
    lat: -21.8448912
  },
  {
    lng: -42.1269889,
    lat: -21.8448994
  },
  {
    lng: -42.1269517,
    lat: -21.8449077
  },
  {
    lng: -42.126915,
    lat: -21.8449093
  },
  {
    lng: -42.1268819,
    lat: -21.844911
  },
  {
    lng: -42.1268345,
    lat: -21.8449086
  },
  {
    lng: -42.1267967,
    lat: -21.8448999
  },
  {
    lng: -42.1266492,
    lat: -21.844889
  },
  {
    lng: -42.126466,
    lat: -21.8448116
  },
  {
    lng: -42.1262861,
    lat: -21.8446593
  },
  {
    lng: -42.1261301,
    lat: -21.8444811
  },
  {
    lng: -42.1260838,
    lat: -21.8444617
  },
  {
    lng: -42.1260421,
    lat: -21.8444562
  },
  {
    lng: -42.1260074,
    lat: -21.8444544
  },
  {
    lng: -42.1259327,
    lat: -21.8444744
  },
  {
    lng: -42.1258152,
    lat: -21.8445571
  },
  {
    lng: -42.1258097,
    lat: -21.8445637
  },
  {
    lng: -42.125705,
    lat: -21.8446892
  },
  {
    lng: -42.1256582,
    lat: -21.8447823
  },
  {
    lng: -42.1256429,
    lat: -21.8448701
  },
  {
    lng: -42.1256381,
    lat: -21.8449653
  },
  {
    lng: -42.1256572,
    lat: -21.8450584
  },
  {
    lng: -42.1256871,
    lat: -21.8451554
  },
  {
    lng: -42.1257046,
    lat: -21.8452449
  },
  {
    lng: -42.1257063,
    lat: -21.8452996
  },
  {
    lng: -42.1257019,
    lat: -21.8453369
  },
  {
    lng: -42.1256856,
    lat: -21.8453599
  },
  {
    lng: -42.125657,
    lat: -21.8453755
  },
  {
    lng: -42.1256137,
    lat: -21.8453665
  },
  {
    lng: -42.1255335,
    lat: -21.8453591
  },
  {
    lng: -42.1254999,
    lat: -21.8453676
  },
  {
    lng: -42.1254839,
    lat: -21.8453873
  },
  {
    lng: -42.1254553,
    lat: -21.8454029
  },
  {
    lng: -42.1254299,
    lat: -21.8453982
  },
  {
    lng: -42.1254058,
    lat: -21.8453765
  },
  {
    lng: -42.125392,
    lat: -21.8453383
  },
  {
    lng: -42.1253779,
    lat: -21.8453035
  },
  {
    lng: -42.1253627,
    lat: -21.8452857
  },
  {
    lng: -42.1253451,
    lat: -21.8452745
  },
  {
    lng: -42.1253129,
    lat: -21.8452627
  },
  {
    lng: -42.1252542,
    lat: -21.8452631
  },
  {
    lng: -42.1251998,
    lat: -21.8452809
  },
  {
    lng: -42.1251497,
    lat: -21.8453159
  },
  {
    lng: -42.1250658,
    lat: -21.8453867
  },
  {
    lng: -42.1250012,
    lat: -21.8454317
  },
  {
    lng: -42.124979,
    lat: -21.8454472
  },
  {
    lng: -42.1249165,
    lat: -21.845502
  },
  {
    lng: -42.1249015,
    lat: -21.8455593
  },
  {
    lng: -42.1249022,
    lat: -21.8456276
  },
  {
    lng: -42.1249108,
    lat: -21.8457133
  },
  {
    lng: -42.1249481,
    lat: -21.8457835
  },
  {
    lng: -42.1250012,
    lat: -21.845828
  },
  {
    lng: -42.1250087,
    lat: -21.8458343
  },
  {
    lng: -42.1251105,
    lat: -21.8458735
  },
  {
    lng: -42.1252041,
    lat: -21.8458987
  },
  {
    lng: -42.1252691,
    lat: -21.8459668
  },
  {
    lng: -42.125295,
    lat: -21.8460159
  },
  {
    lng: -42.1253143,
    lat: -21.8460544
  },
  {
    lng: -42.1253157,
    lat: -21.8461125
  },
  {
    lng: -42.1252916,
    lat: -21.8461693
  },
  {
    lng: -42.1252227,
    lat: -21.8462614
  },
  {
    lng: -42.1251575,
    lat: -21.8463025
  },
  {
    lng: -42.1250012,
    lat: -21.8463652
  },
  {
    lng: -42.1245513,
    lat: -21.8465455
  },
  {
    lng: -42.1244108,
    lat: -21.846559
  },
  {
    lng: -42.1242675,
    lat: -21.8465348
  },
  {
    lng: -42.1241611,
    lat: -21.8464543
  },
  {
    lng: -42.1240932,
    lat: -21.8463758
  },
  {
    lng: -42.1240585,
    lat: -21.8462955
  },
  {
    lng: -42.1240345,
    lat: -21.8462192
  },
  {
    lng: -42.1240277,
    lat: -21.8460822
  },
  {
    lng: -42.1240354,
    lat: -21.8456865
  },
  {
    lng: -42.1240515,
    lat: -21.845537
  },
  {
    lng: -42.1240536,
    lat: -21.8454552
  },
  {
    lng: -42.1240489,
    lat: -21.8454174
  },
  {
    lng: -42.1240221,
    lat: -21.8453546
  },
  {
    lng: -42.1239856,
    lat: -21.8453255
  },
  {
    lng: -42.1239319,
    lat: -21.8453057
  },
  {
    lng: -42.1238692,
    lat: -21.8453094
  },
  {
    lng: -42.1237719,
    lat: -21.8453352
  },
  {
    lng: -42.123682,
    lat: -21.8454126
  },
  {
    lng: -42.1236026,
    lat: -21.8455213
  },
  {
    lng: -42.1235081,
    lat: -21.8457146
  },
  {
    lng: -42.1233776,
    lat: -21.8460531
  },
  {
    lng: -42.1232649,
    lat: -21.846502
  },
  {
    lng: -42.1231289,
    lat: -21.8469157
  },
  {
    lng: -42.1230768,
    lat: -21.8470806
  },
  {
    lng: -42.1231014,
    lat: -21.8474067
  },
  {
    lng: -42.1230754,
    lat: -21.8475662
  },
  {
    lng: -42.123047,
    lat: -21.8476298
  },
  {
    lng: -42.1229837,
    lat: -21.8476917
  },
  {
    lng: -42.1229417,
    lat: -21.8477136
  },
  {
    lng: -42.1228299,
    lat: -21.8477081
  },
  {
    lng: -42.1227327,
    lat: -21.8477033
  },
  {
    lng: -42.1226661,
    lat: -21.8477342
  },
  {
    lng: -42.1226135,
    lat: -21.8477761
  },
  {
    lng: -42.1225721,
    lat: -21.8478665
  },
  {
    lng: -42.1225539,
    lat: -21.8479409
  },
  {
    lng: -42.1225393,
    lat: -21.8480429
  },
  {
    lng: -42.1225466,
    lat: -21.8481219
  },
  {
    lng: -42.1225958,
    lat: -21.8483092
  },
  {
    lng: -42.1226237,
    lat: -21.8485126
  },
  {
    lng: -42.1226208,
    lat: -21.8487076
  },
  {
    lng: -42.1226147,
    lat: -21.8487416
  },
  {
    lng: -42.1226104,
    lat: -21.848803
  },
  {
    lng: -42.1226058,
    lat: -21.8488678
  },
  {
    lng: -42.1226046,
    lat: -21.8489363
  },
  {
    lng: -42.1226013,
    lat: -21.849008
  },
  {
    lng: -42.122604,
    lat: -21.8490733
  },
  {
    lng: -42.122612,
    lat: -21.8491422
  },
  {
    lng: -42.1226255,
    lat: -21.8492113
  },
  {
    lng: -42.1226411,
    lat: -21.8492772
  },
  {
    lng: -42.1226828,
    lat: -21.8493374
  },
  {
    lng: -42.1227308,
    lat: -21.8493877
  },
  {
    lng: -42.1227866,
    lat: -21.8494315
  },
  {
    lng: -42.122838,
    lat: -21.8494854
  },
  {
    lng: -42.1228765,
    lat: -21.8495387
  },
  {
    lng: -42.1229096,
    lat: -21.8495917
  },
  {
    lng: -42.1229362,
    lat: -21.849658
  },
  {
    lng: -42.1229364,
    lat: -21.8496633
  },
  {
    lng: -42.1229387,
    lat: -21.8497267
  },
  {
    lng: -42.1229317,
    lat: -21.8497721
  },
  {
    lng: -42.1229283,
    lat: -21.8497947
  },
  {
    lng: -42.1229014,
    lat: -21.849862
  },
  {
    lng: -42.1228661,
    lat: -21.8499185
  },
  {
    lng: -42.1228189,
    lat: -21.8499608
  },
  {
    lng: -42.1227649,
    lat: -21.8499959
  },
  {
    lng: -42.1226967,
    lat: -21.8500234
  },
  {
    lng: -42.1226303,
    lat: -21.8500511
  },
  {
    lng: -42.1225575,
    lat: -21.8500647
  },
  {
    lng: -42.1224893,
    lat: -21.8500649
  },
  {
    lng: -42.1224251,
    lat: -21.8500618
  },
  {
    lng: -42.1223608,
    lat: -21.8500587
  },
  {
    lng: -42.1222856,
    lat: -21.8500551
  },
  {
    lng: -42.1222124,
    lat: -21.8500481
  },
  {
    lng: -42.1221378,
    lat: -21.8500343
  },
  {
    lng: -42.1220851,
    lat: -21.8500249
  },
  {
    lng: -42.1220105,
    lat: -21.850011
  },
  {
    lng: -42.1219465,
    lat: -21.8500045
  },
  {
    lng: -42.1218804,
    lat: -21.8500013
  },
  {
    lng: -42.1218253,
    lat: -21.8499987
  },
  {
    lng: -42.1217607,
    lat: -21.849975
  },
  {
    lng: -42.1216931,
    lat: -21.8499409
  },
  {
    lng: -42.121648,
    lat: -21.849901
  },
  {
    lng: -42.1216052,
    lat: -21.8498543
  },
  {
    lng: -42.1215632,
    lat: -21.8497974
  },
  {
    lng: -42.1215251,
    lat: -21.8497373
  },
  {
    lng: -42.1214891,
    lat: -21.8496739
  },
  {
    lng: -42.1214602,
    lat: -21.8496142
  },
  {
    lng: -42.121424,
    lat: -21.8495541
  },
  {
    lng: -42.121376,
    lat: -21.8495038
  },
  {
    lng: -42.1213144,
    lat: -21.8494631
  },
  {
    lng: -42.1212455,
    lat: -21.8494461
  },
  {
    lng: -42.1211684,
    lat: -21.8494423
  },
  {
    lng: -42.121093,
    lat: -21.8494387
  },
  {
    lng: -42.1210275,
    lat: -21.8494527
  },
  {
    lng: -42.1209639,
    lat: -21.8494907
  },
  {
    lng: -42.1209122,
    lat: -21.8495431
  },
  {
    lng: -42.1208763,
    lat: -21.8496065
  },
  {
    lng: -42.1208498,
    lat: -21.849667
  },
  {
    lng: -42.1208326,
    lat: -21.8497279
  },
  {
    lng: -42.1208129,
    lat: -21.8497956
  },
  {
    lng: -42.1208115,
    lat: -21.8498675
  },
  {
    lng: -42.1208197,
    lat: -21.8499331
  },
  {
    lng: -42.120832,
    lat: -21.849992
  },
  {
    lng: -42.1208533,
    lat: -21.8500548
  },
  {
    lng: -42.1208712,
    lat: -21.850114
  },
  {
    lng: -42.1208878,
    lat: -21.8501663
  },
  {
    lng: -42.1208957,
    lat: -21.8502353
  },
  {
    lng: -42.1208853,
    lat: -21.8503034
  },
  {
    lng: -42.1208683,
    lat: -21.8503609
  },
  {
    lng: -42.120831,
    lat: -21.8504175
  },
  {
    lng: -42.1207051,
    lat: -21.8504492
  },
  {
    lng: -42.1205827,
    lat: -21.8504131
  },
  {
    lng: -42.1205384,
    lat: -21.8503869
  },
  {
    lng: -42.1204684,
    lat: -21.8503595
  },
  {
    lng: -42.1204136,
    lat: -21.850326
  },
  {
    lng: -42.1203769,
    lat: -21.8502968
  },
  {
    lng: -42.1203302,
    lat: -21.8502533
  },
  {
    lng: -42.120319,
    lat: -21.8502395
  },
  {
    lng: -42.1202895,
    lat: -21.8502033
  },
  {
    lng: -42.1202495,
    lat: -21.850143
  },
  {
    lng: -42.1202141,
    lat: -21.8500967
  },
  {
    lng: -42.1201842,
    lat: -21.8500507
  },
  {
    lng: -42.1201421,
    lat: -21.8499937
  },
  {
    lng: -42.1201106,
    lat: -21.8499441
  },
  {
    lng: -42.1200849,
    lat: -21.8498914
  },
  {
    lng: -42.12005,
    lat: -21.8498382
  },
  {
    lng: -42.1199713,
    lat: -21.8495976
  },
  {
    lng: -42.1199411,
    lat: -21.8491466
  },
  {
    lng: -42.1199356,
    lat: -21.8490949
  },
  {
    lng: -42.1199332,
    lat: -21.8490262
  },
  {
    lng: -42.1199321,
    lat: -21.8489643
  },
  {
    lng: -42.1199287,
    lat: -21.8489093
  },
  {
    lng: -42.1199156,
    lat: -21.8488606
  },
  {
    lng: -42.1198986,
    lat: -21.8488152
  },
  {
    lng: -42.1198702,
    lat: -21.8487487
  },
  {
    lng: -42.1198525,
    lat: -21.8486861
  },
  {
    lng: -42.1198404,
    lat: -21.8486237
  },
  {
    lng: -42.1198365,
    lat: -21.8485755
  },
  {
    lng: -42.1198396,
    lat: -21.8485071
  },
  {
    lng: -42.1198446,
    lat: -21.8484387
  },
  {
    lng: -42.1198511,
    lat: -21.8483739
  },
  {
    lng: -42.11987,
    lat: -21.8483165
  },
  {
    lng: -42.1198942,
    lat: -21.8482628
  },
  {
    lng: -42.1199213,
    lat: -21.8482196
  },
  {
    lng: -42.1199707,
    lat: -21.848174
  },
  {
    lng: -42.120032,
    lat: -21.8481427
  },
  {
    lng: -42.1200931,
    lat: -21.8481149
  },
  {
    lng: -42.1201562,
    lat: -21.8480837
  },
  {
    lng: -42.1202047,
    lat: -21.8480518
  },
  {
    lng: -42.1202525,
    lat: -21.8480027
  },
  {
    lng: -42.1202787,
    lat: -21.8479457
  },
  {
    lng: -42.1202839,
    lat: -21.847874
  },
  {
    lng: -42.1202589,
    lat: -21.8478111
  },
  {
    lng: -42.1200646,
    lat: -21.8476919
  },
  {
    lng: -42.1195355,
    lat: -21.8476076
  },
  {
    lng: -42.1195103,
    lat: -21.8475995
  },
  {
    lng: -42.1194427,
    lat: -21.8475893
  },
  {
    lng: -42.1193691,
    lat: -21.8475857
  },
  {
    lng: -42.1193084,
    lat: -21.8475827
  },
  {
    lng: -42.119244,
    lat: -21.8475795
  },
  {
    lng: -42.1191833,
    lat: -21.8475765
  },
  {
    lng: -42.1191207,
    lat: -21.8475735
  },
  {
    lng: -42.119049,
    lat: -21.8475699
  },
  {
    lng: -42.1189772,
    lat: -21.8475664
  },
  {
    lng: -42.1189257,
    lat: -21.8475639
  },
  {
    lng: -42.1188557,
    lat: -21.8475604
  },
  {
    lng: -42.1187803,
    lat: -21.8475567
  },
  {
    lng: -42.1187144,
    lat: -21.847574
  },
  {
    lng: -42.118649,
    lat: -21.8476085
  },
  {
    lng: -42.1185922,
    lat: -21.8476538
  },
  {
    lng: -42.118531,
    lat: -21.8476816
  },
  {
    lng: -42.1184835,
    lat: -21.8476999
  },
  {
    lng: -42.1184252,
    lat: -21.8477141
  },
  {
    lng: -42.1183535,
    lat: -21.8477346
  },
  {
    lng: -42.1182944,
    lat: -21.8477592
  },
  {
    lng: -42.1182192,
    lat: -21.8477761
  },
  {
    lng: -42.1181459,
    lat: -21.847793
  },
  {
    lng: -42.1180775,
    lat: -21.8477931
  },
  {
    lng: -42.1180092,
    lat: -21.8477658
  },
  {
    lng: -42.1180023,
    lat: -21.8477573
  },
  {
    lng: -42.1179938,
    lat: -21.847747
  },
  {
    lng: -42.1179651,
    lat: -21.8477121
  },
  {
    lng: -42.1179325,
    lat: -21.8476522
  },
  {
    lng: -42.1179243,
    lat: -21.8475866
  },
  {
    lng: -42.1179312,
    lat: -21.8475183
  },
  {
    lng: -42.1179649,
    lat: -21.8474617
  },
  {
    lng: -42.1179981,
    lat: -21.8474119
  },
  {
    lng: -42.1180368,
    lat: -21.8473623
  },
  {
    lng: -42.1180664,
    lat: -21.8473123
  },
  {
    lng: -42.1181001,
    lat: -21.8472557
  },
  {
    lng: -42.1181108,
    lat: -21.8471842
  },
  {
    lng: -42.1180988,
    lat: -21.8471219
  },
  {
    lng: -42.1180746,
    lat: -21.8470727
  },
  {
    lng: -42.118041,
    lat: -21.8470265
  },
  {
    lng: -42.1180077,
    lat: -21.8469768
  },
  {
    lng: -42.117967,
    lat: -21.8469268
  },
  {
    lng: -42.1179226,
    lat: -21.8468766
  },
  {
    lng: -42.1178859,
    lat: -21.8468473
  },
  {
    lng: -42.1178224,
    lat: -21.8468065
  },
  {
    lng: -42.1177673,
    lat: -21.8467763
  },
  {
    lng: -42.1177101,
    lat: -21.8467495
  },
  {
    lng: -42.1176427,
    lat: -21.8467359
  },
  {
    lng: -42.1175801,
    lat: -21.8467328
  },
  {
    lng: -42.1175138,
    lat: -21.8467295
  },
  {
    lng: -42.1174585,
    lat: -21.8467267
  },
  {
    lng: -42.1174014,
    lat: -21.8467239
  },
  {
    lng: -42.1173319,
    lat: -21.8467136
  },
  {
    lng: -42.1172597,
    lat: -21.8466894
  },
  {
    lng: -42.1172001,
    lat: -21.8466693
  },
  {
    lng: -42.1171434,
    lat: -21.8466356
  },
  {
    lng: -42.1170916,
    lat: -21.8465851
  },
  {
    lng: -42.1170609,
    lat: -21.8465252
  },
  {
    lng: -42.1170396,
    lat: -21.8464625
  },
  {
    lng: -42.1170315,
    lat: -21.8463969
  },
  {
    lng: -42.1170299,
    lat: -21.846342
  },
  {
    lng: -42.1170873,
    lat: -21.8461151
  },
  {
    lng: -42.1171383,
    lat: -21.8460251
  },
  {
    lng: -42.1171689,
    lat: -21.8459855
  },
  {
    lng: -42.1172095,
    lat: -21.8459361
  },
  {
    lng: -42.1172525,
    lat: -21.84588
  },
  {
    lng: -42.1172846,
    lat: -21.8458199
  },
  {
    lng: -42.1173158,
    lat: -21.8457735
  },
  {
    lng: -42.1173497,
    lat: -21.8457135
  },
  {
    lng: -42.117378,
    lat: -21.8456566
  },
  {
    lng: -42.1173917,
    lat: -21.8455956
  },
  {
    lng: -42.1173967,
    lat: -21.8455274
  },
  {
    lng: -42.1173883,
    lat: -21.8454653
  },
  {
    lng: -42.1173578,
    lat: -21.8454021
  },
  {
    lng: -42.1173229,
    lat: -21.8453489
  },
  {
    lng: -42.1172909,
    lat: -21.8453062
  },
  {
    lng: -42.117256,
    lat: -21.8452531
  },
  {
    lng: -42.1172305,
    lat: -21.845197
  },
  {
    lng: -42.1172581,
    lat: -21.8449723
  },
  {
    lng: -42.117323,
    lat: -21.8447941
  },
  {
    lng: -42.1173475,
    lat: -21.8447371
  },
  {
    lng: -42.1173694,
    lat: -21.8446902
  },
  {
    lng: -42.1173925,
    lat: -21.8446264
  },
  {
    lng: -42.1174228,
    lat: -21.8445663
  },
  {
    lng: -42.1174589,
    lat: -21.844503
  },
  {
    lng: -42.1174889,
    lat: -21.8444464
  },
  {
    lng: -42.1175221,
    lat: -21.8443967
  },
  {
    lng: -42.1175558,
    lat: -21.8443402
  },
  {
    lng: -42.1175893,
    lat: -21.8442871
  },
  {
    lng: -42.1176219,
    lat: -21.8442443
  },
  {
    lng: -42.1176591,
    lat: -21.8441914
  },
  {
    lng: -42.1177022,
    lat: -21.844132
  },
  {
    lng: -42.117737,
    lat: -21.8440859
  },
  {
    lng: -42.1179693,
    lat: -21.8437624
  },
  {
    lng: -42.118317,
    lat: -21.8430962
  },
  {
    lng: -42.1183596,
    lat: -21.8430437
  },
  {
    lng: -42.1184022,
    lat: -21.8429912
  },
  {
    lng: -42.1184385,
    lat: -21.8429487
  },
  {
    lng: -42.118478,
    lat: -21.8429131
  },
  {
    lng: -42.1185141,
    lat: -21.8428739
  },
  {
    lng: -42.1185624,
    lat: -21.8428183
  },
  {
    lng: -42.1185998,
    lat: -21.8427861
  },
  {
    lng: -42.118644,
    lat: -21.8427371
  },
  {
    lng: -42.1186855,
    lat: -21.8426982
  },
  {
    lng: -42.1187255,
    lat: -21.8426559
  },
  {
    lng: -42.1187694,
    lat: -21.8426103
  },
  {
    lng: -42.1188138,
    lat: -21.8425579
  },
  {
    lng: -42.1189954,
    lat: -21.8422667
  },
  {
    lng: -42.1190498,
    lat: -21.8421022
  },
  {
    lng: -42.1190614,
    lat: -21.8420686
  },
  {
    lng: -42.1190698,
    lat: -21.8420042
  },
  {
    lng: -42.1190727,
    lat: -21.8419395
  },
  {
    lng: -42.1190666,
    lat: -21.8418709
  },
  {
    lng: -42.1190504,
    lat: -21.8418154
  },
  {
    lng: -42.1190168,
    lat: -21.8417693
  },
  {
    lng: -42.1189673,
    lat: -21.8417155
  },
  {
    lng: -42.1189154,
    lat: -21.8416684
  },
  {
    lng: -42.1188636,
    lat: -21.8416213
  },
  {
    lng: -42.1188062,
    lat: -21.841574
  },
  {
    lng: -42.1187704,
    lat: -21.8415346
  },
  {
    lng: -42.1187148,
    lat: -21.8414873
  },
  {
    lng: -42.1186664,
    lat: -21.8414438
  },
  {
    lng: -42.1186127,
    lat: -21.8413966
  },
  {
    lng: -42.1185663,
    lat: -21.8413498
  },
  {
    lng: -42.1185126,
    lat: -21.8413026
  },
  {
    lng: -42.118466,
    lat: -21.8412593
  },
  {
    lng: -42.1182902,
    lat: -21.8410657
  },
  {
    lng: -42.1180001,
    lat: -21.8406905
  },
  {
    lng: -42.1179835,
    lat: -21.8406657
  },
  {
    lng: -42.1179536,
    lat: -21.8406198
  },
  {
    lng: -42.1179193,
    lat: -21.8405599
  },
  {
    lng: -42.1178883,
    lat: -21.8405037
  },
  {
    lng: -42.1178524,
    lat: -21.8404404
  },
  {
    lng: -42.1178215,
    lat: -21.8403841
  },
  {
    lng: -42.117791,
    lat: -21.8403211
  },
  {
    lng: -42.1177598,
    lat: -21.8402682
  },
  {
    lng: -42.1177239,
    lat: -21.8402049
  },
  {
    lng: -42.1177025,
    lat: -21.8401697
  },
  {
    lng: -42.1176702,
    lat: -21.8401065
  },
  {
    lng: -42.1176391,
    lat: -21.8400537
  },
  {
    lng: -42.11754,
    lat: -21.8398198
  },
  {
    lng: -42.1173707,
    lat: -21.8392615
  },
  {
    lng: -42.1173563,
    lat: -21.8392574
  },
  {
    lng: -42.1173355,
    lat: -21.839188
  },
  {
    lng: -42.117323,
    lat: -21.8391328
  },
  {
    lng: -42.1173162,
    lat: -21.8390744
  },
  {
    lng: -42.1173209,
    lat: -21.8390099
  },
  {
    lng: -42.1173263,
    lat: -21.8389616
  },
  {
    lng: -42.1173265,
    lat: -21.838959
  },
  {
    lng: -42.1173376,
    lat: -21.8389084
  },
  {
    lng: -42.1173555,
    lat: -21.8388412
  },
  {
    lng: -42.1173703,
    lat: -21.8387908
  },
  {
    lng: -42.1173916,
    lat: -21.8387272
  },
  {
    lng: -42.1174252,
    lat: -21.838671
  },
  {
    lng: -42.1174699,
    lat: -21.8386154
  },
  {
    lng: -42.1175264,
    lat: -21.8385741
  },
  {
    lng: -42.1175819,
    lat: -21.8385464
  },
  {
    lng: -42.1176498,
    lat: -21.8385261
  },
  {
    lng: -42.1177198,
    lat: -21.8385265
  },
  {
    lng: -42.1177951,
    lat: -21.8385305
  },
  {
    lng: -42.1178576,
    lat: -21.8385338
  },
  {
    lng: -42.1179329,
    lat: -21.8385379
  },
  {
    lng: -42.117999,
    lat: -21.8385414
  },
  {
    lng: -42.1180713,
    lat: -21.838535
  },
  {
    lng: -42.1181415,
    lat: -21.8385081
  },
  {
    lng: -42.1182082,
    lat: -21.8384776
  },
  {
    lng: -42.1182668,
    lat: -21.838433
  },
  {
    lng: -42.1183161,
    lat: -21.838388
  },
  {
    lng: -42.1183644,
    lat: -21.8383326
  },
  {
    lng: -42.1184038,
    lat: -21.8382734
  },
  {
    lng: -42.1184373,
    lat: -21.8382173
  },
  {
    lng: -42.118457,
    lat: -21.8381502
  },
  {
    lng: -42.1184583,
    lat: -21.8380821
  },
  {
    lng: -42.1184428,
    lat: -21.8380166
  },
  {
    lng: -42.1183991,
    lat: -21.8379597
  },
  {
    lng: -42.1183336,
    lat: -21.8379221
  },
  {
    lng: -42.1182654,
    lat: -21.837898
  },
  {
    lng: -42.1181277,
    lat: -21.8378906
  },
  {
    lng: -42.1180947,
    lat: -21.8378889
  },
  {
    lng: -42.1180268,
    lat: -21.8378852
  },
  {
    lng: -42.1179515,
    lat: -21.8378812
  },
  {
    lng: -42.1178781,
    lat: -21.8378772
  },
  {
    lng: -42.1178125,
    lat: -21.8378669
  },
  {
    lng: -42.1177424,
    lat: -21.8378427
  },
  {
    lng: -42.1176801,
    lat: -21.8378121
  },
  {
    lng: -42.1176183,
    lat: -21.8377747
  },
  {
    lng: -42.1175505,
    lat: -21.8377438
  },
  {
    lng: -42.1174802,
    lat: -21.837723
  },
  {
    lng: -42.1174119,
    lat: -21.8376988
  },
  {
    lng: -42.1173399,
    lat: -21.8376745
  },
  {
    lng: -42.1172753,
    lat: -21.8376506
  },
  {
    lng: -42.1172039,
    lat: -21.8376434
  },
  {
    lng: -42.1171322,
    lat: -21.8376395
  },
  {
    lng: -42.1170698,
    lat: -21.8376361
  },
  {
    lng: -42.1170128,
    lat: -21.8376331
  },
  {
    lng: -42.1169393,
    lat: -21.8376291
  },
  {
    lng: -42.1168721,
    lat: -21.8376153
  },
  {
    lng: -42.1168069,
    lat: -21.8375981
  },
  {
    lng: -42.1167399,
    lat: -21.8375809
  },
  {
    lng: -42.116678,
    lat: -21.8375707
  },
  {
    lng: -42.1166149,
    lat: -21.8375503
  },
  {
    lng: -42.1165502,
    lat: -21.8375264
  },
  {
    lng: -42.1165402,
    lat: -21.837521
  },
  {
    lng: -42.1164863,
    lat: -21.8374922
  },
  {
    lng: -42.1164344,
    lat: -21.8374451
  },
  {
    lng: -42.116381,
    lat: -21.8373945
  },
  {
    lng: -42.116348,
    lat: -21.8373416
  },
  {
    lng: -42.1163288,
    lat: -21.8372758
  },
  {
    lng: -42.1163205,
    lat: -21.837214
  },
  {
    lng: -42.1163295,
    lat: -21.837143
  },
  {
    lng: -42.1163466,
    lat: -21.837086
  },
  {
    lng: -42.1163858,
    lat: -21.8370302
  },
  {
    lng: -42.1165152,
    lat: -21.836952
  },
  {
    lng: -42.1167936,
    lat: -21.8368546
  },
  {
    lng: -42.1168497,
    lat: -21.836844
  },
  {
    lng: -42.1169118,
    lat: -21.836827
  },
  {
    lng: -42.1169768,
    lat: -21.8367964
  },
  {
    lng: -42.1170226,
    lat: -21.8367772
  },
  {
    lng: -42.1170415,
    lat: -21.8367693
  },
  {
    lng: -42.1171006,
    lat: -21.8367419
  },
  {
    lng: -42.1171587,
    lat: -21.8367041
  },
  {
    lng: -42.1172337,
    lat: -21.8366878
  },
  {
    lng: -42.1173108,
    lat: -21.836692
  },
  {
    lng: -42.1174409,
    lat: -21.8367024
  },
  {
    lng: -42.1177258,
    lat: -21.8368132
  },
  {
    lng: -42.1178823,
    lat: -21.8369409
  },
  {
    lng: -42.1180965,
    lat: -21.8371601
  },
  {
    lng: -42.1182465,
    lat: -21.83725
  },
  {
    lng: -42.1183735,
    lat: -21.8372772
  },
  {
    lng: -42.1184405,
    lat: -21.8372673
  },
  {
    lng: -42.1185103,
    lat: -21.83722
  },
  {
    lng: -42.1185387,
    lat: -21.837184
  },
  {
    lng: -42.1185631,
    lat: -21.8371275
  },
  {
    lng: -42.118584,
    lat: -21.8370674
  },
  {
    lng: -42.1185947,
    lat: -21.8369965
  },
  {
    lng: -42.1185971,
    lat: -21.8369387
  },
  {
    lng: -42.1185718,
    lat: -21.8368319
  },
  {
    lng: -42.1184788,
    lat: -21.8366431
  },
  {
    lng: -42.1182132,
    lat: -21.8360811
  },
  {
    lng: -42.1182043,
    lat: -21.8360262
  },
  {
    lng: -42.1182073,
    lat: -21.8359855
  },
  {
    lng: -42.1182153,
    lat: -21.8359519
  },
  {
    lng: -42.1182363,
    lat: -21.8359157
  },
  {
    lng: -42.1182836,
    lat: -21.835874
  },
  {
    lng: -42.1183567,
    lat: -21.8358814
  },
  {
    lng: -42.1185365,
    lat: -21.8359899
  },
  {
    lng: -42.1187616,
    lat: -21.8360838
  },
  {
    lng: -42.1188895,
    lat: -21.8360976
  },
  {
    lng: -42.1189912,
    lat: -21.8360657
  },
  {
    lng: -42.1191558,
    lat: -21.8360033
  },
  {
    lng: -42.1192758,
    lat: -21.8359215
  },
  {
    lng: -42.1193443,
    lat: -21.8358912
  },
  {
    lng: -42.1194331,
    lat: -21.8359097
  },
  {
    lng: -42.1195205,
    lat: -21.8359722
  },
  {
    lng: -42.1195863,
    lat: -21.836054
  },
  {
    lng: -42.1196576,
    lat: -21.8361599
  },
  {
    lng: -42.1197491,
    lat: -21.8362431
  },
  {
    lng: -42.1198354,
    lat: -21.8362954
  },
  {
    lng: -42.1199147,
    lat: -21.8363167
  },
  {
    lng: -42.1199941,
    lat: -21.8363381
  },
  {
    lng: -42.1201057,
    lat: -21.8364223
  },
  {
    lng: -42.120276,
    lat: -21.8365064
  },
  {
    lng: -42.1203612,
    lat: -21.8365303
  },
  {
    lng: -42.1203661,
    lat: -21.8365317
  },
  {
    lng: -42.1204518,
    lat: -21.836516
  },
  {
    lng: -42.1204717,
    lat: -21.8365067
  },
  {
    lng: -42.1205621,
    lat: -21.8364642
  },
  {
    lng: -42.1206898,
    lat: -21.836376
  },
  {
    lng: -42.1208226,
    lat: -21.8362167
  },
  {
    lng: -42.1212759,
    lat: -21.8357115
  },
  {
    lng: -42.1213203,
    lat: -21.8356616
  },
  {
    lng: -42.1214429,
    lat: -21.8355239
  },
  {
    lng: -42.1216211,
    lat: -21.8352655
  },
  {
    lng: -42.1218672,
    lat: -21.8348548
  },
  {
    lng: -42.1222447,
    lat: -21.8342448
  },
  {
    lng: -42.1224766,
    lat: -21.8336949
  },
  {
    lng: -42.1224912,
    lat: -21.8336449
  },
  {
    lng: -42.1224955,
    lat: -21.8335841
  },
  {
    lng: -42.122496,
    lat: -21.8335265
  },
  {
    lng: -42.1224903,
    lat: -21.8334516
  },
  {
    lng: -42.122478,
    lat: -21.8333933
  },
  {
    lng: -42.1224411,
    lat: -21.8333201
  },
  {
    lng: -42.1223585,
    lat: -21.8331935
  },
  {
    lng: -42.1220995,
    lat: -21.8329215
  },
  {
    lng: -42.122013,
    lat: -21.8328489
  },
  {
    lng: -42.1219749,
    lat: -21.8327925
  },
  {
    lng: -42.1219525,
    lat: -21.8327472
  },
  {
    lng: -42.1219358,
    lat: -21.8326988
  },
  {
    lng: -42.1219241,
    lat: -21.8326575
  },
  {
    lng: -42.1219197,
    lat: -21.8326166
  },
  {
    lng: -42.1219338,
    lat: -21.8325226
  },
  {
    lng: -42.1219803,
    lat: -21.8324371
  },
  {
    lng: -42.1220618,
    lat: -21.832374
  },
  {
    lng: -42.1221855,
    lat: -21.8323606
  },
  {
    lng: -42.1223616,
    lat: -21.8323841
  },
  {
    lng: -42.122555,
    lat: -21.8324458
  },
  {
    lng: -42.1226567,
    lat: -21.8324583
  },
  {
    lng: -42.1227748,
    lat: -21.832421
  },
  {
    lng: -42.1228552,
    lat: -21.8323713
  },
  {
    lng: -42.1229309,
    lat: -21.8323113
  },
  {
    lng: -42.1229635,
    lat: -21.8322657
  },
  {
    lng: -42.1230291,
    lat: -21.83209
  },
  {
    lng: -42.1230364,
    lat: -21.8319619
  },
  {
    lng: -42.1230285,
    lat: -21.8318937
  },
  {
    lng: -42.123015,
    lat: -21.8318524
  },
  {
    lng: -42.1228801,
    lat: -21.8317161
  },
  {
    lng: -42.1225394,
    lat: -21.8313855
  },
  {
    lng: -42.1224742,
    lat: -21.8313243
  },
  {
    lng: -42.122445,
    lat: -21.831194
  },
  {
    lng: -42.1224451,
    lat: -21.831167
  },
  {
    lng: -42.1224513,
    lat: -21.8310557
  },
  {
    lng: -42.1224893,
    lat: -21.8309598
  },
  {
    lng: -42.1226126,
    lat: -21.8307977
  },
  {
    lng: -42.1227115,
    lat: -21.8307117
  },
  {
    lng: -42.1229382,
    lat: -21.830613
  },
  {
    lng: -42.1231754,
    lat: -21.8304948
  },
  {
    lng: -42.1232158,
    lat: -21.8304666
  },
  {
    lng: -42.1232364,
    lat: -21.830434
  },
  {
    lng: -42.1232516,
    lat: -21.8304011
  },
  {
    lng: -42.1232643,
    lat: -21.8303511
  },
  {
    lng: -42.123264,
    lat: -21.8303038
  },
  {
    lng: -42.1232437,
    lat: -21.8302046
  },
  {
    lng: -42.1232077,
    lat: -21.8301451
  },
  {
    lng: -42.1231524,
    lat: -21.830125
  },
  {
    lng: -42.1230886,
    lat: -21.8301213
  },
  {
    lng: -42.1229057,
    lat: -21.8301717
  },
  {
    lng: -42.1228573,
    lat: -21.8301824
  },
  {
    lng: -42.1228273,
    lat: -21.8301165
  },
  {
    lng: -42.1228467,
    lat: -21.83005
  },
  {
    lng: -42.1228712,
    lat: -21.8300142
  },
  {
    lng: -42.1229351,
    lat: -21.8299401
  },
  {
    lng: -42.1229744,
    lat: -21.8299019
  },
  {
    lng: -42.1230443,
    lat: -21.8298451
  },
  {
    lng: -42.1231543,
    lat: -21.8297906
  },
  {
    lng: -42.1234711,
    lat: -21.8297463
  },
  {
    lng: -42.1241304,
    lat: -21.8297303
  },
  {
    lng: -42.1245673,
    lat: -21.8297015
  },
  {
    lng: -42.1248016,
    lat: -21.8296947
  },
  {
    lng: -42.1249753,
    lat: -21.8297242
  },
  {
    lng: -42.1250016,
    lat: -21.8297399
  },
  {
    lng: -42.1250874,
    lat: -21.8297914
  },
  {
    lng: -42.1253602,
    lat: -21.8299025
  },
  {
    lng: -42.1256667,
    lat: -21.8300079
  },
  {
    lng: -42.1258709,
    lat: -21.8301141
  },
  {
    lng: -42.1260215,
    lat: -21.8302038
  },
  {
    lng: -42.1262072,
    lat: -21.8302617
  },
  {
    lng: -42.1263208,
    lat: -21.8302547
  },
  {
    lng: -42.1266603,
    lat: -21.830146
  },
  {
    lng: -42.1268099,
    lat: -21.83004
  },
  {
    lng: -42.1269497,
    lat: -21.8298659
  },
  {
    lng: -42.127039,
    lat: -21.8296822
  },
  {
    lng: -42.1270748,
    lat: -21.8295359
  },
  {
    lng: -42.1270503,
    lat: -21.829312
  },
  {
    lng: -42.1270159,
    lat: -21.8290741
  },
  {
    lng: -42.1269613,
    lat: -21.8289816
  },
  {
    lng: -42.126902,
    lat: -21.8289175
  },
  {
    lng: -42.1268428,
    lat: -21.8289039
  },
  {
    lng: -42.1267671,
    lat: -21.8288928
  },
  {
    lng: -42.1267173,
    lat: -21.8288494
  },
  {
    lng: -42.1266937,
    lat: -21.8288211
  },
  {
    lng: -42.1266779,
    lat: -21.8287865
  },
  {
    lng: -42.1266706,
    lat: -21.8287355
  },
  {
    lng: -42.1266698,
    lat: -21.828695
  },
  {
    lng: -42.1266721,
    lat: -21.8286614
  },
  {
    lng: -42.1266786,
    lat: -21.8286214
  },
  {
    lng: -42.1266889,
    lat: -21.8285782
  },
  {
    lng: -42.1267146,
    lat: -21.8285224
  },
  {
    lng: -42.126759,
    lat: -21.828461
  },
  {
    lng: -42.1267956,
    lat: -21.8284328
  },
  {
    lng: -42.1268574,
    lat: -21.8284094
  },
  {
    lng: -42.1269086,
    lat: -21.8284057
  },
  {
    lng: -42.1270429,
    lat: -21.8284135
  },
  {
    lng: -42.1271701,
    lat: -21.8284176
  },
  {
    lng: -42.1272227,
    lat: -21.8284206
  },
  {
    lng: -42.1272402,
    lat: -21.8284048
  },
  {
    lng: -42.12725,
    lat: -21.8283953
  },
  {
    lng: -42.1272592,
    lat: -21.8283419
  },
  {
    lng: -42.1272523,
    lat: -21.8282843
  },
  {
    lng: -42.1271634,
    lat: -21.8278615
  },
  {
    lng: -42.1271432,
    lat: -21.8275775
  },
  {
    lng: -42.1270677,
    lat: -21.8272769
  },
  {
    lng: -42.1270565,
    lat: -21.8269161
  },
  {
    lng: -42.1270109,
    lat: -21.8264996
  },
  {
    lng: -42.1269658,
    lat: -21.8262345
  },
  {
    lng: -42.1269048,
    lat: -21.8261166
  },
  {
    lng: -42.1268511,
    lat: -21.8260259
  },
  {
    lng: -42.1267532,
    lat: -21.8258385
  },
  {
    lng: -42.1266222,
    lat: -21.8256559
  },
  {
    lng: -42.1264916,
    lat: -21.8254665
  },
  {
    lng: -42.1263669,
    lat: -21.8252977
  },
  {
    lng: -42.1262421,
    lat: -21.8251826
  },
  {
    lng: -42.1260681,
    lat: -21.8251184
  },
  {
    lng: -42.1259038,
    lat: -21.8250985
  },
  {
    lng: -42.1257482,
    lat: -21.8251094
  },
  {
    lng: -42.1255971,
    lat: -21.8251339
  },
  {
    lng: -42.1255365,
    lat: -21.8251724
  },
  {
    lng: -42.1255081,
    lat: -21.8251875
  },
  {
    lng: -42.1254768,
    lat: -21.8252428
  },
  {
    lng: -42.1254462,
    lat: -21.825315
  },
  {
    lng: -42.1254402,
    lat: -21.8253752
  },
  {
    lng: -42.1254342,
    lat: -21.825459
  },
  {
    lng: -42.1254279,
    lat: -21.8255999
  },
  {
    lng: -42.12542,
    lat: -21.8256869
  },
  {
    lng: -42.1254017,
    lat: -21.8257128
  },
  {
    lng: -42.1253431,
    lat: -21.8257429
  },
  {
    lng: -42.1252214,
    lat: -21.8257357
  },
  {
    lng: -42.1251072,
    lat: -21.825675
  },
  {
    lng: -42.1250123,
    lat: -21.8255987
  },
  {
    lng: -42.1250016,
    lat: -21.8255776
  },
  {
    lng: -42.1249419,
    lat: -21.8254598
  },
  {
    lng: -42.1248988,
    lat: -21.8252957
  },
  {
    lng: -42.1248897,
    lat: -21.8251673
  },
  {
    lng: -42.1249127,
    lat: -21.8249702
  },
  {
    lng: -42.1249615,
    lat: -21.8248217
  },
  {
    lng: -42.1250016,
    lat: -21.8247536
  },
  {
    lng: -42.1250361,
    lat: -21.824695
  },
  {
    lng: -42.1251968,
    lat: -21.8245365
  },
  {
    lng: -42.1253897,
    lat: -21.8244254
  },
  {
    lng: -42.1254623,
    lat: -21.8244298
  },
  {
    lng: -42.1255003,
    lat: -21.8244589
  },
  {
    lng: -42.125573,
    lat: -21.8245642
  },
  {
    lng: -42.1256658,
    lat: -21.8246437
  },
  {
    lng: -42.1257265,
    lat: -21.8246608
  },
  {
    lng: -42.1257737,
    lat: -21.8246637
  },
  {
    lng: -42.1258068,
    lat: -21.8246589
  },
  {
    lng: -42.1258292,
    lat: -21.8245998
  },
  {
    lng: -42.1258298,
    lat: -21.8245393
  },
  {
    lng: -42.1257953,
    lat: -21.8244095
  },
  {
    lng: -42.1257624,
    lat: -21.8243067
  },
  {
    lng: -42.1256771,
    lat: -21.8241738
  },
  {
    lng: -42.1254147,
    lat: -21.823916
  },
  {
    lng: -42.1251956,
    lat: -21.8237683
  },
  {
    lng: -42.1250854,
    lat: -21.823728
  },
  {
    lng: -42.1250016,
    lat: -21.8237123
  },
  {
    lng: -42.1249272,
    lat: -21.8236983
  },
  {
    lng: -42.1248057,
    lat: -21.8236758
  },
  {
    lng: -42.1246687,
    lat: -21.8235767
  },
  {
    lng: -42.1245275,
    lat: -21.8234606
  },
  {
    lng: -42.1244287,
    lat: -21.8234143
  },
  {
    lng: -42.1242125,
    lat: -21.8233777
  },
  {
    lng: -42.12377,
    lat: -21.8232903
  },
  {
    lng: -42.1237523,
    lat: -21.8232825
  },
  {
    lng: -42.1236876,
    lat: -21.8232685
  },
  {
    lng: -42.1236224,
    lat: -21.8232612
  },
  {
    lng: -42.1235524,
    lat: -21.8232704
  },
  {
    lng: -42.1234817,
    lat: -21.8232896
  },
  {
    lng: -42.1234207,
    lat: -21.8233263
  },
  {
    lng: -42.1233612,
    lat: -21.8233664
  },
  {
    lng: -42.1233049,
    lat: -21.8234134
  },
  {
    lng: -42.1232387,
    lat: -21.8234464
  },
  {
    lng: -42.1231711,
    lat: -21.8234726
  },
  {
    lng: -42.1230984,
    lat: -21.8234682
  },
  {
    lng: -42.123033,
    lat: -21.8234373
  },
  {
    lng: -42.122986,
    lat: -21.8233806
  },
  {
    lng: -42.1229514,
    lat: -21.8233281
  },
  {
    lng: -42.1229116,
    lat: -21.8232719
  },
  {
    lng: -42.1228695,
    lat: -21.8232222
  },
  {
    lng: -42.122814,
    lat: -21.8231818
  },
  {
    lng: -42.1227634,
    lat: -21.8231485
  },
  {
    lng: -42.1226942,
    lat: -21.8231207
  },
  {
    lng: -42.1226237,
    lat: -21.8231097
  },
  {
    lng: -42.1225583,
    lat: -21.8231058
  },
  {
    lng: -42.1224964,
    lat: -21.823102
  },
  {
    lng: -42.1221991,
    lat: -21.823121
  },
  {
    lng: -42.1219085,
    lat: -21.8231975
  },
  {
    lng: -42.1218727,
    lat: -21.8232122
  },
  {
    lng: -42.1217998,
    lat: -21.8232347
  },
  {
    lng: -42.1217404,
    lat: -21.8232479
  },
  {
    lng: -42.1216662,
    lat: -21.8232367
  },
  {
    lng: -42.1215992,
    lat: -21.8232023
  },
  {
    lng: -42.1215527,
    lat: -21.8231625
  },
  {
    lng: -42.121509,
    lat: -21.8231093
  },
  {
    lng: -42.1214744,
    lat: -21.8230568
  },
  {
    lng: -42.1214424,
    lat: -21.8229942
  },
  {
    lng: -42.1214057,
    lat: -21.8229449
  },
  {
    lng: -42.1213688,
    lat: -21.8228989
  },
  {
    lng: -42.1213174,
    lat: -21.822852
  },
  {
    lng: -42.1212672,
    lat: -21.822812
  },
  {
    lng: -42.1212176,
    lat: -21.8227651
  },
  {
    lng: -42.1211724,
    lat: -21.8227322
  },
  {
    lng: -42.1211111,
    lat: -21.8226948
  },
  {
    lng: -42.1210652,
    lat: -21.8226667
  },
  {
    lng: -42.1210498,
    lat: -21.8226574
  },
  {
    lng: -42.1210006,
    lat: -21.8226308
  },
  {
    lng: -42.1209287,
    lat: -21.822613
  },
  {
    lng: -42.1208574,
    lat: -21.822612
  },
  {
    lng: -42.1207945,
    lat: -21.8226216
  },
  {
    lng: -42.1207186,
    lat: -21.8226338
  },
  {
    lng: -42.1206439,
    lat: -21.8226293
  },
  {
    lng: -42.1205674,
    lat: -21.8226246
  },
  {
    lng: -42.1205078,
    lat: -21.8226143
  },
  {
    lng: -42.1204398,
    lat: -21.8225933
  },
  {
    lng: -42.120378,
    lat: -21.8225626
  },
  {
    lng: -42.120317,
    lat: -21.8225454
  },
  {
    lng: -42.1202478,
    lat: -21.8225412
  },
  {
    lng: -42.1201741,
    lat: -21.8225468
  },
  {
    lng: -42.1201092,
    lat: -21.8225832
  },
  {
    lng: -42.1200754,
    lat: -21.8226452
  },
  {
    lng: -42.1200594,
    lat: -21.8227149
  },
  {
    lng: -42.120047,
    lat: -21.8227848
  },
  {
    lng: -42.1200309,
    lat: -21.8228546
  },
  {
    lng: -42.1200155,
    lat: -21.8229143
  },
  {
    lng: -42.1199997,
    lat: -21.8229807
  },
  {
    lng: -42.1199883,
    lat: -21.8230372
  },
  {
    lng: -42.119975,
    lat: -21.8230937
  },
  {
    lng: -42.1199519,
    lat: -21.8231596
  },
  {
    lng: -42.119911,
    lat: -21.8232178
  },
  {
    lng: -42.1197693,
    lat: -21.8233776
  },
  {
    lng: -42.1197204,
    lat: -21.823496
  },
  {
    lng: -42.119715,
    lat: -21.8235192
  },
  {
    lng: -42.1197099,
    lat: -21.8235897
  },
  {
    lng: -42.1197084,
    lat: -21.8236604
  },
  {
    lng: -42.1197183,
    lat: -21.823725
  },
  {
    lng: -42.1197355,
    lat: -21.8237901
  },
  {
    lng: -42.1197517,
    lat: -21.823845
  },
  {
    lng: -42.1197712,
    lat: -21.8239035
  },
  {
    lng: -42.1197919,
    lat: -21.8239721
  },
  {
    lng: -42.1198075,
    lat: -21.8240337
  },
  {
    lng: -42.1198211,
    lat: -21.8240986
  },
  {
    lng: -42.1198269,
    lat: -21.8241697
  },
  {
    lng: -42.1198332,
    lat: -21.8242342
  },
  {
    lng: -42.1198393,
    lat: -21.824302
  },
  {
    lng: -42.1198429,
    lat: -21.8243528
  },
  {
    lng: -42.1198492,
    lat: -21.8244172
  },
  {
    lng: -42.1198565,
    lat: -21.8244682
  },
  {
    lng: -42.1198617,
    lat: -21.8245225
  },
  {
    lng: -42.1198732,
    lat: -21.8245906
  },
  {
    lng: -42.1198774,
    lat: -21.8246583
  },
  {
    lng: -42.1198748,
    lat: -21.8247188
  },
  {
    lng: -42.1198699,
    lat: -21.824786
  },
  {
    lng: -42.119865,
    lat: -21.8248532
  },
  {
    lng: -42.1198604,
    lat: -21.824917
  },
  {
    lng: -42.1198498,
    lat: -21.8249872
  },
  {
    lng: -42.119836,
    lat: -21.8250504
  },
  {
    lng: -42.1198149,
    lat: -21.8251133
  },
  {
    lng: -42.1197758,
    lat: -21.8251717
  },
  {
    lng: -42.1197231,
    lat: -21.8252157
  },
  {
    lng: -42.1196459,
    lat: -21.8253191
  },
  {
    lng: -42.1196168,
    lat: -21.8253916
  },
  {
    lng: -42.1196161,
    lat: -21.8254017
  },
  {
    lng: -42.1196059,
    lat: -21.8254652
  },
  {
    lng: -42.1196008,
    lat: -21.8255358
  },
  {
    lng: -42.1196016,
    lat: -21.8255999
  },
  {
    lng: -42.1196095,
    lat: -21.8256679
  },
  {
    lng: -42.1196194,
    lat: -21.8257326
  },
  {
    lng: -42.119633,
    lat: -21.8257976
  },
  {
    lng: -42.1196708,
    lat: -21.8258572
  },
  {
    lng: -42.1196984,
    lat: -21.8259061
  },
  {
    lng: -42.1197258,
    lat: -21.8259584
  },
  {
    lng: -42.1197464,
    lat: -21.8260271
  },
  {
    lng: -42.1197553,
    lat: -21.8260817
  },
  {
    lng: -42.1197582,
    lat: -21.8261426
  },
  {
    lng: -42.1197535,
    lat: -21.8262065
  },
  {
    lng: -42.119747,
    lat: -21.8262702
  },
  {
    lng: -42.119733,
    lat: -21.8263369
  },
  {
    lng: -42.1197137,
    lat: -21.8264
  },
  {
    lng: -42.1196851,
    lat: -21.8264658
  },
  {
    lng: -42.1195697,
    lat: -21.826665
  },
  {
    lng: -42.1194913,
    lat: -21.8268715
  },
  {
    lng: -42.1194826,
    lat: -21.8268913
  },
  {
    lng: -42.1194557,
    lat: -21.8269573
  },
  {
    lng: -42.1194148,
    lat: -21.8270157
  },
  {
    lng: -42.1193634,
    lat: -21.8270667
  },
  {
    lng: -42.1193129,
    lat: -21.8271043
  },
  {
    lng: -42.1192515,
    lat: -21.8271413
  },
  {
    lng: -42.1191832,
    lat: -21.827171
  },
  {
    lng: -42.1191155,
    lat: -21.8271941
  },
  {
    lng: -42.1190446,
    lat: -21.8272102
  },
  {
    lng: -42.1189929,
    lat: -21.8272139
  },
  {
    lng: -42.1189251,
    lat: -21.827237
  },
  {
    lng: -42.1188484,
    lat: -21.8272325
  },
  {
    lng: -42.1187935,
    lat: -21.8272293
  },
  {
    lng: -42.1187241,
    lat: -21.8272252
  },
  {
    lng: -42.1186656,
    lat: -21.8272218
  },
  {
    lng: -42.1186012,
    lat: -21.8271977
  },
  {
    lng: -42.1185332,
    lat: -21.8271734
  },
  {
    lng: -42.1184789,
    lat: -21.8271635
  },
  {
    lng: -42.1184062,
    lat: -21.8271524
  },
  {
    lng: -42.1183367,
    lat: -21.8271483
  },
  {
    lng: -42.1182709,
    lat: -21.8271445
  },
  {
    lng: -42.1182014,
    lat: -21.8271404
  },
  {
    lng: -42.1181287,
    lat: -21.8271294
  },
  {
    lng: -42.1180926,
    lat: -21.8271201
  },
  {
    lng: -42.1180602,
    lat: -21.8271118
  },
  {
    lng: -42.118,
    lat: -21.8270812
  },
  {
    lng: -42.1178533,
    lat: -21.8269779
  },
  {
    lng: -42.1176778,
    lat: -21.8267967
  },
  {
    lng: -42.1176699,
    lat: -21.8267796
  },
  {
    lng: -42.1176487,
    lat: -21.8267184
  },
  {
    lng: -42.1176473,
    lat: -21.826655
  },
  {
    lng: -42.117664,
    lat: -21.8265893
  },
  {
    lng: -42.1177054,
    lat: -21.8265285
  },
  {
    lng: -42.117748,
    lat: -21.8264777
  },
  {
    lng: -42.1177904,
    lat: -21.8264302
  },
  {
    lng: -42.1178366,
    lat: -21.8263797
  },
  {
    lng: -42.117881,
    lat: -21.826329
  },
  {
    lng: -42.1179229,
    lat: -21.8262882
  },
  {
    lng: -42.1179655,
    lat: -21.8262374
  },
  {
    lng: -42.1180121,
    lat: -21.8261802
  },
  {
    lng: -42.1180598,
    lat: -21.8261331
  },
  {
    lng: -42.1181053,
    lat: -21.8260925
  },
  {
    lng: -42.1181483,
    lat: -21.8260351
  },
  {
    lng: -42.1182129,
    lat: -21.8258892
  },
  {
    lng: -42.1182828,
    lat: -21.8251481
  },
  {
    lng: -42.118284,
    lat: -21.8251282
  },
  {
    lng: -42.1182848,
    lat: -21.8250584
  },
  {
    lng: -42.1182839,
    lat: -21.8249886
  },
  {
    lng: -42.1182754,
    lat: -21.8249249
  },
  {
    lng: -42.1182544,
    lat: -21.8248605
  },
  {
    lng: -42.1182243,
    lat: -21.8247988
  },
  {
    lng: -42.118192,
    lat: -21.8247437
  },
  {
    lng: -42.1181525,
    lat: -21.8246882
  },
  {
    lng: -42.1181129,
    lat: -21.824636
  },
  {
    lng: -42.1180584,
    lat: -21.8245929
  },
  {
    lng: -42.1179945,
    lat: -21.8245558
  },
  {
    lng: -42.1179197,
    lat: -21.8245514
  },
  {
    lng: -42.1178431,
    lat: -21.8245468
  },
  {
    lng: -42.1177723,
    lat: -21.8245626
  },
  {
    lng: -42.1176996,
    lat: -21.8245815
  },
  {
    lng: -42.1176497,
    lat: -21.8246351
  },
  {
    lng: -42.1176506,
    lat: -21.824705
  },
  {
    lng: -42.1176589,
    lat: -21.8247719
  },
  {
    lng: -42.1176763,
    lat: -21.8248362
  },
  {
    lng: -42.1176906,
    lat: -21.8248935
  },
  {
    lng: -42.1176643,
    lat: -21.8249984
  },
  {
    lng: -42.1176316,
    lat: -21.8250651
  },
  {
    lng: -42.1176083,
    lat: -21.8250936
  },
  {
    lng: -42.1175551,
    lat: -21.8251437
  },
  {
    lng: -42.1174984,
    lat: -21.8251902
  },
  {
    lng: -42.1174317,
    lat: -21.8252262
  },
  {
    lng: -42.1173652,
    lat: -21.8252589
  },
  {
    lng: -42.1173193,
    lat: -21.8252761
  },
  {
    lng: -42.1172514,
    lat: -21.8253021
  },
  {
    lng: -42.1171878,
    lat: -21.8253183
  },
  {
    lng: -42.1171214,
    lat: -21.8253476
  },
  {
    lng: -42.1170565,
    lat: -21.8253837
  },
  {
    lng: -42.1170004,
    lat: -21.8254203
  },
  {
    lng: -42.1169404,
    lat: -21.8254634
  },
  {
    lng: -42.1168877,
    lat: -21.8255035
  },
  {
    lng: -42.1168258,
    lat: -21.8255465
  },
  {
    lng: -42.1167686,
    lat: -21.8255731
  },
  {
    lng: -42.1166973,
    lat: -21.8255955
  },
  {
    lng: -42.1166343,
    lat: -21.8256284
  },
  {
    lng: -42.1165773,
    lat: -21.8256517
  },
  {
    lng: -42.1165037,
    lat: -21.825654
  },
  {
    lng: -42.1164292,
    lat: -21.8256429
  },
  {
    lng: -42.1163405,
    lat: -21.8256011
  },
  {
    lng: -42.1162099,
    lat: -21.8255134
  },
  {
    lng: -42.1161737,
    lat: -21.8254913
  },
  {
    lng: -42.1161194,
    lat: -21.8254715
  },
  {
    lng: -42.1160508,
    lat: -21.8254508
  },
  {
    lng: -42.1159807,
    lat: -21.8254266
  },
  {
    lng: -42.1159086,
    lat: -21.8254057
  },
  {
    lng: -42.1158347,
    lat: -21.8253847
  },
  {
    lng: -42.1157688,
    lat: -21.8253775
  },
  {
    lng: -42.115701,
    lat: -21.8253735
  },
  {
    lng: -42.1156277,
    lat: -21.8253691
  },
  {
    lng: -42.1155563,
    lat: -21.8253649
  },
  {
    lng: -42.1154847,
    lat: -21.825364
  },
  {
    lng: -42.1154147,
    lat: -21.8253932
  },
  {
    lng: -42.1153222,
    lat: -21.8254643
  },
  {
    lng: -42.1153129,
    lat: -21.8254704
  },
  {
    lng: -42.1152413,
    lat: -21.8254962
  },
  {
    lng: -42.1151775,
    lat: -21.8255124
  },
  {
    lng: -42.115106,
    lat: -21.8255082
  },
  {
    lng: -42.1150321,
    lat: -21.8254871
  },
  {
    lng: -42.1149811,
    lat: -21.8254442
  },
  {
    lng: -42.114951,
    lat: -21.8253824
  },
  {
    lng: -42.1149388,
    lat: -21.8253217
  },
  {
    lng: -42.1149397,
    lat: -21.8252519
  },
  {
    lng: -42.1149313,
    lat: -21.8251881
  },
  {
    lng: -42.1149065,
    lat: -21.8251267
  },
  {
    lng: -42.1148562,
    lat: -21.8250737
  },
  {
    lng: -42.1147914,
    lat: -21.8250499
  },
  {
    lng: -42.1147146,
    lat: -21.8250454
  },
  {
    lng: -42.1146425,
    lat: -21.8250511
  },
  {
    lng: -42.1145748,
    lat: -21.8250704
  },
  {
    lng: -42.1145171,
    lat: -21.8251036
  },
  {
    lng: -42.1144551,
    lat: -21.8251466
  },
  {
    lng: -42.1143998,
    lat: -21.8251966
  },
  {
    lng: -42.1143446,
    lat: -21.8252466
  },
  {
    lng: -42.1142879,
    lat: -21.8252899
  },
  {
    lng: -42.1142384,
    lat: -21.8253336
  },
  {
    lng: -42.1141903,
    lat: -21.8253841
  },
  {
    lng: -42.114135,
    lat: -21.8254341
  },
  {
    lng: -42.1140837,
    lat: -21.8254778
  },
  {
    lng: -42.114017,
    lat: -21.8255105
  },
  {
    lng: -42.1139507,
    lat: -21.8255366
  },
  {
    lng: -42.1138795,
    lat: -21.8255557
  },
  {
    lng: -42.1138033,
    lat: -21.8255678
  },
  {
    lng: -42.1137305,
    lat: -21.8255835
  },
  {
    lng: -42.1136545,
    lat: -21.8255924
  },
  {
    lng: -42.113583,
    lat: -21.8255882
  },
  {
    lng: -42.1135194,
    lat: -21.8255711
  },
  {
    lng: -42.1134526,
    lat: -21.8255505
  },
  {
    lng: -42.1133946,
    lat: -21.8255304
  },
  {
    lng: -42.1133338,
    lat: -21.8255001
  },
  {
    lng: -42.11327,
    lat: -21.8254597
  },
  {
    lng: -42.1130965,
    lat: -21.8253128
  },
  {
    lng: -42.1130034,
    lat: -21.8251928
  },
  {
    lng: -42.1129895,
    lat: -21.8251586
  },
  {
    lng: -42.1129648,
    lat: -21.8250972
  },
  {
    lng: -42.1129495,
    lat: -21.8250296
  },
  {
    lng: -42.1129487,
    lat: -21.8249596
  },
  {
    lng: -42.1129533,
    lat: -21.8248899
  },
  {
    lng: -42.1129648,
    lat: -21.8248239
  },
  {
    lng: -42.1130367,
    lat: -21.8246583
  },
  {
    lng: -42.1132314,
    lat: -21.8244
  },
  {
    lng: -42.1132392,
    lat: -21.8243905
  },
  {
    lng: -42.1132614,
    lat: -21.8243369
  },
  {
    lng: -42.1132648,
    lat: -21.8243288
  },
  {
    lng: -42.1132888,
    lat: -21.8242636
  },
  {
    lng: -42.1132985,
    lat: -21.8241976
  },
  {
    lng: -42.1133009,
    lat: -21.8241345
  },
  {
    lng: -42.113282,
    lat: -21.8240668
  },
  {
    lng: -42.1132354,
    lat: -21.8240107
  },
  {
    lng: -42.1132063,
    lat: -21.823989
  },
  {
    lng: -42.1131462,
    lat: -21.8239488
  },
  {
    lng: -42.1130887,
    lat: -21.8239221
  },
  {
    lng: -42.113029,
    lat: -21.8239019
  },
  {
    lng: -42.1129657,
    lat: -21.8238815
  },
  {
    lng: -42.1129081,
    lat: -21.8238581
  },
  {
    lng: -42.1128421,
    lat: -21.8238242
  },
  {
    lng: -42.1127851,
    lat: -21.8237908
  },
  {
    lng: -42.112733,
    lat: -21.8237644
  },
  {
    lng: -42.1126768,
    lat: -21.8237178
  },
  {
    lng: -42.1126376,
    lat: -21.8236589
  },
  {
    lng: -42.1125986,
    lat: -21.8235967
  },
  {
    lng: -42.1125648,
    lat: -21.8235381
  },
  {
    lng: -42.1125158,
    lat: -21.8234919
  },
  {
    lng: -42.1124483,
    lat: -21.8234812
  },
  {
    lng: -42.1123803,
    lat: -21.8234771
  },
  {
    lng: -42.1123088,
    lat: -21.8234729
  },
  {
    lng: -42.1122335,
    lat: -21.8234717
  },
  {
    lng: -42.112162,
    lat: -21.8234674
  },
  {
    lng: -42.1120887,
    lat: -21.8234631
  },
  {
    lng: -42.1120178,
    lat: -21.8234755
  },
  {
    lng: -42.1119485,
    lat: -21.8234913
  },
  {
    lng: -42.111875,
    lat: -21.8234902
  },
  {
    lng: -42.1117292,
    lat: -21.8234682
  },
  {
    lng: -42.1116312,
    lat: -21.8234291
  },
  {
    lng: -42.1116226,
    lat: -21.8234236
  },
  {
    lng: -42.111614,
    lat: -21.8234181
  },
  {
    lng: -42.1115166,
    lat: -21.8233157
  },
  {
    lng: -42.1114622,
    lat: -21.8232426
  },
  {
    lng: -42.1114445,
    lat: -21.8231849
  },
  {
    lng: -42.1114268,
    lat: -21.8231273
  },
  {
    lng: -42.1114044,
    lat: -21.8230594
  },
  {
    lng: -42.1113746,
    lat: -21.8229944
  },
  {
    lng: -42.111328,
    lat: -21.8229384
  },
  {
    lng: -42.1112728,
    lat: -21.8229051
  },
  {
    lng: -42.1112057,
    lat: -21.8228878
  },
  {
    lng: -42.1111306,
    lat: -21.8228833
  },
  {
    lng: -42.1110628,
    lat: -21.8228759
  },
  {
    lng: -42.1110152,
    lat: -21.8228631
  },
  {
    lng: -42.1109615,
    lat: -21.8228332
  },
  {
    lng: -42.1109138,
    lat: -21.8227938
  },
  {
    lng: -42.1108653,
    lat: -21.8227409
  },
  {
    lng: -42.110831,
    lat: -21.822689
  },
  {
    lng: -42.1108091,
    lat: -21.8226411
  },
  {
    lng: -42.1107829,
    lat: -21.8225763
  },
  {
    lng: -42.110762,
    lat: -21.8225118
  },
  {
    lng: -42.1107506,
    lat: -21.8224413
  },
  {
    lng: -42.1107407,
    lat: -21.8223742
  },
  {
    lng: -42.1107288,
    lat: -21.8223102
  },
  {
    lng: -42.1107172,
    lat: -21.822243
  },
  {
    lng: -42.1107183,
    lat: -21.8221732
  },
  {
    lng: -42.1107296,
    lat: -21.8221107
  },
  {
    lng: -42.1107513,
    lat: -21.8220555
  },
  {
    lng: -42.1107944,
    lat: -21.8220016
  },
  {
    lng: -42.1108429,
    lat: -21.821948
  },
  {
    lng: -42.1108965,
    lat: -21.821898
  },
  {
    lng: -42.1109484,
    lat: -21.8218479
  },
  {
    lng: -42.1109789,
    lat: -21.8217932
  },
  {
    lng: -42.1110048,
    lat: -21.8217283
  },
  {
    lng: -42.1110285,
    lat: -21.8216699
  },
  {
    lng: -42.1110745,
    lat: -21.821573
  },
  {
    lng: -42.1112241,
    lat: -21.8214025
  },
  {
    lng: -42.1112636,
    lat: -21.821375
  },
  {
    lng: -42.1113272,
    lat: -21.8213357
  },
  {
    lng: -42.1113806,
    lat: -21.8212891
  },
  {
    lng: -42.1114286,
    lat: -21.8212421
  },
  {
    lng: -42.1114754,
    lat: -21.8211852
  },
  {
    lng: -42.1115116,
    lat: -21.8211276
  },
  {
    lng: -42.1115347,
    lat: -21.8210758
  },
  {
    lng: -42.1115499,
    lat: -21.8210103
  },
  {
    lng: -42.1115686,
    lat: -21.820945
  },
  {
    lng: -42.1115803,
    lat: -21.820876
  },
  {
    lng: -42.1115796,
    lat: -21.8208063
  },
  {
    lng: -42.1115661,
    lat: -21.820739
  },
  {
    lng: -42.1115435,
    lat: -21.8206746
  },
  {
    lng: -42.1115153,
    lat: -21.8206131
  },
  {
    lng: -42.1114704,
    lat: -21.8205606
  },
  {
    lng: -42.1114217,
    lat: -21.8205112
  },
  {
    lng: -42.1113556,
    lat: -21.8204806
  },
  {
    lng: -42.1112892,
    lat: -21.8204534
  },
  {
    lng: -42.1112142,
    lat: -21.8204488
  },
  {
    lng: -42.1111374,
    lat: -21.8204442
  },
  {
    lng: -42.1110617,
    lat: -21.8204495
  },
  {
    lng: -42.1109933,
    lat: -21.8204786
  },
  {
    lng: -42.1109333,
    lat: -21.8205181
  },
  {
    lng: -42.11086,
    lat: -21.8205137
  },
  {
    lng: -42.1107961,
    lat: -21.8204766
  },
  {
    lng: -42.1107449,
    lat: -21.820437
  },
  {
    lng: -42.1106902,
    lat: -21.8203971
  },
  {
    lng: -42.1106263,
    lat: -21.82036
  },
  {
    lng: -42.1105512,
    lat: -21.8203555
  },
  {
    lng: -42.1104797,
    lat: -21.8203512
  },
  {
    lng: -42.11041,
    lat: -21.8203469
  },
  {
    lng: -42.1103349,
    lat: -21.8203424
  },
  {
    lng: -42.1102605,
    lat: -21.8203545
  },
  {
    lng: -42.1101923,
    lat: -21.8203802
  },
  {
    lng: -42.1101273,
    lat: -21.8204128
  },
  {
    lng: -42.1100636,
    lat: -21.8204521
  },
  {
    lng: -42.1100116,
    lat: -21.8205054
  },
  {
    lng: -42.1099733,
    lat: -21.8205662
  },
  {
    lng: -42.109932,
    lat: -21.8206202
  },
  {
    lng: -42.1098741,
    lat: -21.8206532
  },
  {
    lng: -42.1098035,
    lat: -21.8206622
  },
  {
    lng: -42.1097375,
    lat: -21.8206549
  },
  {
    lng: -42.1096673,
    lat: -21.8206307
  },
  {
    lng: -42.1096067,
    lat: -21.8205971
  },
  {
    lng: -42.1095499,
    lat: -21.8205605
  },
  {
    lng: -42.1094931,
    lat: -21.8205238
  },
  {
    lng: -42.1093878,
    lat: -21.820461
  },
  {
    lng: -42.1092451,
    lat: -21.8203808
  },
  {
    lng: -42.1091847,
    lat: -21.8203439
  },
  {
    lng: -42.109121,
    lat: -21.8203035
  },
  {
    lng: -42.1090606,
    lat: -21.8202666
  },
  {
    lng: -42.1090295,
    lat: -21.8202481
  },
  {
    lng: -42.1089984,
    lat: -21.8202296
  },
  {
    lng: -42.1089497,
    lat: -21.8201802
  },
  {
    lng: -42.1089267,
    lat: -21.8201223
  },
  {
    lng: -42.1089222,
    lat: -21.8200556
  },
  {
    lng: -42.108941,
    lat: -21.8199903
  },
  {
    lng: -42.108967,
    lat: -21.8199255
  },
  {
    lng: -42.1089865,
    lat: -21.8198768
  },
  {
    lng: -42.1090091,
    lat: -21.8198085
  },
  {
    lng: -42.1090299,
    lat: -21.81974
  },
  {
    lng: -42.1090503,
    lat: -21.8196782
  },
  {
    lng: -42.1090693,
    lat: -21.8196096
  },
  {
    lng: -42.1090717,
    lat: -21.8195895
  },
  {
    lng: -42.1090737,
    lat: -21.8195733
  },
  {
    lng: -42.1090776,
    lat: -21.8195404
  },
  {
    lng: -42.1090535,
    lat: -21.8193929
  },
  {
    lng: -42.1090147,
    lat: -21.8192511
  },
  {
    lng: -42.108993,
    lat: -21.8192
  },
  {
    lng: -42.1089671,
    lat: -21.8191321
  },
  {
    lng: -42.108943,
    lat: -21.8190643
  },
  {
    lng: -42.1089209,
    lat: -21.8190198
  },
  {
    lng: -42.1088874,
    lat: -21.818958
  },
  {
    lng: -42.1088514,
    lat: -21.818906
  },
  {
    lng: -42.1088047,
    lat: -21.8188534
  },
  {
    lng: -42.1087489,
    lat: -21.8188036
  },
  {
    lng: -42.1086811,
    lat: -21.8187696
  },
  {
    lng: -42.1086123,
    lat: -21.8187521
  },
  {
    lng: -42.1085401,
    lat: -21.8187311
  },
  {
    lng: -42.1084771,
    lat: -21.8187073
  },
  {
    lng: -42.1084051,
    lat: -21.818683
  },
  {
    lng: -42.1083349,
    lat: -21.8186588
  },
  {
    lng: -42.1082804,
    lat: -21.8186383
  },
  {
    lng: -42.1082719,
    lat: -21.8186351
  },
  {
    lng: -42.1082183,
    lat: -21.818617
  },
  {
    lng: -42.1081999,
    lat: -21.8186108
  },
  {
    lng: -42.1081333,
    lat: -21.8185868
  },
  {
    lng: -42.1080682,
    lat: -21.8185662
  },
  {
    lng: -42.107977,
    lat: -21.8185341
  },
  {
    lng: -42.1078626,
    lat: -21.8184475
  },
  {
    lng: -42.1078346,
    lat: -21.8184358
  },
  {
    lng: -42.1077644,
    lat: -21.8184116
  },
  {
    lng: -42.1076897,
    lat: -21.8184004
  },
  {
    lng: -42.1076171,
    lat: -21.818386
  },
  {
    lng: -42.1075466,
    lat: -21.8183651
  },
  {
    lng: -42.1074827,
    lat: -21.8183545
  },
  {
    lng: -42.1074183,
    lat: -21.8183241
  },
  {
    lng: -42.1073582,
    lat: -21.8182839
  },
  {
    lng: -42.1073244,
    lat: -21.8182254
  },
  {
    lng: -42.1073239,
    lat: -21.8181557
  },
  {
    lng: -42.1073437,
    lat: -21.8180508
  },
  {
    lng: -42.1073544,
    lat: -21.8180249
  },
  {
    lng: -42.1073921,
    lat: -21.8179742
  },
  {
    lng: -42.1074387,
    lat: -21.817924
  },
  {
    lng: -42.1074841,
    lat: -21.8178903
  },
  {
    lng: -42.107536,
    lat: -21.8178404
  },
  {
    lng: -42.107588,
    lat: -21.8177905
  },
  {
    lng: -42.1076384,
    lat: -21.8177373
  },
  {
    lng: -42.1076802,
    lat: -21.8176769
  },
  {
    lng: -42.1076937,
    lat: -21.8176114
  },
  {
    lng: -42.1076947,
    lat: -21.8175452
  },
  {
    lng: -42.1076934,
    lat: -21.8174854
  },
  {
    lng: -42.1076872,
    lat: -21.8174188
  },
  {
    lng: -42.1076862,
    lat: -21.8173557
  },
  {
    lng: -42.1076813,
    lat: -21.8172958
  },
  {
    lng: -42.1076695,
    lat: -21.8172321
  },
  {
    lng: -42.1076552,
    lat: -21.8172072
  },
  {
    lng: -42.1076358,
    lat: -21.8171737
  },
  {
    lng: -42.1075854,
    lat: -21.8171242
  },
  {
    lng: -42.1075157,
    lat: -21.8170934
  },
  {
    lng: -42.1074406,
    lat: -21.8170888
  },
  {
    lng: -42.1073715,
    lat: -21.8171011
  },
  {
    lng: -42.1073003,
    lat: -21.8171166
  },
  {
    lng: -42.1072368,
    lat: -21.8171524
  },
  {
    lng: -42.1071827,
    lat: -21.8172127
  },
  {
    lng: -42.1071535,
    lat: -21.8172706
  },
  {
    lng: -42.1071203,
    lat: -21.8173349
  },
  {
    lng: -42.107088,
    lat: -21.8173859
  },
  {
    lng: -42.107041,
    lat: -21.8174427
  },
  {
    lng: -42.1070024,
    lat: -21.8174801
  },
  {
    lng: -42.106929,
    lat: -21.8175022
  },
  {
    lng: -42.1068584,
    lat: -21.8174845
  },
  {
    lng: -42.1067913,
    lat: -21.8174672
  },
  {
    lng: -42.1067331,
    lat: -21.8174238
  },
  {
    lng: -42.106705,
    lat: -21.8173624
  },
  {
    lng: -42.1066877,
    lat: -21.8173016
  },
  {
    lng: -42.1066851,
    lat: -21.8172351
  },
  {
    lng: -42.1066897,
    lat: -21.8171691
  },
  {
    lng: -42.1067164,
    lat: -21.8169917
  },
  {
    lng: -42.106804,
    lat: -21.8167121
  },
  {
    lng: -42.1068122,
    lat: -21.8166463
  },
  {
    lng: -42.1068239,
    lat: -21.8165808
  },
  {
    lng: -42.1068356,
    lat: -21.8165153
  },
  {
    lng: -42.106851,
    lat: -21.81645
  },
  {
    lng: -42.1068627,
    lat: -21.8163844
  },
  {
    lng: -42.1068811,
    lat: -21.8163259
  },
  {
    lng: -42.106895,
    lat: -21.8162804
  },
  {
    lng: -42.106909,
    lat: -21.8162349
  },
  {
    lng: -42.1069189,
    lat: -21.8161958
  },
  {
    lng: -42.1069377,
    lat: -21.8161307
  },
  {
    lng: -42.1069673,
    lat: -21.8160663
  },
  {
    lng: -42.1069929,
    lat: -21.8160083
  },
  {
    lng: -42.1070185,
    lat: -21.8159503
  },
  {
    lng: -42.1070472,
    lat: -21.8158991
  },
  {
    lng: -42.1070758,
    lat: -21.8158479
  },
  {
    lng: -42.1071045,
    lat: -21.8157967
  },
  {
    lng: -42.1071444,
    lat: -21.8157396
  },
  {
    lng: -42.1071909,
    lat: -21.8156895
  },
  {
    lng: -42.1072339,
    lat: -21.8156393
  },
  {
    lng: -42.1072662,
    lat: -21.8155883
  },
  {
    lng: -42.1072979,
    lat: -21.815544
  },
  {
    lng: -42.1073266,
    lat: -21.8154928
  },
  {
    lng: -42.1073562,
    lat: -21.8154285
  },
  {
    lng: -42.1073777,
    lat: -21.8153769
  },
  {
    lng: -42.1074032,
    lat: -21.8153189
  },
  {
    lng: -42.1074212,
    lat: -21.8152671
  },
  {
    lng: -42.107431,
    lat: -21.815228
  },
  {
    lng: -42.1074387,
    lat: -21.8151689
  },
  {
    lng: -42.1074433,
    lat: -21.8151031
  },
  {
    lng: -42.107446,
    lat: -21.8150635
  },
  {
    lng: -42.1074501,
    lat: -21.8150043
  },
  {
    lng: -42.107451,
    lat: -21.8149382
  },
  {
    lng: -42.107452,
    lat: -21.8148721
  },
  {
    lng: -42.107449,
    lat: -21.8148124
  },
  {
    lng: -42.1074526,
    lat: -21.8147597
  },
  {
    lng: -42.1074679,
    lat: -21.8146945
  },
  {
    lng: -42.1074822,
    lat: -21.8146425
  },
  {
    lng: -42.1074863,
    lat: -21.8145833
  },
  {
    lng: -42.1074899,
    lat: -21.8145306
  },
  {
    lng: -42.1074802,
    lat: -21.8144639
  },
  {
    lng: -42.1074486,
    lat: -21.8144024
  },
  {
    lng: -42.1074191,
    lat: -21.8143609
  },
  {
    lng: -42.1073652,
    lat: -21.8143113
  },
  {
    lng: -42.1073027,
    lat: -21.8142809
  },
  {
    lng: -42.1072312,
    lat: -21.8142765
  },
  {
    lng: -42.1071597,
    lat: -21.814272
  },
  {
    lng: -42.1070919,
    lat: -21.8142678
  },
  {
    lng: -42.1070164,
    lat: -21.8142696
  },
  {
    lng: -42.1069466,
    lat: -21.8142917
  },
  {
    lng: -42.1068836,
    lat: -21.8143208
  },
  {
    lng: -42.1068273,
    lat: -21.814357
  },
  {
    lng: -42.1067807,
    lat: -21.814407
  },
  {
    lng: -42.1067337,
    lat: -21.8144635
  },
  {
    lng: -42.1066872,
    lat: -21.8145135
  },
  {
    lng: -42.1066437,
    lat: -21.8145703
  },
  {
    lng: -42.106505,
    lat: -21.8147072
  },
  {
    lng: -42.1063751,
    lat: -21.8147617
  },
  {
    lng: -42.1061168,
    lat: -21.8148701
  },
  {
    lng: -42.1060693,
    lat: -21.8148901
  },
  {
    lng: -42.1056739,
    lat: -21.8149449
  },
  {
    lng: -42.1052336,
    lat: -21.8149704
  },
  {
    lng: -42.1052148,
    lat: -21.8149677
  },
  {
    lng: -42.105149,
    lat: -21.8149583
  },
  {
    lng: -42.1051313,
    lat: -21.8149447
  },
  {
    lng: -42.1050748,
    lat: -21.814904
  },
  {
    lng: -42.1050075,
    lat: -21.8148765
  },
  {
    lng: -42.1049402,
    lat: -21.8148556
  },
  {
    lng: -42.1048693,
    lat: -21.8148408
  },
  {
    lng: -42.1047701,
    lat: -21.81482
  },
  {
    lng: -42.1047418,
    lat: -21.814813
  },
  {
    lng: -42.104678,
    lat: -21.8147922
  },
  {
    lng: -42.1046108,
    lat: -21.8147647
  },
  {
    lng: -42.1045506,
    lat: -21.8147505
  },
  {
    lng: -42.1044798,
    lat: -21.814723
  },
  {
    lng: -42.104445,
    lat: -21.8147021
  },
  {
    lng: -42.1044232,
    lat: -21.8146889
  },
  {
    lng: -42.1043631,
    lat: -21.8146549
  },
  {
    lng: -42.1042958,
    lat: -21.8146407
  },
  {
    lng: -42.104232,
    lat: -21.8146398
  },
  {
    lng: -42.1041681,
    lat: -21.8146323
  },
  {
    lng: -42.1041009,
    lat: -21.8146114
  },
  {
    lng: -42.1040479,
    lat: -21.8145841
  },
  {
    lng: -42.1039842,
    lat: -21.81455
  },
  {
    lng: -42.1039206,
    lat: -21.8145159
  },
  {
    lng: -42.103857,
    lat: -21.8144818
  },
  {
    lng: -42.1037933,
    lat: -21.8144543
  },
  {
    lng: -42.1037298,
    lat: -21.8144135
  },
  {
    lng: -42.1036697,
    lat: -21.8143795
  },
  {
    lng: -42.1036238,
    lat: -21.8143456
  },
  {
    lng: -42.1035815,
    lat: -21.8143118
  },
  {
    lng: -42.1035392,
    lat: -21.8142714
  },
  {
    lng: -42.1034863,
    lat: -21.8142241
  },
  {
    lng: -42.1034406,
    lat: -21.8141704
  },
  {
    lng: -42.1033949,
    lat: -21.8141166
  },
  {
    lng: -42.1033562,
    lat: -21.8140629
  },
  {
    lng: -42.1033141,
    lat: -21.8140025
  },
  {
    lng: -42.1032861,
    lat: -21.8139423
  },
  {
    lng: -42.1032546,
    lat: -21.8138821
  },
  {
    lng: -42.1032551,
    lat: -21.8138157
  },
  {
    lng: -42.1032662,
    lat: -21.8137494
  },
  {
    lng: -42.1032879,
    lat: -21.8136832
  },
  {
    lng: -42.1033131,
    lat: -21.8136171
  },
  {
    lng: -42.1033312,
    lat: -21.8135642
  },
  {
    lng: -42.1033423,
    lat: -21.8135046
  },
  {
    lng: -42.1033426,
    lat: -21.8134514
  },
  {
    lng: -42.103343,
    lat: -21.8133916
  },
  {
    lng: -42.1033364,
    lat: -21.8133251
  },
  {
    lng: -42.1033261,
    lat: -21.8132784
  },
  {
    lng: -42.1033194,
    lat: -21.8132119
  },
  {
    lng: -42.1033092,
    lat: -21.8131519
  },
  {
    lng: -42.1032989,
    lat: -21.8131053
  },
  {
    lng: -42.1032816,
    lat: -21.8130386
  },
  {
    lng: -42.1032714,
    lat: -21.812972
  },
  {
    lng: -42.1032683,
    lat: -21.8129055
  },
  {
    lng: -42.1032688,
    lat: -21.8128391
  },
  {
    lng: -42.1032774,
    lat: -21.8128036
  },
  {
    lng: -42.1032833,
    lat: -21.8127795
  },
  {
    lng: -42.1033086,
    lat: -21.8127134
  },
  {
    lng: -42.1033445,
    lat: -21.812654
  },
  {
    lng: -42.1033839,
    lat: -21.8125947
  },
  {
    lng: -42.1034197,
    lat: -21.812542
  },
  {
    lng: -42.1034662,
    lat: -21.8124895
  },
  {
    lng: -42.103509,
    lat: -21.8124435
  },
  {
    lng: -42.103559,
    lat: -21.8123977
  },
  {
    lng: -42.103616,
    lat: -21.8123585
  },
  {
    lng: -42.103673,
    lat: -21.8123194
  },
  {
    lng: -42.1037406,
    lat: -21.8122937
  },
  {
    lng: -42.103833,
    lat: -21.8122617
  },
  {
    lng: -42.1040616,
    lat: -21.8122615
  },
  {
    lng: -42.1041305,
    lat: -21.8122663
  },
  {
    lng: -42.1041983,
    lat: -21.8122675
  },
  {
    lng: -42.1042694,
    lat: -21.8122693
  },
  {
    lng: -42.1043433,
    lat: -21.8122695
  },
  {
    lng: -42.1044178,
    lat: -21.8122646
  },
  {
    lng: -42.1044879,
    lat: -21.8122586
  },
  {
    lng: -42.1045613,
    lat: -21.8122506
  },
  {
    lng: -42.1046337,
    lat: -21.8122399
  },
  {
    lng: -42.1047044,
    lat: -21.8122273
  },
  {
    lng: -42.1047709,
    lat: -21.8122011
  },
  {
    lng: -42.1048391,
    lat: -21.8121642
  },
  {
    lng: -42.1048925,
    lat: -21.8121251
  },
  {
    lng: -42.1049103,
    lat: -21.8121051
  },
  {
    lng: -42.1049383,
    lat: -21.8120736
  },
  {
    lng: -42.104955,
    lat: -21.8120114
  },
  {
    lng: -42.1049536,
    lat: -21.811944
  },
  {
    lng: -42.1049383,
    lat: -21.8118805
  },
  {
    lng: -42.104892,
    lat: -21.8118306
  },
  {
    lng: -42.1048374,
    lat: -21.8117868
  },
  {
    lng: -42.1047859,
    lat: -21.8117483
  },
  {
    lng: -42.1047772,
    lat: -21.8117419
  },
  {
    lng: -42.1047254,
    lat: -21.8116971
  },
  {
    lng: -42.1046663,
    lat: -21.8116517
  },
  {
    lng: -42.1046111,
    lat: -21.8116125
  },
  {
    lng: -42.1045442,
    lat: -21.8115779
  },
  {
    lng: -42.1044901,
    lat: -21.8115382
  },
  {
    lng: -42.1044354,
    lat: -21.8114965
  },
  {
    lng: -42.1043857,
    lat: -21.8114522
  },
  {
    lng: -42.1043467,
    lat: -21.8113952
  },
  {
    lng: -42.1043304,
    lat: -21.8113245
  },
  {
    lng: -42.1043312,
    lat: -21.8112508
  },
  {
    lng: -42.1043397,
    lat: -21.811184
  },
  {
    lng: -42.1043609,
    lat: -21.8111147
  },
  {
    lng: -42.104393,
    lat: -21.8110583
  },
  {
    lng: -42.1044229,
    lat: -21.8109979
  },
  {
    lng: -42.1044451,
    lat: -21.8109368
  },
  {
    lng: -42.1044656,
    lat: -21.8108763
  },
  {
    lng: -42.1044768,
    lat: -21.8108125
  },
  {
    lng: -42.1044776,
    lat: -21.8107492
  },
  {
    lng: -42.1044711,
    lat: -21.8106853
  },
  {
    lng: -42.1044337,
    lat: -21.8106298
  },
  {
    lng: -42.104374,
    lat: -21.8105942
  },
  {
    lng: -42.1043047,
    lat: -21.810577
  },
  {
    lng: -42.1043034,
    lat: -21.8105768
  },
  {
    lng: -42.104237,
    lat: -21.8105676
  },
  {
    lng: -42.1041687,
    lat: -21.8105612
  },
  {
    lng: -42.1040904,
    lat: -21.8105605
  },
  {
    lng: -42.1040208,
    lat: -21.8105675
  },
  {
    lng: -42.1039539,
    lat: -21.8105879
  },
  {
    lng: -42.1038863,
    lat: -21.8106171
  },
  {
    lng: -42.103823,
    lat: -21.8106495
  },
  {
    lng: -42.1037564,
    lat: -21.8106879
  },
  {
    lng: -42.1036926,
    lat: -21.8107264
  },
  {
    lng: -42.1036359,
    lat: -21.8107635
  },
  {
    lng: -42.1035676,
    lat: -21.8108055
  },
  {
    lng: -42.103501,
    lat: -21.810843
  },
  {
    lng: -42.1034345,
    lat: -21.8108717
  },
  {
    lng: -42.103368,
    lat: -21.8108973
  },
  {
    lng: -42.1032917,
    lat: -21.810914
  },
  {
    lng: -42.1032157,
    lat: -21.8109122
  },
  {
    lng: -42.1031458,
    lat: -21.8108997
  },
  {
    lng: -42.1030738,
    lat: -21.8108732
  },
  {
    lng: -42.103022,
    lat: -21.8108238
  },
  {
    lng: -42.1029835,
    lat: -21.8107709
  },
  {
    lng: -42.1029577,
    lat: -21.8107124
  },
  {
    lng: -42.1029358,
    lat: -21.8106458
  },
  {
    lng: -42.1029268,
    lat: -21.8105695
  },
  {
    lng: -42.1029244,
    lat: -21.8104907
  },
  {
    lng: -42.102919,
    lat: -21.8104273
  },
  {
    lng: -42.1029116,
    lat: -21.8103536
  },
  {
    lng: -42.1029097,
    lat: -21.8102784
  },
  {
    lng: -42.1029104,
    lat: -21.8102135
  },
  {
    lng: -42.1029228,
    lat: -21.810142
  },
  {
    lng: -42.1029446,
    lat: -21.8100732
  },
  {
    lng: -42.1029706,
    lat: -21.8100117
  },
  {
    lng: -42.1030066,
    lat: -21.8099523
  },
  {
    lng: -42.1030464,
    lat: -21.8098997
  },
  {
    lng: -42.1030933,
    lat: -21.8098466
  },
  {
    lng: -42.1031418,
    lat: -21.8097997
  },
  {
    lng: -42.1031871,
    lat: -21.809743
  },
  {
    lng: -42.103208,
    lat: -21.8097057
  },
  {
    lng: -42.1032192,
    lat: -21.8096857
  },
  {
    lng: -42.1032227,
    lat: -21.8096172
  },
  {
    lng: -42.1032075,
    lat: -21.8095547
  },
  {
    lng: -42.1031617,
    lat: -21.8095064
  },
  {
    lng: -42.1030991,
    lat: -21.8094795
  },
  {
    lng: -42.1030514,
    lat: -21.8094763
  },
  {
    lng: -42.1030286,
    lat: -21.8094747
  },
  {
    lng: -42.1029563,
    lat: -21.8094771
  },
  {
    lng: -42.1028851,
    lat: -21.8094872
  },
  {
    lng: -42.1028182,
    lat: -21.809505
  },
  {
    lng: -42.102749,
    lat: -21.8095239
  },
  {
    lng: -42.1026771,
    lat: -21.8095453
  },
  {
    lng: -42.1026067,
    lat: -21.8095724
  },
  {
    lng: -42.1025436,
    lat: -21.8095955
  },
  {
    lng: -42.102481,
    lat: -21.8096227
  },
  {
    lng: -42.1024129,
    lat: -21.8096457
  },
  {
    lng: -42.1023382,
    lat: -21.809664
  },
  {
    lng: -42.1022686,
    lat: -21.8096803
  },
  {
    lng: -42.1022011,
    lat: -21.8097002
  },
  {
    lng: -42.1021368,
    lat: -21.8097279
  },
  {
    lng: -42.1020839,
    lat: -21.8097701
  },
  {
    lng: -42.1020398,
    lat: -21.8098227
  },
  {
    lng: -42.1020115,
    lat: -21.8098858
  },
  {
    lng: -42.1020112,
    lat: -21.8099574
  },
  {
    lng: -42.1020286,
    lat: -21.8100281
  },
  {
    lng: -42.1020582,
    lat: -21.8100886
  },
  {
    lng: -42.1020911,
    lat: -21.8101513
  },
  {
    lng: -42.1021141,
    lat: -21.8102179
  },
  {
    lng: -42.1021111,
    lat: -21.8102853
  },
  {
    lng: -42.1020719,
    lat: -21.8103421
  },
  {
    lng: -42.1020081,
    lat: -21.8103703
  },
  {
    lng: -42.1019392,
    lat: -21.8103676
  },
  {
    lng: -42.1018683,
    lat: -21.8103524
  },
  {
    lng: -42.1017996,
    lat: -21.8103317
  },
  {
    lng: -42.1017338,
    lat: -21.8102986
  },
  {
    lng: -42.1016725,
    lat: -21.8102614
  },
  {
    lng: -42.1016079,
    lat: -21.8102196
  },
  {
    lng: -42.1015471,
    lat: -21.8101778
  },
  {
    lng: -42.1014892,
    lat: -21.8101329
  },
  {
    lng: -42.1014313,
    lat: -21.8100849
  },
  {
    lng: -42.1013872,
    lat: -21.8100315
  },
  {
    lng: -42.1013642,
    lat: -21.8099689
  },
  {
    lng: -42.1013622,
    lat: -21.8099056
  },
  {
    lng: -42.1013762,
    lat: -21.8098408
  },
  {
    lng: -42.1014055,
    lat: -21.8097809
  },
  {
    lng: -42.1014316,
    lat: -21.8097193
  },
  {
    lng: -42.1014423,
    lat: -21.8096525
  },
  {
    lng: -42.101437,
    lat: -21.8095891
  },
  {
    lng: -42.1014057,
    lat: -21.809527
  },
  {
    lng: -42.101346,
    lat: -21.8094935
  },
  {
    lng: -42.1012795,
    lat: -21.8094717
  },
  {
    lng: -42.1012117,
    lat: -21.8094658
  },
  {
    lng: -42.1011389,
    lat: -21.8094651
  },
  {
    lng: -42.1010633,
    lat: -21.8094726
  },
  {
    lng: -42.1009925,
    lat: -21.8094946
  },
  {
    lng: -42.1009204,
    lat: -21.8095283
  },
  {
    lng: -42.1008587,
    lat: -21.8095694
  },
  {
    lng: -42.1007943,
    lat: -21.809612
  },
  {
    lng: -42.100732,
    lat: -21.8096562
  },
  {
    lng: -42.100677,
    lat: -21.8096933
  },
  {
    lng: -42.100616,
    lat: -21.8097241
  },
  {
    lng: -42.1005501,
    lat: -21.8097476
  },
  {
    lng: -42.100476,
    lat: -21.8097649
  },
  {
    lng: -42.1004025,
    lat: -21.8097801
  },
  {
    lng: -42.1003346,
    lat: -21.809781
  },
  {
    lng: -42.1002675,
    lat: -21.8097741
  },
  {
    lng: -42.1001971,
    lat: -21.8097575
  },
  {
    lng: -42.1001307,
    lat: -21.809728
  },
  {
    lng: -42.1000962,
    lat: -21.8096979
  },
  {
    lng: -42.1000793,
    lat: -21.8096832
  },
  {
    lng: -42.1000408,
    lat: -21.8096292
  },
  {
    lng: -42.1000285,
    lat: -21.8095678
  },
  {
    lng: -42.1000267,
    lat: -21.8095591
  },
  {
    lng: -42.1000512,
    lat: -21.8094944
  },
  {
    lng: -42.1000904,
    lat: -21.8094387
  },
  {
    lng: -42.1001077,
    lat: -21.8093709
  },
  {
    lng: -42.1001003,
    lat: -21.8093018
  },
  {
    lng: -42.1000678,
    lat: -21.8092433
  },
  {
    lng: -42.1000282,
    lat: -21.809216
  },
  {
    lng: -42.1000109,
    lat: -21.8092041
  },
  {
    lng: -42.0999394,
    lat: -21.8091885
  },
  {
    lng: -42.0998704,
    lat: -21.8091955
  },
  {
    lng: -42.0998061,
    lat: -21.8092247
  },
  {
    lng: -42.0997401,
    lat: -21.8092581
  },
  {
    lng: -42.0996762,
    lat: -21.8093012
  },
  {
    lng: -42.0996134,
    lat: -21.8093474
  },
  {
    lng: -42.0995513,
    lat: -21.8093782
  },
  {
    lng: -42.0994799,
    lat: -21.8094002
  },
  {
    lng: -42.0994141,
    lat: -21.809417
  },
  {
    lng: -42.0993461,
    lat: -21.8094271
  },
  {
    lng: -42.0992771,
    lat: -21.8094342
  },
  {
    lng: -42.0991982,
    lat: -21.8094344
  },
  {
    lng: -42.0991266,
    lat: -21.8094332
  },
  {
    lng: -42.0990588,
    lat: -21.8094289
  },
  {
    lng: -42.0989817,
    lat: -21.8094209
  },
  {
    lng: -42.0989151,
    lat: -21.8094084
  },
  {
    lng: -42.0988463,
    lat: -21.809399
  },
  {
    lng: -42.0987763,
    lat: -21.8093911
  },
  {
    lng: -42.0987041,
    lat: -21.8093904
  },
  {
    lng: -42.0986345,
    lat: -21.8094015
  },
  {
    lng: -42.0985713,
    lat: -21.8094359
  },
  {
    lng: -42.0985358,
    lat: -21.8094958
  },
  {
    lng: -42.0985411,
    lat: -21.8095653
  },
  {
    lng: -42.0985635,
    lat: -21.8096268
  },
  {
    lng: -42.0986031,
    lat: -21.809688
  },
  {
    lng: -42.0986444,
    lat: -21.8097409
  },
  {
    lng: -42.0986917,
    lat: -21.8098032
  },
  {
    lng: -42.0987347,
    lat: -21.809852
  },
  {
    lng: -42.0987815,
    lat: -21.8099025
  },
  {
    lng: -42.0988278,
    lat: -21.8099498
  },
  {
    lng: -42.0988709,
    lat: -21.8099986
  },
  {
    lng: -42.0989127,
    lat: -21.8100485
  },
  {
    lng: -42.0989617,
    lat: -21.8101087
  },
  {
    lng: -42.0990168,
    lat: -21.8101623
  },
  {
    lng: -42.0990691,
    lat: -21.8102169
  },
  {
    lng: -42.099117,
    lat: -21.8102735
  },
  {
    lng: -42.0991631,
    lat: -21.8103342
  },
  {
    lng: -42.099212,
    lat: -21.810396
  },
  {
    lng: -42.0992583,
    lat: -21.8104541
  },
  {
    lng: -42.0992957,
    lat: -21.810508
  },
  {
    lng: -42.0993365,
    lat: -21.8105589
  },
  {
    lng: -42.0993772,
    lat: -21.8106103
  },
  {
    lng: -42.0994206,
    lat: -21.8106715
  },
  {
    lng: -42.0994614,
    lat: -21.8107244
  },
  {
    lng: -42.0995109,
    lat: -21.8107821
  },
  {
    lng: -42.0995599,
    lat: -21.8108371
  },
  {
    lng: -42.0996007,
    lat: -21.8108901
  },
  {
    lng: -42.0996242,
    lat: -21.8109562
  },
  {
    lng: -42.0996014,
    lat: -21.8110167
  },
  {
    lng: -42.0995682,
    lat: -21.8110761
  },
  {
    lng: -42.0995334,
    lat: -21.8111314
  },
  {
    lng: -42.099487,
    lat: -21.8111835
  },
  {
    lng: -42.0994317,
    lat: -21.8112442
  },
  {
    lng: -42.0993793,
    lat: -21.8112982
  },
  {
    lng: -42.0993269,
    lat: -21.8113497
  },
  {
    lng: -42.0992733,
    lat: -21.8114022
  },
  {
    lng: -42.0992203,
    lat: -21.8114542
  },
  {
    lng: -42.0991685,
    lat: -21.8115062
  },
  {
    lng: -42.0991144,
    lat: -21.8115587
  },
  {
    lng: -42.0990548,
    lat: -21.8116096
  },
  {
    lng: -42.0990002,
    lat: -21.8116549
  },
  {
    lng: -42.0989479,
    lat: -21.8117002
  },
  {
    lng: -42.0988899,
    lat: -21.8117522
  },
  {
    lng: -42.0988331,
    lat: -21.8118031
  },
  {
    lng: -42.0987701,
    lat: -21.8118596
  },
  {
    lng: -42.0987222,
    lat: -21.8119055
  },
  {
    lng: -42.0986608,
    lat: -21.8119662
  },
  {
    lng: -42.0985989,
    lat: -21.8120258
  },
  {
    lng: -42.0985387,
    lat: -21.8120849
  },
  {
    lng: -42.0984785,
    lat: -21.8121394
  },
  {
    lng: -42.0984151,
    lat: -21.8121872
  },
  {
    lng: -42.0983506,
    lat: -21.812237
  },
  {
    lng: -42.0982877,
    lat: -21.8122827
  },
  {
    lng: -42.0982266,
    lat: -21.8123243
  },
  {
    lng: -42.0981698,
    lat: -21.8123675
  },
  {
    lng: -42.0981192,
    lat: -21.8124113
  },
  {
    lng: -42.0980596,
    lat: -21.8124571
  },
  {
    lng: -42.0980106,
    lat: -21.8125009
  },
  {
    lng: -42.0977108,
    lat: -21.8126969
  },
  {
    lng: -42.0974024,
    lat: -21.8128454
  },
  {
    lng: -42.0973229,
    lat: -21.8128876
  },
  {
    lng: -42.0970974,
    lat: -21.8130072
  },
  {
    lng: -42.0969236,
    lat: -21.813111
  },
  {
    lng: -42.0968203,
    lat: -21.813249
  },
  {
    lng: -42.096642,
    lat: -21.8135053
  },
  {
    lng: -42.0965168,
    lat: -21.8137556
  },
  {
    lng: -42.0964279,
    lat: -21.8138539
  },
  {
    lng: -42.0963252,
    lat: -21.8138923
  },
  {
    lng: -42.0961876,
    lat: -21.8138705
  },
  {
    lng: -42.0958318,
    lat: -21.8137596
  },
  {
    lng: -42.0955214,
    lat: -21.8137288
  },
  {
    lng: -42.095247,
    lat: -21.8137483
  },
  {
    lng: -42.0951295,
    lat: -21.8137567
  },
  {
    lng: -42.0949387,
    lat: -21.8138071
  },
  {
    lng: -42.0947194,
    lat: -21.8138969
  },
  {
    lng: -42.0946407,
    lat: -21.8139241
  },
  {
    lng: -42.0943871,
    lat: -21.8140117
  },
  {
    lng: -42.0941897,
    lat: -21.8140023
  },
  {
    lng: -42.0938588,
    lat: -21.8139315
  },
  {
    lng: -42.0936723,
    lat: -21.813876
  },
  {
    lng: -42.0934898,
    lat: -21.8137542
  },
  {
    lng: -42.0934236,
    lat: -21.8136407
  },
  {
    lng: -42.093319,
    lat: -21.813467
  },
  {
    lng: -42.0932562,
    lat: -21.8133667
  },
  {
    lng: -42.0931824,
    lat: -21.8133326
  },
  {
    lng: -42.0930415,
    lat: -21.8133241
  },
  {
    lng: -42.0927241,
    lat: -21.8133794
  },
  {
    lng: -42.0925055,
    lat: -21.8134096
  },
  {
    lng: -42.0923754,
    lat: -21.8133813
  },
  {
    lng: -42.0921893,
    lat: -21.8132993
  },
  {
    lng: -42.0920736,
    lat: -21.8132117
  },
  {
    lng: -42.091941,
    lat: -21.8130244
  },
  {
    lng: -42.0917881,
    lat: -21.8127045
  },
  {
    lng: -42.0917045,
    lat: -21.8123988
  },
  {
    lng: -42.0916652,
    lat: -21.81234
  },
  {
    lng: -42.0916388,
    lat: -21.8122797
  },
  {
    lng: -42.0916249,
    lat: -21.8122079
  },
  {
    lng: -42.0916216,
    lat: -21.8121435
  },
  {
    lng: -42.0916238,
    lat: -21.8120693
  },
  {
    lng: -42.0916323,
    lat: -21.8120046
  },
  {
    lng: -42.0916377,
    lat: -21.8119407
  },
  {
    lng: -42.0916384,
    lat: -21.811875
  },
  {
    lng: -42.0916314,
    lat: -21.8118033
  },
  {
    lng: -42.0916129,
    lat: -21.8117345
  },
  {
    lng: -42.0915833,
    lat: -21.8116775
  },
  {
    lng: -42.0915333,
    lat: -21.8116242
  },
  {
    lng: -42.0914833,
    lat: -21.8115782
  },
  {
    lng: -42.0914316,
    lat: -21.8115224
  },
  {
    lng: -42.0913899,
    lat: -21.8114726
  },
  {
    lng: -42.0913445,
    lat: -21.8114164
  },
  {
    lng: -42.0912984,
    lat: -21.8113541
  },
  {
    lng: -42.0912555,
    lat: -21.8112863
  },
  {
    lng: -42.0912282,
    lat: -21.8112264
  },
  {
    lng: -42.091206,
    lat: -21.8111549
  },
  {
    lng: -42.0912036,
    lat: -21.8110888
  },
  {
    lng: -42.0912144,
    lat: -21.8110237
  },
  {
    lng: -42.0912372,
    lat: -21.8109621
  },
  {
    lng: -42.091277,
    lat: -21.8108943
  },
  {
    lng: -42.091313,
    lat: -21.8108393
  },
  {
    lng: -42.0913477,
    lat: -21.8107847
  },
  {
    lng: -42.0913819,
    lat: -21.8107284
  },
  {
    lng: -42.0914286,
    lat: -21.810662
  },
  {
    lng: -42.09145,
    lat: -21.8106295
  },
  {
    lng: -42.0914698,
    lat: -21.8105997
  },
  {
    lng: -42.091516,
    lat: -21.8105303
  },
  {
    lng: -42.0915655,
    lat: -21.8104655
  },
  {
    lng: -42.0916154,
    lat: -21.8104038
  },
  {
    lng: -42.091657,
    lat: -21.8103424
  },
  {
    lng: -42.0917004,
    lat: -21.8102841
  },
  {
    lng: -42.0917488,
    lat: -21.8102262
  },
  {
    lng: -42.0917922,
    lat: -21.8101734
  },
  {
    lng: -42.0918421,
    lat: -21.8101113
  },
  {
    lng: -42.0918914,
    lat: -21.8100564
  },
  {
    lng: -42.0919379,
    lat: -21.8100101
  },
  {
    lng: -42.0919881,
    lat: -21.8099613
  },
  {
    lng: -42.092026,
    lat: -21.8099037
  },
  {
    lng: -42.0920547,
    lat: -21.8098465
  },
  {
    lng: -42.0920669,
    lat: -21.8097788
  },
  {
    lng: -42.0920548,
    lat: -21.8097109
  },
  {
    lng: -42.0920215,
    lat: -21.8096556
  },
  {
    lng: -42.0919663,
    lat: -21.8096152
  },
  {
    lng: -42.0919143,
    lat: -21.8095932
  },
  {
    lng: -42.0918955,
    lat: -21.8095853
  },
  {
    lng: -42.0918267,
    lat: -21.809573
  },
  {
    lng: -42.0917491,
    lat: -21.8095624
  },
  {
    lng: -42.0916683,
    lat: -21.809556
  },
  {
    lng: -42.091588,
    lat: -21.8095483
  },
  {
    lng: -42.0915174,
    lat: -21.8095377
  },
  {
    lng: -42.0914504,
    lat: -21.8095246
  },
  {
    lng: -42.0914271,
    lat: -21.8095206
  },
  {
    lng: -42.0913761,
    lat: -21.8095119
  },
  {
    lng: -42.0913078,
    lat: -21.8094983
  },
  {
    lng: -42.0912418,
    lat: -21.8094818
  },
  {
    lng: -42.0911648,
    lat: -21.8094634
  },
  {
    lng: -42.09109,
    lat: -21.8094549
  },
  {
    lng: -42.0910165,
    lat: -21.8094542
  },
  {
    lng: -42.0909471,
    lat: -21.8094561
  },
  {
    lng: -42.0908776,
    lat: -21.8094678
  },
  {
    lng: -42.0908065,
    lat: -21.8094967
  },
  {
    lng: -42.0907423,
    lat: -21.8095244
  },
  {
    lng: -42.0906857,
    lat: -21.8095453
  },
  {
    lng: -42.0906735,
    lat: -21.8095499
  },
  {
    lng: -42.0906001,
    lat: -21.8095787
  },
  {
    lng: -42.0905313,
    lat: -21.8096141
  },
  {
    lng: -42.0904775,
    lat: -21.809656
  },
  {
    lng: -42.0904713,
    lat: -21.8096631
  },
  {
    lng: -42.0904346,
    lat: -21.8097054
  },
  {
    lng: -42.0903798,
    lat: -21.8097533
  },
  {
    lng: -42.0903256,
    lat: -21.8097991
  },
  {
    lng: -42.0902745,
    lat: -21.8098449
  },
  {
    lng: -42.0902056,
    lat: -21.8098374
  },
  {
    lng: -42.0901561,
    lat: -21.8097918
  },
  {
    lng: -42.0901191,
    lat: -21.8097279
  },
  {
    lng: -42.0900914,
    lat: -21.8096637
  },
  {
    lng: -42.0900738,
    lat: -21.8095979
  },
  {
    lng: -42.0900645,
    lat: -21.8095257
  },
  {
    lng: -42.0900607,
    lat: -21.8094562
  },
  {
    lng: -42.0900491,
    lat: -21.809381
  },
  {
    lng: -42.090032,
    lat: -21.8093091
  },
  {
    lng: -42.0900112,
    lat: -21.8092433
  },
  {
    lng: -42.0899886,
    lat: -21.8091735
  },
  {
    lng: -42.0899709,
    lat: -21.8091111
  },
  {
    lng: -42.0899537,
    lat: -21.8090474
  },
  {
    lng: -42.089927,
    lat: -21.8089734
  },
  {
    lng: -42.0898979,
    lat: -21.8089083
  },
  {
    lng: -42.0898687,
    lat: -21.808847
  },
  {
    lng: -42.0898409,
    lat: -21.8087893
  },
  {
    lng: -42.0898223,
    lat: -21.8087264
  },
  {
    lng: -42.0898176,
    lat: -21.8086564
  },
  {
    lng: -42.0898216,
    lat: -21.80859
  },
  {
    lng: -42.089827,
    lat: -21.8085226
  },
  {
    lng: -42.0898305,
    lat: -21.8084523
  },
  {
    lng: -42.0898341,
    lat: -21.8083798
  },
  {
    lng: -42.0898436,
    lat: -21.8083164
  },
  {
    lng: -42.0898564,
    lat: -21.8082406
  },
  {
    lng: -42.089867,
    lat: -21.8081923
  },
  {
    lng: -42.0898705,
    lat: -21.8081768
  },
  {
    lng: -42.0898781,
    lat: -21.8081125
  },
  {
    lng: -42.0898752,
    lat: -21.8080408
  },
  {
    lng: -42.089859,
    lat: -21.8079771
  },
  {
    lng: -42.0898326,
    lat: -21.8079116
  },
  {
    lng: -42.0897965,
    lat: -21.8078564
  },
  {
    lng: -42.0897507,
    lat: -21.8078061
  },
  {
    lng: -42.0897035,
    lat: -21.8077541
  },
  {
    lng: -42.089661,
    lat: -21.8076902
  },
  {
    lng: -42.0896212,
    lat: -21.8076332
  },
  {
    lng: -42.0895911,
    lat: -21.8075728
  },
  {
    lng: -42.0895575,
    lat: -21.8075051
  },
  {
    lng: -42.0895246,
    lat: -21.8074468
  },
  {
    lng: -42.0894811,
    lat: -21.8073936
  },
  {
    lng: -42.0894237,
    lat: -21.8073527
  },
  {
    lng: -42.0893579,
    lat: -21.8073138
  },
  {
    lng: -42.0892986,
    lat: -21.8072759
  },
  {
    lng: -42.0892445,
    lat: -21.8072316
  },
  {
    lng: -42.0891978,
    lat: -21.8071741
  },
  {
    lng: -42.0891506,
    lat: -21.8071229
  },
  {
    lng: -42.0891016,
    lat: -21.8070692
  },
  {
    lng: -42.0890478,
    lat: -21.8070288
  },
  {
    lng: -42.0889834,
    lat: -21.806996
  },
  {
    lng: -42.0889435,
    lat: -21.8069814
  },
  {
    lng: -42.0889171,
    lat: -21.8069717
  },
  {
    lng: -42.0888469,
    lat: -21.8069564
  },
  {
    lng: -42.0887777,
    lat: -21.8069467
  },
  {
    lng: -42.0887263,
    lat: -21.8069409
  },
  {
    lng: -42.088707,
    lat: -21.8069387
  },
  {
    lng: -42.0886262,
    lat: -21.8069323
  },
  {
    lng: -42.0885541,
    lat: -21.8069307
  },
  {
    lng: -42.0884847,
    lat: -21.806927
  },
  {
    lng: -42.0884113,
    lat: -21.8069186
  },
  {
    lng: -42.0883415,
    lat: -21.8069123
  },
  {
    lng: -42.0882626,
    lat: -21.8069055
  },
  {
    lng: -42.0881895,
    lat: -21.8069017
  },
  {
    lng: -42.0881179,
    lat: -21.8068972
  },
  {
    lng: -42.0880389,
    lat: -21.8068916
  },
  {
    lng: -42.08797,
    lat: -21.8068884
  },
  {
    lng: -42.0878971,
    lat: -21.8068812
  },
  {
    lng: -42.087826,
    lat: -21.8068706
  },
  {
    lng: -42.0877595,
    lat: -21.8068532
  },
  {
    lng: -42.0877137,
    lat: -21.806806
  },
  {
    lng: -42.0877062,
    lat: -21.8067385
  },
  {
    lng: -42.0877037,
    lat: -21.8066703
  },
  {
    lng: -42.0877045,
    lat: -21.8066029
  },
  {
    lng: -42.0877047,
    lat: -21.8065887
  },
  {
    lng: -42.0877053,
    lat: -21.8065326
  },
  {
    lng: -42.0877157,
    lat: -21.8064653
  },
  {
    lng: -42.0877257,
    lat: -21.8063984
  },
  {
    lng: -42.0877141,
    lat: -21.8063314
  },
  {
    lng: -42.0876831,
    lat: -21.8062671
  },
  {
    lng: -42.087661,
    lat: -21.8061961
  },
  {
    lng: -42.0876608,
    lat: -21.8061326
  },
  {
    lng: -42.0876616,
    lat: -21.8060622
  },
  {
    lng: -42.087662,
    lat: -21.8059893
  },
  {
    lng: -42.0876628,
    lat: -21.8059142
  },
  {
    lng: -42.0876636,
    lat: -21.8058447
  },
  {
    lng: -42.0876649,
    lat: -21.8057778
  },
  {
    lng: -42.0876699,
    lat: -21.8057447
  },
  {
    lng: -42.0876753,
    lat: -21.8057092
  },
  {
    lng: -42.0877008,
    lat: -21.8056503
  },
  {
    lng: -42.0877359,
    lat: -21.8055927
  },
  {
    lng: -42.0877794,
    lat: -21.8055322
  },
  {
    lng: -42.0878254,
    lat: -21.8054837
  },
  {
    lng: -42.087887,
    lat: -21.8054393
  },
  {
    lng: -42.0879591,
    lat: -21.8054022
  },
  {
    lng: -42.0880169,
    lat: -21.8053826
  },
  {
    lng: -42.0880302,
    lat: -21.8053781
  },
  {
    lng: -42.0881047,
    lat: -21.8053685
  },
  {
    lng: -42.0881765,
    lat: -21.8053658
  },
  {
    lng: -42.0882532,
    lat: -21.8053644
  },
  {
    lng: -42.0883313,
    lat: -21.8053661
  },
  {
    lng: -42.0884043,
    lat: -21.8053685
  },
  {
    lng: -42.0884842,
    lat: -21.8053775
  },
  {
    lng: -42.0885621,
    lat: -21.8053916
  },
  {
    lng: -42.088635,
    lat: -21.805406
  },
  {
    lng: -42.088702,
    lat: -21.8054183
  },
  {
    lng: -42.0887795,
    lat: -21.8054272
  },
  {
    lng: -42.0888539,
    lat: -21.8054336
  },
  {
    lng: -42.0889274,
    lat: -21.8054382
  },
  {
    lng: -42.0889972,
    lat: -21.8054414
  },
  {
    lng: -42.0890711,
    lat: -21.8054435
  },
  {
    lng: -42.0891424,
    lat: -21.8054425
  },
  {
    lng: -42.0892109,
    lat: -21.8054393
  },
  {
    lng: -42.0892808,
    lat: -21.8054293
  },
  {
    lng: -42.0893499,
    lat: -21.8054166
  },
  {
    lng: -42.0894158,
    lat: -21.8054014
  },
  {
    lng: -42.089488,
    lat: -21.8053944
  },
  {
    lng: -42.0895626,
    lat: -21.805387
  },
  {
    lng: -42.0896325,
    lat: -21.8053749
  },
  {
    lng: -42.0897044,
    lat: -21.8053593
  },
  {
    lng: -42.0897846,
    lat: -21.8053403
  },
  {
    lng: -42.0898537,
    lat: -21.8053247
  },
  {
    lng: -42.0899178,
    lat: -21.8053043
  },
  {
    lng: -42.0899874,
    lat: -21.8052806
  },
  {
    lng: -42.0900535,
    lat: -21.8052482
  },
  {
    lng: -42.0901152,
    lat: -21.8052033
  },
  {
    lng: -42.0901658,
    lat: -21.8051566
  },
  {
    lng: -42.0902091,
    lat: -21.8051052
  },
  {
    lng: -42.090258,
    lat: -21.8050512
  },
  {
    lng: -42.0903004,
    lat: -21.8050005
  },
  {
    lng: -42.0903387,
    lat: -21.8049464
  },
  {
    lng: -42.0903793,
    lat: -21.8048927
  },
  {
    lng: -42.0904267,
    lat: -21.8048413
  },
  {
    lng: -42.0904765,
    lat: -21.8047882
  },
  {
    lng: -42.0905308,
    lat: -21.8047394
  },
  {
    lng: -42.0905834,
    lat: -21.8046837
  },
  {
    lng: -42.0906232,
    lat: -21.8046193
  },
  {
    lng: -42.0906442,
    lat: -21.80455
  },
  {
    lng: -42.0906624,
    lat: -21.8044858
  },
  {
    lng: -42.0906843,
    lat: -21.8044229
  },
  {
    lng: -42.0907029,
    lat: -21.8043609
  },
  {
    lng: -42.0907184,
    lat: -21.8042902
  },
  {
    lng: -42.090727,
    lat: -21.8042234
  },
  {
    lng: -42.0907375,
    lat: -21.8041501
  },
  {
    lng: -42.090747,
    lat: -21.8040828
  },
  {
    lng: -42.0907478,
    lat: -21.8040129
  },
  {
    lng: -42.0907458,
    lat: -21.8039468
  },
  {
    lng: -42.0907346,
    lat: -21.803884
  },
  {
    lng: -42.0907165,
    lat: -21.8038173
  },
  {
    lng: -42.090685,
    lat: -21.8037578
  },
  {
    lng: -42.0906466,
    lat: -21.8037042
  },
  {
    lng: -42.0906091,
    lat: -21.803648
  },
  {
    lng: -42.090573,
    lat: -21.8035919
  },
  {
    lng: -42.0905351,
    lat: -21.8035353
  },
  {
    lng: -42.0904889,
    lat: -21.8034722
  },
  {
    lng: -42.0904662,
    lat: -21.8034435
  },
  {
    lng: -42.0904441,
    lat: -21.8034155
  },
  {
    lng: -42.0904038,
    lat: -21.8033636
  },
  {
    lng: -42.0903621,
    lat: -21.8033113
  },
  {
    lng: -42.0903173,
    lat: -21.8032512
  },
  {
    lng: -42.0902664,
    lat: -21.8031983
  },
  {
    lng: -42.0902044,
    lat: -21.8031578
  },
  {
    lng: -42.0901474,
    lat: -21.803122
  },
  {
    lng: -42.0900793,
    lat: -21.8030887
  },
  {
    lng: -42.0900041,
    lat: -21.8030768
  },
  {
    lng: -42.0899356,
    lat: -21.8030761
  },
  {
    lng: -42.0899132,
    lat: -21.8030759
  },
  {
    lng: -42.089863,
    lat: -21.8030754
  },
  {
    lng: -42.0897941,
    lat: -21.8030747
  },
  {
    lng: -42.0897211,
    lat: -21.8030744
  },
  {
    lng: -42.0896494,
    lat: -21.8030737
  },
  {
    lng: -42.089603,
    lat: -21.8030704
  },
  {
    lng: -42.0895801,
    lat: -21.8030687
  },
  {
    lng: -42.0895478,
    lat: -21.8030607
  },
  {
    lng: -42.08951,
    lat: -21.8030513
  },
  {
    lng: -42.0894414,
    lat: -21.8030167
  },
  {
    lng: -42.0893952,
    lat: -21.8029622
  },
  {
    lng: -42.0893707,
    lat: -21.8028911
  },
  {
    lng: -42.0893559,
    lat: -21.8028201
  },
  {
    lng: -42.0893545,
    lat: -21.8027472
  },
  {
    lng: -42.0893599,
    lat: -21.8026743
  },
  {
    lng: -42.0893764,
    lat: -21.8026011
  },
  {
    lng: -42.0893947,
    lat: -21.8025296
  },
  {
    lng: -42.0894193,
    lat: -21.8024603
  },
  {
    lng: -42.0894551,
    lat: -21.8023916
  },
  {
    lng: -42.0894948,
    lat: -21.8023306
  },
  {
    lng: -42.0895411,
    lat: -21.8022654
  },
  {
    lng: -42.0895812,
    lat: -21.8022096
  },
  {
    lng: -42.0896191,
    lat: -21.8021555
  },
  {
    lng: -42.0896565,
    lat: -21.8020988
  },
  {
    lng: -42.0897036,
    lat: -21.8020354
  },
  {
    lng: -42.0897073,
    lat: -21.8020306
  },
  {
    lng: -42.0897456,
    lat: -21.8019817
  },
  {
    lng: -42.0897633,
    lat: -21.801918
  },
  {
    lng: -42.0897646,
    lat: -21.8018442
  },
  {
    lng: -42.0897558,
    lat: -21.8017771
  },
  {
    lng: -42.0897349,
    lat: -21.8017134
  },
  {
    lng: -42.0897108,
    lat: -21.8016535
  },
  {
    lng: -42.0896714,
    lat: -21.8015986
  },
  {
    lng: -42.0896229,
    lat: -21.8015454
  },
  {
    lng: -42.089566,
    lat: -21.8014967
  },
  {
    lng: -42.0895068,
    lat: -21.8014515
  },
  {
    lng: -42.0894406,
    lat: -21.8014092
  },
  {
    lng: -42.0893795,
    lat: -21.8013717
  },
  {
    lng: -42.089315,
    lat: -21.8013515
  },
  {
    lng: -42.0892356,
    lat: -21.8013346
  },
  {
    lng: -42.0891612,
    lat: -21.8013309
  },
  {
    lng: -42.0890835,
    lat: -21.8013426
  },
  {
    lng: -42.0890153,
    lat: -21.8013577
  },
  {
    lng: -42.0889498,
    lat: -21.8013794
  },
  {
    lng: -42.0888768,
    lat: -21.8014113
  },
  {
    lng: -42.088807,
    lat: -21.8014453
  },
  {
    lng: -42.0887404,
    lat: -21.8014829
  },
  {
    lng: -42.0886757,
    lat: -21.8015165
  },
  {
    lng: -42.0886483,
    lat: -21.8015318
  },
  {
    lng: -42.0886174,
    lat: -21.801549
  },
  {
    lng: -42.0885582,
    lat: -21.8015857
  },
  {
    lng: -42.0884989,
    lat: -21.8016255
  },
  {
    lng: -42.0884447,
    lat: -21.8016657
  },
  {
    lng: -42.0883919,
    lat: -21.8017059
  },
  {
    lng: -42.0883404,
    lat: -21.8017479
  },
  {
    lng: -42.0882847,
    lat: -21.8017907
  },
  {
    lng: -42.0882364,
    lat: -21.8018352
  },
  {
    lng: -42.0881917,
    lat: -21.8018854
  },
  {
    lng: -42.0881594,
    lat: -21.8019413
  },
  {
    lng: -42.0881348,
    lat: -21.8020037
  },
  {
    lng: -42.0881157,
    lat: -21.8020662
  },
  {
    lng: -42.0881094,
    lat: -21.8021322
  },
  {
    lng: -42.0881085,
    lat: -21.8022069
  },
  {
    lng: -42.0881073,
    lat: -21.8022716
  },
  {
    lng: -42.0881065,
    lat: -21.8023416
  },
  {
    lng: -42.0881057,
    lat: -21.8024124
  },
  {
    lng: -42.0881003,
    lat: -21.8024831
  },
  {
    lng: -42.0880903,
    lat: -21.8025573
  },
  {
    lng: -42.0880803,
    lat: -21.8026275
  },
  {
    lng: -42.088067,
    lat: -21.8027038
  },
  {
    lng: -42.0880488,
    lat: -21.802768
  },
  {
    lng: -42.0880223,
    lat: -21.8028316
  },
  {
    lng: -42.0880022,
    lat: -21.8029001
  },
  {
    lng: -42.0879963,
    lat: -21.8029721
  },
  {
    lng: -42.087995,
    lat: -21.8030468
  },
  {
    lng: -42.0879943,
    lat: -21.8031124
  },
  {
    lng: -42.0879911,
    lat: -21.8031849
  },
  {
    lng: -42.0879829,
    lat: -21.8032569
  },
  {
    lng: -42.0879698,
    lat: -21.8033237
  },
  {
    lng: -42.0879478,
    lat: -21.8033947
  },
  {
    lng: -42.0879209,
    lat: -21.8034601
  },
  {
    lng: -42.0878931,
    lat: -21.8035204
  },
  {
    lng: -42.0878611,
    lat: -21.8035857
  },
  {
    lng: -42.0878287,
    lat: -21.8036454
  },
  {
    lng: -42.0877862,
    lat: -21.8037064
  },
  {
    lng: -42.0877377,
    lat: -21.8037604
  },
  {
    lng: -42.0877193,
    lat: -21.8037722
  },
  {
    lng: -42.0876762,
    lat: -21.8037997
  },
  {
    lng: -42.0876016,
    lat: -21.8038127
  },
  {
    lng: -42.0875276,
    lat: -21.8038119
  },
  {
    lng: -42.0874612,
    lat: -21.8037936
  },
  {
    lng: -42.0874048,
    lat: -21.8037454
  },
  {
    lng: -42.0873747,
    lat: -21.8036876
  },
  {
    lng: -42.0873441,
    lat: -21.8036243
  },
  {
    lng: -42.0873131,
    lat: -21.8035656
  },
  {
    lng: -42.0872789,
    lat: -21.8035004
  },
  {
    lng: -42.0872387,
    lat: -21.8034473
  },
  {
    lng: -42.0871993,
    lat: -21.8033958
  },
  {
    lng: -42.0871557,
    lat: -21.8033469
  },
  {
    lng: -42.087108,
    lat: -21.8032996
  },
  {
    lng: -42.0870603,
    lat: -21.8032502
  },
  {
    lng: -42.0870121,
    lat: -21.8032055
  },
  {
    lng: -42.0869579,
    lat: -21.8031677
  },
  {
    lng: -42.0869004,
    lat: -21.8031336
  },
  {
    lng: -42.0868402,
    lat: -21.803094
  },
  {
    lng: -42.0868128,
    lat: -21.803074
  },
  {
    lng: -42.0867842,
    lat: -21.8030531
  },
  {
    lng: -42.0867308,
    lat: -21.8030139
  },
  {
    lng: -42.0866831,
    lat: -21.8029679
  },
  {
    lng: -42.0866379,
    lat: -21.8029091
  },
  {
    lng: -42.0865897,
    lat: -21.8028601
  },
  {
    lng: -42.0865397,
    lat: -21.8028103
  },
  {
    lng: -42.0864852,
    lat: -21.8027595
  },
  {
    lng: -42.0864293,
    lat: -21.8027032
  },
  {
    lng: -42.0863863,
    lat: -21.80265
  },
  {
    lng: -42.0863229,
    lat: -21.8026205
  },
  {
    lng: -42.0862727,
    lat: -21.8025736
  },
  {
    lng: -42.0862294,
    lat: -21.8025193
  },
  {
    lng: -42.0861862,
    lat: -21.8024611
  },
  {
    lng: -42.086147,
    lat: -21.8024088
  },
  {
    lng: -42.0861075,
    lat: -21.8023549
  },
  {
    lng: -42.0860677,
    lat: -21.8022904
  },
  {
    lng: -42.0860371,
    lat: -21.8022261
  },
  {
    lng: -42.0860027,
    lat: -21.8021652
  },
  {
    lng: -42.0859657,
    lat: -21.8021118
  },
  {
    lng: -42.0859292,
    lat: -21.8020552
  },
  {
    lng: -42.0858896,
    lat: -21.8020014
  },
  {
    lng: -42.085848,
    lat: -21.8019436
  },
  {
    lng: -42.0858098,
    lat: -21.8018874
  },
  {
    lng: -42.0857737,
    lat: -21.8018284
  },
  {
    lng: -42.0857393,
    lat: -21.8017676
  },
  {
    lng: -42.0857033,
    lat: -21.8017016
  },
  {
    lng: -42.0856656,
    lat: -21.8016407
  },
  {
    lng: -42.0856241,
    lat: -21.801577
  },
  {
    lng: -42.0855791,
    lat: -21.8015242
  },
  {
    lng: -42.0855189,
    lat: -21.8014744
  },
  {
    lng: -42.0854534,
    lat: -21.8014446
  },
  {
    lng: -42.0853767,
    lat: -21.8014279
  },
  {
    lng: -42.0852959,
    lat: -21.8014151
  },
  {
    lng: -42.0852229,
    lat: -21.8014086
  },
  {
    lng: -42.0851523,
    lat: -21.8014077
  },
  {
    lng: -42.0850771,
    lat: -21.8014072
  },
  {
    lng: -42.0850061,
    lat: -21.8014062
  },
  {
    lng: -42.0849339,
    lat: -21.8014053
  },
  {
    lng: -42.0848637,
    lat: -21.8014044
  },
  {
    lng: -42.0847923,
    lat: -21.8014058
  },
  {
    lng: -42.0847226,
    lat: -21.8014057
  },
  {
    lng: -42.0846541,
    lat: -21.8014049
  },
  {
    lng: -42.0845865,
    lat: -21.8014036
  },
  {
    lng: -42.084518,
    lat: -21.8014015
  },
  {
    lng: -42.0844491,
    lat: -21.801401
  },
  {
    lng: -42.0843803,
    lat: -21.8013998
  },
  {
    lng: -42.084311,
    lat: -21.8013989
  },
  {
    lng: -42.0842785,
    lat: -21.8013976
  },
  {
    lng: -42.0842362,
    lat: -21.8013959
  },
  {
    lng: -42.0841678,
    lat: -21.8013919
  },
  {
    lng: -42.0840953,
    lat: -21.8013831
  },
  {
    lng: -42.0840177,
    lat: -21.8013712
  },
  {
    lng: -42.0839498,
    lat: -21.8013605
  },
  {
    lng: -42.0838686,
    lat: -21.8013457
  },
  {
    lng: -42.0837881,
    lat: -21.8013302
  },
  {
    lng: -42.0837124,
    lat: -21.8013115
  },
  {
    lng: -42.0836379,
    lat: -21.801291
  },
  {
    lng: -42.0835664,
    lat: -21.8012649
  },
  {
    lng: -42.0835035,
    lat: -21.8012316
  },
  {
    lng: -42.0834469,
    lat: -21.8011959
  },
  {
    lng: -42.0833824,
    lat: -21.8011547
  },
  {
    lng: -42.0833237,
    lat: -21.8011155
  },
  {
    lng: -42.0832634,
    lat: -21.801077
  },
  {
    lng: -42.0832,
    lat: -21.8010464
  },
  {
    lng: -42.0831353,
    lat: -21.8010197
  },
  {
    lng: -42.083068,
    lat: -21.8009933
  },
  {
    lng: -42.0829949,
    lat: -21.8009653
  },
  {
    lng: -42.082921,
    lat: -21.8009361
  },
  {
    lng: -42.0828487,
    lat: -21.8009097
  },
  {
    lng: -42.0827759,
    lat: -21.8008864
  },
  {
    lng: -42.0827494,
    lat: -21.8008797
  },
  {
    lng: -42.0827023,
    lat: -21.8008678
  },
  {
    lng: -42.0826278,
    lat: -21.8008499
  },
  {
    lng: -42.0825571,
    lat: -21.8008314
  },
  {
    lng: -42.0824805,
    lat: -21.8008065
  },
  {
    lng: -42.0824074,
    lat: -21.8007828
  },
  {
    lng: -42.0823346,
    lat: -21.8007646
  },
  {
    lng: -42.0822816,
    lat: -21.8007556
  },
  {
    lng: -42.0822646,
    lat: -21.8007527
  },
  {
    lng: -42.082197,
    lat: -21.8007463
  },
  {
    lng: -42.0821248,
    lat: -21.8007454
  },
  {
    lng: -42.08205,
    lat: -21.8007444
  },
  {
    lng: -42.0819815,
    lat: -21.8007447
  },
  {
    lng: -42.0819084,
    lat: -21.80075
  },
  {
    lng: -42.0818373,
    lat: -21.8007578
  },
  {
    lng: -42.0817631,
    lat: -21.8007737
  },
  {
    lng: -42.0816939,
    lat: -21.8007916
  },
  {
    lng: -42.0816278,
    lat: -21.8008065
  },
  {
    lng: -42.0815533,
    lat: -21.8008126
  },
  {
    lng: -42.0814785,
    lat: -21.8008124
  },
  {
    lng: -42.0814743,
    lat: -21.8008121
  },
  {
    lng: -42.0814068,
    lat: -21.8008083
  },
  {
    lng: -42.0813376,
    lat: -21.8007984
  },
  {
    lng: -42.0812677,
    lat: -21.8007834
  },
  {
    lng: -42.0812051,
    lat: -21.8007555
  },
  {
    lng: -42.0811476,
    lat: -21.8007202
  },
  {
    lng: -42.0810919,
    lat: -21.8006803
  },
  {
    lng: -42.0810447,
    lat: -21.8006342
  },
  {
    lng: -42.0809949,
    lat: -21.8005892
  },
  {
    lng: -42.0809439,
    lat: -21.8005469
  },
  {
    lng: -42.0808784,
    lat: -21.8005179
  },
  {
    lng: -42.0808109,
    lat: -21.8005064
  },
  {
    lng: -42.0807408,
    lat: -21.8005067
  },
  {
    lng: -42.0806671,
    lat: -21.8005144
  },
  {
    lng: -42.0805954,
    lat: -21.8005358
  },
  {
    lng: -42.0805319,
    lat: -21.8005652
  },
  {
    lng: -42.0804647,
    lat: -21.8005961
  },
  {
    lng: -42.0803907,
    lat: -21.8006257
  },
  {
    lng: -42.0803261,
    lat: -21.8006469
  },
  {
    lng: -42.0802624,
    lat: -21.8006696
  },
  {
    lng: -42.0801989,
    lat: -21.8007009
  },
  {
    lng: -42.0801379,
    lat: -21.8007327
  },
  {
    lng: -42.0801275,
    lat: -21.8007386
  },
  {
    lng: -42.0800719,
    lat: -21.8007699
  },
  {
    lng: -42.0800137,
    lat: -21.8008072
  },
  {
    lng: -42.0799627,
    lat: -21.8008521
  },
  {
    lng: -42.0799215,
    lat: -21.8009112
  },
  {
    lng: -42.079897,
    lat: -21.8009748
  },
  {
    lng: -42.0798763,
    lat: -21.8010365
  },
  {
    lng: -42.0798531,
    lat: -21.8011021
  },
  {
    lng: -42.0798316,
    lat: -21.8011623
  },
  {
    lng: -42.0798302,
    lat: -21.8011674
  },
  {
    lng: -42.0798112,
    lat: -21.8012365
  },
  {
    lng: -42.0797943,
    lat: -21.8013034
  },
  {
    lng: -42.0797824,
    lat: -21.8013692
  },
  {
    lng: -42.079773,
    lat: -21.8014365
  },
  {
    lng: -42.0797594,
    lat: -21.8015034
  },
  {
    lng: -42.0797412,
    lat: -21.8015695
  },
  {
    lng: -42.0797222,
    lat: -21.8016312
  },
  {
    lng: -42.0797053,
    lat: -21.8016938
  },
  {
    lng: -42.0796621,
    lat: -21.8017446
  },
  {
    lng: -42.0796036,
    lat: -21.8017804
  },
  {
    lng: -42.079539,
    lat: -21.8018078
  },
  {
    lng: -42.0794614,
    lat: -21.8018217
  },
  {
    lng: -42.0793821,
    lat: -21.8018191
  },
  {
    lng: -42.0793108,
    lat: -21.8018123
  },
  {
    lng: -42.0792425,
    lat: -21.8017973
  },
  {
    lng: -42.0791766,
    lat: -21.8017698
  },
  {
    lng: -42.0791121,
    lat: -21.8017273
  },
  {
    lng: -42.0790497,
    lat: -21.801681
  },
  {
    lng: -42.0789946,
    lat: -21.8016289
  },
  {
    lng: -42.0789777,
    lat: -21.8016056
  },
  {
    lng: -42.0789535,
    lat: -21.8015723
  },
  {
    lng: -42.0789178,
    lat: -21.8015095
  },
  {
    lng: -42.0788902,
    lat: -21.8014475
  },
  {
    lng: -42.0788701,
    lat: -21.8013853
  },
  {
    lng: -42.0788564,
    lat: -21.8013168
  },
  {
    lng: -42.078846,
    lat: -21.8012512
  },
  {
    lng: -42.0788392,
    lat: -21.8011777
  },
  {
    lng: -42.0788233,
    lat: -21.801114
  },
  {
    lng: -42.0788003,
    lat: -21.8010489
  },
  {
    lng: -42.0787727,
    lat: -21.8009819
  },
  {
    lng: -42.0787472,
    lat: -21.8009219
  },
  {
    lng: -42.0787169,
    lat: -21.8008631
  },
  {
    lng: -42.0786749,
    lat: -21.800806
  },
  {
    lng: -42.0786172,
    lat: -21.8007606
  },
  {
    lng: -42.078547,
    lat: -21.8007357
  },
  {
    lng: -42.078479,
    lat: -21.8007302
  },
  {
    lng: -42.0784056,
    lat: -21.8007268
  },
  {
    lng: -42.0783283,
    lat: -21.8007282
  },
  {
    lng: -42.0782548,
    lat: -21.8007508
  },
  {
    lng: -42.0781867,
    lat: -21.800784
  },
  {
    lng: -42.0781151,
    lat: -21.8008251
  },
  {
    lng: -42.0780485,
    lat: -21.8008709
  },
  {
    lng: -42.0779856,
    lat: -21.8009192
  },
  {
    lng: -42.0779312,
    lat: -21.8009589
  },
  {
    lng: -42.0778752,
    lat: -21.8009958
  },
  {
    lng: -42.0778065,
    lat: -21.8010408
  },
  {
    lng: -42.0777468,
    lat: -21.8010746
  },
  {
    lng: -42.0776743,
    lat: -21.801114
  },
  {
    lng: -42.0776078,
    lat: -21.8011528
  },
  {
    lng: -42.0775409,
    lat: -21.80119
  },
  {
    lng: -42.0774791,
    lat: -21.8012194
  },
  {
    lng: -42.0774149,
    lat: -21.8012433
  },
  {
    lng: -42.0773432,
    lat: -21.8012624
  },
  {
    lng: -42.0772707,
    lat: -21.8012775
  },
  {
    lng: -42.0771996,
    lat: -21.801286
  },
  {
    lng: -42.0771303,
    lat: -21.8012867
  },
  {
    lng: -42.0770602,
    lat: -21.8012834
  },
  {
    lng: -42.0769809,
    lat: -21.8012777
  },
  {
    lng: -42.0769108,
    lat: -21.8012729
  },
  {
    lng: -42.0768369,
    lat: -21.801266
  },
  {
    lng: -42.0767665,
    lat: -21.8012569
  },
  {
    lng: -42.0766957,
    lat: -21.8012434
  },
  {
    lng: -42.0766161,
    lat: -21.8012279
  },
  {
    lng: -42.0765487,
    lat: -21.8012156
  },
  {
    lng: -42.0764741,
    lat: -21.8011982
  },
  {
    lng: -42.0763946,
    lat: -21.8011768
  },
  {
    lng: -42.0763277,
    lat: -21.8011555
  },
  {
    lng: -42.0762638,
    lat: -21.8011307
  },
  {
    lng: -42.0761874,
    lat: -21.8010988
  },
  {
    lng: -42.0761174,
    lat: -21.8010645
  },
  {
    lng: -42.0760516,
    lat: -21.8010252
  },
  {
    lng: -42.0759887,
    lat: -21.8009867
  },
  {
    lng: -42.0759308,
    lat: -21.8009538
  },
  {
    lng: -42.0758708,
    lat: -21.8009228
  },
  {
    lng: -42.07581,
    lat: -21.8008833
  },
  {
    lng: -42.075754,
    lat: -21.8008327
  },
  {
    lng: -42.0756966,
    lat: -21.8007927
  },
  {
    lng: -42.0756392,
    lat: -21.8007563
  },
  {
    lng: -42.0755687,
    lat: -21.8007197
  },
  {
    lng: -42.0755003,
    lat: -21.8006866
  },
  {
    lng: -42.0754416,
    lat: -21.8006514
  },
  {
    lng: -42.0753762,
    lat: -21.8006148
  },
  {
    lng: -42.0753045,
    lat: -21.8005786
  },
  {
    lng: -42.0752361,
    lat: -21.800542
  },
  {
    lng: -42.0751804,
    lat: -21.8005052
  },
  {
    lng: -42.0751218,
    lat: -21.8004585
  },
  {
    lng: -42.0750717,
    lat: -21.800412
  },
  {
    lng: -42.0750682,
    lat: -21.8004091
  },
  {
    lng: -42.075014,
    lat: -21.8003649
  },
  {
    lng: -42.0749495,
    lat: -21.8003229
  },
  {
    lng: -42.0748841,
    lat: -21.800284
  },
  {
    lng: -42.0748216,
    lat: -21.8002503
  },
  {
    lng: -42.0747604,
    lat: -21.8002169
  },
  {
    lng: -42.074697,
    lat: -21.8001759
  },
  {
    lng: -42.0746334,
    lat: -21.800138
  },
  {
    lng: -42.0745697,
    lat: -21.8001003
  },
  {
    lng: -42.0745056,
    lat: -21.8000571
  },
  {
    lng: -42.0744818,
    lat: -21.8000399
  },
  {
    lng: -42.0744458,
    lat: -21.8000139
  },
  {
    lng: -42.0743931,
    lat: -21.7999701
  },
  {
    lng: -42.0743438,
    lat: -21.7999251
  },
  {
    lng: -42.0742937,
    lat: -21.7998696
  },
  {
    lng: -42.0742551,
    lat: -21.7998153
  },
  {
    lng: -42.0742136,
    lat: -21.7997504
  },
  {
    lng: -42.0741703,
    lat: -21.7996953
  },
  {
    lng: -42.0741232,
    lat: -21.7996406
  },
  {
    lng: -42.0740842,
    lat: -21.7995824
  },
  {
    lng: -42.0740519,
    lat: -21.7995212
  },
  {
    lng: -42.0740281,
    lat: -21.7994569
  },
  {
    lng: -42.0740111,
    lat: -21.7993845
  },
  {
    lng: -42.0740066,
    lat: -21.7993209
  },
  {
    lng: -42.074008,
    lat: -21.7992542
  },
  {
    lng: -42.0740111,
    lat: -21.7991825
  },
  {
    lng: -42.0740248,
    lat: -21.7991093
  },
  {
    lng: -42.0740375,
    lat: -21.7990443
  },
  {
    lng: -42.0740474,
    lat: -21.7989719
  },
  {
    lng: -42.0740421,
    lat: -21.7989051
  },
  {
    lng: -42.0740187,
    lat: -21.7988452
  },
  {
    lng: -42.0739762,
    lat: -21.7987897
  },
  {
    lng: -42.073919,
    lat: -21.7987372
  },
  {
    lng: -42.07386,
    lat: -21.798696
  },
  {
    lng: -42.0738025,
    lat: -21.7986619
  },
  {
    lng: -42.073752,
    lat: -21.7986115
  },
  {
    lng: -42.0737121,
    lat: -21.798558
  },
  {
    lng: -42.0736704,
    lat: -21.798508
  },
  {
    lng: -42.0736206,
    lat: -21.7984634
  },
  {
    lng: -42.0735615,
    lat: -21.7984254
  },
  {
    lng: -42.0734932,
    lat: -21.798388
  },
  {
    lng: -42.0734302,
    lat: -21.7983574
  },
  {
    lng: -42.0733613,
    lat: -21.7983306
  },
  {
    lng: -42.0732927,
    lat: -21.7983113
  },
  {
    lng: -42.0732219,
    lat: -21.7982951
  },
  {
    lng: -42.073144,
    lat: -21.7982792
  },
  {
    lng: -42.0730728,
    lat: -21.7982657
  },
  {
    lng: -42.0730007,
    lat: -21.7982542
  },
  {
    lng: -42.0729219,
    lat: -21.7982422
  },
  {
    lng: -42.0728473,
    lat: -21.7982326
  },
  {
    lng: -42.0727756,
    lat: -21.7982238
  },
  {
    lng: -42.0727001,
    lat: -21.7982169
  },
  {
    lng: -42.0726275,
    lat: -21.7982085
  },
  {
    lng: -42.0725567,
    lat: -21.7982006
  },
  {
    lng: -42.0724736,
    lat: -21.7981928
  },
  {
    lng: -42.0723947,
    lat: -21.7981851
  },
  {
    lng: -42.0723239,
    lat: -21.7981756
  },
  {
    lng: -42.0722565,
    lat: -21.7981618
  },
  {
    lng: -42.07219,
    lat: -21.7981378
  },
  {
    lng: -42.0721293,
    lat: -21.7980938
  },
  {
    lng: -42.0720818,
    lat: -21.7980422
  },
  {
    lng: -42.072049,
    lat: -21.7979868
  },
  {
    lng: -42.0720218,
    lat: -21.7979249
  },
  {
    lng: -42.0720006,
    lat: -21.7978528
  },
  {
    lng: -42.071981,
    lat: -21.7977882
  },
  {
    lng: -42.0719581,
    lat: -21.7977162
  },
  {
    lng: -42.0719482,
    lat: -21.7976489
  },
  {
    lng: -42.0719454,
    lat: -21.7975802
  },
  {
    lng: -42.0719464,
    lat: -21.7975132
  },
  {
    lng: -42.0719473,
    lat: -21.7974492
  },
  {
    lng: -42.0719491,
    lat: -21.7973845
  },
  {
    lng: -42.0719515,
    lat: -21.797312
  },
  {
    lng: -42.0719605,
    lat: -21.7972442
  },
  {
    lng: -42.0719854,
    lat: -21.7971783
  },
  {
    lng: -42.0720152,
    lat: -21.7971198
  },
  {
    lng: -42.072043,
    lat: -21.7970609
  },
  {
    lng: -42.0720577,
    lat: -21.7970258
  },
  {
    lng: -42.0720691,
    lat: -21.7969985
  },
  {
    lng: -42.0720781,
    lat: -21.7969303
  },
  {
    lng: -42.0720754,
    lat: -21.7968609
  },
  {
    lng: -42.0720487,
    lat: -21.7967938
  },
  {
    lng: -42.0719998,
    lat: -21.7967461
  },
  {
    lng: -42.0719283,
    lat: -21.7967252
  },
  {
    lng: -42.0718665,
    lat: -21.7966989
  },
  {
    lng: -42.0718028,
    lat: -21.7966612
  },
  {
    lng: -42.0717496,
    lat: -21.7966217
  },
  {
    lng: -42.0716943,
    lat: -21.7965829
  },
  {
    lng: -42.0716305,
    lat: -21.7965487
  },
  {
    lng: -42.0715615,
    lat: -21.7965329
  },
  {
    lng: -42.0714867,
    lat: -21.7965292
  },
  {
    lng: -42.0714127,
    lat: -21.7965337
  },
  {
    lng: -42.071349,
    lat: -21.7965564
  },
  {
    lng: -42.0712863,
    lat: -21.796589
  },
  {
    lng: -42.071224,
    lat: -21.796629
  },
  {
    lng: -42.0711712,
    lat: -21.7966754
  },
  {
    lng: -42.0711221,
    lat: -21.7967257
  },
  {
    lng: -42.0710738,
    lat: -21.7967832
  },
  {
    lng: -42.0710352,
    lat: -21.7968364
  },
  {
    lng: -42.0709952,
    lat: -21.7968987
  },
  {
    lng: -42.0709682,
    lat: -21.7969638
  },
  {
    lng: -42.0709496,
    lat: -21.7970271
  },
  {
    lng: -42.0709323,
    lat: -21.7970932
  },
  {
    lng: -42.0709215,
    lat: -21.7971653
  },
  {
    lng: -42.0709126,
    lat: -21.7972287
  },
  {
    lng: -42.0709028,
    lat: -21.7972949
  },
  {
    lng: -42.0708851,
    lat: -21.797357
  },
  {
    lng: -42.0708582,
    lat: -21.7974155
  },
  {
    lng: -42.0708249,
    lat: -21.7974751
  },
  {
    lng: -42.0707842,
    lat: -21.7975295
  },
  {
    lng: -42.0707389,
    lat: -21.7975803
  },
  {
    lng: -42.0706845,
    lat: -21.7976251
  },
  {
    lng: -42.0706214,
    lat: -21.7976592
  },
  {
    lng: -42.0705533,
    lat: -21.7976634
  },
  {
    lng: -42.0704832,
    lat: -21.7976574
  },
  {
    lng: -42.0704138,
    lat: -21.7976381
  },
  {
    lng: -42.0703487,
    lat: -21.7976067
  },
  {
    lng: -42.0702935,
    lat: -21.7975655
  },
  {
    lng: -42.0702481,
    lat: -21.7975096
  },
  {
    lng: -42.0702216,
    lat: -21.7974508
  },
  {
    lng: -42.0702059,
    lat: -21.797382
  },
  {
    lng: -42.0702051,
    lat: -21.7973749
  },
  {
    lng: -42.0701985,
    lat: -21.7973132
  },
  {
    lng: -42.0701928,
    lat: -21.7972457
  },
  {
    lng: -42.070182,
    lat: -21.7971804
  },
  {
    lng: -42.0701678,
    lat: -21.7971175
  },
  {
    lng: -42.0701578,
    lat: -21.7970534
  },
  {
    lng: -42.0701424,
    lat: -21.7969908
  },
  {
    lng: -42.0701147,
    lat: -21.7969328
  },
  {
    lng: -42.0700751,
    lat: -21.7968805
  },
  {
    lng: -42.0700275,
    lat: -21.7968344
  },
  {
    lng: -42.0699649,
    lat: -21.7968025
  },
  {
    lng: -42.069898,
    lat: -21.7967809
  },
  {
    lng: -42.069825,
    lat: -21.7967745
  },
  {
    lng: -42.0697511,
    lat: -21.7967735
  },
  {
    lng: -42.0696709,
    lat: -21.7967756
  },
  {
    lng: -42.069598,
    lat: -21.7967852
  },
  {
    lng: -42.0695247,
    lat: -21.7968039
  },
  {
    lng: -42.0694621,
    lat: -21.7968313
  },
  {
    lng: -42.0693906,
    lat: -21.7968653
  },
  {
    lng: -42.0693236,
    lat: -21.7969053
  },
  {
    lng: -42.0692672,
    lat: -21.7969422
  },
  {
    lng: -42.0692149,
    lat: -21.7969839
  },
  {
    lng: -42.0691662,
    lat: -21.7970398
  },
  {
    lng: -42.0691384,
    lat: -21.7970776
  },
  {
    lng: -42.069125,
    lat: -21.7970957
  },
  {
    lng: -42.0690775,
    lat: -21.7971559
  },
  {
    lng: -42.0690302,
    lat: -21.7972043
  },
  {
    lng: -42.0689769,
    lat: -21.7972539
  },
  {
    lng: -42.0689275,
    lat: -21.7973042
  },
  {
    lng: -42.0688785,
    lat: -21.7973495
  },
  {
    lng: -42.068819,
    lat: -21.7973966
  },
  {
    lng: -42.068759,
    lat: -21.7974472
  },
  {
    lng: -42.0687067,
    lat: -21.7974904
  },
  {
    lng: -42.0686569,
    lat: -21.7975345
  },
  {
    lng: -42.0685982,
    lat: -21.7975812
  },
  {
    lng: -42.0685412,
    lat: -21.7976307
  },
  {
    lng: -42.068503,
    lat: -21.7976863
  },
  {
    lng: -42.0684637,
    lat: -21.7977533
  },
  {
    lng: -42.0684375,
    lat: -21.7978247
  },
  {
    lng: -42.0684226,
    lat: -21.7978952
  },
  {
    lng: -42.0684215,
    lat: -21.7979673
  },
  {
    lng: -42.0684205,
    lat: -21.7980313
  },
  {
    lng: -42.0684195,
    lat: -21.7981015
  },
  {
    lng: -42.0684189,
    lat: -21.7981725
  },
  {
    lng: -42.0684246,
    lat: -21.7982416
  },
  {
    lng: -42.0684357,
    lat: -21.79831
  },
  {
    lng: -42.0684516,
    lat: -21.798373
  },
  {
    lng: -42.0684708,
    lat: -21.7984344
  },
  {
    lng: -42.0684989,
    lat: -21.7984991
  },
  {
    lng: -42.0685345,
    lat: -21.7985604
  },
  {
    lng: -42.0685732,
    lat: -21.7986123
  },
  {
    lng: -42.0686174,
    lat: -21.7986611
  },
  {
    lng: -42.0686642,
    lat: -21.7987068
  },
  {
    lng: -42.0687195,
    lat: -21.7987495
  },
  {
    lng: -42.068781,
    lat: -21.7987907
  },
  {
    lng: -42.0688384,
    lat: -21.7988315
  },
  {
    lng: -42.0689041,
    lat: -21.7988739
  },
  {
    lng: -42.0689663,
    lat: -21.7989038
  },
  {
    lng: -42.0690323,
    lat: -21.7989305
  },
  {
    lng: -42.0690991,
    lat: -21.7989545
  },
  {
    lng: -42.0691735,
    lat: -21.7989783
  },
  {
    lng: -42.0692447,
    lat: -21.7989964
  },
  {
    lng: -42.0693099,
    lat: -21.7990145
  },
  {
    lng: -42.0693769,
    lat: -21.7990331
  },
  {
    lng: -42.0694447,
    lat: -21.7990481
  },
  {
    lng: -42.0695205,
    lat: -21.7990628
  },
  {
    lng: -42.0695937,
    lat: -21.7990853
  },
  {
    lng: -42.0696639,
    lat: -21.7991105
  },
  {
    lng: -42.0697248,
    lat: -21.7991411
  },
  {
    lng: -42.0697756,
    lat: -21.7991963
  },
  {
    lng: -42.0698159,
    lat: -21.7992569
  },
  {
    lng: -42.0698444,
    lat: -21.7993188
  },
  {
    lng: -42.069853,
    lat: -21.7993904
  },
  {
    lng: -42.0698365,
    lat: -21.7994525
  },
  {
    lng: -42.0697908,
    lat: -21.7995076
  },
  {
    lng: -42.06973,
    lat: -21.7995543
  },
  {
    lng: -42.0696639,
    lat: -21.7995919
  },
  {
    lng: -42.0695928,
    lat: -21.7996239
  },
  {
    lng: -42.0695291,
    lat: -21.7996455
  },
  {
    lng: -42.0694573,
    lat: -21.7996693
  },
  {
    lng: -42.0693885,
    lat: -21.7996935
  },
  {
    lng: -42.0693247,
    lat: -21.7997166
  },
  {
    lng: -42.0692545,
    lat: -21.7997467
  },
  {
    lng: -42.0691868,
    lat: -21.7997842
  },
  {
    lng: -42.0691256,
    lat: -21.7998278
  },
  {
    lng: -42.0690699,
    lat: -21.7998749
  },
  {
    lng: -42.0690208,
    lat: -21.7999249
  },
  {
    lng: -42.0689758,
    lat: -21.7999851
  },
  {
    lng: -42.0689426,
    lat: -21.8000435
  },
  {
    lng: -42.0689123,
    lat: -21.8001059
  },
  {
    lng: -42.0688824,
    lat: -21.8001659
  },
  {
    lng: -42.0688542,
    lat: -21.8002256
  },
  {
    lng: -42.0688179,
    lat: -21.8002957
  },
  {
    lng: -42.0687774,
    lat: -21.8003619
  },
  {
    lng: -42.068737,
    lat: -21.8004238
  },
  {
    lng: -42.0686963,
    lat: -21.8004781
  },
  {
    lng: -42.0686496,
    lat: -21.8005376
  },
  {
    lng: -42.0686019,
    lat: -21.8005828
  },
  {
    lng: -42.0685386,
    lat: -21.8006291
  },
  {
    lng: -42.0684773,
    lat: -21.8006593
  },
  {
    lng: -42.0684072,
    lat: -21.80068
  },
  {
    lng: -42.068336,
    lat: -21.8006975
  },
  {
    lng: -42.0682656,
    lat: -21.8007127
  },
  {
    lng: -42.0681981,
    lat: -21.8007271
  },
  {
    lng: -42.0681228,
    lat: -21.8007398
  },
  {
    lng: -42.0680487,
    lat: -21.8007487
  },
  {
    lng: -42.0680232,
    lat: -21.800751
  },
  {
    lng: -42.0679738,
    lat: -21.8007556
  },
  {
    lng: -42.0679036,
    lat: -21.8007582
  },
  {
    lng: -42.0678322,
    lat: -21.8007573
  },
  {
    lng: -42.0677612,
    lat: -21.8007567
  },
  {
    lng: -42.0676932,
    lat: -21.8007566
  },
  {
    lng: -42.0676256,
    lat: -21.8007538
  },
  {
    lng: -42.0675569,
    lat: -21.8007419
  },
  {
    lng: -42.0674867,
    lat: -21.8007139
  },
  {
    lng: -42.0674196,
    lat: -21.8006793
  },
  {
    lng: -42.0673617,
    lat: -21.8006433
  },
  {
    lng: -42.0672986,
    lat: -21.8005962
  },
  {
    lng: -42.067244,
    lat: -21.8005401
  },
  {
    lng: -42.0671989,
    lat: -21.8004893
  },
  {
    lng: -42.0671951,
    lat: -21.8004839
  },
  {
    lng: -42.0671586,
    lat: -21.8004323
  },
  {
    lng: -42.0671213,
    lat: -21.8003706
  },
  {
    lng: -42.0670845,
    lat: -21.8003054
  },
  {
    lng: -42.0670464,
    lat: -21.8002363
  },
  {
    lng: -42.067008,
    lat: -21.8001644
  },
  {
    lng: -42.066973,
    lat: -21.8000882
  },
  {
    lng: -42.0669473,
    lat: -21.8000106
  },
  {
    lng: -42.066933,
    lat: -21.7999272
  },
  {
    lng: -42.0669314,
    lat: -21.7998617
  },
  {
    lng: -42.0669325,
    lat: -21.7997903
  },
  {
    lng: -42.0669339,
    lat: -21.7997217
  },
  {
    lng: -42.0669368,
    lat: -21.7996421
  },
  {
    lng: -42.0669463,
    lat: -21.7995649
  },
  {
    lng: -42.0669587,
    lat: -21.7994964
  },
  {
    lng: -42.0669736,
    lat: -21.7994268
  },
  {
    lng: -42.0669885,
    lat: -21.7993544
  },
  {
    lng: -42.0669955,
    lat: -21.7992811
  },
  {
    lng: -42.0669948,
    lat: -21.7992144
  },
  {
    lng: -42.0669706,
    lat: -21.7991521
  },
  {
    lng: -42.0669289,
    lat: -21.7990982
  },
  {
    lng: -42.0668725,
    lat: -21.79905
  },
  {
    lng: -42.0668113,
    lat: -21.7990151
  },
  {
    lng: -42.0667444,
    lat: -21.7989923
  },
  {
    lng: -42.0666753,
    lat: -21.7989757
  },
  {
    lng: -42.0666006,
    lat: -21.7989708
  },
  {
    lng: -42.0665229,
    lat: -21.7989698
  },
  {
    lng: -42.0664443,
    lat: -21.798977
  },
  {
    lng: -42.0663708,
    lat: -21.799
  },
  {
    lng: -42.0662984,
    lat: -21.7990371
  },
  {
    lng: -42.066233,
    lat: -21.7990857
  },
  {
    lng: -42.0661768,
    lat: -21.7991399
  },
  {
    lng: -42.0661323,
    lat: -21.7991899
  },
  {
    lng: -42.0660912,
    lat: -21.7992478
  },
  {
    lng: -42.066056,
    lat: -21.7993235
  },
  {
    lng: -42.0660337,
    lat: -21.7993856
  },
  {
    lng: -42.0660159,
    lat: -21.7994485
  },
  {
    lng: -42.0659998,
    lat: -21.7995154
  },
  {
    lng: -42.0659879,
    lat: -21.7995827
  },
  {
    lng: -42.0659818,
    lat: -21.7996497
  },
  {
    lng: -42.0659775,
    lat: -21.7997132
  },
  {
    lng: -42.0659713,
    lat: -21.7997931
  },
  {
    lng: -42.065963,
    lat: -21.7998676
  },
  {
    lng: -42.0659561,
    lat: -21.7999357
  },
  {
    lng: -42.0659518,
    lat: -21.8000024
  },
  {
    lng: -42.0659498,
    lat: -21.8000808
  },
  {
    lng: -42.0659486,
    lat: -21.8001616
  },
  {
    lng: -42.0659444,
    lat: -21.8002436
  },
  {
    lng: -42.0659306,
    lat: -21.8003238
  },
  {
    lng: -42.0659157,
    lat: -21.800397
  },
  {
    lng: -42.065905,
    lat: -21.8004655
  },
  {
    lng: -42.0658935,
    lat: -21.800532
  },
  {
    lng: -42.0658807,
    lat: -21.8005993
  },
  {
    lng: -42.0658676,
    lat: -21.800667
  },
  {
    lng: -42.0658522,
    lat: -21.8007359
  },
  {
    lng: -42.0658278,
    lat: -21.8007972
  },
  {
    lng: -42.0657903,
    lat: -21.8008594
  },
  {
    lng: -42.0657462,
    lat: -21.8009193
  },
  {
    lng: -42.0656987,
    lat: -21.8009759
  },
  {
    lng: -42.0656662,
    lat: -21.8010414
  },
  {
    lng: -42.0656585,
    lat: -21.8011068
  },
  {
    lng: -42.0656575,
    lat: -21.8011727
  },
  {
    lng: -42.065656,
    lat: -21.8012453
  },
  {
    lng: -42.0656429,
    lat: -21.8013075
  },
  {
    lng: -42.0656139,
    lat: -21.8013656
  },
  {
    lng: -42.0655708,
    lat: -21.8014152
  },
  {
    lng: -42.06551,
    lat: -21.80146
  },
  {
    lng: -42.0654361,
    lat: -21.8014872
  },
  {
    lng: -42.0653615,
    lat: -21.8015024
  },
  {
    lng: -42.0652884,
    lat: -21.8015065
  },
  {
    lng: -42.0652203,
    lat: -21.8015056
  },
  {
    lng: -42.0651524,
    lat: -21.8014977
  },
  {
    lng: -42.0650889,
    lat: -21.8014733
  },
  {
    lng: -42.0650294,
    lat: -21.8014349
  },
  {
    lng: -42.0649794,
    lat: -21.8013801
  },
  {
    lng: -42.0649462,
    lat: -21.8013247
  },
  {
    lng: -42.0649119,
    lat: -21.8012568
  },
  {
    lng: -42.0648835,
    lat: -21.8011882
  },
  {
    lng: -42.0648548,
    lat: -21.8011152
  },
  {
    lng: -42.0648238,
    lat: -21.8010536
  },
  {
    lng: -42.0647911,
    lat: -21.8009873
  },
  {
    lng: -42.0647573,
    lat: -21.800919
  },
  {
    lng: -42.0647204,
    lat: -21.8008593
  },
  {
    lng: -42.0646838,
    lat: -21.8008019
  },
  {
    lng: -42.064646,
    lat: -21.8007461
  },
  {
    lng: -42.0645951,
    lat: -21.8006988
  },
  {
    lng: -42.0645284,
    lat: -21.8006642
  },
  {
    lng: -42.0644572,
    lat: -21.8006479
  },
  {
    lng: -42.0643782,
    lat: -21.8006512
  },
  {
    lng: -42.0643073,
    lat: -21.8006723
  },
  {
    lng: -42.0642337,
    lat: -21.8007023
  },
  {
    lng: -42.0641656,
    lat: -21.8007324
  },
  {
    lng: -42.0640939,
    lat: -21.8007574
  },
  {
    lng: -42.0640218,
    lat: -21.8007714
  },
  {
    lng: -42.0639482,
    lat: -21.8007763
  },
  {
    lng: -42.0638798,
    lat: -21.8007746
  },
  {
    lng: -42.0638006,
    lat: -21.8007614
  },
  {
    lng: -42.0637223,
    lat: -21.8007443
  },
  {
    lng: -42.0636539,
    lat: -21.8007391
  },
  {
    lng: -42.0635736,
    lat: -21.8007389
  },
  {
    lng: -42.063495,
    lat: -21.8007476
  },
  {
    lng: -42.0634166,
    lat: -21.8007627
  },
  {
    lng: -42.0633428,
    lat: -21.8007802
  },
  {
    lng: -42.0632731,
    lat: -21.8008087
  },
  {
    lng: -42.0632112,
    lat: -21.8008428
  },
  {
    lng: -42.0631551,
    lat: -21.8008872
  },
  {
    lng: -42.0631006,
    lat: -21.8009359
  },
  {
    lng: -42.0630494,
    lat: -21.8009937
  },
  {
    lng: -42.0629989,
    lat: -21.8010511
  },
  {
    lng: -42.0629703,
    lat: -21.8011123
  },
  {
    lng: -42.0629549,
    lat: -21.8011882
  },
  {
    lng: -42.0629526,
    lat: -21.8012588
  },
  {
    lng: -42.0629566,
    lat: -21.8013264
  },
  {
    lng: -42.0629808,
    lat: -21.8013969
  },
  {
    lng: -42.0630093,
    lat: -21.8014569
  },
  {
    lng: -42.0630469,
    lat: -21.8015264
  },
  {
    lng: -42.0630854,
    lat: -21.8015893
  },
  {
    lng: -42.063119,
    lat: -21.801647
  },
  {
    lng: -42.0631605,
    lat: -21.8017111
  },
  {
    lng: -42.0631941,
    lat: -21.8017677
  },
  {
    lng: -42.0632079,
    lat: -21.8018314
  },
  {
    lng: -42.0632069,
    lat: -21.8018969
  },
  {
    lng: -42.0632059,
    lat: -21.8019608
  },
  {
    lng: -42.0631945,
    lat: -21.8020242
  },
  {
    lng: -42.0631529,
    lat: -21.8020766
  },
  {
    lng: -42.0631002,
    lat: -21.8021195
  },
  {
    lng: -42.0630297,
    lat: -21.8021445
  },
  {
    lng: -42.0629541,
    lat: -21.8021443
  },
  {
    lng: -42.0628861,
    lat: -21.8021422
  },
  {
    lng: -42.0628122,
    lat: -21.8021346
  },
  {
    lng: -42.0627405,
    lat: -21.802127
  },
  {
    lng: -42.0626941,
    lat: -21.8021203
  },
  {
    lng: -42.0626692,
    lat: -21.8021167
  },
  {
    lng: -42.0625934,
    lat: -21.8021059
  },
  {
    lng: -42.0625083,
    lat: -21.8020517
  },
  {
    lng: -42.0624325,
    lat: -21.8020484
  },
  {
    lng: -42.0623484,
    lat: -21.8020202
  },
  {
    lng: -42.0622846,
    lat: -21.8019797
  },
  {
    lng: -42.0622242,
    lat: -21.8019472
  },
  {
    lng: -42.0621625,
    lat: -21.8019222
  },
  {
    lng: -42.0621022,
    lat: -21.8018998
  },
  {
    lng: -42.0620319,
    lat: -21.8018831
  },
  {
    lng: -42.0619691,
    lat: -21.8018685
  },
  {
    lng: -42.061899,
    lat: -21.8018615
  },
  {
    lng: -42.061827,
    lat: -21.8018604
  },
  {
    lng: -42.0617548,
    lat: -21.8018607
  },
  {
    lng: -42.0616933,
    lat: -21.8018646
  },
  {
    lng: -42.0616289,
    lat: -21.8018854
  },
  {
    lng: -42.0615644,
    lat: -21.8019096
  },
  {
    lng: -42.061504,
    lat: -21.8019366
  },
  {
    lng: -42.0614637,
    lat: -21.8019719
  },
  {
    lng: -42.0614256,
    lat: -21.8020239
  },
  {
    lng: -42.0613909,
    lat: -21.8020769
  },
  {
    lng: -42.0613594,
    lat: -21.8021318
  },
  {
    lng: -42.0613377,
    lat: -21.8021896
  },
  {
    lng: -42.0613237,
    lat: -21.8022474
  },
  {
    lng: -42.0613196,
    lat: -21.8023217
  },
  {
    lng: -42.0612798,
    lat: -21.8024026
  },
  {
    lng: -42.0612095,
    lat: -21.8024533
  },
  {
    lng: -42.061141,
    lat: -21.8024778
  },
  {
    lng: -42.0610761,
    lat: -21.8025115
  },
  {
    lng: -42.0609757,
    lat: -21.8025213
  },
  {
    lng: -42.0609022,
    lat: -21.8024657
  },
  {
    lng: -42.0608485,
    lat: -21.8024077
  },
  {
    lng: -42.0608138,
    lat: -21.802342
  },
  {
    lng: -42.0607802,
    lat: -21.8022762
  },
  {
    lng: -42.060755,
    lat: -21.8022086
  },
  {
    lng: -42.0607435,
    lat: -21.8021348
  },
  {
    lng: -42.0607408,
    lat: -21.8020615
  },
  {
    lng: -42.0607457,
    lat: -21.8019937
  },
  {
    lng: -42.0607463,
    lat: -21.8019285
  },
  {
    lng: -42.0607486,
    lat: -21.8018756
  },
  {
    lng: -42.0607252,
    lat: -21.8018355
  },
  {
    lng: -42.0606838,
    lat: -21.8018009
  },
  {
    lng: -42.0606246,
    lat: -21.8017709
  },
  {
    lng: -42.0605647,
    lat: -21.8017508
  },
  {
    lng: -42.0604997,
    lat: -21.8017424
  },
  {
    lng: -42.0604323,
    lat: -21.8017428
  },
  {
    lng: -42.0603675,
    lat: -21.8017486
  },
  {
    lng: -42.0603018,
    lat: -21.8017638
  },
  {
    lng: -42.0602277,
    lat: -21.8017774
  },
  {
    lng: -42.0601509,
    lat: -21.8017816
  },
  {
    lng: -42.0600498,
    lat: -21.801778
  },
  {
    lng: -42.0599925,
    lat: -21.8016891
  },
  {
    lng: -42.059992,
    lat: -21.8015965
  },
  {
    lng: -42.0600347,
    lat: -21.8015245
  },
  {
    lng: -42.060083,
    lat: -21.8014729
  },
  {
    lng: -42.0601273,
    lat: -21.8014215
  },
  {
    lng: -42.0601768,
    lat: -21.8013702
  },
  {
    lng: -42.0602112,
    lat: -21.8013289
  },
  {
    lng: -42.0602254,
    lat: -21.8012765
  },
  {
    lng: -42.0602259,
    lat: -21.8012192
  },
  {
    lng: -42.0602233,
    lat: -21.8011596
  },
  {
    lng: -42.0601982,
    lat: -21.8011112
  },
  {
    lng: -42.0601554,
    lat: -21.8010587
  },
  {
    lng: -42.0601083,
    lat: -21.801011
  },
  {
    lng: -42.0600583,
    lat: -21.8009579
  },
  {
    lng: -42.0600108,
    lat: -21.800909
  },
  {
    lng: -42.0599545,
    lat: -21.8008699
  },
  {
    lng: -42.0598938,
    lat: -21.800838
  },
  {
    lng: -42.0598277,
    lat: -21.800799
  },
  {
    lng: -42.0597698,
    lat: -21.8007697
  },
  {
    lng: -42.0597024,
    lat: -21.800744
  },
  {
    lng: -42.059629,
    lat: -21.8007177
  },
  {
    lng: -42.0595648,
    lat: -21.8006934
  },
  {
    lng: -42.0594949,
    lat: -21.8006725
  },
  {
    lng: -42.0594271,
    lat: -21.8006574
  },
  {
    lng: -42.0593561,
    lat: -21.8006469
  },
  {
    lng: -42.0592811,
    lat: -21.8006411
  },
  {
    lng: -42.0592138,
    lat: -21.80064
  },
  {
    lng: -42.0591452,
    lat: -21.8006487
  },
  {
    lng: -42.0590883,
    lat: -21.8006667
  },
  {
    lng: -42.0590288,
    lat: -21.8006938
  },
  {
    lng: -42.0589653,
    lat: -21.800728
  },
  {
    lng: -42.0589081,
    lat: -21.800763
  },
  {
    lng: -42.0588532,
    lat: -21.8007994
  },
  {
    lng: -42.0588018,
    lat: -21.8008438
  },
  {
    lng: -42.0587491,
    lat: -21.8008931
  },
  {
    lng: -42.0586886,
    lat: -21.8009383
  },
  {
    lng: -42.0586267,
    lat: -21.8009815
  },
  {
    lng: -42.0585706,
    lat: -21.8010258
  },
  {
    lng: -42.0584945,
    lat: -21.8010644
  },
  {
    lng: -42.0584041,
    lat: -21.8010707
  },
  {
    lng: -42.0583154,
    lat: -21.8010437
  },
  {
    lng: -42.0582399,
    lat: -21.8009915
  },
  {
    lng: -42.058225,
    lat: -21.800945
  },
  {
    lng: -42.0582121,
    lat: -21.8009045
  },
  {
    lng: -42.0582116,
    lat: -21.8008313
  },
  {
    lng: -42.0582134,
    lat: -21.8007592
  },
  {
    lng: -42.0582183,
    lat: -21.800694
  },
  {
    lng: -42.0582245,
    lat: -21.8006243
  },
  {
    lng: -42.0582405,
    lat: -21.800549
  },
  {
    lng: -42.0582542,
    lat: -21.8004786
  },
  {
    lng: -42.0582651,
    lat: -21.8004053
  },
  {
    lng: -42.0582796,
    lat: -21.8003401
  },
  {
    lng: -42.0582826,
    lat: -21.8002788
  },
  {
    lng: -42.0582817,
    lat: -21.8002154
  },
  {
    lng: -42.0582702,
    lat: -21.8001437
  },
  {
    lng: -42.0582817,
    lat: -21.8000613
  },
  {
    lng: -42.0583171,
    lat: -21.799988
  },
  {
    lng: -42.0583873,
    lat: -21.7999292
  },
  {
    lng: -42.0584635,
    lat: -21.7999046
  },
  {
    lng: -42.0585392,
    lat: -21.7998882
  },
  {
    lng: -42.058613,
    lat: -21.799881
  },
  {
    lng: -42.0586812,
    lat: -21.7998761
  },
  {
    lng: -42.0587478,
    lat: -21.7998688
  },
  {
    lng: -42.0588211,
    lat: -21.7998615
  },
  {
    lng: -42.058897,
    lat: -21.7998534
  },
  {
    lng: -42.0589718,
    lat: -21.7998426
  },
  {
    lng: -42.0590345,
    lat: -21.7998278
  },
  {
    lng: -42.0590989,
    lat: -21.799807
  },
  {
    lng: -42.0591572,
    lat: -21.7997822
  },
  {
    lng: -42.0592215,
    lat: -21.7997503
  },
  {
    lng: -42.059281,
    lat: -21.7997136
  },
  {
    lng: -42.0593386,
    lat: -21.7996701
  },
  {
    lng: -42.0594054,
    lat: -21.7996283
  },
  {
    lng: -42.059471,
    lat: -21.7995914
  },
  {
    lng: -42.0595437,
    lat: -21.7995592
  },
  {
    lng: -42.059611,
    lat: -21.799537
  },
  {
    lng: -42.0596822,
    lat: -21.7995153
  },
  {
    lng: -42.0597122,
    lat: -21.7995074
  },
  {
    lng: -42.0597523,
    lat: -21.7994969
  },
  {
    lng: -42.0598318,
    lat: -21.7994813
  },
  {
    lng: -42.059898,
    lat: -21.799469
  },
  {
    lng: -42.0599771,
    lat: -21.7994531
  },
  {
    lng: -42.0600535,
    lat: -21.7994419
  },
  {
    lng: -42.0601311,
    lat: -21.7994359
  },
  {
    lng: -42.0602006,
    lat: -21.799433
  },
  {
    lng: -42.0602728,
    lat: -21.7994272
  },
  {
    lng: -42.0603416,
    lat: -21.7994218
  },
  {
    lng: -42.0604137,
    lat: -21.7994183
  },
  {
    lng: -42.0604831,
    lat: -21.7994169
  },
  {
    lng: -42.0606359,
    lat: -21.7994182
  },
  {
    lng: -42.0607113,
    lat: -21.7994183
  },
  {
    lng: -42.0607871,
    lat: -21.7994117
  },
  {
    lng: -42.060861,
    lat: -21.7994069
  },
  {
    lng: -42.0609385,
    lat: -21.7993973
  },
  {
    lng: -42.0610102,
    lat: -21.7993769
  },
  {
    lng: -42.0610757,
    lat: -21.7993707
  },
  {
    lng: -42.0611412,
    lat: -21.7993607
  },
  {
    lng: -42.0612083,
    lat: -21.7993428
  },
  {
    lng: -42.0612752,
    lat: -21.7993261
  },
  {
    lng: -42.0613293,
    lat: -21.7993006
  },
  {
    lng: -42.0613711,
    lat: -21.7992668
  },
  {
    lng: -42.0614093,
    lat: -21.7992128
  },
  {
    lng: -42.0614461,
    lat: -21.7991574
  },
  {
    lng: -42.061476,
    lat: -21.7991062
  },
  {
    lng: -42.0614976,
    lat: -21.7990466
  },
  {
    lng: -42.0615147,
    lat: -21.7989891
  },
  {
    lng: -42.0615261,
    lat: -21.7989161
  },
  {
    lng: -42.0615309,
    lat: -21.7988441
  },
  {
    lng: -42.0615336,
    lat: -21.7987783
  },
  {
    lng: -42.0615342,
    lat: -21.7987106
  },
  {
    lng: -42.0615344,
    lat: -21.7986385
  },
  {
    lng: -42.0615319,
    lat: -21.7985677
  },
  {
    lng: -42.0615284,
    lat: -21.798499
  },
  {
    lng: -42.0615244,
    lat: -21.7984297
  },
  {
    lng: -42.0615147,
    lat: -21.7983631
  },
  {
    lng: -42.0615004,
    lat: -21.7983014
  },
  {
    lng: -42.0614825,
    lat: -21.798244
  },
  {
    lng: -42.0614604,
    lat: -21.7981861
  },
  {
    lng: -42.0614291,
    lat: -21.7981162
  },
  {
    lng: -42.0614025,
    lat: -21.7980433
  },
  {
    lng: -42.0613771,
    lat: -21.7979818
  },
  {
    lng: -42.0613473,
    lat: -21.7979196
  },
  {
    lng: -42.0613141,
    lat: -21.7978595
  },
  {
    lng: -42.0612774,
    lat: -21.7978064
  },
  {
    lng: -42.0612342,
    lat: -21.7977568
  },
  {
    lng: -42.0611878,
    lat: -21.7977042
  },
  {
    lng: -42.0611484,
    lat: -21.7976436
  },
  {
    lng: -42.061107,
    lat: -21.7975763
  },
  {
    lng: -42.0610906,
    lat: -21.7974938
  },
  {
    lng: -42.0611002,
    lat: -21.7974183
  },
  {
    lng: -42.061119,
    lat: -21.7973457
  },
  {
    lng: -42.0611535,
    lat: -21.7972736
  },
  {
    lng: -42.0612162,
    lat: -21.7972116
  },
  {
    lng: -42.0612893,
    lat: -21.7971744
  },
  {
    lng: -42.0613611,
    lat: -21.7971463
  },
  {
    lng: -42.0613713,
    lat: -21.7971421
  },
  {
    lng: -42.0614311,
    lat: -21.7971176
  },
  {
    lng: -42.0615074,
    lat: -21.7970944
  },
  {
    lng: -42.0615884,
    lat: -21.7970751
  },
  {
    lng: -42.0616622,
    lat: -21.7970678
  },
  {
    lng: -42.061734,
    lat: -21.7970612
  },
  {
    lng: -42.0617956,
    lat: -21.7970514
  },
  {
    lng: -42.061864,
    lat: -21.7970305
  },
  {
    lng: -42.061931,
    lat: -21.7970039
  },
  {
    lng: -42.0619826,
    lat: -21.7969729
  },
  {
    lng: -42.0620306,
    lat: -21.7969337
  },
  {
    lng: -42.06207,
    lat: -21.7968943
  },
  {
    lng: -42.0620944,
    lat: -21.79685
  },
  {
    lng: -42.0620966,
    lat: -21.7967967
  },
  {
    lng: -42.0620978,
    lat: -21.7967252
  },
  {
    lng: -42.0621024,
    lat: -21.7966529
  },
  {
    lng: -42.0621121,
    lat: -21.7965928
  },
  {
    lng: -42.0621091,
    lat: -21.7965352
  },
  {
    lng: -42.062095,
    lat: -21.7964779
  },
  {
    lng: -42.0620761,
    lat: -21.7964194
  },
  {
    lng: -42.0620524,
    lat: -21.7963587
  },
  {
    lng: -42.0620244,
    lat: -21.7963047
  },
  {
    lng: -42.0619888,
    lat: -21.7962491
  },
  {
    lng: -42.0619428,
    lat: -21.7961951
  },
  {
    lng: -42.0619001,
    lat: -21.7961478
  },
  {
    lng: -42.0618546,
    lat: -21.7961036
  },
  {
    lng: -42.0617985,
    lat: -21.7960507
  },
  {
    lng: -42.0617411,
    lat: -21.7959982
  },
  {
    lng: -42.0616836,
    lat: -21.7959435
  },
  {
    lng: -42.0616307,
    lat: -21.7958917
  },
  {
    lng: -42.0615805,
    lat: -21.7958404
  },
  {
    lng: -42.0615278,
    lat: -21.7957819
  },
  {
    lng: -42.0614862,
    lat: -21.7957283
  },
  {
    lng: -42.0614394,
    lat: -21.7956652
  },
  {
    lng: -42.061407,
    lat: -21.7955962
  },
  {
    lng: -42.0613764,
    lat: -21.7955272
  },
  {
    lng: -42.0613532,
    lat: -21.7954552
  },
  {
    lng: -42.0613401,
    lat: -21.7953835
  },
  {
    lng: -42.0613322,
    lat: -21.795308
  },
  {
    lng: -42.0613335,
    lat: -21.7952314
  },
  {
    lng: -42.0613368,
    lat: -21.7951635
  },
  {
    lng: -42.061342,
    lat: -21.7950931
  },
  {
    lng: -42.0613534,
    lat: -21.7950229
  },
  {
    lng: -42.0613702,
    lat: -21.7949513
  },
  {
    lng: -42.0613846,
    lat: -21.7948777
  },
  {
    lng: -42.0613996,
    lat: -21.794813
  },
  {
    lng: -42.0614205,
    lat: -21.7947404
  },
  {
    lng: -42.0614403,
    lat: -21.7946764
  },
  {
    lng: -42.0614663,
    lat: -21.7946072
  },
  {
    lng: -42.0615011,
    lat: -21.7945442
  },
  {
    lng: -42.0615455,
    lat: -21.7944801
  },
  {
    lng: -42.0615816,
    lat: -21.7944261
  },
  {
    lng: -42.0616139,
    lat: -21.7943721
  },
  {
    lng: -42.0616471,
    lat: -21.794314
  },
  {
    lng: -42.0616925,
    lat: -21.794247
  },
  {
    lng: -42.0617424,
    lat: -21.7941826
  },
  {
    lng: -42.0617893,
    lat: -21.7941313
  },
  {
    lng: -42.0618359,
    lat: -21.7940835
  },
  {
    lng: -42.0618827,
    lat: -21.7940328
  },
  {
    lng: -42.0619303,
    lat: -21.7939846
  },
  {
    lng: -42.0619755,
    lat: -21.7939378
  },
  {
    lng: -42.0620204,
    lat: -21.793891
  },
  {
    lng: -42.0620579,
    lat: -21.7938429
  },
  {
    lng: -42.0621022,
    lat: -21.79378
  },
  {
    lng: -42.0621442,
    lat: -21.7937207
  },
  {
    lng: -42.0621816,
    lat: -21.793656
  },
  {
    lng: -42.0622176,
    lat: -21.7935874
  },
  {
    lng: -42.0622513,
    lat: -21.7935209
  },
  {
    lng: -42.0622846,
    lat: -21.7934602
  },
  {
    lng: -42.0623145,
    lat: -21.7934041
  },
  {
    lng: -42.062366,
    lat: -21.7932677
  },
  {
    lng: -42.0623857,
    lat: -21.7932066
  },
  {
    lng: -42.0623963,
    lat: -21.793146
  },
  {
    lng: -42.0624009,
    lat: -21.7930853
  },
  {
    lng: -42.0624035,
    lat: -21.7930237
  },
  {
    lng: -42.0624048,
    lat: -21.7928867
  },
  {
    lng: -42.0624132,
    lat: -21.7928207
  },
  {
    lng: -42.0624104,
    lat: -21.7927679
  },
  {
    lng: -42.0623926,
    lat: -21.7927267
  },
  {
    lng: -42.0623544,
    lat: -21.792689
  },
  {
    lng: -42.0623006,
    lat: -21.7926539
  },
  {
    lng: -42.0622386,
    lat: -21.7926053
  },
  {
    lng: -42.0621902,
    lat: -21.7925546
  },
  {
    lng: -42.0621396,
    lat: -21.7925084
  },
  {
    lng: -42.0620827,
    lat: -21.7924669
  },
  {
    lng: -42.0620262,
    lat: -21.7924153
  },
  {
    lng: -42.0619778,
    lat: -21.7923603
  },
  {
    lng: -42.061937,
    lat: -21.7922962
  },
  {
    lng: -42.0619052,
    lat: -21.7922183
  },
  {
    lng: -42.0618948,
    lat: -21.792137
  },
  {
    lng: -42.0619089,
    lat: -21.7920572
  },
  {
    lng: -42.0619437,
    lat: -21.7919871
  },
  {
    lng: -42.0619795,
    lat: -21.791919
  },
  {
    lng: -42.0620281,
    lat: -21.7918572
  },
  {
    lng: -42.0620812,
    lat: -21.7918045
  },
  {
    lng: -42.0621261,
    lat: -21.7917532
  },
  {
    lng: -42.0621842,
    lat: -21.791703
  },
  {
    lng: -42.0622423,
    lat: -21.7916561
  },
  {
    lng: -42.0622925,
    lat: -21.7916143
  },
  {
    lng: -42.062343,
    lat: -21.7915675
  },
  {
    lng: -42.0624028,
    lat: -21.791523
  },
  {
    lng: -42.0624636,
    lat: -21.7914793
  },
  {
    lng: -42.062522,
    lat: -21.7914411
  },
  {
    lng: -42.0625893,
    lat: -21.7914011
  },
  {
    lng: -42.0626736,
    lat: -21.7913814
  },
  {
    lng: -42.0627422,
    lat: -21.7913608
  },
  {
    lng: -42.0628024,
    lat: -21.7913454
  },
  {
    lng: -42.0628598,
    lat: -21.7913153
  },
  {
    lng: -42.0629143,
    lat: -21.7912774
  },
  {
    lng: -42.0629685,
    lat: -21.7912382
  },
  {
    lng: -42.0630118,
    lat: -21.7911939
  },
  {
    lng: -42.0630584,
    lat: -21.7911451
  },
  {
    lng: -42.0631081,
    lat: -21.7911
  },
  {
    lng: -42.0631546,
    lat: -21.7910452
  },
  {
    lng: -42.0632016,
    lat: -21.7909987
  },
  {
    lng: -42.0632148,
    lat: -21.7909829
  },
  {
    lng: -42.0632426,
    lat: -21.7909499
  },
  {
    lng: -42.0632707,
    lat: -21.7909027
  },
  {
    lng: -42.063286,
    lat: -21.790848
  },
  {
    lng: -42.0632865,
    lat: -21.7907879
  },
  {
    lng: -42.0632795,
    lat: -21.790719
  },
  {
    lng: -42.063273,
    lat: -21.7906529
  },
  {
    lng: -42.0632593,
    lat: -21.7905914
  },
  {
    lng: -42.0632349,
    lat: -21.7905453
  },
  {
    lng: -42.0631939,
    lat: -21.7905001
  },
  {
    lng: -42.0631494,
    lat: -21.7904559
  },
  {
    lng: -42.0630986,
    lat: -21.7904171
  },
  {
    lng: -42.0630472,
    lat: -21.7903788
  },
  {
    lng: -42.0629906,
    lat: -21.7903515
  },
  {
    lng: -42.0629264,
    lat: -21.7903254
  },
  {
    lng: -42.0628697,
    lat: -21.7903082
  },
  {
    lng: -42.062814,
    lat: -21.7903049
  },
  {
    lng: -42.062751,
    lat: -21.7903158
  },
  {
    lng: -42.0626826,
    lat: -21.7903319
  },
  {
    lng: -42.0626184,
    lat: -21.7903498
  },
  {
    lng: -42.0625498,
    lat: -21.7903694
  },
  {
    lng: -42.0624707,
    lat: -21.7903882
  },
  {
    lng: -42.0624002,
    lat: -21.7904012
  },
  {
    lng: -42.0623293,
    lat: -21.7904143
  },
  {
    lng: -42.0622646,
    lat: -21.7904295
  },
  {
    lng: -42.0621957,
    lat: -21.7904482
  },
  {
    lng: -42.0621258,
    lat: -21.7904654
  },
  {
    lng: -42.062051,
    lat: -21.7904864
  },
  {
    lng: -42.0619774,
    lat: -21.7905112
  },
  {
    lng: -42.0619073,
    lat: -21.7905382
  },
  {
    lng: -42.061847,
    lat: -21.7905694
  },
  {
    lng: -42.0617902,
    lat: -21.7906088
  },
  {
    lng: -42.0617388,
    lat: -21.7906509
  },
  {
    lng: -42.0616966,
    lat: -21.7906957
  },
  {
    lng: -42.0616501,
    lat: -21.7907478
  },
  {
    lng: -42.0616146,
    lat: -21.7908095
  },
  {
    lng: -42.0615816,
    lat: -21.7908698
  },
  {
    lng: -42.0615562,
    lat: -21.7909323
  },
  {
    lng: -42.0615355,
    lat: -21.7909954
  },
  {
    lng: -42.0615155,
    lat: -21.7910619
  },
  {
    lng: -42.061496,
    lat: -21.7911279
  },
  {
    lng: -42.0614771,
    lat: -21.7911983
  },
  {
    lng: -42.0614702,
    lat: -21.791254
  },
  {
    lng: -42.0614776,
    lat: -21.7913195
  },
  {
    lng: -42.0614792,
    lat: -21.7913913
  },
  {
    lng: -42.0614752,
    lat: -21.7914634
  },
  {
    lng: -42.0614667,
    lat: -21.7915336
  },
  {
    lng: -42.0614519,
    lat: -21.7916058
  },
  {
    lng: -42.0614197,
    lat: -21.7916777
  },
  {
    lng: -42.0613583,
    lat: -21.7917409
  },
  {
    lng: -42.0612983,
    lat: -21.7917863
  },
  {
    lng: -42.0612315,
    lat: -21.7918285
  },
  {
    lng: -42.0611397,
    lat: -21.7918475
  },
  {
    lng: -42.061054,
    lat: -21.7918468
  },
  {
    lng: -42.0609766,
    lat: -21.791843
  },
  {
    lng: -42.060901,
    lat: -21.7918352
  },
  {
    lng: -42.0608235,
    lat: -21.7918249
  },
  {
    lng: -42.0607461,
    lat: -21.7918104
  },
  {
    lng: -42.0606783,
    lat: -21.7917944
  },
  {
    lng: -42.0606721,
    lat: -21.791793
  },
  {
    lng: -42.0606005,
    lat: -21.7917738
  },
  {
    lng: -42.0605308,
    lat: -21.7917495
  },
  {
    lng: -42.0604592,
    lat: -21.7917123
  },
  {
    lng: -42.0603889,
    lat: -21.7916629
  },
  {
    lng: -42.0603409,
    lat: -21.7915988
  },
  {
    lng: -42.0603058,
    lat: -21.7915261
  },
  {
    lng: -42.0603001,
    lat: -21.791447
  },
  {
    lng: -42.0603084,
    lat: -21.7913732
  },
  {
    lng: -42.0603225,
    lat: -21.791307
  },
  {
    lng: -42.0603432,
    lat: -21.79123
  },
  {
    lng: -42.0603672,
    lat: -21.7911652
  },
  {
    lng: -42.0603929,
    lat: -21.7911047
  },
  {
    lng: -42.0604213,
    lat: -21.7910433
  },
  {
    lng: -42.0604535,
    lat: -21.7909819
  },
  {
    lng: -42.0604951,
    lat: -21.7909217
  },
  {
    lng: -42.0605362,
    lat: -21.7908629
  },
  {
    lng: -42.0605735,
    lat: -21.7908069
  },
  {
    lng: -42.0606047,
    lat: -21.7907442
  },
  {
    lng: -42.0606371,
    lat: -21.7906736
  },
  {
    lng: -42.0606656,
    lat: -21.7906058
  },
  {
    lng: -42.0606854,
    lat: -21.7905365
  },
  {
    lng: -42.0607034,
    lat: -21.7904605
  },
  {
    lng: -42.0607296,
    lat: -21.7903855
  },
  {
    lng: -42.0607652,
    lat: -21.7903118
  },
  {
    lng: -42.0607958,
    lat: -21.790253
  },
  {
    lng: -42.0608282,
    lat: -21.7901827
  },
  {
    lng: -42.0608588,
    lat: -21.7901224
  },
  {
    lng: -42.0608841,
    lat: -21.7900567
  },
  {
    lng: -42.060901,
    lat: -21.78999
  },
  {
    lng: -42.0609178,
    lat: -21.7899213
  },
  {
    lng: -42.060931,
    lat: -21.7898573
  },
  {
    lng: -42.0609443,
    lat: -21.7897934
  },
  {
    lng: -42.0609582,
    lat: -21.7897207
  },
  {
    lng: -42.0609714,
    lat: -21.7896568
  },
  {
    lng: -42.0609738,
    lat: -21.7896005
  },
  {
    lng: -42.0609645,
    lat: -21.7895445
  },
  {
    lng: -42.0609424,
    lat: -21.7894933
  },
  {
    lng: -42.0609093,
    lat: -21.7894466
  },
  {
    lng: -42.0608635,
    lat: -21.7894026
  },
  {
    lng: -42.0608079,
    lat: -21.7893629
  },
  {
    lng: -42.0607556,
    lat: -21.7893399
  },
  {
    lng: -42.0606967,
    lat: -21.7893252
  },
  {
    lng: -42.0606262,
    lat: -21.7893145
  },
  {
    lng: -42.0605477,
    lat: -21.7892994
  },
  {
    lng: -42.0604709,
    lat: -21.7892797
  },
  {
    lng: -42.0604019,
    lat: -21.7892577
  },
  {
    lng: -42.0603293,
    lat: -21.7892286
  },
  {
    lng: -42.0602643,
    lat: -21.7891947
  },
  {
    lng: -42.0602047,
    lat: -21.7891573
  },
  {
    lng: -42.0601759,
    lat: -21.7891376
  },
  {
    lng: -42.0601615,
    lat: -21.7891277
  },
  {
    lng: -42.0601471,
    lat: -21.7891178
  },
  {
    lng: -42.060083,
    lat: -21.7890655
  },
  {
    lng: -42.0600251,
    lat: -21.7890017
  },
  {
    lng: -42.0599789,
    lat: -21.78893
  },
  {
    lng: -42.0599445,
    lat: -21.7888702
  },
  {
    lng: -42.0599129,
    lat: -21.7888051
  },
  {
    lng: -42.0598852,
    lat: -21.7887367
  },
  {
    lng: -42.0598635,
    lat: -21.7886679
  },
  {
    lng: -42.0598409,
    lat: -21.7886101
  },
  {
    lng: -42.0598145,
    lat: -21.7885455
  },
  {
    lng: -42.0597885,
    lat: -21.7884794
  },
  {
    lng: -42.0597601,
    lat: -21.7884177
  },
  {
    lng: -42.0597338,
    lat: -21.7883453
  },
  {
    lng: -42.0597044,
    lat: -21.7882822
  },
  {
    lng: -42.0596698,
    lat: -21.7882138
  },
  {
    lng: -42.0596401,
    lat: -21.7881611
  },
  {
    lng: -42.0596044,
    lat: -21.7881172
  },
  {
    lng: -42.0595561,
    lat: -21.7880819
  },
  {
    lng: -42.0594784,
    lat: -21.7880538
  },
  {
    lng: -42.0594288,
    lat: -21.7880259
  },
  {
    lng: -42.0593629,
    lat: -21.7879956
  },
  {
    lng: -42.0593032,
    lat: -21.787969
  },
  {
    lng: -42.059243,
    lat: -21.7879466
  },
  {
    lng: -42.0591885,
    lat: -21.7879331
  },
  {
    lng: -42.0591221,
    lat: -21.7879295
  },
  {
    lng: -42.0590502,
    lat: -21.7879289
  },
  {
    lng: -42.058985,
    lat: -21.7879301
  },
  {
    lng: -42.0589266,
    lat: -21.787943
  },
  {
    lng: -42.0588573,
    lat: -21.7879638
  },
  {
    lng: -42.0587741,
    lat: -21.7879784
  },
  {
    lng: -42.0586898,
    lat: -21.7879804
  },
  {
    lng: -42.0586053,
    lat: -21.7879761
  },
  {
    lng: -42.0585139,
    lat: -21.7879426
  },
  {
    lng: -42.0584441,
    lat: -21.7878842
  },
  {
    lng: -42.0583858,
    lat: -21.7878236
  },
  {
    lng: -42.0583355,
    lat: -21.7877496
  },
  {
    lng: -42.0583125,
    lat: -21.7876605
  },
  {
    lng: -42.0583133,
    lat: -21.7875815
  },
  {
    lng: -42.0583178,
    lat: -21.7875023
  },
  {
    lng: -42.058348,
    lat: -21.7874305
  },
  {
    lng: -42.0583663,
    lat: -21.7873693
  },
  {
    lng: -42.0583753,
    lat: -21.7873228
  },
  {
    lng: -42.058366,
    lat: -21.787282
  },
  {
    lng: -42.0583361,
    lat: -21.7872318
  },
  {
    lng: -42.0582951,
    lat: -21.7871878
  },
  {
    lng: -42.0582485,
    lat: -21.7871479
  },
  {
    lng: -42.0581947,
    lat: -21.7871107
  },
  {
    lng: -42.058135,
    lat: -21.7870721
  },
  {
    lng: -42.0580715,
    lat: -21.7870211
  },
  {
    lng: -42.0580132,
    lat: -21.7869625
  },
  {
    lng: -42.0579634,
    lat: -21.7869094
  },
  {
    lng: -42.0579138,
    lat: -21.7868476
  },
  {
    lng: -42.057869,
    lat: -21.7867811
  },
  {
    lng: -42.0578282,
    lat: -21.786719
  },
  {
    lng: -42.0577843,
    lat: -21.7866668
  },
  {
    lng: -42.0577364,
    lat: -21.7866075
  },
  {
    lng: -42.0576883,
    lat: -21.7865547
  },
  {
    lng: -42.0576399,
    lat: -21.7865092
  },
  {
    lng: -42.0575912,
    lat: -21.7864704
  },
  {
    lng: -42.0575367,
    lat: -21.7864335
  },
  {
    lng: -42.0574848,
    lat: -21.7864038
  },
  {
    lng: -42.0574285,
    lat: -21.7863796
  },
  {
    lng: -42.0573779,
    lat: -21.7863629
  },
  {
    lng: -42.057364,
    lat: -21.7863583
  },
  {
    lng: -42.0572838,
    lat: -21.7863278
  },
  {
    lng: -42.0572064,
    lat: -21.7862986
  },
  {
    lng: -42.0571347,
    lat: -21.7862659
  },
  {
    lng: -42.0570935,
    lat: -21.7862461
  },
  {
    lng: -42.0570678,
    lat: -21.7862337
  },
  {
    lng: -42.0569973,
    lat: -21.786202
  },
  {
    lng: -42.0569325,
    lat: -21.7861737
  },
  {
    lng: -42.0568677,
    lat: -21.7861493
  },
  {
    lng: -42.056797,
    lat: -21.7861271
  },
  {
    lng: -42.0567206,
    lat: -21.7861106
  },
  {
    lng: -42.0566553,
    lat: -21.7860983
  },
  {
    lng: -42.056592,
    lat: -21.7860905
  },
  {
    lng: -42.0565275,
    lat: -21.7860866
  },
  {
    lng: -42.0564524,
    lat: -21.7860845
  },
  {
    lng: -42.0563758,
    lat: -21.7860815
  },
  {
    lng: -42.0562999,
    lat: -21.7860808
  },
  {
    lng: -42.0562219,
    lat: -21.7860765
  },
  {
    lng: -42.0561427,
    lat: -21.7860673
  },
  {
    lng: -42.0561266,
    lat: -21.7860641
  },
  {
    lng: -42.0560657,
    lat: -21.7860519
  },
  {
    lng: -42.055989,
    lat: -21.7860225
  },
  {
    lng: -42.0559177,
    lat: -21.7859774
  },
  {
    lng: -42.0558611,
    lat: -21.7859148
  },
  {
    lng: -42.0558151,
    lat: -21.7858535
  },
  {
    lng: -42.0557751,
    lat: -21.7857868
  },
  {
    lng: -42.0557452,
    lat: -21.7857141
  },
  {
    lng: -42.0557305,
    lat: -21.7856341
  },
  {
    lng: -42.0557214,
    lat: -21.785564
  },
  {
    lng: -42.0557209,
    lat: -21.7854884
  },
  {
    lng: -42.0557312,
    lat: -21.7854143
  },
  {
    lng: -42.0557405,
    lat: -21.7853418
  },
  {
    lng: -42.0557636,
    lat: -21.7852701
  },
  {
    lng: -42.055793,
    lat: -21.7852029
  },
  {
    lng: -42.05582,
    lat: -21.7851385
  },
  {
    lng: -42.0558586,
    lat: -21.7850725
  },
  {
    lng: -42.0558879,
    lat: -21.7850162
  },
  {
    lng: -42.0559153,
    lat: -21.7849569
  },
  {
    lng: -42.0559527,
    lat: -21.7848884
  },
  {
    lng: -42.0559875,
    lat: -21.784831
  },
  {
    lng: -42.0560235,
    lat: -21.7847756
  },
  {
    lng: -42.0560589,
    lat: -21.7847204
  },
  {
    lng: -42.0560926,
    lat: -21.7846646
  },
  {
    lng: -42.056117,
    lat: -21.7846078
  },
  {
    lng: -42.056129,
    lat: -21.7845517
  },
  {
    lng: -42.0561377,
    lat: -21.7844884
  },
  {
    lng: -42.0561449,
    lat: -21.7844197
  },
  {
    lng: -42.0561464,
    lat: -21.7843554
  },
  {
    lng: -42.0561414,
    lat: -21.784302
  },
  {
    lng: -42.0561217,
    lat: -21.7842518
  },
  {
    lng: -42.0560864,
    lat: -21.7841951
  },
  {
    lng: -42.0560459,
    lat: -21.7841415
  },
  {
    lng: -42.056003,
    lat: -21.7840947
  },
  {
    lng: -42.0559524,
    lat: -21.7840462
  },
  {
    lng: -42.0559013,
    lat: -21.7840054
  },
  {
    lng: -42.0558418,
    lat: -21.7839523
  },
  {
    lng: -42.0557915,
    lat: -21.7839165
  },
  {
    lng: -42.0557315,
    lat: -21.7838757
  },
  {
    lng: -42.055669,
    lat: -21.7838281
  },
  {
    lng: -42.0556039,
    lat: -21.7837771
  },
  {
    lng: -42.0555439,
    lat: -21.7837247
  },
  {
    lng: -42.0554852,
    lat: -21.783671
  },
  {
    lng: -42.0554321,
    lat: -21.7836195
  },
  {
    lng: -42.0553745,
    lat: -21.7835707
  },
  {
    lng: -42.0553172,
    lat: -21.7835138
  },
  {
    lng: -42.0552748,
    lat: -21.7834309
  },
  {
    lng: -42.0552529,
    lat: -21.7833537
  },
  {
    lng: -42.0552543,
    lat: -21.783272
  },
  {
    lng: -42.0552657,
    lat: -21.7832019
  },
  {
    lng: -42.055276,
    lat: -21.7831344
  },
  {
    lng: -42.0552891,
    lat: -21.7830637
  },
  {
    lng: -42.0553016,
    lat: -21.7830004
  },
  {
    lng: -42.055318,
    lat: -21.7829258
  },
  {
    lng: -42.0553587,
    lat: -21.782845
  },
  {
    lng: -42.0554048,
    lat: -21.7827804
  },
  {
    lng: -42.0554568,
    lat: -21.7827184
  },
  {
    lng: -42.0555081,
    lat: -21.7826564
  },
  {
    lng: -42.0555595,
    lat: -21.7825996
  },
  {
    lng: -42.0556184,
    lat: -21.7825498
  },
  {
    lng: -42.0556714,
    lat: -21.7825069
  },
  {
    lng: -42.0557192,
    lat: -21.7824622
  },
  {
    lng: -42.055752,
    lat: -21.7824242
  },
  {
    lng: -42.0557606,
    lat: -21.7823805
  },
  {
    lng: -42.0557651,
    lat: -21.7823123
  },
  {
    lng: -42.0557664,
    lat: -21.782182
  },
  {
    lng: -42.0557606,
    lat: -21.7821138
  },
  {
    lng: -42.0557518,
    lat: -21.7820548
  },
  {
    lng: -42.0557366,
    lat: -21.7819878
  },
  {
    lng: -42.0557157,
    lat: -21.7819208
  },
  {
    lng: -42.0556922,
    lat: -21.7818647
  },
  {
    lng: -42.0556594,
    lat: -21.7818087
  },
  {
    lng: -42.055625,
    lat: -21.7817654
  },
  {
    lng: -42.0555779,
    lat: -21.7817215
  },
  {
    lng: -42.0555204,
    lat: -21.7816742
  },
  {
    lng: -42.0554716,
    lat: -21.7816331
  },
  {
    lng: -42.0554189,
    lat: -21.7815948
  },
  {
    lng: -42.055365,
    lat: -21.7815683
  },
  {
    lng: -42.0553055,
    lat: -21.7815503
  },
  {
    lng: -42.055238,
    lat: -21.7815424
  },
  {
    lng: -42.0551724,
    lat: -21.7815405
  },
  {
    lng: -42.0551011,
    lat: -21.7815399
  },
  {
    lng: -42.0550365,
    lat: -21.7815402
  },
  {
    lng: -42.0549721,
    lat: -21.7815536
  },
  {
    lng: -42.0549033,
    lat: -21.7815701
  },
  {
    lng: -42.054833,
    lat: -21.7815831
  },
  {
    lng: -42.0547586,
    lat: -21.7815933
  },
  {
    lng: -42.0546662,
    lat: -21.7815951
  },
  {
    lng: -42.0545689,
    lat: -21.7815578
  },
  {
    lng: -42.0545098,
    lat: -21.7815015
  },
  {
    lng: -42.0544494,
    lat: -21.7814543
  },
  {
    lng: -42.0543899,
    lat: -21.7813941
  },
  {
    lng: -42.0543425,
    lat: -21.7813081
  },
  {
    lng: -42.0543343,
    lat: -21.7812155
  },
  {
    lng: -42.0543447,
    lat: -21.7811477
  },
  {
    lng: -42.0543494,
    lat: -21.7810795
  },
  {
    lng: -42.0543506,
    lat: -21.780944
  },
  {
    lng: -42.0543461,
    lat: -21.7808825
  },
  {
    lng: -42.0543346,
    lat: -21.780834
  },
  {
    lng: -42.054311,
    lat: -21.780797
  },
  {
    lng: -42.0542607,
    lat: -21.780761
  },
  {
    lng: -42.0542057,
    lat: -21.7807152
  },
  {
    lng: -42.0541514,
    lat: -21.7806635
  },
  {
    lng: -42.0541034,
    lat: -21.7806025
  },
  {
    lng: -42.0540519,
    lat: -21.7805282
  },
  {
    lng: -42.0540355,
    lat: -21.7804347
  },
  {
    lng: -42.0540393,
    lat: -21.780356
  },
  {
    lng: -42.0540469,
    lat: -21.7802813
  },
  {
    lng: -42.0540614,
    lat: -21.7802142
  },
  {
    lng: -42.0540762,
    lat: -21.7801425
  },
  {
    lng: -42.0541007,
    lat: -21.7800756
  },
  {
    lng: -42.0541197,
    lat: -21.7800216
  },
  {
    lng: -42.0541274,
    lat: -21.7799702
  },
  {
    lng: -42.0541197,
    lat: -21.7799235
  },
  {
    lng: -42.0540971,
    lat: -21.7798873
  },
  {
    lng: -42.0540566,
    lat: -21.7798547
  },
  {
    lng: -42.054002,
    lat: -21.7798238
  },
  {
    lng: -42.0539404,
    lat: -21.7797855
  },
  {
    lng: -42.0538882,
    lat: -21.7797603
  },
  {
    lng: -42.053835,
    lat: -21.7797467
  },
  {
    lng: -42.053774,
    lat: -21.7797458
  },
  {
    lng: -42.0537049,
    lat: -21.7797475
  },
  {
    lng: -42.0536415,
    lat: -21.7797538
  },
  {
    lng: -42.0535641,
    lat: -21.7797659
  },
  {
    lng: -42.053471,
    lat: -21.7797568
  },
  {
    lng: -42.0533889,
    lat: -21.7797245
  },
  {
    lng: -42.0533266,
    lat: -21.7796835
  },
  {
    lng: -42.0532776,
    lat: -21.7796561
  },
  {
    lng: -42.053221,
    lat: -21.7796462
  },
  {
    lng: -42.0531471,
    lat: -21.7796363
  },
  {
    lng: -42.0530761,
    lat: -21.7796265
  },
  {
    lng: -42.0530103,
    lat: -21.7796195
  },
  {
    lng: -42.0529383,
    lat: -21.7796179
  },
  {
    lng: -42.052875,
    lat: -21.7796214
  },
  {
    lng: -42.052814,
    lat: -21.7796313
  },
  {
    lng: -42.0527541,
    lat: -21.7796481
  },
  {
    lng: -42.0526864,
    lat: -21.7796726
  },
  {
    lng: -42.052617,
    lat: -21.7796961
  },
  {
    lng: -42.0525506,
    lat: -21.7797207
  },
  {
    lng: -42.0524834,
    lat: -21.7797471
  },
  {
    lng: -42.0523514,
    lat: -21.7797932
  },
  {
    lng: -42.0522898,
    lat: -21.7798194
  },
  {
    lng: -42.052221,
    lat: -21.7798486
  },
  {
    lng: -42.052149,
    lat: -21.7798764
  },
  {
    lng: -42.0520912,
    lat: -21.7799027
  },
  {
    lng: -42.0520329,
    lat: -21.7799332
  },
  {
    lng: -42.0519834,
    lat: -21.7799742
  },
  {
    lng: -42.0519331,
    lat: -21.7800112
  },
  {
    lng: -42.0518839,
    lat: -21.7800655
  },
  {
    lng: -42.0518318,
    lat: -21.7801079
  },
  {
    lng: -42.0517834,
    lat: -21.7801601
  },
  {
    lng: -42.0517072,
    lat: -21.7802069
  },
  {
    lng: -42.0516241,
    lat: -21.7802337
  },
  {
    lng: -42.0515301,
    lat: -21.7802385
  },
  {
    lng: -42.0514462,
    lat: -21.7802243
  },
  {
    lng: -42.0513658,
    lat: -21.7801942
  },
  {
    lng: -42.0512897,
    lat: -21.7801508
  },
  {
    lng: -42.0512329,
    lat: -21.7801017
  },
  {
    lng: -42.0511756,
    lat: -21.7800545
  },
  {
    lng: -42.0511205,
    lat: -21.7800123
  },
  {
    lng: -42.0510555,
    lat: -21.7799649
  },
  {
    lng: -42.0509909,
    lat: -21.7798977
  },
  {
    lng: -42.0509619,
    lat: -21.7798175
  },
  {
    lng: -42.0509505,
    lat: -21.7797367
  },
  {
    lng: -42.0509584,
    lat: -21.7796526
  },
  {
    lng: -42.0509813,
    lat: -21.7795855
  },
  {
    lng: -42.0510024,
    lat: -21.7795167
  },
  {
    lng: -42.0510098,
    lat: -21.7794595
  },
  {
    lng: -42.0510122,
    lat: -21.7793841
  },
  {
    lng: -42.0510235,
    lat: -21.7793085
  },
  {
    lng: -42.0510419,
    lat: -21.7792386
  },
  {
    lng: -42.0510579,
    lat: -21.7791755
  },
  {
    lng: -42.0510709,
    lat: -21.7791083
  },
  {
    lng: -42.051077,
    lat: -21.7790422
  },
  {
    lng: -42.0510816,
    lat: -21.77897
  },
  {
    lng: -42.0510955,
    lat: -21.7788942
  },
  {
    lng: -42.0511113,
    lat: -21.7788288
  },
  {
    lng: -42.0511165,
    lat: -21.7787731
  },
  {
    lng: -42.0511167,
    lat: -21.7787123
  },
  {
    lng: -42.0511067,
    lat: -21.7786624
  },
  {
    lng: -42.051085,
    lat: -21.7786219
  },
  {
    lng: -42.0510583,
    lat: -21.7785933
  },
  {
    lng: -42.0510198,
    lat: -21.7785812
  },
  {
    lng: -42.0509578,
    lat: -21.7785787
  },
  {
    lng: -42.0508942,
    lat: -21.7785829
  },
  {
    lng: -42.0508262,
    lat: -21.7785948
  },
  {
    lng: -42.0507643,
    lat: -21.7786119
  },
  {
    lng: -42.0507029,
    lat: -21.7786393
  },
  {
    lng: -42.0506449,
    lat: -21.7786787
  },
  {
    lng: -42.0505828,
    lat: -21.7787295
  },
  {
    lng: -42.0505305,
    lat: -21.7787674
  },
  {
    lng: -42.0504869,
    lat: -21.7788075
  },
  {
    lng: -42.050436,
    lat: -21.7788661
  },
  {
    lng: -42.0503801,
    lat: -21.7789226
  },
  {
    lng: -42.0503331,
    lat: -21.778964
  },
  {
    lng: -42.0502895,
    lat: -21.77902
  },
  {
    lng: -42.0502396,
    lat: -21.7790784
  },
  {
    lng: -42.0501971,
    lat: -21.7791278
  },
  {
    lng: -42.0501552,
    lat: -21.7791836
  },
  {
    lng: -42.0500957,
    lat: -21.7792495
  },
  {
    lng: -42.0500288,
    lat: -21.7793064
  },
  {
    lng: -42.0499606,
    lat: -21.7793462
  },
  {
    lng: -42.0498927,
    lat: -21.7793798
  },
  {
    lng: -42.049821,
    lat: -21.7794111
  },
  {
    lng: -42.049737,
    lat: -21.779436
  },
  {
    lng: -42.0496579,
    lat: -21.7794531
  },
  {
    lng: -42.0495812,
    lat: -21.7794627
  },
  {
    lng: -42.0495084,
    lat: -21.779473
  },
  {
    lng: -42.0492152,
    lat: -21.7795025
  },
  {
    lng: -42.0491394,
    lat: -21.7794977
  },
  {
    lng: -42.049073,
    lat: -21.7794868
  },
  {
    lng: -42.0490028,
    lat: -21.7794699
  },
  {
    lng: -42.048934,
    lat: -21.7794514
  },
  {
    lng: -42.0488668,
    lat: -21.7794302
  },
  {
    lng: -42.0488083,
    lat: -21.7794036
  },
  {
    lng: -42.0487543,
    lat: -21.7793715
  },
  {
    lng: -42.0486927,
    lat: -21.7793289
  },
  {
    lng: -42.0486294,
    lat: -21.7792804
  },
  {
    lng: -42.0485788,
    lat: -21.7792361
  },
  {
    lng: -42.0485301,
    lat: -21.7791917
  },
  {
    lng: -42.0484759,
    lat: -21.7791364
  },
  {
    lng: -42.0484352,
    lat: -21.7790876
  },
  {
    lng: -42.0483949,
    lat: -21.7790339
  },
  {
    lng: -42.048361,
    lat: -21.7789812
  },
  {
    lng: -42.0483285,
    lat: -21.7789209
  },
  {
    lng: -42.0482969,
    lat: -21.778862
  },
  {
    lng: -42.048265,
    lat: -21.7788002
  },
  {
    lng: -42.0482292,
    lat: -21.7787347
  },
  {
    lng: -42.0481928,
    lat: -21.778671
  },
  {
    lng: -42.0481665,
    lat: -21.778636
  },
  {
    lng: -42.0481402,
    lat: -21.778601
  },
  {
    lng: -42.0480576,
    lat: -21.7785624
  },
  {
    lng: -42.0479828,
    lat: -21.7785413
  },
  {
    lng: -42.0479051,
    lat: -21.7785336
  },
  {
    lng: -42.0478206,
    lat: -21.7785361
  },
  {
    lng: -42.0477401,
    lat: -21.7785538
  },
  {
    lng: -42.0476608,
    lat: -21.7785799
  },
  {
    lng: -42.0475936,
    lat: -21.778609
  },
  {
    lng: -42.0475252,
    lat: -21.7786442
  },
  {
    lng: -42.0474934,
    lat: -21.7786687
  },
  {
    lng: -42.0474615,
    lat: -21.7786931
  },
  {
    lng: -42.0474066,
    lat: -21.7787416
  },
  {
    lng: -42.0473518,
    lat: -21.7787858
  },
  {
    lng: -42.0473006,
    lat: -21.7788385
  },
  {
    lng: -42.0472545,
    lat: -21.7788943
  },
  {
    lng: -42.0472161,
    lat: -21.7789739
  },
  {
    lng: -42.0472057,
    lat: -21.7790467
  },
  {
    lng: -42.0472066,
    lat: -21.7791278
  },
  {
    lng: -42.0472145,
    lat: -21.7792007
  },
  {
    lng: -42.0472169,
    lat: -21.7792683
  },
  {
    lng: -42.0472146,
    lat: -21.7793386
  },
  {
    lng: -42.0472151,
    lat: -21.7794123
  },
  {
    lng: -42.0472372,
    lat: -21.7794855
  },
  {
    lng: -42.047269,
    lat: -21.77955
  },
  {
    lng: -42.0472996,
    lat: -21.7796088
  },
  {
    lng: -42.0473224,
    lat: -21.7796656
  },
  {
    lng: -42.0473381,
    lat: -21.7797222
  },
  {
    lng: -42.0473423,
    lat: -21.7797811
  },
  {
    lng: -42.0473385,
    lat: -21.779843
  },
  {
    lng: -42.0473166,
    lat: -21.7798977
  },
  {
    lng: -42.0472803,
    lat: -21.7799364
  },
  {
    lng: -42.0472262,
    lat: -21.7799543
  },
  {
    lng: -42.0471648,
    lat: -21.7799689
  },
  {
    lng: -42.0470968,
    lat: -21.7799756
  },
  {
    lng: -42.0469532,
    lat: -21.7799744
  },
  {
    lng: -42.046873,
    lat: -21.7799766
  },
  {
    lng: -42.0467882,
    lat: -21.7800118
  },
  {
    lng: -42.0467398,
    lat: -21.7800762
  },
  {
    lng: -42.0467083,
    lat: -21.7801379
  },
  {
    lng: -42.0466798,
    lat: -21.7802051
  },
  {
    lng: -42.046673,
    lat: -21.780281
  },
  {
    lng: -42.0466815,
    lat: -21.7803558
  },
  {
    lng: -42.0466977,
    lat: -21.7804304
  },
  {
    lng: -42.0467229,
    lat: -21.7804987
  },
  {
    lng: -42.0467496,
    lat: -21.7805591
  },
  {
    lng: -42.0467808,
    lat: -21.7806242
  },
  {
    lng: -42.0468354,
    lat: -21.7806877
  },
  {
    lng: -42.0468934,
    lat: -21.7807268
  },
  {
    lng: -42.046917,
    lat: -21.7807483
  },
  {
    lng: -42.0469407,
    lat: -21.7807699
  },
  {
    lng: -42.0469863,
    lat: -21.7808227
  },
  {
    lng: -42.0470357,
    lat: -21.7808713
  },
  {
    lng: -42.0470808,
    lat: -21.7809106
  },
  {
    lng: -42.0471,
    lat: -21.7809527
  },
  {
    lng: -42.0470885,
    lat: -21.781
  },
  {
    lng: -42.0470657,
    lat: -21.7810556
  },
  {
    lng: -42.0470379,
    lat: -21.7811115
  },
  {
    lng: -42.0470043,
    lat: -21.7811749
  },
  {
    lng: -42.0469862,
    lat: -21.781208
  },
  {
    lng: -42.0469681,
    lat: -21.781241
  },
  {
    lng: -42.0469373,
    lat: -21.7812998
  },
  {
    lng: -42.0469061,
    lat: -21.7813571
  },
  {
    lng: -42.0468648,
    lat: -21.7814098
  },
  {
    lng: -42.0468205,
    lat: -21.7814615
  },
  {
    lng: -42.0467755,
    lat: -21.7815093
  },
  {
    lng: -42.0467226,
    lat: -21.7815583
  },
  {
    lng: -42.0466646,
    lat: -21.7815961
  },
  {
    lng: -42.0466075,
    lat: -21.7816261
  },
  {
    lng: -42.0465448,
    lat: -21.7816468
  },
  {
    lng: -42.0464722,
    lat: -21.7816681
  },
  {
    lng: -42.0464035,
    lat: -21.7816813
  },
  {
    lng: -42.046336,
    lat: -21.7816841
  },
  {
    lng: -42.0462579,
    lat: -21.7816942
  },
  {
    lng: -42.0461815,
    lat: -21.781719
  },
  {
    lng: -42.046104,
    lat: -21.7817749
  },
  {
    lng: -42.0460882,
    lat: -21.7818685
  },
  {
    lng: -42.0461178,
    lat: -21.7819411
  },
  {
    lng: -42.0461432,
    lat: -21.7820021
  },
  {
    lng: -42.0461697,
    lat: -21.7820688
  },
  {
    lng: -42.0462047,
    lat: -21.7821357
  },
  {
    lng: -42.0462363,
    lat: -21.7821936
  },
  {
    lng: -42.0462704,
    lat: -21.7822611
  },
  {
    lng: -42.0462978,
    lat: -21.7823159
  },
  {
    lng: -42.0463029,
    lat: -21.782363
  },
  {
    lng: -42.0462856,
    lat: -21.7824122
  },
  {
    lng: -42.046243,
    lat: -21.7824599
  },
  {
    lng: -42.0461954,
    lat: -21.7825085
  },
  {
    lng: -42.046147,
    lat: -21.7825658
  },
  {
    lng: -42.0460976,
    lat: -21.7826212
  },
  {
    lng: -42.0460468,
    lat: -21.7826734
  },
  {
    lng: -42.0459958,
    lat: -21.782713
  },
  {
    lng: -42.045945,
    lat: -21.7827577
  },
  {
    lng: -42.0458896,
    lat: -21.7828039
  },
  {
    lng: -42.0458357,
    lat: -21.7828347
  },
  {
    lng: -42.0457713,
    lat: -21.7828616
  },
  {
    lng: -42.04571,
    lat: -21.7828754
  },
  {
    lng: -42.0456457,
    lat: -21.7828762
  },
  {
    lng: -42.0455819,
    lat: -21.7828753
  },
  {
    lng: -42.0455229,
    lat: -21.7828562
  },
  {
    lng: -42.0454612,
    lat: -21.7828188
  },
  {
    lng: -42.0454076,
    lat: -21.7827793
  },
  {
    lng: -42.0453525,
    lat: -21.7827328
  },
  {
    lng: -42.045297,
    lat: -21.7826854
  },
  {
    lng: -42.0452413,
    lat: -21.7826372
  },
  {
    lng: -42.0452034,
    lat: -21.7825923
  },
  {
    lng: -42.0451685,
    lat: -21.7825314
  },
  {
    lng: -42.0451278,
    lat: -21.7824643
  },
  {
    lng: -42.0450596,
    lat: -21.7824102
  },
  {
    lng: -42.0449764,
    lat: -21.7823908
  },
  {
    lng: -42.0448871,
    lat: -21.7823888
  },
  {
    lng: -42.0448029,
    lat: -21.7824354
  },
  {
    lng: -42.0447568,
    lat: -21.7825077
  },
  {
    lng: -42.0447431,
    lat: -21.7825809
  },
  {
    lng: -42.0447423,
    lat: -21.7826623
  },
  {
    lng: -42.0447422,
    lat: -21.7827305
  },
  {
    lng: -42.0447448,
    lat: -21.7828022
  },
  {
    lng: -42.0447524,
    lat: -21.7828677
  },
  {
    lng: -42.0447652,
    lat: -21.7829444
  },
  {
    lng: -42.0447818,
    lat: -21.7830211
  },
  {
    lng: -42.0447969,
    lat: -21.7830852
  },
  {
    lng: -42.0448201,
    lat: -21.7831615
  },
  {
    lng: -42.0448605,
    lat: -21.7832343
  },
  {
    lng: -42.0449057,
    lat: -21.7832948
  },
  {
    lng: -42.044936,
    lat: -21.7833481
  },
  {
    lng: -42.0449616,
    lat: -21.7834102
  },
  {
    lng: -42.0449881,
    lat: -21.783471
  },
  {
    lng: -42.0450119,
    lat: -21.783528
  },
  {
    lng: -42.0450275,
    lat: -21.7835841
  },
  {
    lng: -42.0450246,
    lat: -21.7836401
  },
  {
    lng: -42.0450165,
    lat: -21.7837034
  },
  {
    lng: -42.0449999,
    lat: -21.7837663
  },
  {
    lng: -42.0449734,
    lat: -21.7838241
  },
  {
    lng: -42.0449403,
    lat: -21.783881
  },
  {
    lng: -42.0448961,
    lat: -21.7839317
  },
  {
    lng: -42.0448396,
    lat: -21.7839771
  },
  {
    lng: -42.0447837,
    lat: -21.7840172
  },
  {
    lng: -42.0447258,
    lat: -21.7840601
  },
  {
    lng: -42.0446681,
    lat: -21.7841002
  },
  {
    lng: -42.0446037,
    lat: -21.784137
  },
  {
    lng: -42.0445387,
    lat: -21.7841794
  },
  {
    lng: -42.0444855,
    lat: -21.7842094
  },
  {
    lng: -42.0444229,
    lat: -21.7842309
  },
  {
    lng: -42.0443535,
    lat: -21.7842569
  },
  {
    lng: -42.0442888,
    lat: -21.7842696
  },
  {
    lng: -42.0442194,
    lat: -21.7842704
  },
  {
    lng: -42.0441526,
    lat: -21.7842684
  },
  {
    lng: -42.0440159,
    lat: -21.7842604
  },
  {
    lng: -42.043947,
    lat: -21.7842521
  },
  {
    lng: -42.0438768,
    lat: -21.7842417
  },
  {
    lng: -42.0438075,
    lat: -21.7842311
  },
  {
    lng: -42.0437387,
    lat: -21.7842127
  },
  {
    lng: -42.0436753,
    lat: -21.7841853
  },
  {
    lng: -42.0436299,
    lat: -21.784132
  },
  {
    lng: -42.0436261,
    lat: -21.7841276
  },
  {
    lng: -42.0435581,
    lat: -21.7840927
  },
  {
    lng: -42.0434942,
    lat: -21.7840562
  },
  {
    lng: -42.0434356,
    lat: -21.784015
  },
  {
    lng: -42.0433807,
    lat: -21.7839668
  },
  {
    lng: -42.0433303,
    lat: -21.7839285
  },
  {
    lng: -42.0432849,
    lat: -21.7839124
  },
  {
    lng: -42.043227,
    lat: -21.7839162
  },
  {
    lng: -42.043156,
    lat: -21.7839315
  },
  {
    lng: -42.043087,
    lat: -21.7839519
  },
  {
    lng: -42.0430168,
    lat: -21.7839703
  },
  {
    lng: -42.0429498,
    lat: -21.7839886
  },
  {
    lng: -42.0428756,
    lat: -21.7840127
  },
  {
    lng: -42.0427969,
    lat: -21.7840301
  },
  {
    lng: -42.042751,
    lat: -21.7840285
  },
  {
    lng: -42.0427052,
    lat: -21.7840269
  },
  {
    lng: -42.0426266,
    lat: -21.7840009
  },
  {
    lng: -42.0425522,
    lat: -21.7839537
  },
  {
    lng: -42.0424922,
    lat: -21.7838993
  },
  {
    lng: -42.042443,
    lat: -21.7838438
  },
  {
    lng: -42.0424039,
    lat: -21.7837819
  },
  {
    lng: -42.0423747,
    lat: -21.7837144
  },
  {
    lng: -42.0423545,
    lat: -21.7836431
  },
  {
    lng: -42.0423499,
    lat: -21.7835728
  },
  {
    lng: -42.0423511,
    lat: -21.7835046
  },
  {
    lng: -42.0423586,
    lat: -21.7834314
  },
  {
    lng: -42.0423722,
    lat: -21.7833595
  },
  {
    lng: -42.0423914,
    lat: -21.7832929
  },
  {
    lng: -42.0424202,
    lat: -21.7832156
  },
  {
    lng: -42.042475,
    lat: -21.783154
  },
  {
    lng: -42.0425385,
    lat: -21.78311
  },
  {
    lng: -42.0426037,
    lat: -21.7830723
  },
  {
    lng: -42.0426752,
    lat: -21.7830407
  },
  {
    lng: -42.0427472,
    lat: -21.7830145
  },
  {
    lng: -42.0428238,
    lat: -21.7829899
  },
  {
    lng: -42.0428962,
    lat: -21.7829685
  },
  {
    lng: -42.0429662,
    lat: -21.7829477
  },
  {
    lng: -42.0430289,
    lat: -21.7829259
  },
  {
    lng: -42.0431061,
    lat: -21.7828939
  },
  {
    lng: -42.0431754,
    lat: -21.7828699
  },
  {
    lng: -42.0432435,
    lat: -21.7828482
  },
  {
    lng: -42.0433085,
    lat: -21.7828258
  },
  {
    lng: -42.0433745,
    lat: -21.7828018
  },
  {
    lng: -42.0434563,
    lat: -21.7827758
  },
  {
    lng: -42.0435258,
    lat: -21.7827593
  },
  {
    lng: -42.0436096,
    lat: -21.7827425
  },
  {
    lng: -42.0436851,
    lat: -21.7827331
  },
  {
    lng: -42.0437553,
    lat: -21.7827221
  },
  {
    lng: -42.0438257,
    lat: -21.7827082
  },
  {
    lng: -42.0438884,
    lat: -21.7826888
  },
  {
    lng: -42.0439411,
    lat: -21.7826653
  },
  {
    lng: -42.0439894,
    lat: -21.7826295
  },
  {
    lng: -42.0440327,
    lat: -21.7825862
  },
  {
    lng: -42.0440683,
    lat: -21.7825436
  },
  {
    lng: -42.0440865,
    lat: -21.7824995
  },
  {
    lng: -42.0440761,
    lat: -21.7824489
  },
  {
    lng: -42.0440512,
    lat: -21.782388
  },
  {
    lng: -42.0440262,
    lat: -21.782324
  },
  {
    lng: -42.0440044,
    lat: -21.7822545
  },
  {
    lng: -42.0439814,
    lat: -21.7821918
  },
  {
    lng: -42.0439653,
    lat: -21.7821169
  },
  {
    lng: -42.0439484,
    lat: -21.7820548
  },
  {
    lng: -42.0439159,
    lat: -21.7820088
  },
  {
    lng: -42.0438646,
    lat: -21.7819566
  },
  {
    lng: -42.0438139,
    lat: -21.781898
  },
  {
    lng: -42.0437697,
    lat: -21.781841
  },
  {
    lng: -42.0437363,
    lat: -21.7817671
  },
  {
    lng: -42.0437159,
    lat: -21.7816971
  },
  {
    lng: -42.0436902,
    lat: -21.7816285
  },
  {
    lng: -42.0436683,
    lat: -21.7815593
  },
  {
    lng: -42.0436514,
    lat: -21.7814909
  },
  {
    lng: -42.0436429,
    lat: -21.781415
  },
  {
    lng: -42.0436442,
    lat: -21.7813368
  },
  {
    lng: -42.0436573,
    lat: -21.781267
  },
  {
    lng: -42.0436818,
    lat: -21.7811927
  },
  {
    lng: -42.0437219,
    lat: -21.7811267
  },
  {
    lng: -42.0437751,
    lat: -21.7810654
  },
  {
    lng: -42.0438202,
    lat: -21.7810138
  },
  {
    lng: -42.0438366,
    lat: -21.7809438
  },
  {
    lng: -42.0438264,
    lat: -21.7808048
  },
  {
    lng: -42.0437829,
    lat: -21.780673
  },
  {
    lng: -42.0437004,
    lat: -21.7805672
  },
  {
    lng: -42.0436489,
    lat: -21.7805462
  },
  {
    lng: -42.0436014,
    lat: -21.7805468
  },
  {
    lng: -42.0435493,
    lat: -21.7805656
  },
  {
    lng: -42.0434968,
    lat: -21.7806002
  },
  {
    lng: -42.0434459,
    lat: -21.7806448
  },
  {
    lng: -42.0434028,
    lat: -21.7806937
  },
  {
    lng: -42.043354,
    lat: -21.7807446
  },
  {
    lng: -42.043299,
    lat: -21.7807991
  },
  {
    lng: -42.0432402,
    lat: -21.7808458
  },
  {
    lng: -42.0431747,
    lat: -21.7808926
  },
  {
    lng: -42.0431151,
    lat: -21.7809297
  },
  {
    lng: -42.0430483,
    lat: -21.780965
  },
  {
    lng: -42.0429793,
    lat: -21.7809992
  },
  {
    lng: -42.0429072,
    lat: -21.7810232
  },
  {
    lng: -42.0428288,
    lat: -21.7810348
  },
  {
    lng: -42.0427447,
    lat: -21.7810352
  },
  {
    lng: -42.0426564,
    lat: -21.7810172
  },
  {
    lng: -42.0425813,
    lat: -21.7809735
  },
  {
    lng: -42.0425202,
    lat: -21.7809241
  },
  {
    lng: -42.0424727,
    lat: -21.7808537
  },
  {
    lng: -42.0424388,
    lat: -21.7807838
  },
  {
    lng: -42.0424206,
    lat: -21.7807073
  },
  {
    lng: -42.0424196,
    lat: -21.7806299
  },
  {
    lng: -42.0424231,
    lat: -21.7805559
  },
  {
    lng: -42.0424287,
    lat: -21.7804879
  },
  {
    lng: -42.0424411,
    lat: -21.7804211
  },
  {
    lng: -42.0424597,
    lat: -21.7803449
  },
  {
    lng: -42.0424872,
    lat: -21.7802664
  },
  {
    lng: -42.0425213,
    lat: -21.7802011
  },
  {
    lng: -42.0425549,
    lat: -21.7801445
  },
  {
    lng: -42.0425895,
    lat: -21.7800813
  },
  {
    lng: -42.0426499,
    lat: -21.7800183
  },
  {
    lng: -42.0427268,
    lat: -21.7799759
  },
  {
    lng: -42.0428052,
    lat: -21.7799586
  },
  {
    lng: -42.0428846,
    lat: -21.7799518
  },
  {
    lng: -42.04297,
    lat: -21.7799664
  },
  {
    lng: -42.0430363,
    lat: -21.7800086
  },
  {
    lng: -42.0430945,
    lat: -21.7800337
  },
  {
    lng: -42.043156,
    lat: -21.7800542
  },
  {
    lng: -42.0432168,
    lat: -21.7800661
  },
  {
    lng: -42.0432745,
    lat: -21.7800678
  },
  {
    lng: -42.0433279,
    lat: -21.780059
  },
  {
    lng: -42.0433552,
    lat: -21.780036
  },
  {
    lng: -42.0433643,
    lat: -21.7799901
  },
  {
    lng: -42.0433634,
    lat: -21.7799331
  },
  {
    lng: -42.0433575,
    lat: -21.77986
  },
  {
    lng: -42.0433464,
    lat: -21.7797886
  },
  {
    lng: -42.0433323,
    lat: -21.7797147
  },
  {
    lng: -42.0433223,
    lat: -21.7796516
  },
  {
    lng: -42.0433106,
    lat: -21.7795877
  },
  {
    lng: -42.0432952,
    lat: -21.7795269
  },
  {
    lng: -42.0432782,
    lat: -21.7794629
  },
  {
    lng: -42.0432559,
    lat: -21.779394
  },
  {
    lng: -42.0432341,
    lat: -21.7793267
  },
  {
    lng: -42.0432111,
    lat: -21.7792665
  },
  {
    lng: -42.0431846,
    lat: -21.7792039
  },
  {
    lng: -42.0431527,
    lat: -21.7791489
  },
  {
    lng: -42.0431157,
    lat: -21.7791045
  },
  {
    lng: -42.0430673,
    lat: -21.779063
  },
  {
    lng: -42.0430098,
    lat: -21.7790206
  },
  {
    lng: -42.0429623,
    lat: -21.7789754
  },
  {
    lng: -42.042915,
    lat: -21.7789435
  },
  {
    lng: -42.0428622,
    lat: -21.7789333
  },
  {
    lng: -42.0427918,
    lat: -21.7789347
  },
  {
    lng: -42.0427159,
    lat: -21.7789177
  },
  {
    lng: -42.0426595,
    lat: -21.778914
  },
  {
    lng: -42.0425904,
    lat: -21.7789295
  },
  {
    lng: -42.0425161,
    lat: -21.7789331
  },
  {
    lng: -42.0424621,
    lat: -21.7789637
  },
  {
    lng: -42.0423996,
    lat: -21.7789818
  },
  {
    lng: -42.0423398,
    lat: -21.779005
  },
  {
    lng: -42.0422834,
    lat: -21.7790396
  },
  {
    lng: -42.0422251,
    lat: -21.7790742
  },
  {
    lng: -42.0421615,
    lat: -21.7791111
  },
  {
    lng: -42.0420769,
    lat: -21.7791532
  },
  {
    lng: -42.0419712,
    lat: -21.7791537
  },
  {
    lng: -42.0418729,
    lat: -21.7791089
  },
  {
    lng: -42.041813,
    lat: -21.7790326
  },
  {
    lng: -42.0417888,
    lat: -21.7789415
  },
  {
    lng: -42.0418064,
    lat: -21.7788503
  },
  {
    lng: -42.0418473,
    lat: -21.7787699
  },
  {
    lng: -42.0418895,
    lat: -21.7787127
  },
  {
    lng: -42.0419587,
    lat: -21.7786742
  },
  {
    lng: -42.0420229,
    lat: -21.7786499
  },
  {
    lng: -42.0420682,
    lat: -21.7786024
  },
  {
    lng: -42.0421213,
    lat: -21.77856
  },
  {
    lng: -42.0421741,
    lat: -21.7785058
  },
  {
    lng: -42.0422265,
    lat: -21.7784506
  },
  {
    lng: -42.0422808,
    lat: -21.7783875
  },
  {
    lng: -42.0423204,
    lat: -21.7783113
  },
  {
    lng: -42.0423311,
    lat: -21.7782206
  },
  {
    lng: -42.042298,
    lat: -21.7781266
  },
  {
    lng: -42.0422196,
    lat: -21.7780662
  },
  {
    lng: -42.0421432,
    lat: -21.7780297
  },
  {
    lng: -42.0420675,
    lat: -21.7780002
  },
  {
    lng: -42.0419826,
    lat: -21.7779781
  },
  {
    lng: -42.041893,
    lat: -21.7779638
  },
  {
    lng: -42.0418155,
    lat: -21.7779649
  },
  {
    lng: -42.0417389,
    lat: -21.7779711
  },
  {
    lng: -42.0416595,
    lat: -21.7779831
  },
  {
    lng: -42.0415809,
    lat: -21.7780054
  },
  {
    lng: -42.0415059,
    lat: -21.7780284
  },
  {
    lng: -42.041434,
    lat: -21.7780512
  },
  {
    lng: -42.0413716,
    lat: -21.7780657
  },
  {
    lng: -42.0413043,
    lat: -21.778073
  },
  {
    lng: -42.0412406,
    lat: -21.7780738
  },
  {
    lng: -42.0410898,
    lat: -21.7780726
  },
  {
    lng: -42.0410228,
    lat: -21.7780686
  },
  {
    lng: -42.0409616,
    lat: -21.7780518
  },
  {
    lng: -42.040905,
    lat: -21.7780274
  },
  {
    lng: -42.040846,
    lat: -21.7779963
  },
  {
    lng: -42.0407979,
    lat: -21.7779627
  },
  {
    lng: -42.0407523,
    lat: -21.7779229
  },
  {
    lng: -42.0407117,
    lat: -21.7778773
  },
  {
    lng: -42.0406794,
    lat: -21.7778299
  },
  {
    lng: -42.0406577,
    lat: -21.7777855
  },
  {
    lng: -42.0406523,
    lat: -21.7777325
  },
  {
    lng: -42.040658,
    lat: -21.7776672
  },
  {
    lng: -42.0406688,
    lat: -21.7776089
  },
  {
    lng: -42.0406892,
    lat: -21.7775526
  },
  {
    lng: -42.0407162,
    lat: -21.7774963
  },
  {
    lng: -42.0407518,
    lat: -21.7774409
  },
  {
    lng: -42.0407938,
    lat: -21.7773882
  },
  {
    lng: -42.0408391,
    lat: -21.7773427
  },
  {
    lng: -42.0408903,
    lat: -21.7773012
  },
  {
    lng: -42.0409545,
    lat: -21.7772539
  },
  {
    lng: -42.0410203,
    lat: -21.777182
  },
  {
    lng: -42.0410412,
    lat: -21.7770742
  },
  {
    lng: -42.0410005,
    lat: -21.776979
  },
  {
    lng: -42.0409409,
    lat: -21.7769229
  },
  {
    lng: -42.0408938,
    lat: -21.77688
  },
  {
    lng: -42.0408564,
    lat: -21.7768365
  },
  {
    lng: -42.0408182,
    lat: -21.7767825
  },
  {
    lng: -42.0407643,
    lat: -21.7767163
  },
  {
    lng: -42.0406921,
    lat: -21.7766602
  },
  {
    lng: -42.0406092,
    lat: -21.7766266
  },
  {
    lng: -42.0405319,
    lat: -21.7766055
  },
  {
    lng: -42.0404517,
    lat: -21.7765912
  },
  {
    lng: -42.0403815,
    lat: -21.7765861
  },
  {
    lng: -42.040322,
    lat: -21.776575
  },
  {
    lng: -42.0402481,
    lat: -21.7765505
  },
  {
    lng: -42.0401654,
    lat: -21.7765325
  },
  {
    lng: -42.0400802,
    lat: -21.7765307
  },
  {
    lng: -42.0400099,
    lat: -21.7765301
  },
  {
    lng: -42.0399336,
    lat: -21.776531
  },
  {
    lng: -42.0398585,
    lat: -21.7765403
  },
  {
    lng: -42.039788,
    lat: -21.7765416
  },
  {
    lng: -42.0397164,
    lat: -21.776541
  },
  {
    lng: -42.0396533,
    lat: -21.7765395
  },
  {
    lng: -42.0395941,
    lat: -21.7765305
  },
  {
    lng: -42.0395336,
    lat: -21.7765086
  },
  {
    lng: -42.0394697,
    lat: -21.7764714
  },
  {
    lng: -42.0393783,
    lat: -21.7764304
  },
  {
    lng: -42.0392756,
    lat: -21.776437
  },
  {
    lng: -42.0392154,
    lat: -21.7764649
  },
  {
    lng: -42.0391807,
    lat: -21.7764598
  },
  {
    lng: -42.0391221,
    lat: -21.7764288
  },
  {
    lng: -42.0390221,
    lat: -21.776405
  },
  {
    lng: -42.0389308,
    lat: -21.7764272
  },
  {
    lng: -42.0388716,
    lat: -21.7764378
  },
  {
    lng: -42.0388107,
    lat: -21.7764372
  },
  {
    lng: -42.0387418,
    lat: -21.7764283
  },
  {
    lng: -42.0386696,
    lat: -21.7764123
  },
  {
    lng: -42.0386068,
    lat: -21.7763966
  },
  {
    lng: -42.0385458,
    lat: -21.7763782
  },
  {
    lng: -42.038489,
    lat: -21.7763557
  },
  {
    lng: -42.0384355,
    lat: -21.7763273
  },
  {
    lng: -42.038381,
    lat: -21.7762935
  },
  {
    lng: -42.0383326,
    lat: -21.7762582
  },
  {
    lng: -42.0382894,
    lat: -21.7762179
  },
  {
    lng: -42.0382421,
    lat: -21.776167
  },
  {
    lng: -42.0381922,
    lat: -21.776117
  },
  {
    lng: -42.0381424,
    lat: -21.7760697
  },
  {
    lng: -42.0380912,
    lat: -21.7760155
  },
  {
    lng: -42.0380373,
    lat: -21.7759633
  },
  {
    lng: -42.0379927,
    lat: -21.7759152
  },
  {
    lng: -42.0379585,
    lat: -21.7758706
  },
  {
    lng: -42.0379478,
    lat: -21.7758265
  },
  {
    lng: -42.0379501,
    lat: -21.775771
  },
  {
    lng: -42.0379561,
    lat: -21.775703
  },
  {
    lng: -42.0379694,
    lat: -21.7756428
  },
  {
    lng: -42.0379931,
    lat: -21.7755745
  },
  {
    lng: -42.038012,
    lat: -21.7755113
  },
  {
    lng: -42.0380318,
    lat: -21.7754597
  },
  {
    lng: -42.0380669,
    lat: -21.7754056
  },
  {
    lng: -42.0381098,
    lat: -21.7753604
  },
  {
    lng: -42.038167,
    lat: -21.7753129
  },
  {
    lng: -42.0382177,
    lat: -21.7752779
  },
  {
    lng: -42.0382751,
    lat: -21.7752449
  },
  {
    lng: -42.0383063,
    lat: -21.7752291
  },
  {
    lng: -42.0383376,
    lat: -21.7752133
  },
  {
    lng: -42.0384087,
    lat: -21.7751803
  },
  {
    lng: -42.0384743,
    lat: -21.7751501
  },
  {
    lng: -42.0385357,
    lat: -21.7751238
  },
  {
    lng: -42.0386116,
    lat: -21.7750911
  },
  {
    lng: -42.0386774,
    lat: -21.7750645
  },
  {
    lng: -42.0387452,
    lat: -21.7750436
  },
  {
    lng: -42.0388173,
    lat: -21.7750231
  },
  {
    lng: -42.0388871,
    lat: -21.7750093
  },
  {
    lng: -42.0389637,
    lat: -21.7749967
  },
  {
    lng: -42.0390375,
    lat: -21.77499
  },
  {
    lng: -42.0391112,
    lat: -21.7749888
  },
  {
    lng: -42.0391785,
    lat: -21.7749888
  },
  {
    lng: -42.0392465,
    lat: -21.7749914
  },
  {
    lng: -42.0393133,
    lat: -21.7749939
  },
  {
    lng: -42.0393846,
    lat: -21.7749983
  },
  {
    lng: -42.0394462,
    lat: -21.775005
  },
  {
    lng: -42.0395114,
    lat: -21.7750204
  },
  {
    lng: -42.0395599,
    lat: -21.7750404
  },
  {
    lng: -42.039597,
    lat: -21.7750692
  },
  {
    lng: -42.0396249,
    lat: -21.7751116
  },
  {
    lng: -42.0396425,
    lat: -21.7751678
  },
  {
    lng: -42.0396745,
    lat: -21.7752457
  },
  {
    lng: -42.0397582,
    lat: -21.7753153
  },
  {
    lng: -42.0398687,
    lat: -21.7753358
  },
  {
    lng: -42.0399985,
    lat: -21.7752921
  },
  {
    lng: -42.040013,
    lat: -21.7751723
  },
  {
    lng: -42.0399658,
    lat: -21.7751082
  },
  {
    lng: -42.0399493,
    lat: -21.7750392
  },
  {
    lng: -42.0399276,
    lat: -21.774968
  },
  {
    lng: -42.0398892,
    lat: -21.7749066
  },
  {
    lng: -42.0398516,
    lat: -21.7748423
  },
  {
    lng: -42.0398118,
    lat: -21.7747795
  },
  {
    lng: -42.0397749,
    lat: -21.7747245
  },
  {
    lng: -42.0397372,
    lat: -21.7746629
  },
  {
    lng: -42.0397074,
    lat: -21.7746069
  },
  {
    lng: -42.0396807,
    lat: -21.774551
  },
  {
    lng: -42.0396611,
    lat: -21.7744914
  },
  {
    lng: -42.0396354,
    lat: -21.7744227
  },
  {
    lng: -42.0396165,
    lat: -21.7743614
  },
  {
    lng: -42.0396076,
    lat: -21.7742974
  },
  {
    lng: -42.0395969,
    lat: -21.7741624
  },
  {
    lng: -42.0395944,
    lat: -21.7740936
  },
  {
    lng: -42.0395951,
    lat: -21.7740279
  },
  {
    lng: -42.0396028,
    lat: -21.7739591
  },
  {
    lng: -42.0396174,
    lat: -21.7738975
  },
  {
    lng: -42.0396367,
    lat: -21.7738391
  },
  {
    lng: -42.0396632,
    lat: -21.7737891
  },
  {
    lng: -42.0397076,
    lat: -21.7737415
  },
  {
    lng: -42.0397612,
    lat: -21.7737106
  },
  {
    lng: -42.0398227,
    lat: -21.7736839
  },
  {
    lng: -42.0398856,
    lat: -21.7736572
  },
  {
    lng: -42.0399525,
    lat: -21.7736281
  },
  {
    lng: -42.040018,
    lat: -21.7735964
  },
  {
    lng: -42.0400793,
    lat: -21.7735514
  },
  {
    lng: -42.0401241,
    lat: -21.7734901
  },
  {
    lng: -42.0401506,
    lat: -21.7734168
  },
  {
    lng: -42.0401601,
    lat: -21.7733455
  },
  {
    lng: -42.0401585,
    lat: -21.7732746
  },
  {
    lng: -42.0401433,
    lat: -21.7732011
  },
  {
    lng: -42.0401215,
    lat: -21.7731265
  },
  {
    lng: -42.0401045,
    lat: -21.7730647
  },
  {
    lng: -42.040082,
    lat: -21.7729914
  },
  {
    lng: -42.0400556,
    lat: -21.7729177
  },
  {
    lng: -42.0400109,
    lat: -21.7728469
  },
  {
    lng: -42.0399537,
    lat: -21.7727903
  },
  {
    lng: -42.0398865,
    lat: -21.7727446
  },
  {
    lng: -42.0398149,
    lat: -21.7727043
  },
  {
    lng: -42.0397511,
    lat: -21.7726708
  },
  {
    lng: -42.0396836,
    lat: -21.772635
  },
  {
    lng: -42.0396152,
    lat: -21.7726039
  },
  {
    lng: -42.0395374,
    lat: -21.7725769
  },
  {
    lng: -42.0394584,
    lat: -21.7725619
  },
  {
    lng: -42.0393875,
    lat: -21.7725457
  },
  {
    lng: -42.0393139,
    lat: -21.7725277
  },
  {
    lng: -42.039232,
    lat: -21.7725179
  },
  {
    lng: -42.039153,
    lat: -21.7725057
  },
  {
    lng: -42.0390732,
    lat: -21.7724989
  },
  {
    lng: -42.0389978,
    lat: -21.7724958
  },
  {
    lng: -42.0389267,
    lat: -21.7724918
  },
  {
    lng: -42.0388887,
    lat: -21.7724895
  },
  {
    lng: -42.0388507,
    lat: -21.7724873
  },
  {
    lng: -42.0387782,
    lat: -21.7724768
  },
  {
    lng: -42.0387118,
    lat: -21.7724608
  },
  {
    lng: -42.038643,
    lat: -21.7724372
  },
  {
    lng: -42.0385889,
    lat: -21.7724077
  },
  {
    lng: -42.0385389,
    lat: -21.772369
  },
  {
    lng: -42.0384934,
    lat: -21.7723252
  },
  {
    lng: -42.0384568,
    lat: -21.7722761
  },
  {
    lng: -42.0384264,
    lat: -21.7722238
  },
  {
    lng: -42.0383947,
    lat: -21.772155
  },
  {
    lng: -42.0383659,
    lat: -21.7720842
  },
  {
    lng: -42.0383446,
    lat: -21.772021
  },
  {
    lng: -42.038323,
    lat: -21.7719591
  },
  {
    lng: -42.0383035,
    lat: -21.7718988
  },
  {
    lng: -42.0382796,
    lat: -21.7718272
  },
  {
    lng: -42.0382495,
    lat: -21.771762
  },
  {
    lng: -42.0382075,
    lat: -21.7716995
  },
  {
    lng: -42.0381544,
    lat: -21.7716473
  },
  {
    lng: -42.0380959,
    lat: -21.7716076
  },
  {
    lng: -42.0380363,
    lat: -21.7715678
  },
  {
    lng: -42.0379773,
    lat: -21.7715284
  },
  {
    lng: -42.0379157,
    lat: -21.7714896
  },
  {
    lng: -42.0378506,
    lat: -21.7714517
  },
  {
    lng: -42.0377863,
    lat: -21.7714174
  },
  {
    lng: -42.0377202,
    lat: -21.7713834
  },
  {
    lng: -42.0376545,
    lat: -21.7713417
  },
  {
    lng: -42.0375853,
    lat: -21.7713025
  },
  {
    lng: -42.0375126,
    lat: -21.7712655
  },
  {
    lng: -42.0374424,
    lat: -21.7712327
  },
  {
    lng: -42.037378,
    lat: -21.7711997
  },
  {
    lng: -42.0373083,
    lat: -21.7711652
  },
  {
    lng: -42.037235,
    lat: -21.7711304
  },
  {
    lng: -42.0371575,
    lat: -21.7711038
  },
  {
    lng: -42.0370911,
    lat: -21.771079
  },
  {
    lng: -42.0370263,
    lat: -21.7710525
  },
  {
    lng: -42.0369538,
    lat: -21.7710248
  },
  {
    lng: -42.0369345,
    lat: -21.7710158
  },
  {
    lng: -42.0368951,
    lat: -21.7709971
  },
  {
    lng: -42.0368318,
    lat: -21.7709633
  },
  {
    lng: -42.0367643,
    lat: -21.7709238
  },
  {
    lng: -42.036701,
    lat: -21.770883
  },
  {
    lng: -42.0366424,
    lat: -21.7708389
  },
  {
    lng: -42.0365867,
    lat: -21.7707898
  },
  {
    lng: -42.0365361,
    lat: -21.7707485
  },
  {
    lng: -42.0364966,
    lat: -21.7706995
  },
  {
    lng: -42.0364592,
    lat: -21.7706468
  },
  {
    lng: -42.0364189,
    lat: -21.7705911
  },
  {
    lng: -42.0363792,
    lat: -21.7705288
  },
  {
    lng: -42.0363416,
    lat: -21.7704644
  },
  {
    lng: -42.0363176,
    lat: -21.7704034
  },
  {
    lng: -42.0362939,
    lat: -21.770326
  },
  {
    lng: -42.0362761,
    lat: -21.7702616
  },
  {
    lng: -42.0362587,
    lat: -21.7701931
  },
  {
    lng: -42.036248,
    lat: -21.7701223
  },
  {
    lng: -42.0362434,
    lat: -21.7700603
  },
  {
    lng: -42.0362405,
    lat: -21.7699983
  },
  {
    lng: -42.0362424,
    lat: -21.7699193
  },
  {
    lng: -42.0362452,
    lat: -21.7698503
  },
  {
    lng: -42.0362489,
    lat: -21.7697843
  },
  {
    lng: -42.0362597,
    lat: -21.7697187
  },
  {
    lng: -42.0362761,
    lat: -21.7696482
  },
  {
    lng: -42.0362965,
    lat: -21.7695798
  },
  {
    lng: -42.0363207,
    lat: -21.7695114
  },
  {
    lng: -42.0363459,
    lat: -21.7694437
  },
  {
    lng: -42.0363694,
    lat: -21.7693757
  },
  {
    lng: -42.0363894,
    lat: -21.7693099
  },
  {
    lng: -42.0364045,
    lat: -21.7692456
  },
  {
    lng: -42.0364128,
    lat: -21.7691791
  },
  {
    lng: -42.0364159,
    lat: -21.7691017
  },
  {
    lng: -42.0364136,
    lat: -21.7690284
  },
  {
    lng: -42.0363952,
    lat: -21.7689532
  },
  {
    lng: -42.0363698,
    lat: -21.7688886
  },
  {
    lng: -42.036333,
    lat: -21.7688281
  },
  {
    lng: -42.0362816,
    lat: -21.7687682
  },
  {
    lng: -42.0362222,
    lat: -21.7687175
  },
  {
    lng: -42.0361455,
    lat: -21.768678
  },
  {
    lng: -42.0360706,
    lat: -21.7686468
  },
  {
    lng: -42.0360034,
    lat: -21.7686082
  },
  {
    lng: -42.0359295,
    lat: -21.768572
  },
  {
    lng: -42.035857,
    lat: -21.7685349
  },
  {
    lng: -42.0357936,
    lat: -21.7685039
  },
  {
    lng: -42.0357305,
    lat: -21.7684711
  },
  {
    lng: -42.035668,
    lat: -21.7684412
  },
  {
    lng: -42.0356049,
    lat: -21.768409
  },
  {
    lng: -42.0355265,
    lat: -21.7683796
  },
  {
    lng: -42.0354524,
    lat: -21.7683521
  },
  {
    lng: -42.0353767,
    lat: -21.7683242
  },
  {
    lng: -42.0352982,
    lat: -21.7683007
  },
  {
    lng: -42.0352245,
    lat: -21.7682904
  },
  {
    lng: -42.0351471,
    lat: -21.7682843
  },
  {
    lng: -42.0349271,
    lat: -21.7682767
  },
  {
    lng: -42.0348537,
    lat: -21.7682703
  },
  {
    lng: -42.0347795,
    lat: -21.7682616
  },
  {
    lng: -42.0347106,
    lat: -21.7682509
  },
  {
    lng: -42.0346464,
    lat: -21.7682377
  },
  {
    lng: -42.0345807,
    lat: -21.7682204
  },
  {
    lng: -42.0345193,
    lat: -21.7681949
  },
  {
    lng: -42.0344553,
    lat: -21.7681589
  },
  {
    lng: -42.0344023,
    lat: -21.7681204
  },
  {
    lng: -42.0343474,
    lat: -21.7680794
  },
  {
    lng: -42.0342943,
    lat: -21.7680419
  },
  {
    lng: -42.0342474,
    lat: -21.7679969
  },
  {
    lng: -42.0342015,
    lat: -21.76794
  },
  {
    lng: -42.0341605,
    lat: -21.7678866
  },
  {
    lng: -42.0341109,
    lat: -21.7678391
  },
  {
    lng: -42.0340787,
    lat: -21.7677657
  },
  {
    lng: -42.0340393,
    lat: -21.7677216
  },
  {
    lng: -42.033985,
    lat: -21.7676757
  },
  {
    lng: -42.0339358,
    lat: -21.7676347
  },
  {
    lng: -42.0338842,
    lat: -21.7675834
  },
  {
    lng: -42.0338375,
    lat: -21.7675333
  },
  {
    lng: -42.0337818,
    lat: -21.7674854
  },
  {
    lng: -42.0337292,
    lat: -21.7674421
  },
  {
    lng: -42.0336662,
    lat: -21.7673925
  },
  {
    lng: -42.0336166,
    lat: -21.7673454
  },
  {
    lng: -42.0335623,
    lat: -21.767295
  },
  {
    lng: -42.0335069,
    lat: -21.7672477
  },
  {
    lng: -42.0334556,
    lat: -21.7672034
  },
  {
    lng: -42.0334071,
    lat: -21.767154
  },
  {
    lng: -42.0333495,
    lat: -21.7670961
  },
  {
    lng: -42.0332931,
    lat: -21.7670473
  },
  {
    lng: -42.0332379,
    lat: -21.7670007
  },
  {
    lng: -42.0331856,
    lat: -21.7669581
  },
  {
    lng: -42.0331237,
    lat: -21.7669059
  },
  {
    lng: -42.0330565,
    lat: -21.7668531
  },
  {
    lng: -42.0329749,
    lat: -21.7668114
  },
  {
    lng: -42.0328975,
    lat: -21.7667845
  },
  {
    lng: -42.0328123,
    lat: -21.7667635
  },
  {
    lng: -42.0327411,
    lat: -21.7667448
  },
  {
    lng: -42.0326702,
    lat: -21.7667311
  },
  {
    lng: -42.0325923,
    lat: -21.7667185
  },
  {
    lng: -42.032515,
    lat: -21.76671
  },
  {
    lng: -42.0324375,
    lat: -21.7667022
  },
  {
    lng: -42.0323567,
    lat: -21.7666955
  },
  {
    lng: -42.032276,
    lat: -21.766684
  },
  {
    lng: -42.0322068,
    lat: -21.7666716
  },
  {
    lng: -42.0321256,
    lat: -21.7666569
  },
  {
    lng: -42.0320587,
    lat: -21.766645
  },
  {
    lng: -42.0319838,
    lat: -21.7666318
  },
  {
    lng: -42.0319145,
    lat: -21.7666174
  },
  {
    lng: -42.0318454,
    lat: -21.7665987
  },
  {
    lng: -42.0317893,
    lat: -21.7665767
  },
  {
    lng: -42.0317355,
    lat: -21.7665469
  },
  {
    lng: -42.0316877,
    lat: -21.7665143
  },
  {
    lng: -42.0316772,
    lat: -21.7665072
  },
  {
    lng: -42.0316134,
    lat: -21.7664676
  },
  {
    lng: -42.0315689,
    lat: -21.7664323
  },
  {
    lng: -42.0315333,
    lat: -21.7663888
  },
  {
    lng: -42.0315152,
    lat: -21.7663386
  },
  {
    lng: -42.0315158,
    lat: -21.7662872
  },
  {
    lng: -42.0315236,
    lat: -21.7662331
  },
  {
    lng: -42.0315443,
    lat: -21.7661797
  },
  {
    lng: -42.031575,
    lat: -21.7661143
  },
  {
    lng: -42.0315897,
    lat: -21.7660339
  },
  {
    lng: -42.0315683,
    lat: -21.7659372
  },
  {
    lng: -42.0315234,
    lat: -21.7659061
  },
  {
    lng: -42.0314785,
    lat: -21.7658749
  },
  {
    lng: -42.0313815,
    lat: -21.7658637
  },
  {
    lng: -42.0312992,
    lat: -21.7658643
  },
  {
    lng: -42.0312183,
    lat: -21.76589
  },
  {
    lng: -42.0311454,
    lat: -21.7659343
  },
  {
    lng: -42.0310865,
    lat: -21.7659994
  },
  {
    lng: -42.0310407,
    lat: -21.7660656
  },
  {
    lng: -42.0310086,
    lat: -21.7661402
  },
  {
    lng: -42.031,
    lat: -21.7662266
  },
  {
    lng: -42.0310164,
    lat: -21.7663128
  },
  {
    lng: -42.0310344,
    lat: -21.7663762
  },
  {
    lng: -42.0310523,
    lat: -21.7664453
  },
  {
    lng: -42.0310723,
    lat: -21.7665155
  },
  {
    lng: -42.0310937,
    lat: -21.7665864
  },
  {
    lng: -42.0311112,
    lat: -21.766648
  },
  {
    lng: -42.031131,
    lat: -21.7667144
  },
  {
    lng: -42.0311492,
    lat: -21.766778
  },
  {
    lng: -42.0311635,
    lat: -21.7668388
  },
  {
    lng: -42.0311737,
    lat: -21.7669029
  },
  {
    lng: -42.0311822,
    lat: -21.7669748
  },
  {
    lng: -42.0311913,
    lat: -21.767047
  },
  {
    lng: -42.0311967,
    lat: -21.7671187
  },
  {
    lng: -42.0311999,
    lat: -21.7671856
  },
  {
    lng: -42.0311976,
    lat: -21.7672574
  },
  {
    lng: -42.0311939,
    lat: -21.7673207
  },
  {
    lng: -42.031187,
    lat: -21.7673811
  },
  {
    lng: -42.0311732,
    lat: -21.7674419
  },
  {
    lng: -42.0311486,
    lat: -21.7675063
  },
  {
    lng: -42.0311159,
    lat: -21.76756
  },
  {
    lng: -42.031077,
    lat: -21.7675958
  },
  {
    lng: -42.0310298,
    lat: -21.7676216
  },
  {
    lng: -42.0309703,
    lat: -21.7676397
  },
  {
    lng: -42.0309112,
    lat: -21.7676516
  },
  {
    lng: -42.0308546,
    lat: -21.7676538
  },
  {
    lng: -42.0307873,
    lat: -21.7676435
  },
  {
    lng: -42.0307176,
    lat: -21.7676262
  },
  {
    lng: -42.0306441,
    lat: -21.7676049
  },
  {
    lng: -42.0305674,
    lat: -21.7675804
  },
  {
    lng: -42.030497,
    lat: -21.7675526
  },
  {
    lng: -42.0304313,
    lat: -21.7675193
  },
  {
    lng: -42.0303574,
    lat: -21.7674775
  },
  {
    lng: -42.0302988,
    lat: -21.7674459
  },
  {
    lng: -42.030227,
    lat: -21.7674026
  },
  {
    lng: -42.0301656,
    lat: -21.7673665
  },
  {
    lng: -42.0301069,
    lat: -21.7673343
  },
  {
    lng: -42.0300424,
    lat: -21.7672943
  },
  {
    lng: -42.0299745,
    lat: -21.7672488
  },
  {
    lng: -42.0298972,
    lat: -21.7672059
  },
  {
    lng: -42.0298144,
    lat: -21.7671723
  },
  {
    lng: -42.0297339,
    lat: -21.7671486
  },
  {
    lng: -42.0296598,
    lat: -21.7671306
  },
  {
    lng: -42.0295891,
    lat: -21.7671176
  },
  {
    lng: -42.0295162,
    lat: -21.7671065
  },
  {
    lng: -42.0294357,
    lat: -21.7670933
  },
  {
    lng: -42.0293637,
    lat: -21.7670764
  },
  {
    lng: -42.0293124,
    lat: -21.767055
  },
  {
    lng: -42.0292609,
    lat: -21.7670202
  },
  {
    lng: -42.0292232,
    lat: -21.7669719
  },
  {
    lng: -42.0291952,
    lat: -21.7669123
  },
  {
    lng: -42.0291739,
    lat: -21.7668406
  },
  {
    lng: -42.0291535,
    lat: -21.7667725
  },
  {
    lng: -42.0291441,
    lat: -21.7667144
  },
  {
    lng: -42.0291368,
    lat: -21.7666412
  },
  {
    lng: -42.0291272,
    lat: -21.7665711
  },
  {
    lng: -42.0291044,
    lat: -21.7664912
  },
  {
    lng: -42.0290713,
    lat: -21.7664166
  },
  {
    lng: -42.0290294,
    lat: -21.7663483
  },
  {
    lng: -42.0289684,
    lat: -21.7662922
  },
  {
    lng: -42.0288902,
    lat: -21.7662543
  },
  {
    lng: -42.0287977,
    lat: -21.7662351
  },
  {
    lng: -42.0287124,
    lat: -21.7662434
  },
  {
    lng: -42.0286399,
    lat: -21.7662664
  },
  {
    lng: -42.028557,
    lat: -21.7662976
  },
  {
    lng: -42.0284814,
    lat: -21.7663489
  },
  {
    lng: -42.0284284,
    lat: -21.7664079
  },
  {
    lng: -42.0283847,
    lat: -21.7664825
  },
  {
    lng: -42.0283646,
    lat: -21.7665739
  },
  {
    lng: -42.0283645,
    lat: -21.7666613
  },
  {
    lng: -42.0283707,
    lat: -21.7667299
  },
  {
    lng: -42.0283806,
    lat: -21.7668093
  },
  {
    lng: -42.028392,
    lat: -21.7668852
  },
  {
    lng: -42.0284084,
    lat: -21.7669592
  },
  {
    lng: -42.0284254,
    lat: -21.767031
  },
  {
    lng: -42.0284396,
    lat: -21.7671031
  },
  {
    lng: -42.0284525,
    lat: -21.7671856
  },
  {
    lng: -42.0284661,
    lat: -21.7672727
  },
  {
    lng: -42.0284786,
    lat: -21.7673421
  },
  {
    lng: -42.0284905,
    lat: -21.7674097
  },
  {
    lng: -42.0285042,
    lat: -21.7674889
  },
  {
    lng: -42.0285153,
    lat: -21.7675597
  },
  {
    lng: -42.0285267,
    lat: -21.76763
  },
  {
    lng: -42.0285419,
    lat: -21.767702
  },
  {
    lng: -42.0285589,
    lat: -21.7677732
  },
  {
    lng: -42.028578,
    lat: -21.7678428
  },
  {
    lng: -42.0285995,
    lat: -21.7679078
  },
  {
    lng: -42.0286276,
    lat: -21.76798
  },
  {
    lng: -42.0286652,
    lat: -21.7680494
  },
  {
    lng: -42.0287215,
    lat: -21.7681122
  },
  {
    lng: -42.0287823,
    lat: -21.7681643
  },
  {
    lng: -42.0288458,
    lat: -21.768209
  },
  {
    lng: -42.0289067,
    lat: -21.768248
  },
  {
    lng: -42.0289677,
    lat: -21.7682866
  },
  {
    lng: -42.029022,
    lat: -21.7683228
  },
  {
    lng: -42.0290697,
    lat: -21.7683617
  },
  {
    lng: -42.0291143,
    lat: -21.768406
  },
  {
    lng: -42.0291359,
    lat: -21.7684452
  },
  {
    lng: -42.0291363,
    lat: -21.768496
  },
  {
    lng: -42.0291338,
    lat: -21.7685592
  },
  {
    lng: -42.0291312,
    lat: -21.7686394
  },
  {
    lng: -42.029116,
    lat: -21.7686921
  },
  {
    lng: -42.0290883,
    lat: -21.7687386
  },
  {
    lng: -42.0290454,
    lat: -21.7687721
  },
  {
    lng: -42.0289989,
    lat: -21.7687898
  },
  {
    lng: -42.0289378,
    lat: -21.7687886
  },
  {
    lng: -42.028862,
    lat: -21.768786
  },
  {
    lng: -42.0288073,
    lat: -21.768783
  },
  {
    lng: -42.0287822,
    lat: -21.7687816
  },
  {
    lng: -42.0287083,
    lat: -21.7687773
  },
  {
    lng: -42.0286242,
    lat: -21.768781
  },
  {
    lng: -42.0285534,
    lat: -21.7687913
  },
  {
    lng: -42.0284782,
    lat: -21.7687985
  },
  {
    lng: -42.0284004,
    lat: -21.7688018
  },
  {
    lng: -42.0283298,
    lat: -21.7688005
  },
  {
    lng: -42.0281866,
    lat: -21.7687955
  },
  {
    lng: -42.0281122,
    lat: -21.7687919
  },
  {
    lng: -42.0280377,
    lat: -21.7687788
  },
  {
    lng: -42.0279704,
    lat: -21.7687604
  },
  {
    lng: -42.0279153,
    lat: -21.7687349
  },
  {
    lng: -42.0278618,
    lat: -21.768701
  },
  {
    lng: -42.027808,
    lat: -21.7686651
  },
  {
    lng: -42.0277463,
    lat: -21.7686181
  },
  {
    lng: -42.0276765,
    lat: -21.7685802
  },
  {
    lng: -42.0275992,
    lat: -21.7685557
  },
  {
    lng: -42.0275191,
    lat: -21.768546
  },
  {
    lng: -42.0274287,
    lat: -21.7685475
  },
  {
    lng: -42.0273555,
    lat: -21.7685761
  },
  {
    lng: -42.0272924,
    lat: -21.7685991
  },
  {
    lng: -42.0272415,
    lat: -21.7686047
  },
  {
    lng: -42.0271927,
    lat: -21.7685823
  },
  {
    lng: -42.0271356,
    lat: -21.7685431
  },
  {
    lng: -42.0270932,
    lat: -21.7685005
  },
  {
    lng: -42.0270459,
    lat: -21.7684501
  },
  {
    lng: -42.0270089,
    lat: -21.7684012
  },
  {
    lng: -42.0269682,
    lat: -21.7683417
  },
  {
    lng: -42.0269312,
    lat: -21.7682761
  },
  {
    lng: -42.0269023,
    lat: -21.7682193
  },
  {
    lng: -42.0268659,
    lat: -21.768148
  },
  {
    lng: -42.0268374,
    lat: -21.7680812
  },
  {
    lng: -42.0268115,
    lat: -21.7680138
  },
  {
    lng: -42.0267933,
    lat: -21.7679505
  },
  {
    lng: -42.0267873,
    lat: -21.7678943
  },
  {
    lng: -42.0267992,
    lat: -21.7678259
  },
  {
    lng: -42.0268189,
    lat: -21.7677503
  },
  {
    lng: -42.0268349,
    lat: -21.7676828
  },
  {
    lng: -42.0268517,
    lat: -21.7676164
  },
  {
    lng: -42.0268749,
    lat: -21.7675486
  },
  {
    lng: -42.0269059,
    lat: -21.7674856
  },
  {
    lng: -42.0269366,
    lat: -21.7674322
  },
  {
    lng: -42.0269736,
    lat: -21.7673811
  },
  {
    lng: -42.0270222,
    lat: -21.7673314
  },
  {
    lng: -42.027079,
    lat: -21.7672826
  },
  {
    lng: -42.0271339,
    lat: -21.7672382
  },
  {
    lng: -42.0271863,
    lat: -21.767197
  },
  {
    lng: -42.0272483,
    lat: -21.7671541
  },
  {
    lng: -42.0273081,
    lat: -21.7671218
  },
  {
    lng: -42.0273634,
    lat: -21.7670844
  },
  {
    lng: -42.027435,
    lat: -21.7670513
  },
  {
    lng: -42.0274999,
    lat: -21.7670126
  },
  {
    lng: -42.0275668,
    lat: -21.7669506
  },
  {
    lng: -42.0275943,
    lat: -21.7668582
  },
  {
    lng: -42.0275444,
    lat: -21.7667713
  },
  {
    lng: -42.0274544,
    lat: -21.766729
  },
  {
    lng: -42.0273679,
    lat: -21.766714
  },
  {
    lng: -42.0272889,
    lat: -21.7667071
  },
  {
    lng: -42.0272022,
    lat: -21.7667041
  },
  {
    lng: -42.0271272,
    lat: -21.7667069
  },
  {
    lng: -42.0270508,
    lat: -21.7667162
  },
  {
    lng: -42.0270303,
    lat: -21.7667202
  },
  {
    lng: -42.0269796,
    lat: -21.76673
  },
  {
    lng: -42.0269049,
    lat: -21.7667516
  },
  {
    lng: -42.0268655,
    lat: -21.7667677
  },
  {
    lng: -42.0268262,
    lat: -21.7667838
  },
  {
    lng: -42.0267605,
    lat: -21.7668143
  },
  {
    lng: -42.0266921,
    lat: -21.76685
  },
  {
    lng: -42.0266191,
    lat: -21.7668734
  },
  {
    lng: -42.026549,
    lat: -21.7668791
  },
  {
    lng: -42.0264774,
    lat: -21.7668766
  },
  {
    lng: -42.0264124,
    lat: -21.7668716
  },
  {
    lng: -42.0263364,
    lat: -21.7668593
  },
  {
    lng: -42.0262639,
    lat: -21.7668421
  },
  {
    lng: -42.0261967,
    lat: -21.7668241
  },
  {
    lng: -42.0261197,
    lat: -21.7668117
  },
  {
    lng: -42.0260446,
    lat: -21.7668078
  },
  {
    lng: -42.0259588,
    lat: -21.7668128
  },
  {
    lng: -42.0258792,
    lat: -21.766828
  },
  {
    lng: -42.0258023,
    lat: -21.7668464
  },
  {
    lng: -42.0257254,
    lat: -21.7668842
  },
  {
    lng: -42.0256645,
    lat: -21.7669587
  },
  {
    lng: -42.0256391,
    lat: -21.7670378
  },
  {
    lng: -42.0256341,
    lat: -21.7670956
  },
  {
    lng: -42.0256023,
    lat: -21.7671395
  },
  {
    lng: -42.02556,
    lat: -21.7671863
  },
  {
    lng: -42.0255115,
    lat: -21.7672177
  },
  {
    lng: -42.0254486,
    lat: -21.7672365
  },
  {
    lng: -42.0253818,
    lat: -21.7672377
  },
  {
    lng: -42.0253023,
    lat: -21.7672349
  },
  {
    lng: -42.0252358,
    lat: -21.7672321
  },
  {
    lng: -42.025167,
    lat: -21.767225
  },
  {
    lng: -42.0251043,
    lat: -21.7672087
  },
  {
    lng: -42.025041,
    lat: -21.7671816
  },
  {
    lng: -42.024981,
    lat: -21.7671486
  },
  {
    lng: -42.0249554,
    lat: -21.767128
  },
  {
    lng: -42.0249298,
    lat: -21.7671075
  },
  {
    lng: -42.024884,
    lat: -21.7670565
  },
  {
    lng: -42.0248415,
    lat: -21.7670024
  },
  {
    lng: -42.0248148,
    lat: -21.7669506
  },
  {
    lng: -42.0248073,
    lat: -21.7668933
  },
  {
    lng: -42.0248183,
    lat: -21.7668275
  },
  {
    lng: -42.0248382,
    lat: -21.7667688
  },
  {
    lng: -42.0248663,
    lat: -21.766713
  },
  {
    lng: -42.0248986,
    lat: -21.7666598
  },
  {
    lng: -42.0249378,
    lat: -21.7666132
  },
  {
    lng: -42.0249899,
    lat: -21.7665597
  },
  {
    lng: -42.0250357,
    lat: -21.7664982
  },
  {
    lng: -42.0250587,
    lat: -21.7664162
  },
  {
    lng: -42.0250337,
    lat: -21.7663274
  },
  {
    lng: -42.0249841,
    lat: -21.7662596
  },
  {
    lng: -42.0249444,
    lat: -21.7662368
  },
  {
    lng: -42.0249047,
    lat: -21.7662139
  },
  {
    lng: -42.0248114,
    lat: -21.7661983
  },
  {
    lng: -42.0247189,
    lat: -21.7662266
  },
  {
    lng: -42.0246607,
    lat: -21.76629
  },
  {
    lng: -42.0246225,
    lat: -21.7663482
  },
  {
    lng: -42.0245769,
    lat: -21.7664049
  },
  {
    lng: -42.0245334,
    lat: -21.766453
  },
  {
    lng: -42.0244886,
    lat: -21.7664923
  },
  {
    lng: -42.024426,
    lat: -21.7665236
  },
  {
    lng: -42.0243629,
    lat: -21.7665496
  },
  {
    lng: -42.0242964,
    lat: -21.7665817
  },
  {
    lng: -42.0242347,
    lat: -21.7666267
  },
  {
    lng: -42.0241716,
    lat: -21.7666706
  },
  {
    lng: -42.0241051,
    lat: -21.766717
  },
  {
    lng: -42.0240445,
    lat: -21.7667708
  },
  {
    lng: -42.0240032,
    lat: -21.7668381
  },
  {
    lng: -42.0239962,
    lat: -21.76686
  },
  {
    lng: -42.0239804,
    lat: -21.7669093
  },
  {
    lng: -42.0239705,
    lat: -21.7669792
  },
  {
    lng: -42.0239638,
    lat: -21.7670545
  },
  {
    lng: -42.0239643,
    lat: -21.7671235
  },
  {
    lng: -42.023973,
    lat: -21.7671954
  },
  {
    lng: -42.0239896,
    lat: -21.767273
  },
  {
    lng: -42.0240097,
    lat: -21.7673415
  },
  {
    lng: -42.0240545,
    lat: -21.7674166
  },
  {
    lng: -42.0241175,
    lat: -21.7674752
  },
  {
    lng: -42.0241782,
    lat: -21.7675196
  },
  {
    lng: -42.0242356,
    lat: -21.7675583
  },
  {
    lng: -42.0242896,
    lat: -21.7675949
  },
  {
    lng: -42.0243344,
    lat: -21.7676298
  },
  {
    lng: -42.0243627,
    lat: -21.7676742
  },
  {
    lng: -42.0243795,
    lat: -21.7677306
  },
  {
    lng: -42.0243975,
    lat: -21.7677972
  },
  {
    lng: -42.0244094,
    lat: -21.7678577
  },
  {
    lng: -42.0244076,
    lat: -21.7679175
  },
  {
    lng: -42.0243914,
    lat: -21.7679844
  },
  {
    lng: -42.0243653,
    lat: -21.7680415
  },
  {
    lng: -42.0243321,
    lat: -21.7681019
  },
  {
    lng: -42.0242949,
    lat: -21.7681622
  },
  {
    lng: -42.0242622,
    lat: -21.7682253
  },
  {
    lng: -42.0242299,
    lat: -21.7682762
  },
  {
    lng: -42.0242098,
    lat: -21.7682958
  },
  {
    lng: -42.0241896,
    lat: -21.7683154
  },
  {
    lng: -42.0241358,
    lat: -21.7683517
  },
  {
    lng: -42.0240699,
    lat: -21.7683854
  },
  {
    lng: -42.024005,
    lat: -21.7684119
  },
  {
    lng: -42.0239431,
    lat: -21.7684346
  },
  {
    lng: -42.0238673,
    lat: -21.7684498
  },
  {
    lng: -42.0237959,
    lat: -21.7684804
  },
  {
    lng: -42.0237291,
    lat: -21.7685203
  },
  {
    lng: -42.0236661,
    lat: -21.7685559
  },
  {
    lng: -42.023606,
    lat: -21.7685782
  },
  {
    lng: -42.0235365,
    lat: -21.7685979
  },
  {
    lng: -42.0234602,
    lat: -21.7686146
  },
  {
    lng: -42.0233937,
    lat: -21.7686279
  },
  {
    lng: -42.0233337,
    lat: -21.7686276
  },
  {
    lng: -42.0232782,
    lat: -21.7686011
  },
  {
    lng: -42.0232252,
    lat: -21.7685656
  },
  {
    lng: -42.0231673,
    lat: -21.7685264
  },
  {
    lng: -42.0230992,
    lat: -21.768484
  },
  {
    lng: -42.0230424,
    lat: -21.768448
  },
  {
    lng: -42.0229859,
    lat: -21.7684135
  },
  {
    lng: -42.0229317,
    lat: -21.7683778
  },
  {
    lng: -42.0228869,
    lat: -21.7683328
  },
  {
    lng: -42.0228436,
    lat: -21.7682779
  },
  {
    lng: -42.0228016,
    lat: -21.7682242
  },
  {
    lng: -42.0227431,
    lat: -21.7681606
  },
  {
    lng: -42.0226583,
    lat: -21.7681233
  },
  {
    lng: -42.0225717,
    lat: -21.7681133
  },
  {
    lng: -42.0224968,
    lat: -21.7681113
  },
  {
    lng: -42.0224111,
    lat: -21.7681131
  },
  {
    lng: -42.022369,
    lat: -21.7681212
  },
  {
    lng: -42.0223269,
    lat: -21.7681293
  },
  {
    lng: -42.0222571,
    lat: -21.7681657
  },
  {
    lng: -42.0221879,
    lat: -21.7681952
  },
  {
    lng: -42.0221209,
    lat: -21.7682144
  },
  {
    lng: -42.0220436,
    lat: -21.7682413
  },
  {
    lng: -42.0219766,
    lat: -21.7682882
  },
  {
    lng: -42.0219229,
    lat: -21.768358
  },
  {
    lng: -42.0218902,
    lat: -21.768424
  },
  {
    lng: -42.0218577,
    lat: -21.7684877
  },
  {
    lng: -42.0218324,
    lat: -21.7685693
  },
  {
    lng: -42.021862,
    lat: -21.7686569
  },
  {
    lng: -42.0219233,
    lat: -21.7687152
  },
  {
    lng: -42.0219724,
    lat: -21.7687616
  },
  {
    lng: -42.022024,
    lat: -21.7688141
  },
  {
    lng: -42.022075,
    lat: -21.7688637
  },
  {
    lng: -42.0221235,
    lat: -21.7689113
  },
  {
    lng: -42.022167,
    lat: -21.7689596
  },
  {
    lng: -42.0222048,
    lat: -21.7690059
  },
  {
    lng: -42.0222151,
    lat: -21.7690313
  },
  {
    lng: -42.0222255,
    lat: -21.7690566
  },
  {
    lng: -42.0222274,
    lat: -21.7691012
  },
  {
    lng: -42.0222013,
    lat: -21.7691411
  },
  {
    lng: -42.0221607,
    lat: -21.7691758
  },
  {
    lng: -42.0221352,
    lat: -21.7691863
  },
  {
    lng: -42.0221096,
    lat: -21.7691968
  },
  {
    lng: -42.0220436,
    lat: -21.7692019
  },
  {
    lng: -42.0219783,
    lat: -21.7692007
  },
  {
    lng: -42.0219125,
    lat: -21.7691979
  },
  {
    lng: -42.0218483,
    lat: -21.7691904
  },
  {
    lng: -42.021781,
    lat: -21.7691755
  },
  {
    lng: -42.0217083,
    lat: -21.7691601
  },
  {
    lng: -42.0216259,
    lat: -21.7691497
  },
  {
    lng: -42.0215583,
    lat: -21.7691417
  },
  {
    lng: -42.0214915,
    lat: -21.7691333
  },
  {
    lng: -42.0214252,
    lat: -21.7691203
  },
  {
    lng: -42.0213491,
    lat: -21.7691096
  },
  {
    lng: -42.0212679,
    lat: -21.7691155
  },
  {
    lng: -42.0211896,
    lat: -21.7691258
  },
  {
    lng: -42.021121,
    lat: -21.7691605
  },
  {
    lng: -42.0210473,
    lat: -21.7691941
  },
  {
    lng: -42.0210277,
    lat: -21.7692338
  },
  {
    lng: -42.0210081,
    lat: -21.7692736
  },
  {
    lng: -42.0210281,
    lat: -21.7693412
  },
  {
    lng: -42.0210543,
    lat: -21.7694071
  },
  {
    lng: -42.0210769,
    lat: -21.7694735
  },
  {
    lng: -42.0210966,
    lat: -21.7695384
  },
  {
    lng: -42.0211219,
    lat: -21.7696072
  },
  {
    lng: -42.0211405,
    lat: -21.7696659
  },
  {
    lng: -42.0211448,
    lat: -21.769722
  },
  {
    lng: -42.0211423,
    lat: -21.7699139
  },
  {
    lng: -42.0211364,
    lat: -21.7699739
  },
  {
    lng: -42.0211206,
    lat: -21.7700326
  },
  {
    lng: -42.0210947,
    lat: -21.770089
  },
  {
    lng: -42.0210599,
    lat: -21.770135
  },
  {
    lng: -42.0210185,
    lat: -21.7701728
  },
  {
    lng: -42.0209646,
    lat: -21.7702048
  },
  {
    lng: -42.0209077,
    lat: -21.770239
  },
  {
    lng: -42.0208466,
    lat: -21.770271
  },
  {
    lng: -42.0207728,
    lat: -21.7703006
  },
  {
    lng: -42.0207119,
    lat: -21.770322
  },
  {
    lng: -42.0206355,
    lat: -21.7703439
  },
  {
    lng: -42.0205614,
    lat: -21.7703609
  },
  {
    lng: -42.0204845,
    lat: -21.77037
  },
  {
    lng: -42.0204147,
    lat: -21.7703725
  },
  {
    lng: -42.020349,
    lat: -21.7703718
  },
  {
    lng: -42.0202752,
    lat: -21.7703693
  },
  {
    lng: -42.0202109,
    lat: -21.7703636
  },
  {
    lng: -42.0201475,
    lat: -21.7703514
  },
  {
    lng: -42.0200877,
    lat: -21.7703273
  },
  {
    lng: -42.0200323,
    lat: -21.7702944
  },
  {
    lng: -42.0200266,
    lat: -21.7702904
  },
  {
    lng: -42.0199787,
    lat: -21.7702568
  },
  {
    lng: -42.0199156,
    lat: -21.7702175
  },
  {
    lng: -42.0198388,
    lat: -21.7701724
  },
  {
    lng: -42.0197959,
    lat: -21.770173
  },
  {
    lng: -42.0197376,
    lat: -21.7701737
  },
  {
    lng: -42.0196552,
    lat: -21.7702005
  },
  {
    lng: -42.0195883,
    lat: -21.7702413
  },
  {
    lng: -42.0195256,
    lat: -21.770276
  },
  {
    lng: -42.0194634,
    lat: -21.7703161
  },
  {
    lng: -42.0193999,
    lat: -21.7703722
  },
  {
    lng: -42.0193509,
    lat: -21.770418
  },
  {
    lng: -42.0192913,
    lat: -21.7704713
  },
  {
    lng: -42.0192391,
    lat: -21.7705142
  },
  {
    lng: -42.0191879,
    lat: -21.770558
  },
  {
    lng: -42.0191393,
    lat: -21.7706
  },
  {
    lng: -42.0190852,
    lat: -21.7706329
  },
  {
    lng: -42.019019,
    lat: -21.7706626
  },
  {
    lng: -42.0189561,
    lat: -21.7706905
  },
  {
    lng: -42.018889,
    lat: -21.7707216
  },
  {
    lng: -42.0188236,
    lat: -21.7707608
  },
  {
    lng: -42.0187632,
    lat: -21.7708139
  },
  {
    lng: -42.0187063,
    lat: -21.770867
  },
  {
    lng: -42.0186546,
    lat: -21.7709142
  },
  {
    lng: -42.0185995,
    lat: -21.7709581
  },
  {
    lng: -42.0185445,
    lat: -21.7710053
  },
  {
    lng: -42.0184912,
    lat: -21.7710496
  },
  {
    lng: -42.0184266,
    lat: -21.7710855
  },
  {
    lng: -42.0183657,
    lat: -21.7711202
  },
  {
    lng: -42.0183079,
    lat: -21.7711545
  },
  {
    lng: -42.0182411,
    lat: -21.7711891
  },
  {
    lng: -42.0181696,
    lat: -21.7712218
  },
  {
    lng: -42.018104,
    lat: -21.7712535
  },
  {
    lng: -42.0180431,
    lat: -21.7712742
  },
  {
    lng: -42.0179728,
    lat: -21.7712895
  },
  {
    lng: -42.0178922,
    lat: -21.7713029
  },
  {
    lng: -42.0178113,
    lat: -21.771313
  },
  {
    lng: -42.0177345,
    lat: -21.7713196
  },
  {
    lng: -42.0176676,
    lat: -21.7713234
  },
  {
    lng: -42.0175334,
    lat: -21.7713219
  },
  {
    lng: -42.0174625,
    lat: -21.7713194
  },
  {
    lng: -42.0173883,
    lat: -21.7713135
  },
  {
    lng: -42.0173173,
    lat: -21.7713036
  },
  {
    lng: -42.0172514,
    lat: -21.7712914
  },
  {
    lng: -42.017189,
    lat: -21.77127
  },
  {
    lng: -42.0171476,
    lat: -21.7712396
  },
  {
    lng: -42.0171053,
    lat: -21.7711889
  },
  {
    lng: -42.0170731,
    lat: -21.771134
  },
  {
    lng: -42.0170275,
    lat: -21.7710731
  },
  {
    lng: -42.0169697,
    lat: -21.7710172
  },
  {
    lng: -42.0169228,
    lat: -21.7709693
  },
  {
    lng: -42.016868,
    lat: -21.7709157
  },
  {
    lng: -42.0168074,
    lat: -21.7708591
  },
  {
    lng: -42.0167285,
    lat: -21.7708175
  },
  {
    lng: -42.0166428,
    lat: -21.7707966
  },
  {
    lng: -42.0166141,
    lat: -21.770794
  },
  {
    lng: -42.0165624,
    lat: -21.7707892
  },
  {
    lng: -42.0164801,
    lat: -21.7707896
  },
  {
    lng: -42.0163997,
    lat: -21.770805
  },
  {
    lng: -42.0163229,
    lat: -21.7708243
  },
  {
    lng: -42.0162408,
    lat: -21.7708609
  },
  {
    lng: -42.0161768,
    lat: -21.7709036
  },
  {
    lng: -42.0161187,
    lat: -21.7709509
  },
  {
    lng: -42.0160634,
    lat: -21.7710057
  },
  {
    lng: -42.0160197,
    lat: -21.7710583
  },
  {
    lng: -42.0159723,
    lat: -21.7711015
  },
  {
    lng: -42.0159147,
    lat: -21.7711427
  },
  {
    lng: -42.0158634,
    lat: -21.7711717
  },
  {
    lng: -42.0158033,
    lat: -21.7711922
  },
  {
    lng: -42.0157398,
    lat: -21.7711982
  },
  {
    lng: -42.015669,
    lat: -21.771198
  },
  {
    lng: -42.015604,
    lat: -21.7711939
  },
  {
    lng: -42.0155413,
    lat: -21.7711838
  },
  {
    lng: -42.0154687,
    lat: -21.7711685
  },
  {
    lng: -42.0153963,
    lat: -21.7711531
  },
  {
    lng: -42.0153229,
    lat: -21.7711491
  },
  {
    lng: -42.0152534,
    lat: -21.7711471
  },
  {
    lng: -42.0151804,
    lat: -21.7711469
  },
  {
    lng: -42.0151056,
    lat: -21.771157
  },
  {
    lng: -42.015023,
    lat: -21.7711737
  },
  {
    lng: -42.0149482,
    lat: -21.7712043
  },
  {
    lng: -42.0148735,
    lat: -21.771227
  },
  {
    lng: -42.0147944,
    lat: -21.7712515
  },
  {
    lng: -42.0147231,
    lat: -21.7712946
  },
  {
    lng: -42.0146632,
    lat: -21.7713327
  },
  {
    lng: -42.0145996,
    lat: -21.7713723
  },
  {
    lng: -42.0145405,
    lat: -21.7714204
  },
  {
    lng: -42.0144899,
    lat: -21.7714715
  },
  {
    lng: -42.0144373,
    lat: -21.7715338
  },
  {
    lng: -42.0143906,
    lat: -21.7716008
  },
  {
    lng: -42.0143535,
    lat: -21.7716654
  },
  {
    lng: -42.0143275,
    lat: -21.7717471
  },
  {
    lng: -42.014316,
    lat: -21.7718244
  },
  {
    lng: -42.0143142,
    lat: -21.7719633
  },
  {
    lng: -42.0143128,
    lat: -21.7720247
  },
  {
    lng: -42.014306,
    lat: -21.7720824
  },
  {
    lng: -42.0142869,
    lat: -21.7721285
  },
  {
    lng: -42.0142476,
    lat: -21.7721753
  },
  {
    lng: -42.014206,
    lat: -21.7722159
  },
  {
    lng: -42.0141556,
    lat: -21.7722464
  },
  {
    lng: -42.0140985,
    lat: -21.7722612
  },
  {
    lng: -42.0140434,
    lat: -21.7722669
  },
  {
    lng: -42.013983,
    lat: -21.772258
  },
  {
    lng: -42.0139129,
    lat: -21.7722452
  },
  {
    lng: -42.013833,
    lat: -21.7722257
  },
  {
    lng: -42.0137699,
    lat: -21.7722102
  },
  {
    lng: -42.0137047,
    lat: -21.7721879
  },
  {
    lng: -42.0136505,
    lat: -21.7721564
  },
  {
    lng: -42.0136007,
    lat: -21.7721183
  },
  {
    lng: -42.013543,
    lat: -21.7720707
  },
  {
    lng: -42.0134894,
    lat: -21.7720244
  },
  {
    lng: -42.0134525,
    lat: -21.771976
  },
  {
    lng: -42.0134219,
    lat: -21.7719229
  },
  {
    lng: -42.0133927,
    lat: -21.7718841
  },
  {
    lng: -42.0133587,
    lat: -21.7718241
  },
  {
    lng: -42.0133286,
    lat: -21.7717541
  },
  {
    lng: -42.0133202,
    lat: -21.7716681
  },
  {
    lng: -42.0133212,
    lat: -21.7715897
  },
  {
    lng: -42.0133332,
    lat: -21.7715161
  },
  {
    lng: -42.0133505,
    lat: -21.7714432
  },
  {
    lng: -42.013378,
    lat: -21.7713652
  },
  {
    lng: -42.0134152,
    lat: -21.7712966
  },
  {
    lng: -42.0134558,
    lat: -21.7712346
  },
  {
    lng: -42.0134924,
    lat: -21.7711715
  },
  {
    lng: -42.0135195,
    lat: -21.7711111
  },
  {
    lng: -42.0135405,
    lat: -21.7710495
  },
  {
    lng: -42.0135442,
    lat: -21.7709838
  },
  {
    lng: -42.013547,
    lat: -21.7707597
  },
  {
    lng: -42.0135505,
    lat: -21.7706944
  },
  {
    lng: -42.0135567,
    lat: -21.7706158
  },
  {
    lng: -42.013568,
    lat: -21.770543
  },
  {
    lng: -42.0135892,
    lat: -21.770467
  },
  {
    lng: -42.0136117,
    lat: -21.770398
  },
  {
    lng: -42.0136392,
    lat: -21.7703238
  },
  {
    lng: -42.0136839,
    lat: -21.770254
  },
  {
    lng: -42.0137357,
    lat: -21.7701951
  },
  {
    lng: -42.0137902,
    lat: -21.770146
  },
  {
    lng: -42.0138487,
    lat: -21.7700979
  },
  {
    lng: -42.0139179,
    lat: -21.7700632
  },
  {
    lng: -42.0139855,
    lat: -21.7700363
  },
  {
    lng: -42.0140553,
    lat: -21.7700146
  },
  {
    lng: -42.0141304,
    lat: -21.7699941
  },
  {
    lng: -42.0141956,
    lat: -21.7699737
  },
  {
    lng: -42.014254,
    lat: -21.769953
  },
  {
    lng: -42.0142836,
    lat: -21.769932
  },
  {
    lng: -42.0142927,
    lat: -21.7698968
  },
  {
    lng: -42.0142859,
    lat: -21.7698559
  },
  {
    lng: -42.0142543,
    lat: -21.7698069
  },
  {
    lng: -42.014211,
    lat: -21.7697571
  },
  {
    lng: -42.0141577,
    lat: -21.7696971
  },
  {
    lng: -42.0141121,
    lat: -21.7696444
  },
  {
    lng: -42.0140692,
    lat: -21.769593
  },
  {
    lng: -42.0140256,
    lat: -21.7695406
  },
  {
    lng: -42.0139775,
    lat: -21.7694842
  },
  {
    lng: -42.0139335,
    lat: -21.7694276
  },
  {
    lng: -42.0138939,
    lat: -21.7693688
  },
  {
    lng: -42.0138564,
    lat: -21.769314
  },
  {
    lng: -42.0138127,
    lat: -21.7692535
  },
  {
    lng: -42.0137722,
    lat: -21.7692024
  },
  {
    lng: -42.0137233,
    lat: -21.7691399
  },
  {
    lng: -42.0136875,
    lat: -21.7690665
  },
  {
    lng: -42.0136802,
    lat: -21.7689874
  },
  {
    lng: -42.0136811,
    lat: -21.7689134
  },
  {
    lng: -42.0136832,
    lat: -21.7688465
  },
  {
    lng: -42.013714,
    lat: -21.7686877
  },
  {
    lng: -42.0137279,
    lat: -21.7686287
  },
  {
    lng: -42.0137469,
    lat: -21.7685664
  },
  {
    lng: -42.0137682,
    lat: -21.7685082
  },
  {
    lng: -42.0137963,
    lat: -21.7684507
  },
  {
    lng: -42.0138283,
    lat: -21.7684013
  },
  {
    lng: -42.0138751,
    lat: -21.7683424
  },
  {
    lng: -42.0138978,
    lat: -21.7682627
  },
  {
    lng: -42.0138975,
    lat: -21.7681769
  },
  {
    lng: -42.0138906,
    lat: -21.768099
  },
  {
    lng: -42.0138774,
    lat: -21.7680307
  },
  {
    lng: -42.0138673,
    lat: -21.7679697
  },
  {
    lng: -42.0138607,
    lat: -21.7679053
  },
  {
    lng: -42.0138467,
    lat: -21.7678313
  },
  {
    lng: -42.0138221,
    lat: -21.7677638
  },
  {
    lng: -42.01379,
    lat: -21.7676955
  },
  {
    lng: -42.0137436,
    lat: -21.7676275
  },
  {
    lng: -42.0136922,
    lat: -21.767573
  },
  {
    lng: -42.0136431,
    lat: -21.7675276
  },
  {
    lng: -42.0135941,
    lat: -21.7674726
  },
  {
    lng: -42.0135428,
    lat: -21.7674157
  },
  {
    lng: -42.0135142,
    lat: -21.7673927
  },
  {
    lng: -42.0134856,
    lat: -21.7673698
  },
  {
    lng: -42.0134522,
    lat: -21.7673311
  },
  {
    lng: -42.0134321,
    lat: -21.7672804
  },
  {
    lng: -42.0134266,
    lat: -21.7672332
  },
  {
    lng: -42.0134383,
    lat: -21.7671922
  },
  {
    lng: -42.0134708,
    lat: -21.7671535
  },
  {
    lng: -42.0135237,
    lat: -21.7671069
  },
  {
    lng: -42.0135756,
    lat: -21.7670546
  },
  {
    lng: -42.0136244,
    lat: -21.7670051
  },
  {
    lng: -42.0136722,
    lat: -21.766947
  },
  {
    lng: -42.0137097,
    lat: -21.7668846
  },
  {
    lng: -42.0137396,
    lat: -21.7668238
  },
  {
    lng: -42.0137707,
    lat: -21.7667615
  },
  {
    lng: -42.0137913,
    lat: -21.7666958
  },
  {
    lng: -42.0138086,
    lat: -21.7666338
  },
  {
    lng: -42.01383,
    lat: -21.7665624
  },
  {
    lng: -42.0138444,
    lat: -21.7664962
  },
  {
    lng: -42.0138617,
    lat: -21.7664215
  },
  {
    lng: -42.0138668,
    lat: -21.7663465
  },
  {
    lng: -42.0138496,
    lat: -21.7662626
  },
  {
    lng: -42.0137984,
    lat: -21.766195
  },
  {
    lng: -42.0137522,
    lat: -21.7661468
  },
  {
    lng: -42.0137193,
    lat: -21.7660958
  },
  {
    lng: -42.0136835,
    lat: -21.7660424
  },
  {
    lng: -42.0136501,
    lat: -21.7659894
  },
  {
    lng: -42.0136242,
    lat: -21.765933
  },
  {
    lng: -42.0136059,
    lat: -21.7658751
  },
  {
    lng: -42.0135947,
    lat: -21.765818
  },
  {
    lng: -42.0135911,
    lat: -21.7657604
  },
  {
    lng: -42.0135972,
    lat: -21.765704
  },
  {
    lng: -42.0136166,
    lat: -21.765652
  },
  {
    lng: -42.0136485,
    lat: -21.7656001
  },
  {
    lng: -42.0136871,
    lat: -21.7655458
  },
  {
    lng: -42.0137262,
    lat: -21.7655003
  },
  {
    lng: -42.0137764,
    lat: -21.7654599
  },
  {
    lng: -42.0138274,
    lat: -21.7654261
  },
  {
    lng: -42.0138829,
    lat: -21.7654011
  },
  {
    lng: -42.0139459,
    lat: -21.7653823
  },
  {
    lng: -42.0140064,
    lat: -21.765374
  },
  {
    lng: -42.0140552,
    lat: -21.7653808
  },
  {
    lng: -42.0141059,
    lat: -21.7654063
  },
  {
    lng: -42.014176,
    lat: -21.7654438
  },
  {
    lng: -42.0142555,
    lat: -21.7654682
  },
  {
    lng: -42.0143332,
    lat: -21.7654835
  },
  {
    lng: -42.0143997,
    lat: -21.7654965
  },
  {
    lng: -42.0144742,
    lat: -21.7655126
  },
  {
    lng: -42.0145475,
    lat: -21.7655314
  },
  {
    lng: -42.0146233,
    lat: -21.7655427
  },
  {
    lng: -42.0147023,
    lat: -21.7655458
  },
  {
    lng: -42.0147869,
    lat: -21.765539
  },
  {
    lng: -42.0148754,
    lat: -21.7655129
  },
  {
    lng: -42.0149486,
    lat: -21.7654704
  },
  {
    lng: -42.0150096,
    lat: -21.7654226
  },
  {
    lng: -42.0150648,
    lat: -21.7653819
  },
  {
    lng: -42.0151289,
    lat: -21.7653273
  },
  {
    lng: -42.0151741,
    lat: -21.7652604
  },
  {
    lng: -42.0152,
    lat: -21.7651832
  },
  {
    lng: -42.0152032,
    lat: -21.7651035
  },
  {
    lng: -42.0152049,
    lat: -21.7650366
  },
  {
    lng: -42.0152006,
    lat: -21.7649712
  },
  {
    lng: -42.015203,
    lat: -21.7649109
  },
  {
    lng: -42.0152139,
    lat: -21.7648617
  },
  {
    lng: -42.0152461,
    lat: -21.7648124
  },
  {
    lng: -42.0152933,
    lat: -21.7647659
  },
  {
    lng: -42.0153451,
    lat: -21.7647246
  },
  {
    lng: -42.0154036,
    lat: -21.764668
  },
  {
    lng: -42.0154374,
    lat: -21.7646019
  },
  {
    lng: -42.0154663,
    lat: -21.7645541
  },
  {
    lng: -42.0155061,
    lat: -21.7645254
  },
  {
    lng: -42.0155654,
    lat: -21.7645005
  },
  {
    lng: -42.0156289,
    lat: -21.7644669
  },
  {
    lng: -42.0156852,
    lat: -21.7644313
  },
  {
    lng: -42.0157353,
    lat: -21.764412
  },
  {
    lng: -42.0157889,
    lat: -21.7644073
  },
  {
    lng: -42.0158467,
    lat: -21.7644142
  },
  {
    lng: -42.0159046,
    lat: -21.7644306
  },
  {
    lng: -42.015956,
    lat: -21.7644569
  },
  {
    lng: -42.0160015,
    lat: -21.7644911
  },
  {
    lng: -42.0160441,
    lat: -21.7645355
  },
  {
    lng: -42.0160732,
    lat: -21.7645839
  },
  {
    lng: -42.0160819,
    lat: -21.7646102
  },
  {
    lng: -42.0160914,
    lat: -21.7646385
  },
  {
    lng: -42.0160955,
    lat: -21.7646858
  },
  {
    lng: -42.0160773,
    lat: -21.7647234
  },
  {
    lng: -42.0160184,
    lat: -21.7647812
  },
  {
    lng: -42.0160288,
    lat: -21.7648919
  },
  {
    lng: -42.0161082,
    lat: -21.7649623
  },
  {
    lng: -42.0162052,
    lat: -21.7649721
  },
  {
    lng: -42.0162961,
    lat: -21.7649558
  },
  {
    lng: -42.0163716,
    lat: -21.7649115
  },
  {
    lng: -42.0164303,
    lat: -21.7648452
  },
  {
    lng: -42.0164689,
    lat: -21.7647663
  },
  {
    lng: -42.0164655,
    lat: -21.7646794
  },
  {
    lng: -42.0164501,
    lat: -21.7646109
  },
  {
    lng: -42.0164318,
    lat: -21.7645445
  },
  {
    lng: -42.0164076,
    lat: -21.7644772
  },
  {
    lng: -42.0163748,
    lat: -21.7644121
  },
  {
    lng: -42.0163506,
    lat: -21.7643538
  },
  {
    lng: -42.0163269,
    lat: -21.7642974
  },
  {
    lng: -42.0163155,
    lat: -21.764246
  },
  {
    lng: -42.0163223,
    lat: -21.764208
  },
  {
    lng: -42.0163517,
    lat: -21.7641753
  },
  {
    lng: -42.0164087,
    lat: -21.7641461
  },
  {
    lng: -42.0164724,
    lat: -21.7641091
  },
  {
    lng: -42.0165294,
    lat: -21.7640612
  },
  {
    lng: -42.0165849,
    lat: -21.7640064
  },
  {
    lng: -42.0166268,
    lat: -21.7639452
  },
  {
    lng: -42.0166659,
    lat: -21.7638927
  },
  {
    lng: -42.016704,
    lat: -21.7638589
  },
  {
    lng: -42.0167425,
    lat: -21.763847
  },
  {
    lng: -42.0168004,
    lat: -21.7638587
  },
  {
    lng: -42.016891,
    lat: -21.763864
  },
  {
    lng: -42.0169744,
    lat: -21.7638327
  },
  {
    lng: -42.0170422,
    lat: -21.763805
  },
  {
    lng: -42.0171055,
    lat: -21.7637796
  },
  {
    lng: -42.0171702,
    lat: -21.7637541
  },
  {
    lng: -42.0172411,
    lat: -21.7637273
  },
  {
    lng: -42.0173058,
    lat: -21.7637061
  },
  {
    lng: -42.0173739,
    lat: -21.7636787
  },
  {
    lng: -42.0174344,
    lat: -21.7636572
  },
  {
    lng: -42.0175035,
    lat: -21.7636387
  },
  {
    lng: -42.0175731,
    lat: -21.7636211
  },
  {
    lng: -42.0176423,
    lat: -21.7636038
  },
  {
    lng: -42.0177103,
    lat: -21.7635872
  },
  {
    lng: -42.0177777,
    lat: -21.7635729
  },
  {
    lng: -42.0178456,
    lat: -21.7635595
  },
  {
    lng: -42.0179167,
    lat: -21.7635457
  },
  {
    lng: -42.017993,
    lat: -21.7635251
  },
  {
    lng: -42.0180647,
    lat: -21.7634964
  },
  {
    lng: -42.0181379,
    lat: -21.7634537
  },
  {
    lng: -42.0182028,
    lat: -21.7634067
  },
  {
    lng: -42.0182654,
    lat: -21.7633644
  },
  {
    lng: -42.0183283,
    lat: -21.7633173
  },
  {
    lng: -42.0183838,
    lat: -21.7632697
  },
  {
    lng: -42.0184375,
    lat: -21.7632259
  },
  {
    lng: -42.0184925,
    lat: -21.7631899
  },
  {
    lng: -42.0185502,
    lat: -21.7631572
  },
  {
    lng: -42.0186099,
    lat: -21.7631259
  },
  {
    lng: -42.0186695,
    lat: -21.7631007
  },
  {
    lng: -42.0187388,
    lat: -21.76308
  },
  {
    lng: -42.018805,
    lat: -21.7630613
  },
  {
    lng: -42.0188762,
    lat: -21.7630376
  },
  {
    lng: -42.01894,
    lat: -21.7630202
  },
  {
    lng: -42.0190113,
    lat: -21.763001
  },
  {
    lng: -42.0190854,
    lat: -21.7629891
  },
  {
    lng: -42.0191635,
    lat: -21.7629793
  },
  {
    lng: -42.0192346,
    lat: -21.7629674
  },
  {
    lng: -42.0193127,
    lat: -21.7629512
  },
  {
    lng: -42.0193816,
    lat: -21.7629339
  },
  {
    lng: -42.0194541,
    lat: -21.7629156
  },
  {
    lng: -42.0195314,
    lat: -21.7628883
  },
  {
    lng: -42.0196032,
    lat: -21.7628393
  },
  {
    lng: -42.0196689,
    lat: -21.7627847
  },
  {
    lng: -42.0197261,
    lat: -21.7627211
  },
  {
    lng: -42.0197645,
    lat: -21.7626497
  },
  {
    lng: -42.0197969,
    lat: -21.7625754
  },
  {
    lng: -42.0198167,
    lat: -21.7625086
  },
  {
    lng: -42.0198329,
    lat: -21.7624424
  },
  {
    lng: -42.0198456,
    lat: -21.7623747
  },
  {
    lng: -42.0198515,
    lat: -21.7622963
  },
  {
    lng: -42.0198545,
    lat: -21.7622218
  },
  {
    lng: -42.019857,
    lat: -21.7621493
  },
  {
    lng: -42.0198555,
    lat: -21.7620728
  },
  {
    lng: -42.0198426,
    lat: -21.7619978
  },
  {
    lng: -42.0198282,
    lat: -21.7619324
  },
  {
    lng: -42.0198139,
    lat: -21.7618688
  },
  {
    lng: -42.0197945,
    lat: -21.7618023
  },
  {
    lng: -42.0197778,
    lat: -21.7617378
  },
  {
    lng: -42.0197668,
    lat: -21.7616768
  },
  {
    lng: -42.0197595,
    lat: -21.7616118
  },
  {
    lng: -42.0197545,
    lat: -21.7615458
  },
  {
    lng: -42.0197524,
    lat: -21.7614752
  },
  {
    lng: -42.0197481,
    lat: -21.7614117
  },
  {
    lng: -42.0197499,
    lat: -21.7613457
  },
  {
    lng: -42.0197494,
    lat: -21.7612762
  },
  {
    lng: -42.0197428,
    lat: -21.7612033
  },
  {
    lng: -42.0197336,
    lat: -21.761132
  },
  {
    lng: -42.0197224,
    lat: -21.761061
  },
  {
    lng: -42.0197086,
    lat: -21.7609933
  },
  {
    lng: -42.0196938,
    lat: -21.7609271
  },
  {
    lng: -42.0196744,
    lat: -21.7608602
  },
  {
    lng: -42.0196517,
    lat: -21.7608005
  },
  {
    lng: -42.0196396,
    lat: -21.7607448
  },
  {
    lng: -42.0196506,
    lat: -21.7606909
  },
  {
    lng: -42.0196692,
    lat: -21.7606305
  },
  {
    lng: -42.0196874,
    lat: -21.7605651
  },
  {
    lng: -42.0197051,
    lat: -21.7604985
  },
  {
    lng: -42.0197215,
    lat: -21.7604289
  },
  {
    lng: -42.0197408,
    lat: -21.7603593
  },
  {
    lng: -42.019758,
    lat: -21.7602924
  },
  {
    lng: -42.0197766,
    lat: -21.7602356
  },
  {
    lng: -42.0198043,
    lat: -21.7601902
  },
  {
    lng: -42.0198138,
    lat: -21.760182
  },
  {
    lng: -42.0198489,
    lat: -21.7601515
  },
  {
    lng: -42.0199093,
    lat: -21.7601076
  },
  {
    lng: -42.0199549,
    lat: -21.7600575
  },
  {
    lng: -42.0200031,
    lat: -21.7600295
  },
  {
    lng: -42.0200584,
    lat: -21.7600075
  },
  {
    lng: -42.0201168,
    lat: -21.7599952
  },
  {
    lng: -42.0201834,
    lat: -21.7599888
  },
  {
    lng: -42.0202525,
    lat: -21.7599854
  },
  {
    lng: -42.020315,
    lat: -21.7599888
  },
  {
    lng: -42.0203743,
    lat: -21.7600004
  },
  {
    lng: -42.0204356,
    lat: -21.7600228
  },
  {
    lng: -42.0204894,
    lat: -21.7600488
  },
  {
    lng: -42.0204961,
    lat: -21.7600521
  },
  {
    lng: -42.0205673,
    lat: -21.7600775
  },
  {
    lng: -42.02064,
    lat: -21.7600993
  },
  {
    lng: -42.0207223,
    lat: -21.7601221
  },
  {
    lng: -42.0208125,
    lat: -21.760118
  },
  {
    lng: -42.0209006,
    lat: -21.7600864
  },
  {
    lng: -42.0209654,
    lat: -21.7600413
  },
  {
    lng: -42.0210242,
    lat: -21.7599962
  },
  {
    lng: -42.0210834,
    lat: -21.7599483
  },
  {
    lng: -42.0211421,
    lat: -21.7598862
  },
  {
    lng: -42.0211841,
    lat: -21.7598228
  },
  {
    lng: -42.0212158,
    lat: -21.7597519
  },
  {
    lng: -42.0212381,
    lat: -21.7596865
  },
  {
    lng: -42.0212625,
    lat: -21.7596177
  },
  {
    lng: -42.0212853,
    lat: -21.7595448
  },
  {
    lng: -42.0213009,
    lat: -21.7594751
  },
  {
    lng: -42.0213101,
    lat: -21.7594069
  },
  {
    lng: -42.0213156,
    lat: -21.7592696
  },
  {
    lng: -42.0213157,
    lat: -21.7591962
  },
  {
    lng: -42.0213127,
    lat: -21.7591308
  },
  {
    lng: -42.0213105,
    lat: -21.759059
  },
  {
    lng: -42.0213103,
    lat: -21.7589974
  },
  {
    lng: -42.0213131,
    lat: -21.7589257
  },
  {
    lng: -42.0213143,
    lat: -21.7588986
  },
  {
    lng: -42.0213159,
    lat: -21.7588633
  },
  {
    lng: -42.0213266,
    lat: -21.7588087
  },
  {
    lng: -42.0213505,
    lat: -21.7587553
  },
  {
    lng: -42.0213768,
    lat: -21.7586996
  },
  {
    lng: -42.0214066,
    lat: -21.7586472
  },
  {
    lng: -42.0214509,
    lat: -21.7585974
  },
  {
    lng: -42.0214891,
    lat: -21.7585422
  },
  {
    lng: -42.0215253,
    lat: -21.7584964
  },
  {
    lng: -42.0215647,
    lat: -21.7584712
  },
  {
    lng: -42.021626,
    lat: -21.758457
  },
  {
    lng: -42.0216928,
    lat: -21.7584437
  },
  {
    lng: -42.0217588,
    lat: -21.7584335
  },
  {
    lng: -42.0218493,
    lat: -21.7584198
  },
  {
    lng: -42.0219244,
    lat: -21.7583452
  },
  {
    lng: -42.0219402,
    lat: -21.7582386
  },
  {
    lng: -42.0218776,
    lat: -21.7581427
  },
  {
    lng: -42.0218028,
    lat: -21.7581252
  },
  {
    lng: -42.0217804,
    lat: -21.75812
  },
  {
    lng: -42.0217117,
    lat: -21.7581151
  },
  {
    lng: -42.0216509,
    lat: -21.7581013
  },
  {
    lng: -42.0215858,
    lat: -21.758082
  },
  {
    lng: -42.021507,
    lat: -21.75807
  },
  {
    lng: -42.0214382,
    lat: -21.7580487
  },
  {
    lng: -42.0213636,
    lat: -21.7580323
  },
  {
    lng: -42.0212848,
    lat: -21.7580207
  },
  {
    lng: -42.0212043,
    lat: -21.7580118
  },
  {
    lng: -42.0211329,
    lat: -21.7580082
  },
  {
    lng: -42.0209856,
    lat: -21.7580031
  },
  {
    lng: -42.0209041,
    lat: -21.7580049
  },
  {
    lng: -42.0208239,
    lat: -21.758007
  },
  {
    lng: -42.0207529,
    lat: -21.7580113
  },
  {
    lng: -42.0206815,
    lat: -21.7580115
  },
  {
    lng: -42.0206109,
    lat: -21.758008
  },
  {
    lng: -42.0205483,
    lat: -21.7579953
  },
  {
    lng: -42.0204904,
    lat: -21.7579724
  },
  {
    lng: -42.0204469,
    lat: -21.7579387
  },
  {
    lng: -42.0204309,
    lat: -21.7579197
  },
  {
    lng: -42.0204149,
    lat: -21.7579007
  },
  {
    lng: -42.0204027,
    lat: -21.757853
  },
  {
    lng: -42.0204011,
    lat: -21.7578022
  },
  {
    lng: -42.0204161,
    lat: -21.7577527
  },
  {
    lng: -42.0204455,
    lat: -21.7576946
  },
  {
    lng: -42.0204704,
    lat: -21.7576396
  },
  {
    lng: -42.0205035,
    lat: -21.7575947
  },
  {
    lng: -42.0205467,
    lat: -21.7575546
  },
  {
    lng: -42.0206038,
    lat: -21.7575155
  },
  {
    lng: -42.0206565,
    lat: -21.7574815
  },
  {
    lng: -42.0207073,
    lat: -21.7574573
  },
  {
    lng: -42.0207658,
    lat: -21.7574484
  },
  {
    lng: -42.0208351,
    lat: -21.7574593
  },
  {
    lng: -42.02088,
    lat: -21.7574603
  },
  {
    lng: -42.0209249,
    lat: -21.7574614
  },
  {
    lng: -42.0210086,
    lat: -21.7574391
  },
  {
    lng: -42.0210779,
    lat: -21.7573957
  },
  {
    lng: -42.0211367,
    lat: -21.7573447
  },
  {
    lng: -42.0211895,
    lat: -21.7573009
  },
  {
    lng: -42.021243,
    lat: -21.7572614
  },
  {
    lng: -42.0213043,
    lat: -21.7572172
  },
  {
    lng: -42.0213619,
    lat: -21.7571752
  },
  {
    lng: -42.0214147,
    lat: -21.757144
  },
  {
    lng: -42.0214694,
    lat: -21.7571235
  },
  {
    lng: -42.0215284,
    lat: -21.7571182
  },
  {
    lng: -42.021597,
    lat: -21.7571197
  },
  {
    lng: -42.0216828,
    lat: -21.7571148
  },
  {
    lng: -42.0217669,
    lat: -21.7570896
  },
  {
    lng: -42.0218353,
    lat: -21.7570367
  },
  {
    lng: -42.0218847,
    lat: -21.7569675
  },
  {
    lng: -42.0219218,
    lat: -21.7568965
  },
  {
    lng: -42.0219499,
    lat: -21.7568208
  },
  {
    lng: -42.0219559,
    lat: -21.7567398
  },
  {
    lng: -42.0219513,
    lat: -21.7566644
  },
  {
    lng: -42.0219261,
    lat: -21.7565861
  },
  {
    lng: -42.0218987,
    lat: -21.7565225
  },
  {
    lng: -42.0218709,
    lat: -21.7564606
  },
  {
    lng: -42.0218356,
    lat: -21.7564018
  },
  {
    lng: -42.0218001,
    lat: -21.7563425
  },
  {
    lng: -42.0217727,
    lat: -21.756289
  },
  {
    lng: -42.0217524,
    lat: -21.7562294
  },
  {
    lng: -42.021743,
    lat: -21.7561662
  },
  {
    lng: -42.0217471,
    lat: -21.7561086
  },
  {
    lng: -42.0217624,
    lat: -21.7560506
  },
  {
    lng: -42.0217835,
    lat: -21.755997
  },
  {
    lng: -42.0218129,
    lat: -21.7559472
  },
  {
    lng: -42.0218518,
    lat: -21.7559012
  },
  {
    lng: -42.0218992,
    lat: -21.7558691
  },
  {
    lng: -42.0219571,
    lat: -21.755839
  },
  {
    lng: -42.0220173,
    lat: -21.7558183
  },
  {
    lng: -42.0220891,
    lat: -21.7558026
  },
  {
    lng: -42.022158,
    lat: -21.7557926
  },
  {
    lng: -42.0222327,
    lat: -21.7557907
  },
  {
    lng: -42.0223126,
    lat: -21.7557897
  },
  {
    lng: -42.0223901,
    lat: -21.7557863
  },
  {
    lng: -42.0224711,
    lat: -21.7557817
  },
  {
    lng: -42.0225397,
    lat: -21.7557766
  },
  {
    lng: -42.0226298,
    lat: -21.7557677
  },
  {
    lng: -42.0227076,
    lat: -21.7557126
  },
  {
    lng: -42.0227549,
    lat: -21.7556292
  },
  {
    lng: -42.0227391,
    lat: -21.7555394
  },
  {
    lng: -42.0226955,
    lat: -21.7554651
  },
  {
    lng: -42.0226354,
    lat: -21.7554065
  },
  {
    lng: -42.0225824,
    lat: -21.75536
  },
  {
    lng: -42.0225334,
    lat: -21.7553152
  },
  {
    lng: -42.0224717,
    lat: -21.7552637
  },
  {
    lng: -42.0224096,
    lat: -21.7552154
  },
  {
    lng: -42.0223519,
    lat: -21.7551676
  },
  {
    lng: -42.0222729,
    lat: -21.7551298
  },
  {
    lng: -42.0222086,
    lat: -21.7550914
  },
  {
    lng: -42.0221225,
    lat: -21.7550635
  },
  {
    lng: -42.0220311,
    lat: -21.7550847
  },
  {
    lng: -42.0219637,
    lat: -21.7551139
  },
  {
    lng: -42.0219027,
    lat: -21.7551322
  },
  {
    lng: -42.0218364,
    lat: -21.7551387
  },
  {
    lng: -42.0217668,
    lat: -21.7551366
  },
  {
    lng: -42.0217056,
    lat: -21.7551226
  },
  {
    lng: -42.0216553,
    lat: -21.7550978
  },
  {
    lng: -42.0216123,
    lat: -21.755054
  },
  {
    lng: -42.021564,
    lat: -21.7550007
  },
  {
    lng: -42.0215303,
    lat: -21.7549505
  },
  {
    lng: -42.0215,
    lat: -21.754895
  },
  {
    lng: -42.0214688,
    lat: -21.7548375
  },
  {
    lng: -42.0214563,
    lat: -21.7547843
  },
  {
    lng: -42.0214716,
    lat: -21.7547325
  },
  {
    lng: -42.0215009,
    lat: -21.7546847
  },
  {
    lng: -42.0215421,
    lat: -21.7546321
  },
  {
    lng: -42.0215868,
    lat: -21.7545802
  },
  {
    lng: -42.0216291,
    lat: -21.7545265
  },
  {
    lng: -42.0216694,
    lat: -21.7544734
  },
  {
    lng: -42.0217027,
    lat: -21.7544353
  },
  {
    lng: -42.0217131,
    lat: -21.7544234
  },
  {
    lng: -42.0217615,
    lat: -21.7543854
  },
  {
    lng: -42.0218248,
    lat: -21.7543539
  },
  {
    lng: -42.0218835,
    lat: -21.7543256
  },
  {
    lng: -42.0219534,
    lat: -21.7542968
  },
  {
    lng: -42.0220388,
    lat: -21.7542347
  },
  {
    lng: -42.0220197,
    lat: -21.7541333
  },
  {
    lng: -42.0219766,
    lat: -21.754071
  },
  {
    lng: -42.0219381,
    lat: -21.7540131
  },
  {
    lng: -42.0219031,
    lat: -21.7539588
  },
  {
    lng: -42.0218753,
    lat: -21.7538991
  },
  {
    lng: -42.0218455,
    lat: -21.7538357
  },
  {
    lng: -42.0218147,
    lat: -21.7537674
  },
  {
    lng: -42.0217776,
    lat: -21.7537034
  },
  {
    lng: -42.0217354,
    lat: -21.753651
  },
  {
    lng: -42.0216975,
    lat: -21.7535951
  },
  {
    lng: -42.0216838,
    lat: -21.75357
  },
  {
    lng: -42.0216617,
    lat: -21.7535297
  },
  {
    lng: -42.0216116,
    lat: -21.7534658
  },
  {
    lng: -42.0215493,
    lat: -21.7534159
  },
  {
    lng: -42.0214875,
    lat: -21.7533783
  },
  {
    lng: -42.0214733,
    lat: -21.7533711
  },
  {
    lng: -42.0214236,
    lat: -21.7533458
  },
  {
    lng: -42.0213663,
    lat: -21.7533131
  },
  {
    lng: -42.0213196,
    lat: -21.7532684
  },
  {
    lng: -42.021284,
    lat: -21.7532178
  },
  {
    lng: -42.0212634,
    lat: -21.7531672
  },
  {
    lng: -42.0212554,
    lat: -21.7531022
  },
  {
    lng: -42.0212538,
    lat: -21.753043
  },
  {
    lng: -42.0212616,
    lat: -21.7529787
  },
  {
    lng: -42.0212768,
    lat: -21.7529214
  },
  {
    lng: -42.0213023,
    lat: -21.7528716
  },
  {
    lng: -42.0213412,
    lat: -21.7528255
  },
  {
    lng: -42.0213914,
    lat: -21.7527891
  },
  {
    lng: -42.0214515,
    lat: -21.7527555
  },
  {
    lng: -42.021519,
    lat: -21.7527191
  },
  {
    lng: -42.021588,
    lat: -21.7526644
  },
  {
    lng: -42.0216296,
    lat: -21.7525905
  },
  {
    lng: -42.0216453,
    lat: -21.7525085
  },
  {
    lng: -42.0216472,
    lat: -21.7524445
  },
  {
    lng: -42.021661,
    lat: -21.7523835
  },
  {
    lng: -42.0216807,
    lat: -21.7523173
  },
  {
    lng: -42.0216794,
    lat: -21.7522428
  },
  {
    lng: -42.0216625,
    lat: -21.7521721
  },
  {
    lng: -42.0216286,
    lat: -21.752099
  },
  {
    lng: -42.0215853,
    lat: -21.7520384
  },
  {
    lng: -42.02153,
    lat: -21.7519882
  },
  {
    lng: -42.0214702,
    lat: -21.7519425
  },
  {
    lng: -42.0214046,
    lat: -21.7519028
  },
  {
    lng: -42.0213338,
    lat: -21.7518708
  },
  {
    lng: -42.0212572,
    lat: -21.751848
  },
  {
    lng: -42.0211773,
    lat: -21.7518369
  },
  {
    lng: -42.0211019,
    lat: -21.7518343
  },
  {
    lng: -42.0210278,
    lat: -21.7518332
  },
  {
    lng: -42.0209449,
    lat: -21.7518422
  },
  {
    lng: -42.0208622,
    lat: -21.7518673
  },
  {
    lng: -42.0207868,
    lat: -21.7519101
  },
  {
    lng: -42.0207477,
    lat: -21.751938
  },
  {
    lng: -42.0207192,
    lat: -21.7519583
  },
  {
    lng: -42.0206722,
    lat: -21.7520207
  },
  {
    lng: -42.0206365,
    lat: -21.7520941
  },
  {
    lng: -42.020609,
    lat: -21.75216
  },
  {
    lng: -42.0205902,
    lat: -21.752226
  },
  {
    lng: -42.020574,
    lat: -21.7522897
  },
  {
    lng: -42.0205511,
    lat: -21.7523567
  },
  {
    lng: -42.0205289,
    lat: -21.7524148
  },
  {
    lng: -42.0205008,
    lat: -21.7524761
  },
  {
    lng: -42.0204687,
    lat: -21.7525228
  },
  {
    lng: -42.0204179,
    lat: -21.7525623
  },
  {
    lng: -42.0203661,
    lat: -21.7525978
  },
  {
    lng: -42.0203154,
    lat: -21.7526204
  },
  {
    lng: -42.0202648,
    lat: -21.7526269
  },
  {
    lng: -42.0202179,
    lat: -21.7526147
  },
  {
    lng: -42.0201952,
    lat: -21.7525964
  },
  {
    lng: -42.0201724,
    lat: -21.752578
  },
  {
    lng: -42.0201312,
    lat: -21.752526
  },
  {
    lng: -42.0200904,
    lat: -21.7524735
  },
  {
    lng: -42.0200409,
    lat: -21.7524158
  },
  {
    lng: -42.0199914,
    lat: -21.7523566
  },
  {
    lng: -42.0199476,
    lat: -21.7523041
  },
  {
    lng: -42.0199012,
    lat: -21.7522452
  },
  {
    lng: -42.0198053,
    lat: -21.7521388
  },
  {
    lng: -42.0197626,
    lat: -21.7520856
  },
  {
    lng: -42.019722,
    lat: -21.7520298
  },
  {
    lng: -42.0196797,
    lat: -21.7519778
  },
  {
    lng: -42.0196286,
    lat: -21.7519196
  },
  {
    lng: -42.0195879,
    lat: -21.7518703
  },
  {
    lng: -42.0195463,
    lat: -21.7518165
  },
  {
    lng: -42.0194925,
    lat: -21.7517578
  },
  {
    lng: -42.0194248,
    lat: -21.7517144
  },
  {
    lng: -42.0193511,
    lat: -21.7516807
  },
  {
    lng: -42.0193285,
    lat: -21.7516716
  },
  {
    lng: -42.019282,
    lat: -21.7516528
  },
  {
    lng: -42.0192096,
    lat: -21.7516314
  },
  {
    lng: -42.019143,
    lat: -21.7516108
  },
  {
    lng: -42.0190816,
    lat: -21.7515788
  },
  {
    lng: -42.0190234,
    lat: -21.751541
  },
  {
    lng: -42.0189616,
    lat: -21.7515041
  },
  {
    lng: -42.0189104,
    lat: -21.7514687
  },
  {
    lng: -42.0189007,
    lat: -21.751462
  },
  {
    lng: -42.0188525,
    lat: -21.7514205
  },
  {
    lng: -42.018811,
    lat: -21.7513718
  },
  {
    lng: -42.0187754,
    lat: -21.7513191
  },
  {
    lng: -42.0187452,
    lat: -21.7512725
  },
  {
    lng: -42.0187366,
    lat: -21.7512252
  },
  {
    lng: -42.0187458,
    lat: -21.7511719
  },
  {
    lng: -42.0187722,
    lat: -21.7511156
  },
  {
    lng: -42.0187749,
    lat: -21.7511117
  },
  {
    lng: -42.0188104,
    lat: -21.7510612
  },
  {
    lng: -42.0188551,
    lat: -21.7509976
  },
  {
    lng: -42.018876,
    lat: -21.7509159
  },
  {
    lng: -42.018869,
    lat: -21.7508349
  },
  {
    lng: -42.0188452,
    lat: -21.7507539
  },
  {
    lng: -42.0188365,
    lat: -21.7507439
  },
  {
    lng: -42.0187889,
    lat: -21.7506896
  },
  {
    lng: -42.0187234,
    lat: -21.750637
  },
  {
    lng: -42.0186726,
    lat: -21.7506137
  },
  {
    lng: -42.018644,
    lat: -21.7506007
  },
  {
    lng: -42.0185522,
    lat: -21.7505975
  },
  {
    lng: -42.0184765,
    lat: -21.7506107
  },
  {
    lng: -42.0183948,
    lat: -21.7506347
  },
  {
    lng: -42.0183217,
    lat: -21.7506736
  },
  {
    lng: -42.0182547,
    lat: -21.7507148
  },
  {
    lng: -42.0181932,
    lat: -21.7507523
  },
  {
    lng: -42.0181305,
    lat: -21.7507909
  },
  {
    lng: -42.0180734,
    lat: -21.7508293
  },
  {
    lng: -42.0180164,
    lat: -21.750869
  },
  {
    lng: -42.0179593,
    lat: -21.7509117
  },
  {
    lng: -42.0179031,
    lat: -21.7509506
  },
  {
    lng: -42.0178533,
    lat: -21.7509734
  },
  {
    lng: -42.017786,
    lat: -21.7509776
  },
  {
    lng: -42.0177705,
    lat: -21.750983
  },
  {
    lng: -42.0177076,
    lat: -21.7510048
  },
  {
    lng: -42.0176408,
    lat: -21.7510493
  },
  {
    lng: -42.0175922,
    lat: -21.7511006
  },
  {
    lng: -42.017546,
    lat: -21.7511326
  },
  {
    lng: -42.017488,
    lat: -21.7511513
  },
  {
    lng: -42.0174212,
    lat: -21.7511519
  },
  {
    lng: -42.017352,
    lat: -21.7511469
  },
  {
    lng: -42.0172805,
    lat: -21.7511338
  },
  {
    lng: -42.0172142,
    lat: -21.7511207
  },
  {
    lng: -42.0171419,
    lat: -21.7511035
  },
  {
    lng: -42.0170818,
    lat: -21.7510836
  },
  {
    lng: -42.0170202,
    lat: -21.7510579
  },
  {
    lng: -42.016967,
    lat: -21.7510245
  },
  {
    lng: -42.0169224,
    lat: -21.7509819
  },
  {
    lng: -42.0168805,
    lat: -21.7509278
  },
  {
    lng: -42.016838,
    lat: -21.750872
  },
  {
    lng: -42.0168054,
    lat: -21.7508181
  },
  {
    lng: -42.0167806,
    lat: -21.7507611
  },
  {
    lng: -42.0167629,
    lat: -21.7507036
  },
  {
    lng: -42.0167493,
    lat: -21.7506311
  },
  {
    lng: -42.0166955,
    lat: -21.7505505
  },
  {
    lng: -42.0166012,
    lat: -21.7505315
  },
  {
    lng: -42.0165267,
    lat: -21.7505424
  },
  {
    lng: -42.0164624,
    lat: -21.750543
  },
  {
    lng: -42.0163913,
    lat: -21.7505357
  },
  {
    lng: -42.0163533,
    lat: -21.7505373
  },
  {
    lng: -42.0163076,
    lat: -21.7505392
  },
  {
    lng: -42.01623,
    lat: -21.7505775
  },
  {
    lng: -42.0161675,
    lat: -21.7506241
  },
  {
    lng: -42.0161152,
    lat: -21.7506673
  },
  {
    lng: -42.0160699,
    lat: -21.7506989
  },
  {
    lng: -42.0160126,
    lat: -21.7507089
  },
  {
    lng: -42.0159436,
    lat: -21.7507032
  },
  {
    lng: -42.0158667,
    lat: -21.7507079
  },
  {
    lng: -42.0157962,
    lat: -21.7507266
  },
  {
    lng: -42.0157283,
    lat: -21.7507354
  },
  {
    lng: -42.0156631,
    lat: -21.7507316
  },
  {
    lng: -42.0155962,
    lat: -21.750725
  },
  {
    lng: -42.0155215,
    lat: -21.7507113
  },
  {
    lng: -42.0154451,
    lat: -21.750717
  },
  {
    lng: -42.0153783,
    lat: -21.7507236
  },
  {
    lng: -42.015309,
    lat: -21.7507261
  },
  {
    lng: -42.0152364,
    lat: -21.7507355
  },
  {
    lng: -42.0151573,
    lat: -21.7507556
  },
  {
    lng: -42.0150896,
    lat: -21.7507813
  },
  {
    lng: -42.0150265,
    lat: -21.7507993
  },
  {
    lng: -42.0149614,
    lat: -21.7508167
  },
  {
    lng: -42.0148949,
    lat: -21.750824
  },
  {
    lng: -42.0148187,
    lat: -21.7508315
  },
  {
    lng: -42.0147443,
    lat: -21.7508377
  },
  {
    lng: -42.01467,
    lat: -21.7508447
  },
  {
    lng: -42.0145971,
    lat: -21.7508511
  },
  {
    lng: -42.0145224,
    lat: -21.7508546
  },
  {
    lng: -42.0144536,
    lat: -21.7508566
  },
  {
    lng: -42.0143686,
    lat: -21.7508428
  },
  {
    lng: -42.0143223,
    lat: -21.7508354
  },
  {
    lng: -42.014314,
    lat: -21.7508341
  },
  {
    lng: -42.0142525,
    lat: -21.7508112
  },
  {
    lng: -42.0141883,
    lat: -21.7507881
  },
  {
    lng: -42.0141233,
    lat: -21.7507584
  },
  {
    lng: -42.0140656,
    lat: -21.7507257
  },
  {
    lng: -42.0139996,
    lat: -21.7506857
  },
  {
    lng: -42.0139393,
    lat: -21.7506459
  },
  {
    lng: -42.0138906,
    lat: -21.750607
  },
  {
    lng: -42.0138386,
    lat: -21.7505582
  },
  {
    lng: -42.0137851,
    lat: -21.7505145
  },
  {
    lng: -42.0137451,
    lat: -21.750467
  },
  {
    lng: -42.0137005,
    lat: -21.750419
  },
  {
    lng: -42.0136588,
    lat: -21.7503652
  },
  {
    lng: -42.0136083,
    lat: -21.7503126
  },
  {
    lng: -42.0135602,
    lat: -21.7502617
  },
  {
    lng: -42.013474,
    lat: -21.7501449
  },
  {
    lng: -42.0134337,
    lat: -21.7501111
  },
  {
    lng: -42.0134284,
    lat: -21.7501076
  },
  {
    lng: -42.0133526,
    lat: -21.7500565
  },
  {
    lng: -42.0133328,
    lat: -21.7500299
  },
  {
    lng: -42.0133166,
    lat: -21.7500045
  },
  {
    lng: -42.0133033,
    lat: -21.7499835
  },
  {
    lng: -42.0132812,
    lat: -21.7499244
  },
  {
    lng: -42.0132527,
    lat: -21.749852
  },
  {
    lng: -42.013224,
    lat: -21.7497862
  },
  {
    lng: -42.0131541,
    lat: -21.7496152
  },
  {
    lng: -42.0131139,
    lat: -21.7494841
  },
  {
    lng: -42.0130806,
    lat: -21.7493533
  },
  {
    lng: -42.0130444,
    lat: -21.7492094
  },
  {
    lng: -42.0130015,
    lat: -21.7490588
  },
  {
    lng: -42.0129695,
    lat: -21.7489864
  },
  {
    lng: -42.0129417,
    lat: -21.7488947
  },
  {
    lng: -42.0129261,
    lat: -21.7488487
  },
  {
    lng: -42.0129186,
    lat: -21.7488374
  },
  {
    lng: -42.0128868,
    lat: -21.7487891
  },
  {
    lng: -42.0128301,
    lat: -21.7487288
  },
  {
    lng: -42.0127626,
    lat: -21.7486812
  },
  {
    lng: -42.0126568,
    lat: -21.7486387
  },
  {
    lng: -42.0125726,
    lat: -21.74863
  },
  {
    lng: -42.0125636,
    lat: -21.7486291
  },
  {
    lng: -42.0124799,
    lat: -21.7486457
  },
  {
    lng: -42.0124406,
    lat: -21.7486768
  },
  {
    lng: -42.0124216,
    lat: -21.7487216
  },
  {
    lng: -42.0124028,
    lat: -21.7487599
  },
  {
    lng: -42.0123712,
    lat: -21.7487718
  },
  {
    lng: -42.012319,
    lat: -21.7487765
  },
  {
    lng: -42.0122743,
    lat: -21.7487685
  },
  {
    lng: -42.0122402,
    lat: -21.7487544
  },
  {
    lng: -42.012227,
    lat: -21.7487345
  },
  {
    lng: -42.0122075,
    lat: -21.7487014
  },
  {
    lng: -42.0121837,
    lat: -21.7485969
  },
  {
    lng: -42.0121564,
    lat: -21.7484922
  },
  {
    lng: -42.0121351,
    lat: -21.7484137
  },
  {
    lng: -42.012113,
    lat: -21.7483546
  },
  {
    lng: -42.0120966,
    lat: -21.7483064
  },
  {
    lng: -42.0120818,
    lat: -21.7482628
  },
  {
    lng: -42.0120771,
    lat: -21.7482043
  },
  {
    lng: -42.0120941,
    lat: -21.7481206
  },
  {
    lng: -42.0121501,
    lat: -21.7480123
  },
  {
    lng: -42.0122165,
    lat: -21.7479044
  },
  {
    lng: -42.012276,
    lat: -21.7477962
  },
  {
    lng: -42.0123641,
    lat: -21.7476631
  },
  {
    lng: -42.0124251,
    lat: -21.7476069
  },
  {
    lng: -42.0124965,
    lat: -21.747551
  },
  {
    lng: -42.0125424,
    lat: -21.7475267
  },
  {
    lng: -42.0125982,
    lat: -21.7475156
  },
  {
    lng: -42.0126955,
    lat: -21.747506
  },
  {
    lng: -42.0128106,
    lat: -21.747484
  },
  {
    lng: -42.0128597,
    lat: -21.7474662
  },
  {
    lng: -42.0129022,
    lat: -21.7474418
  },
  {
    lng: -42.0129231,
    lat: -21.7474116
  },
  {
    lng: -42.0129461,
    lat: -21.7473785
  },
  {
    lng: -42.0129584,
    lat: -21.7473271
  },
  {
    lng: -42.0129568,
    lat: -21.7473074
  },
  {
    lng: -42.0129514,
    lat: -21.7472362
  },
  {
    lng: -42.0129266,
    lat: -21.7471577
  },
  {
    lng: -42.0128974,
    lat: -21.7471049
  },
  {
    lng: -42.0128576,
    lat: -21.7470582
  },
  {
    lng: -42.012856,
    lat: -21.7470571
  },
  {
    lng: -42.0127699,
    lat: -21.746997
  },
  {
    lng: -42.0126409,
    lat: -21.7469278
  },
  {
    lng: -42.012482,
    lat: -21.7468253
  },
  {
    lng: -42.0123708,
    lat: -21.7467438
  },
  {
    lng: -42.0122873,
    lat: -21.7466632
  },
  {
    lng: -42.0122188,
    lat: -21.7465508
  },
  {
    lng: -42.0121765,
    lat: -21.7464781
  },
  {
    lng: -42.0121324,
    lat: -21.7463601
  },
  {
    lng: -42.0121094,
    lat: -21.7462364
  },
  {
    lng: -42.012097,
    lat: -21.7461923
  },
  {
    lng: -42.0120819,
    lat: -21.7461384
  },
  {
    lng: -42.0120542,
    lat: -21.7460468
  },
  {
    lng: -42.0120245,
    lat: -21.7459987
  },
  {
    lng: -42.0119889,
    lat: -21.745941
  },
  {
    lng: -42.0119387,
    lat: -21.745894
  },
  {
    lng: -42.011898,
    lat: -21.7458732
  },
  {
    lng: -42.0118389,
    lat: -21.7458776
  },
  {
    lng: -42.011776,
    lat: -21.7458948
  },
  {
    lng: -42.0117048,
    lat: -21.7459441
  },
  {
    lng: -42.011672,
    lat: -21.7459883
  },
  {
    lng: -42.0116142,
    lat: -21.746051
  },
  {
    lng: -42.0115458,
    lat: -21.7461198
  },
  {
    lng: -42.0114892,
    lat: -21.7461502
  },
  {
    lng: -42.0114082,
    lat: -21.7461863
  },
  {
    lng: -42.011342,
    lat: -21.7461969
  },
  {
    lng: -42.0112797,
    lat: -21.7461948
  },
  {
    lng: -42.0112145,
    lat: -21.7461796
  },
  {
    lng: -42.0111705,
    lat: -21.7461522
  },
  {
    lng: -42.01112,
    lat: -21.7461116
  },
  {
    lng: -42.0110817,
    lat: -21.7460261
  },
  {
    lng: -42.0110668,
    lat: -21.7459608
  },
  {
    lng: -42.011071,
    lat: -21.745851
  },
  {
    lng: -42.0111021,
    lat: -21.7457614
  },
  {
    lng: -42.0111834,
    lat: -21.7456284
  },
  {
    lng: -42.0112854,
    lat: -21.745496
  },
  {
    lng: -42.0113938,
    lat: -21.7453769
  },
  {
    lng: -42.0115084,
    lat: -21.7452774
  },
  {
    lng: -42.0116286,
    lat: -21.7452105
  },
  {
    lng: -42.0117422,
    lat: -21.7451368
  },
  {
    lng: -42.0117674,
    lat: -21.7451119
  },
  {
    lng: -42.0117787,
    lat: -21.7450864
  },
  {
    lng: -42.0117901,
    lat: -21.7450609
  },
  {
    lng: -42.0117849,
    lat: -21.7450155
  },
  {
    lng: -42.0117584,
    lat: -21.7449822
  },
  {
    lng: -42.0116811,
    lat: -21.7449213
  },
  {
    lng: -42.0116065,
    lat: -21.7448799
  },
  {
    lng: -42.011528,
    lat: -21.7448513
  },
  {
    lng: -42.0114487,
    lat: -21.7448421
  },
  {
    lng: -42.011359,
    lat: -21.7448325
  },
  {
    lng: -42.0112373,
    lat: -21.7448476
  },
  {
    lng: -42.0111466,
    lat: -21.7448638
  },
  {
    lng: -42.0110764,
    lat: -21.7448673
  },
  {
    lng: -42.0110703,
    lat: -21.7448676
  },
  {
    lng: -42.0110365,
    lat: -21.7448529
  },
  {
    lng: -42.0109897,
    lat: -21.744806
  },
  {
    lng: -42.010906,
    lat: -21.7447319
  },
  {
    lng: -42.0108115,
    lat: -21.7446639
  },
  {
    lng: -42.0107469,
    lat: -21.7446371
  },
  {
    lng: -42.0106922,
    lat: -21.7446144
  },
  {
    lng: -42.0105586,
    lat: -21.7445768
  },
  {
    lng: -42.0104174,
    lat: -21.7445524
  },
  {
    lng: -42.010228,
    lat: -21.7445199
  },
  {
    lng: -42.010086,
    lat: -21.7445149
  },
  {
    lng: -42.0099406,
    lat: -21.7445097
  },
  {
    lng: -42.0098154,
    lat: -21.7445183
  },
  {
    lng: -42.0097033,
    lat: -21.7445467
  },
  {
    lng: -42.009587,
    lat: -21.7445944
  },
  {
    lng: -42.0094947,
    lat: -21.7446494
  },
  {
    lng: -42.0094014,
    lat: -21.7447303
  },
  {
    lng: -42.0093187,
    lat: -21.7448051
  },
  {
    lng: -42.0092466,
    lat: -21.7448737
  },
  {
    lng: -42.009127,
    lat: -21.7449149
  },
  {
    lng: -42.0089777,
    lat: -21.7449161
  },
  {
    lng: -42.0089749,
    lat: -21.7449154
  },
  {
    lng: -42.0088334,
    lat: -21.7448787
  },
  {
    lng: -42.0086648,
    lat: -21.7448404
  },
  {
    lng: -42.0086125,
    lat: -21.744845
  },
  {
    lng: -42.0085597,
    lat: -21.7448626
  },
  {
    lng: -42.0085171,
    lat: -21.744887
  },
  {
    lng: -42.0084732,
    lat: -21.7449438
  },
  {
    lng: -42.0084355,
    lat: -21.7450202
  },
  {
    lng: -42.008365,
    lat: -21.7451344
  },
  {
    lng: -42.008306,
    lat: -21.745223
  },
  {
    lng: -42.0082549,
    lat: -21.745286
  },
  {
    lng: -42.0081566,
    lat: -21.7453992
  },
  {
    lng: -42.0080258,
    lat: -21.7455438
  },
  {
    lng: -42.0079296,
    lat: -21.7456052
  },
  {
    lng: -42.0078197,
    lat: -21.7456598
  },
  {
    lng: -42.0077232,
    lat: -21.7457277
  },
  {
    lng: -42.0076576,
    lat: -21.7458033
  },
  {
    lng: -42.0075145,
    lat: -21.7459929
  },
  {
    lng: -42.0073019,
    lat: -21.7461801
  },
  {
    lng: -42.0071453,
    lat: -21.7462721
  },
  {
    lng: -42.0070518,
    lat: -21.7463467
  },
  {
    lng: -42.0069638,
    lat: -21.7464605
  },
  {
    lng: -42.006888,
    lat: -21.7465293
  },
  {
    lng: -42.0067844,
    lat: -21.7465971
  },
  {
    lng: -42.0066876,
    lat: -21.7466393
  },
  {
    lng: -42.0066463,
    lat: -21.7466573
  },
  {
    lng: -42.0064664,
    lat: -21.746716
  },
  {
    lng: -42.0063156,
    lat: -21.7467433
  },
  {
    lng: -42.0061244,
    lat: -21.7467368
  },
  {
    lng: -42.0059267,
    lat: -21.746717
  },
  {
    lng: -42.0057854,
    lat: -21.7466797
  },
  {
    lng: -42.0056248,
    lat: -21.7466027
  },
  {
    lng: -42.005498,
    lat: -21.7465529
  },
  {
    lng: -42.0053979,
    lat: -21.74653
  },
  {
    lng: -42.005262,
    lat: -21.7465318
  },
  {
    lng: -42.0051565,
    lat: -21.7465542
  },
  {
    lng: -42.0050717,
    lat: -21.7465838
  },
  {
    lng: -42.0050029,
    lat: -21.7466464
  },
  {
    lng: -42.0049548,
    lat: -21.7467162
  },
  {
    lng: -42.0049063,
    lat: -21.7467925
  },
  {
    lng: -42.0048437,
    lat: -21.7468748
  },
  {
    lng: -42.0047899,
    lat: -21.746912
  },
  {
    lng: -42.0047754,
    lat: -21.7469168
  },
  {
    lng: -42.0047722,
    lat: -21.7469179
  },
  {
    lng: -42.0047302,
    lat: -21.7469229
  },
  {
    lng: -42.0046957,
    lat: -21.7469152
  },
  {
    lng: -42.0046547,
    lat: -21.7468943
  },
  {
    lng: -42.0045976,
    lat: -21.7468404
  },
  {
    lng: -42.0045237,
    lat: -21.7467729
  },
  {
    lng: -42.0044838,
    lat: -21.746726
  },
  {
    lng: -42.0044618,
    lat: -21.7466668
  },
  {
    lng: -42.0044379,
    lat: -21.7465685
  },
  {
    lng: -42.0044315,
    lat: -21.7464708
  },
  {
    lng: -42.0044502,
    lat: -21.74627
  },
  {
    lng: -42.0044965,
    lat: -21.7460768
  },
  {
    lng: -42.0045842,
    lat: -21.7458915
  },
  {
    lng: -42.0046276,
    lat: -21.7457696
  },
  {
    lng: -42.0046372,
    lat: -21.745705
  },
  {
    lng: -42.0046291,
    lat: -21.7455619
  },
  {
    lng: -42.0046007,
    lat: -21.7454051
  },
  {
    lng: -42.0045878,
    lat: -21.7452944
  },
  {
    lng: -42.0046001,
    lat: -21.745165
  },
  {
    lng: -42.0046324,
    lat: -21.7450558
  },
  {
    lng: -42.0047108,
    lat: -21.7449288
  },
  {
    lng: -42.0048506,
    lat: -21.7447456
  },
  {
    lng: -42.0049426,
    lat: -21.7446256
  },
  {
    lng: -42.0050174,
    lat: -21.7444985
  },
  {
    lng: -42.0050596,
    lat: -21.7444027
  },
  {
    lng: -42.005071,
    lat: -21.7442929
  },
  {
    lng: -42.0050461,
    lat: -21.7441364
  },
  {
    lng: -42.0049963,
    lat: -21.7440049
  },
  {
    lng: -42.0049864,
    lat: -21.7439788
  },
  {
    lng: -42.0049283,
    lat: -21.7438665
  },
  {
    lng: -42.0048494,
    lat: -21.7437535
  },
  {
    lng: -42.0047756,
    lat: -21.7436861
  },
  {
    lng: -42.0046833,
    lat: -21.743644
  },
  {
    lng: -42.0045322,
    lat: -21.7435932
  },
  {
    lng: -42.0043658,
    lat: -21.7435243
  },
  {
    lng: -42.004361,
    lat: -21.7435223
  },
  {
    lng: -42.0042543,
    lat: -21.7434926
  },
  {
    lng: -42.0041708,
    lat: -21.7434897
  },
  {
    lng: -42.0040834,
    lat: -21.7434995
  },
  {
    lng: -42.0040106,
    lat: -21.7434904
  },
  {
    lng: -42.0039525,
    lat: -21.7434625
  },
  {
    lng: -42.0039231,
    lat: -21.743416
  },
  {
    lng: -42.003925,
    lat: -21.7433707
  },
  {
    lng: -42.0039606,
    lat: -21.7432683
  },
  {
    lng: -42.0040408,
    lat: -21.7431804
  },
  {
    lng: -42.0041074,
    lat: -21.7430856
  },
  {
    lng: -42.0041614,
    lat: -21.742958
  },
  {
    lng: -42.004193,
    lat: -21.7428684
  },
  {
    lng: -42.0042376,
    lat: -21.7427988
  },
  {
    lng: -42.0042956,
    lat: -21.7427426
  },
  {
    lng: -42.0043563,
    lat: -21.7427059
  },
  {
    lng: -42.0043694,
    lat: -21.742693
  },
  {
    lng: -42.0043817,
    lat: -21.7426809
  },
  {
    lng: -42.004383,
    lat: -21.7426486
  },
  {
    lng: -42.004367,
    lat: -21.7426156
  },
  {
    lng: -42.0043402,
    lat: -21.7425887
  },
  {
    lng: -42.004275,
    lat: -21.742567
  },
  {
    lng: -42.0042156,
    lat: -21.7425713
  },
  {
    lng: -42.004148,
    lat: -21.7426078
  },
  {
    lng: -42.0040876,
    lat: -21.742638
  },
  {
    lng: -42.0040346,
    lat: -21.7426555
  },
  {
    lng: -42.0039825,
    lat: -21.7426536
  },
  {
    lng: -42.0039234,
    lat: -21.7426515
  },
  {
    lng: -42.0038602,
    lat: -21.7426622
  },
  {
    lng: -42.0037934,
    lat: -21.7426792
  },
  {
    lng: -42.0037482,
    lat: -21.7426776
  },
  {
    lng: -42.003662,
    lat: -21.7426551
  },
  {
    lng: -42.0035788,
    lat: -21.7426456
  },
  {
    lng: -42.0034753,
    lat: -21.7426225
  },
  {
    lng: -42.0033779,
    lat: -21.742619
  },
  {
    lng: -42.0033319,
    lat: -21.7426368
  },
  {
    lng: -42.0032746,
    lat: -21.7426736
  },
  {
    lng: -42.0032066,
    lat: -21.7427165
  },
  {
    lng: -42.0031678,
    lat: -21.7427281
  },
  {
    lng: -42.0031119,
    lat: -21.7427325
  },
  {
    lng: -42.0030773,
    lat: -21.7427248
  },
  {
    lng: -42.0030332,
    lat: -21.7426973
  },
  {
    lng: -42.0030139,
    lat: -21.7426577
  },
  {
    lng: -42.0029837,
    lat: -21.7426307
  },
  {
    lng: -42.0029494,
    lat: -21.7426166
  },
  {
    lng: -42.002893,
    lat: -21.742634
  },
  {
    lng: -42.0028145,
    lat: -21.7426765
  },
  {
    lng: -42.0027436,
    lat: -21.7427064
  },
  {
    lng: -42.0026943,
    lat: -21.7427176
  },
  {
    lng: -42.0026316,
    lat: -21.7427153
  },
  {
    lng: -42.0026086,
    lat: -21.7427124
  },
  {
    lng: -42.0025588,
    lat: -21.7427062
  },
  {
    lng: -42.0024563,
    lat: -21.7426572
  },
  {
    lng: -42.0023792,
    lat: -21.7425831
  },
  {
    lng: -42.0023337,
    lat: -21.7425037
  },
  {
    lng: -42.0023058,
    lat: -21.7424402
  },
  {
    lng: -42.0023019,
    lat: -21.7424313
  },
  {
    lng: -42.0022773,
    lat: -21.7423526
  },
  {
    lng: -42.0022742,
    lat: -21.7422618
  },
  {
    lng: -42.0022815,
    lat: -21.7421714
  },
  {
    lng: -42.0023132,
    lat: -21.7420818
  },
  {
    lng: -42.0023638,
    lat: -21.7419541
  },
  {
    lng: -42.0024421,
    lat: -21.7418339
  },
  {
    lng: -42.002519,
    lat: -21.741746
  },
  {
    lng: -42.0025953,
    lat: -21.741671
  },
  {
    lng: -42.0026368,
    lat: -21.7415948
  },
  {
    lng: -42.0026473,
    lat: -21.7415111
  },
  {
    lng: -42.0026423,
    lat: -21.7413814
  },
  {
    lng: -42.0025974,
    lat: -21.7412891
  },
  {
    lng: -42.002523,
    lat: -21.7412347
  },
  {
    lng: -42.0024682,
    lat: -21.7412132
  },
  {
    lng: -42.0023919,
    lat: -21.741204
  },
  {
    lng: -42.0023111,
    lat: -21.7412205
  },
  {
    lng: -42.0022535,
    lat: -21.7412637
  },
  {
    lng: -42.0021873,
    lat: -21.7413454
  },
  {
    lng: -42.002137,
    lat: -21.7413825
  },
  {
    lng: -42.0020596,
    lat: -21.7413991
  },
  {
    lng: -42.0019514,
    lat: -21.7414016
  },
  {
    lng: -42.001825,
    lat: -21.7414229
  },
  {
    lng: -42.0017147,
    lat: -21.7414772
  },
  {
    lng: -42.001604,
    lat: -21.7415379
  },
  {
    lng: -42.001467,
    lat: -21.7416431
  },
  {
    lng: -42.0012755,
    lat: -21.7417981
  },
  {
    lng: -42.0010904,
    lat: -21.7419664
  },
  {
    lng: -42.0009839,
    lat: -21.7420922
  },
  {
    lng: -42.0009124,
    lat: -21.7422128
  },
  {
    lng: -42.0008752,
    lat: -21.7422652
  },
  {
    lng: -42.0008047,
    lat: -21.7423645
  },
  {
    lng: -42.0007164,
    lat: -21.7424715
  },
  {
    lng: -42.0006619,
    lat: -21.7425215
  },
  {
    lng: -42.000591,
    lat: -21.7425449
  },
  {
    lng: -42.0005036,
    lat: -21.7425482
  },
  {
    lng: -42.0004129,
    lat: -21.742545
  },
  {
    lng: -42.0003258,
    lat: -21.7425418
  },
  {
    lng: -42.0002161,
    lat: -21.7424925
  },
  {
    lng: -42.0001585,
    lat: -21.7424515
  },
  {
    lng: -42.0001157,
    lat: -21.7423916
  },
  {
    lng: -42.0000949,
    lat: -21.7423065
  },
  {
    lng: -42.0001018,
    lat: -21.7422289
  },
  {
    lng: -42.0001237,
    lat: -21.742126
  },
  {
    lng: -42.0001426,
    lat: -21.7420099
  },
  {
    lng: -42.0001651,
    lat: -21.7418941
  },
  {
    lng: -42.0001633,
    lat: -21.741693
  },
  {
    lng: -42.000179,
    lat: -21.7415705
  },
  {
    lng: -42.0002485,
    lat: -21.7414174
  },
  {
    lng: -42.00036,
    lat: -21.7412595
  },
  {
    lng: -42.0004585,
    lat: -21.7411594
  },
  {
    lng: -42.0005752,
    lat: -21.741068
  },
  {
    lng: -42.0005849,
    lat: -21.7410604
  },
  {
    lng: -42.0007525,
    lat: -21.7409758
  },
  {
    lng: -42.0009651,
    lat: -21.7408994
  },
  {
    lng: -42.0010517,
    lat: -21.7408314
  },
  {
    lng: -42.0011081,
    lat: -21.7407363
  },
  {
    lng: -42.0011556,
    lat: -21.7406021
  },
  {
    lng: -42.0011703,
    lat: -21.7404214
  },
  {
    lng: -42.0011739,
    lat: -21.7403374
  },
  {
    lng: -42.0011831,
    lat: -21.740286
  },
  {
    lng: -42.0012107,
    lat: -21.7402094
  },
  {
    lng: -42.0012788,
    lat: -21.7401666
  },
  {
    lng: -42.0013567,
    lat: -21.7401371
  },
  {
    lng: -42.00145,
    lat: -21.7400758
  },
  {
    lng: -42.0014904,
    lat: -21.7400256
  },
  {
    lng: -42.0015044,
    lat: -21.739942
  },
  {
    lng: -42.0014866,
    lat: -21.7398702
  },
  {
    lng: -42.001461,
    lat: -21.7398175
  },
  {
    lng: -42.0014104,
    lat: -21.7397768
  },
  {
    lng: -42.0013031,
    lat: -21.7397599
  },
  {
    lng: -42.0012121,
    lat: -21.7397695
  },
  {
    lng: -42.0010956,
    lat: -21.739804
  },
  {
    lng: -42.000975,
    lat: -21.7398513
  },
  {
    lng: -42.0008968,
    lat: -21.7398993
  },
  {
    lng: -42.0008855,
    lat: -21.7399062
  },
  {
    lng: -42.0007772,
    lat: -21.7399928
  },
  {
    lng: -42.0006721,
    lat: -21.740086
  },
  {
    lng: -42.000648,
    lat: -21.7401146
  },
  {
    lng: -42.0005508,
    lat: -21.7402304
  },
  {
    lng: -42.0005485,
    lat: -21.7402331
  },
  {
    lng: -42.0004587,
    lat: -21.7403435
  },
  {
    lng: -42.0003527,
    lat: -21.7404561
  },
  {
    lng: -42.0002783,
    lat: -21.7405635
  },
  {
    lng: -42.0002291,
    lat: -21.7406523
  },
  {
    lng: -42.0001563,
    lat: -21.7407209
  },
  {
    lng: -42.0000991,
    lat: -21.7407567
  },
  {
    lng: -41.9999995,
    lat: -21.7407789
  },
  {
    lng: -41.9998382,
    lat: -21.7408567
  },
  {
    lng: -41.9997964,
    lat: -21.7408749
  },
  {
    lng: -41.9996871,
    lat: -21.740898
  },
  {
    lng: -41.999549,
    lat: -21.7408633
  },
  {
    lng: -41.9994972,
    lat: -21.7408216
  },
  {
    lng: -41.9994628,
    lat: -21.7407946
  },
  {
    lng: -41.999397,
    lat: -21.74069
  },
  {
    lng: -41.9993867,
    lat: -21.7406271
  },
  {
    lng: -41.9993692,
    lat: -21.7404786
  },
  {
    lng: -41.9993916,
    lat: -21.7402724
  },
  {
    lng: -41.9994892,
    lat: -21.7399723
  },
  {
    lng: -41.9995888,
    lat: -21.7398193
  },
  {
    lng: -41.9997476,
    lat: -21.7396569
  },
  {
    lng: -41.9998458,
    lat: -21.7395525
  },
  {
    lng: -41.9998783,
    lat: -21.7393945
  },
  {
    lng: -41.9998552,
    lat: -21.7392168
  },
  {
    lng: -41.9997794,
    lat: -21.7390664
  },
  {
    lng: -41.9997092,
    lat: -21.739066
  },
  {
    lng: -41.9995984,
    lat: -21.7390081
  },
  {
    lng: -41.9994594,
    lat: -21.7389695
  },
  {
    lng: -41.9993095,
    lat: -21.7390049
  },
  {
    lng: -41.9991109,
    lat: -21.7390443
  },
  {
    lng: -41.9989208,
    lat: -21.7390815
  },
  {
    lng: -41.9986898,
    lat: -21.739142
  },
  {
    lng: -41.9984893,
    lat: -21.7391888
  },
  {
    lng: -41.9982062,
    lat: -21.7391135
  },
  {
    lng: -41.9980853,
    lat: -21.7390126
  },
  {
    lng: -41.9979593,
    lat: -21.7386602
  },
  {
    lng: -41.9979534,
    lat: -21.7386399
  },
  {
    lng: -41.9979291,
    lat: -21.7385552
  },
  {
    lng: -41.9978468,
    lat: -21.7384797
  },
  {
    lng: -41.9977388,
    lat: -21.7384913
  },
  {
    lng: -41.9976236,
    lat: -21.7385305
  },
  {
    lng: -41.9974576,
    lat: -21.7387331
  },
  {
    lng: -41.9974492,
    lat: -21.7388098
  },
  {
    lng: -41.9974516,
    lat: -21.7389327
  },
  {
    lng: -41.9973747,
    lat: -21.7389751
  },
  {
    lng: -41.9972424,
    lat: -21.7389637
  },
  {
    lng: -41.9970843,
    lat: -21.7389084
  },
  {
    lng: -41.9969827,
    lat: -21.7388315
  },
  {
    lng: -41.9969257,
    lat: -21.7387279
  },
  {
    lng: -41.9968922,
    lat: -21.7385798
  },
  {
    lng: -41.9969365,
    lat: -21.7384063
  },
  {
    lng: -41.9970431,
    lat: -21.7382651
  },
  {
    lng: -41.9972764,
    lat: -21.7379705
  },
  {
    lng: -41.9972762,
    lat: -21.7379419
  },
  {
    lng: -41.9971816,
    lat: -21.7377876
  },
  {
    lng: -41.9970036,
    lat: -21.7377757
  },
  {
    lng: -41.9967882,
    lat: -21.737787
  },
  {
    lng: -41.996696,
    lat: -21.7378302
  },
  {
    lng: -41.9965061,
    lat: -21.7378301
  },
  {
    lng: -41.996352,
    lat: -21.7377308
  },
  {
    lng: -41.9962216,
    lat: -21.7376502
  },
  {
    lng: -41.9960877,
    lat: -21.7376281
  },
  {
    lng: -41.9957164,
    lat: -21.7375145
  },
  {
    lng: -41.9957018,
    lat: -21.7375153
  },
  {
    lng: -41.9955671,
    lat: -21.7375484
  },
  {
    lng: -41.995394,
    lat: -21.7376285
  },
  {
    lng: -41.9952295,
    lat: -21.7377948
  },
  {
    lng: -41.9950981,
    lat: -21.737873
  },
  {
    lng: -41.9948909,
    lat: -21.7379596
  },
  {
    lng: -41.9946251,
    lat: -21.7379943
  },
  {
    lng: -41.9944574,
    lat: -21.738125
  },
  {
    lng: -41.9942141,
    lat: -21.7383057
  },
  {
    lng: -41.9940849,
    lat: -21.7383834
  },
  {
    lng: -41.9937568,
    lat: -21.7385927
  },
  {
    lng: -41.9936241,
    lat: -21.7386535
  },
  {
    lng: -41.9934955,
    lat: -21.7386789
  },
  {
    lng: -41.9932884,
    lat: -21.7386727
  },
  {
    lng: -41.9929814,
    lat: -21.7386506
  },
  {
    lng: -41.9928549,
    lat: -21.7386791
  },
  {
    lng: -41.9927335,
    lat: -21.7387951
  },
  {
    lng: -41.9925179,
    lat: -21.7391014
  },
  {
    lng: -41.9925112,
    lat: -21.7391117
  },
  {
    lng: -41.9924553,
    lat: -21.7391492
  },
  {
    lng: -41.9923993,
    lat: -21.7391868
  },
  {
    lng: -41.9922267,
    lat: -21.7391705
  },
  {
    lng: -41.9920195,
    lat: -21.7391065
  },
  {
    lng: -41.9918263,
    lat: -21.7389473
  },
  {
    lng: -41.9915952,
    lat: -21.7387196
  },
  {
    lng: -41.991563,
    lat: -21.7386468
  },
  {
    lng: -41.9915308,
    lat: -21.738574
  },
  {
    lng: -41.9915295,
    lat: -21.7384378
  },
  {
    lng: -41.9915239,
    lat: -21.7383038
  },
  {
    lng: -41.9915942,
    lat: -21.7382002
  },
  {
    lng: -41.9916554,
    lat: -21.7381542
  },
  {
    lng: -41.9917769,
    lat: -21.7381047
  },
  {
    lng: -41.9918962,
    lat: -21.737969
  },
  {
    lng: -41.9919637,
    lat: -21.7377912
  },
  {
    lng: -41.9919215,
    lat: -21.7376502
  },
  {
    lng: -41.9918726,
    lat: -21.7374697
  },
  {
    lng: -41.9918812,
    lat: -21.7373114
  },
  {
    lng: -41.9919155,
    lat: -21.7371749
  },
  {
    lng: -41.9918609,
    lat: -21.7368681
  },
  {
    lng: -41.991812,
    lat: -21.7368039
  },
  {
    lng: -41.9915853,
    lat: -21.7367126
  },
  {
    lng: -41.9915497,
    lat: -21.7367036
  },
  {
    lng: -41.9914609,
    lat: -21.7367459
  },
  {
    lng: -41.9913526,
    lat: -21.7367734
  },
  {
    lng: -41.9912303,
    lat: -21.7367562
  },
  {
    lng: -41.9911436,
    lat: -21.7367463
  },
  {
    lng: -41.9910347,
    lat: -21.7367259
  },
  {
    lng: -41.9909487,
    lat: -21.7367791
  },
  {
    lng: -41.9908822,
    lat: -21.7368144
  },
  {
    lng: -41.9907796,
    lat: -21.7368715
  },
  {
    lng: -41.9906746,
    lat: -21.73692
  },
  {
    lng: -41.9905836,
    lat: -21.7369455
  },
  {
    lng: -41.9905192,
    lat: -21.7369637
  },
  {
    lng: -41.9903157,
    lat: -21.736889
  },
  {
    lng: -41.99009,
    lat: -21.7368604
  },
  {
    lng: -41.9899482,
    lat: -21.7368793
  },
  {
    lng: -41.9897837,
    lat: -21.736883
  },
  {
    lng: -41.989775,
    lat: -21.7368835
  },
  {
    lng: -41.9897276,
    lat: -21.7368684
  },
  {
    lng: -41.9895061,
    lat: -21.7368311
  },
  {
    lng: -41.989302,
    lat: -21.7368373
  },
  {
    lng: -41.9889064,
    lat: -21.7368173
  },
  {
    lng: -41.9888506,
    lat: -21.7368297
  },
  {
    lng: -41.9887224,
    lat: -21.7368324
  },
  {
    lng: -41.9885725,
    lat: -21.736761
  },
  {
    lng: -41.9884101,
    lat: -21.7365772
  },
  {
    lng: -41.9882997,
    lat: -21.7363796
  },
  {
    lng: -41.9881846,
    lat: -21.7363086
  },
  {
    lng: -41.9879601,
    lat: -21.7363333
  },
  {
    lng: -41.9878086,
    lat: -21.7363081
  },
  {
    lng: -41.9876529,
    lat: -21.7362823
  },
  {
    lng: -41.9874888,
    lat: -21.7360841
  },
  {
    lng: -41.9874083,
    lat: -21.735881
  },
  {
    lng: -41.9872528,
    lat: -21.7355777
  },
  {
    lng: -41.9871107,
    lat: -21.7353029
  },
  {
    lng: -41.9869762,
    lat: -21.7350226
  },
  {
    lng: -41.9868262,
    lat: -21.7348227
  },
  {
    lng: -41.9867135,
    lat: -21.7347646
  },
  {
    lng: -41.9865832,
    lat: -21.7346974
  },
  {
    lng: -41.9863958,
    lat: -21.7345264
  },
  {
    lng: -41.9862225,
    lat: -21.7341668
  },
  {
    lng: -41.9860173,
    lat: -21.7337894
  },
  {
    lng: -41.9859086,
    lat: -21.7336062
  },
  {
    lng: -41.9857792,
    lat: -21.733421
  },
  {
    lng: -41.9857322,
    lat: -21.7333757
  },
  {
    lng: -41.985498,
    lat: -21.7331497
  },
  {
    lng: -41.9853109,
    lat: -21.733007
  },
  {
    lng: -41.9849886,
    lat: -21.7328857
  },
  {
    lng: -41.9846851,
    lat: -21.7328611
  },
  {
    lng: -41.9843424,
    lat: -21.7328994
  },
  {
    lng: -41.9839693,
    lat: -21.7328984
  },
  {
    lng: -41.9837366,
    lat: -21.7329863
  },
  {
    lng: -41.983405,
    lat: -21.7331344
  },
  {
    lng: -41.9830343,
    lat: -21.7332563
  },
  {
    lng: -41.9829858,
    lat: -21.7332745
  },
  {
    lng: -41.9826436,
    lat: -21.7333172
  },
  {
    lng: -41.9823322,
    lat: -21.7332813
  },
  {
    lng: -41.9820608,
    lat: -21.7332646
  },
  {
    lng: -41.9817222,
    lat: -21.7331543
  },
  {
    lng: -41.9816102,
    lat: -21.7331589
  },
  {
    lng: -41.9815927,
    lat: -21.7331597
  },
  {
    lng: -41.9814116,
    lat: -21.7332426
  },
  {
    lng: -41.9813584,
    lat: -21.7334876
  },
  {
    lng: -41.9813585,
    lat: -21.7338499
  },
  {
    lng: -41.9813807,
    lat: -21.7342132
  },
  {
    lng: -41.9813685,
    lat: -21.7345458
  },
  {
    lng: -41.9813158,
    lat: -21.7348906
  },
  {
    lng: -41.9811676,
    lat: -21.7350685
  },
  {
    lng: -41.9810084,
    lat: -21.7352665
  },
  {
    lng: -41.9807772,
    lat: -21.7355261
  },
  {
    lng: -41.9805388,
    lat: -21.7358147
  },
  {
    lng: -41.980291,
    lat: -21.7361092
  },
  {
    lng: -41.9800864,
    lat: -21.7364275
  },
  {
    lng: -41.9798927,
    lat: -21.7367423
  },
  {
    lng: -41.9798653,
    lat: -21.7368885
  },
  {
    lng: -41.979998,
    lat: -21.7372299
  },
  {
    lng: -41.9800548,
    lat: -21.7372989
  },
  {
    lng: -41.9801495,
    lat: -21.73742
  },
  {
    lng: -41.980425,
    lat: -21.737715
  },
  {
    lng: -41.9805726,
    lat: -21.7378601
  },
  {
    lng: -41.9808009,
    lat: -21.7381721
  },
  {
    lng: -41.9808267,
    lat: -21.7382382
  },
  {
    lng: -41.9808385,
    lat: -21.7383031
  },
  {
    lng: -41.9807839,
    lat: -21.7383921
  },
  {
    lng: -41.9807131,
    lat: -21.7384992
  },
  {
    lng: -41.9806231,
    lat: -21.7386127
  },
  {
    lng: -41.9805513,
    lat: -21.7386664
  },
  {
    lng: -41.9803763,
    lat: -21.7387059
  },
  {
    lng: -41.9802371,
    lat: -21.7387885
  },
  {
    lng: -41.9801223,
    lat: -21.738903
  },
  {
    lng: -41.9799145,
    lat: -21.7390667
  },
  {
    lng: -41.9797762,
    lat: -21.739107
  },
  {
    lng: -41.979723,
    lat: -21.7391225
  },
  {
    lng: -41.9795656,
    lat: -21.7392012
  },
  {
    lng: -41.9792918,
    lat: -21.7393001
  },
  {
    lng: -41.9788742,
    lat: -21.7394019
  },
  {
    lng: -41.9785961,
    lat: -21.7394892
  },
  {
    lng: -41.9782664,
    lat: -21.7395314
  },
  {
    lng: -41.9778935,
    lat: -21.739511
  },
  {
    lng: -41.9774932,
    lat: -21.7394853
  },
  {
    lng: -41.977439,
    lat: -21.7394726
  },
  {
    lng: -41.9772334,
    lat: -21.7394272
  },
  {
    lng: -41.9769037,
    lat: -21.7393735
  },
  {
    lng: -41.9765949,
    lat: -21.7392569
  },
  {
    lng: -41.9762595,
    lat: -21.7390412
  },
  {
    lng: -41.9762295,
    lat: -21.7389891
  },
  {
    lng: -41.976125,
    lat: -21.7388076
  },
  {
    lng: -41.9760021,
    lat: -21.7386774
  },
  {
    lng: -41.9758978,
    lat: -21.7385679
  },
  {
    lng: -41.9757534,
    lat: -21.7384124
  },
  {
    lng: -41.9756044,
    lat: -21.7382244
  },
  {
    lng: -41.9754997,
    lat: -21.7380904
  },
  {
    lng: -41.9753725,
    lat: -21.7378806
  },
  {
    lng: -41.9753525,
    lat: -21.7377481
  },
  {
    lng: -41.9753889,
    lat: -21.7376549
  },
  {
    lng: -41.9755081,
    lat: -21.7374393
  },
  {
    lng: -41.9756994,
    lat: -21.7371765
  },
  {
    lng: -41.9757813,
    lat: -21.7369868
  },
  {
    lng: -41.9758474,
    lat: -21.736793
  },
  {
    lng: -41.9760638,
    lat: -21.7364854
  },
  {
    lng: -41.9760715,
    lat: -21.7364773
  },
  {
    lng: -41.976145,
    lat: -21.736379
  },
  {
    lng: -41.9762534,
    lat: -21.7362132
  },
  {
    lng: -41.9764479,
    lat: -21.7358966
  },
  {
    lng: -41.9764677,
    lat: -21.7358699
  },
  {
    lng: -41.9765144,
    lat: -21.7356987
  },
  {
    lng: -41.9765447,
    lat: -21.7354215
  },
  {
    lng: -41.9765159,
    lat: -21.735146
  },
  {
    lng: -41.9764522,
    lat: -21.734917
  },
  {
    lng: -41.9764562,
    lat: -21.73464
  },
  {
    lng: -41.9763769,
    lat: -21.7344176
  },
  {
    lng: -41.976161,
    lat: -21.7342676
  },
  {
    lng: -41.9759521,
    lat: -21.7342436
  },
  {
    lng: -41.9755634,
    lat: -21.7342593
  },
  {
    lng: -41.9752086,
    lat: -21.7342567
  },
  {
    lng: -41.9747616,
    lat: -21.7342648
  },
  {
    lng: -41.9743327,
    lat: -21.7342355
  },
  {
    lng: -41.9739364,
    lat: -21.7342173
  },
  {
    lng: -41.9735406,
    lat: -21.7342197
  },
  {
    lng: -41.9735276,
    lat: -21.734229
  },
  {
    lng: -41.9734429,
    lat: -21.7343382
  },
  {
    lng: -41.9734199,
    lat: -21.7344457
  },
  {
    lng: -41.9733441,
    lat: -21.7345307
  },
  {
    lng: -41.9731119,
    lat: -21.7345859
  },
  {
    lng: -41.9730477,
    lat: -21.7345713
  },
  {
    lng: -41.9729193,
    lat: -21.7345422
  },
  {
    lng: -41.9727124,
    lat: -21.7345113
  },
  {
    lng: -41.972486,
    lat: -21.7343931
  },
  {
    lng: -41.9724821,
    lat: -21.7343904
  },
  {
    lng: -41.972208,
    lat: -21.7343293
  },
  {
    lng: -41.9718042,
    lat: -21.7343179
  },
  {
    lng: -41.9714933,
    lat: -21.7343371
  },
  {
    lng: -41.9710991,
    lat: -21.7342712
  },
  {
    lng: -41.9710284,
    lat: -21.7342415
  },
  {
    lng: -41.970915,
    lat: -21.7341479
  },
  {
    lng: -41.9708021,
    lat: -21.7337992
  },
  {
    lng: -41.9708172,
    lat: -21.7337311
  },
  {
    lng: -41.9708474,
    lat: -21.7334068
  },
  {
    lng: -41.9707315,
    lat: -21.7331474
  },
  {
    lng: -41.9706941,
    lat: -21.7330638
  },
  {
    lng: -41.9704814,
    lat: -21.7327465
  },
  {
    lng: -41.9704603,
    lat: -21.7327173
  },
  {
    lng: -41.9702355,
    lat: -21.7325458
  },
  {
    lng: -41.9699278,
    lat: -21.7323889
  },
  {
    lng: -41.9695308,
    lat: -21.7322415
  },
  {
    lng: -41.9693053,
    lat: -21.7322017
  },
  {
    lng: -41.9689101,
    lat: -21.7321603
  },
  {
    lng: -41.9687342,
    lat: -21.7321631
  },
  {
    lng: -41.9686024,
    lat: -21.7321852
  },
  {
    lng: -41.9685804,
    lat: -21.7322721
  },
  {
    lng: -41.9685922,
    lat: -21.7325173
  },
  {
    lng: -41.9684381,
    lat: -21.7327811
  },
  {
    lng: -41.9683115,
    lat: -21.7331349
  },
  {
    lng: -41.9682796,
    lat: -21.7331551
  },
  {
    lng: -41.9681023,
    lat: -21.7333027
  },
  {
    lng: -41.9678832,
    lat: -21.7333744
  },
  {
    lng: -41.9675691,
    lat: -21.7334263
  },
  {
    lng: -41.9673128,
    lat: -21.733475
  },
  {
    lng: -41.9671209,
    lat: -21.7334348
  },
  {
    lng: -41.9670419,
    lat: -21.7334182
  },
  {
    lng: -41.9668775,
    lat: -21.73324
  },
  {
    lng: -41.9667502,
    lat: -21.7330008
  },
  {
    lng: -41.9666077,
    lat: -21.7328867
  },
  {
    lng: -41.9664494,
    lat: -21.7328352
  },
  {
    lng: -41.9664155,
    lat: -21.7327176
  },
  {
    lng: -41.9663922,
    lat: -21.7326201
  },
  {
    lng: -41.9662976,
    lat: -21.7324773
  },
  {
    lng: -41.9660311,
    lat: -21.7323547
  },
  {
    lng: -41.9658761,
    lat: -21.732333
  },
  {
    lng: -41.9657211,
    lat: -21.7323112
  },
  {
    lng: -41.9653324,
    lat: -21.7322887
  },
  {
    lng: -41.9652798,
    lat: -21.7323031
  },
  {
    lng: -41.964982,
    lat: -21.7324315
  },
  {
    lng: -41.9647712,
    lat: -21.7325849
  },
  {
    lng: -41.9645794,
    lat: -21.7326677
  },
  {
    lng: -41.9641845,
    lat: -21.7326927
  },
  {
    lng: -41.9641597,
    lat: -21.7326918
  },
  {
    lng: -41.9639752,
    lat: -21.7327408
  },
  {
    lng: -41.9638705,
    lat: -21.7329657
  },
  {
    lng: -41.9638624,
    lat: -21.7332032
  },
  {
    lng: -41.9638233,
    lat: -21.733449
  },
  {
    lng: -41.9636726,
    lat: -21.7336044
  },
  {
    lng: -41.9633675,
    lat: -21.7336902
  },
  {
    lng: -41.9632747,
    lat: -21.7336507
  },
  {
    lng: -41.9630068,
    lat: -21.7335369
  },
  {
    lng: -41.9627536,
    lat: -21.7333676
  },
  {
    lng: -41.9625638,
    lat: -21.7331395
  },
  {
    lng: -41.9623967,
    lat: -21.7329104
  },
  {
    lng: -41.9621949,
    lat: -21.732587
  },
  {
    lng: -41.9619535,
    lat: -21.7322993
  },
  {
    lng: -41.9618756,
    lat: -21.7321312
  },
  {
    lng: -41.9617929,
    lat: -21.731953
  },
  {
    lng: -41.9617668,
    lat: -21.7318098
  },
  {
    lng: -41.9617259,
    lat: -21.7315849
  },
  {
    lng: -41.961665,
    lat: -21.7313026
  },
  {
    lng: -41.9615951,
    lat: -21.7311745
  },
  {
    lng: -41.9614603,
    lat: -21.7311204
  },
  {
    lng: -41.961377,
    lat: -21.731087
  },
  {
    lng: -41.9610664,
    lat: -21.7311295
  },
  {
    lng: -41.9608698,
    lat: -21.7311313
  },
  {
    lng: -41.9604732,
    lat: -21.7311877
  },
  {
    lng: -41.9603811,
    lat: -21.7312009
  },
  {
    lng: -41.9599635,
    lat: -21.7312231
  },
  {
    lng: -41.959761,
    lat: -21.7312066
  },
  {
    lng: -41.9595701,
    lat: -21.7311911
  },
  {
    lng: -41.9592722,
    lat: -21.7311057
  },
  {
    lng: -41.958995,
    lat: -21.7310175
  },
  {
    lng: -41.9586687,
    lat: -21.7309927
  },
  {
    lng: -41.958268,
    lat: -21.7309994
  },
  {
    lng: -41.9578142,
    lat: -21.7310174
  },
  {
    lng: -41.9574015,
    lat: -21.7310761
  },
  {
    lng: -41.9569729,
    lat: -21.7311181
  },
  {
    lng: -41.9566312,
    lat: -21.7311739
  },
  {
    lng: -41.9562128,
    lat: -21.73125
  },
  {
    lng: -41.9562097,
    lat: -21.7312507
  },
  {
    lng: -41.9558359,
    lat: -21.7313329
  },
  {
    lng: -41.9554354,
    lat: -21.7313767
  },
  {
    lng: -41.9554194,
    lat: -21.7313702
  },
  {
    lng: -41.9552913,
    lat: -21.7313159
  },
  {
    lng: -41.9551735,
    lat: -21.7312128
  },
  {
    lng: -41.955076,
    lat: -21.7309947
  },
  {
    lng: -41.9550749,
    lat: -21.7307596
  },
  {
    lng: -41.9550771,
    lat: -21.7303766
  },
  {
    lng: -41.9550764,
    lat: -21.7303365
  },
  {
    lng: -41.9551164,
    lat: -21.7300367
  },
  {
    lng: -41.9552299,
    lat: -21.7297567
  },
  {
    lng: -41.9552831,
    lat: -21.7295587
  },
  {
    lng: -41.9552557,
    lat: -21.7294129
  },
  {
    lng: -41.9551861,
    lat: -21.7293155
  },
  {
    lng: -41.9550099,
    lat: -21.7292406
  },
  {
    lng: -41.954958,
    lat: -21.7292186
  },
  {
    lng: -41.9548445,
    lat: -21.729234
  },
  {
    lng: -41.9546297,
    lat: -21.7292845
  },
  {
    lng: -41.9545452,
    lat: -21.7292728
  },
  {
    lng: -41.9542072,
    lat: -21.7292258
  },
  {
    lng: -41.953836,
    lat: -21.7291056
  },
  {
    lng: -41.9536334,
    lat: -21.7290128
  },
  {
    lng: -41.9534501,
    lat: -21.7288455
  },
  {
    lng: -41.9532542,
    lat: -21.7286143
  },
  {
    lng: -41.9529735,
    lat: -21.7284972
  },
  {
    lng: -41.9528161,
    lat: -21.7284969
  },
  {
    lng: -41.9526924,
    lat: -21.7284967
  },
  {
    lng: -41.9526056,
    lat: -21.7286065
  },
  {
    lng: -41.9524428,
    lat: -21.7288213
  },
  {
    lng: -41.9521766,
    lat: -21.7291237
  },
  {
    lng: -41.9520159,
    lat: -21.7292939
  },
  {
    lng: -41.9519128,
    lat: -21.7294031
  },
  {
    lng: -41.9515758,
    lat: -21.7296425
  },
  {
    lng: -41.9514157,
    lat: -21.7296806
  },
  {
    lng: -41.9511967,
    lat: -21.7298364
  },
  {
    lng: -41.950827,
    lat: -21.7299745
  },
  {
    lng: -41.9505015,
    lat: -21.7301195
  },
  {
    lng: -41.9502127,
    lat: -21.7302336
  },
  {
    lng: -41.949953,
    lat: -21.7303237
  },
  {
    lng: -41.9495417,
    lat: -21.7303722
  },
  {
    lng: -41.9494184,
    lat: -21.7303619
  },
  {
    lng: -41.9490217,
    lat: -21.7302809
  },
  {
    lng: -41.9489182,
    lat: -21.7302945
  },
  {
    lng: -41.9488364,
    lat: -21.7303116
  },
  {
    lng: -41.9487594,
    lat: -21.7303276
  },
  {
    lng: -41.9486286,
    lat: -21.7304601
  },
  {
    lng: -41.9486077,
    lat: -21.7306523
  },
  {
    lng: -41.9486431,
    lat: -21.7310232
  },
  {
    lng: -41.9485909,
    lat: -21.7311497
  },
  {
    lng: -41.9484403,
    lat: -21.7313522
  },
  {
    lng: -41.9482696,
    lat: -21.7317374
  },
  {
    lng: -41.9480156,
    lat: -21.732035
  },
  {
    lng: -41.9479538,
    lat: -21.7320862
  },
  {
    lng: -41.9477672,
    lat: -21.7324078
  },
  {
    lng: -41.9475785,
    lat: -21.7326016
  },
  {
    lng: -41.9473326,
    lat: -21.7328917
  },
  {
    lng: -41.9473025,
    lat: -21.7329747
  },
  {
    lng: -41.947229,
    lat: -21.733049
  },
  {
    lng: -41.9470798,
    lat: -21.7332134
  },
  {
    lng: -41.947022,
    lat: -21.7334437
  },
  {
    lng: -41.9468445,
    lat: -21.7337917
  },
  {
    lng: -41.9467755,
    lat: -21.7341176
  },
  {
    lng: -41.9466575,
    lat: -21.7343435
  },
  {
    lng: -41.9465675,
    lat: -21.7347143
  },
  {
    lng: -41.9465096,
    lat: -21.7349216
  },
  {
    lng: -41.946423,
    lat: -21.7351805
  },
  {
    lng: -41.9463907,
    lat: -21.7352773
  },
  {
    lng: -41.9463441,
    lat: -21.7353376
  },
  {
    lng: -41.9462719,
    lat: -21.735448
  },
  {
    lng: -41.946146,
    lat: -21.7356716
  },
  {
    lng: -41.9460896,
    lat: -21.7358093
  },
  {
    lng: -41.9459702,
    lat: -21.7359197
  },
  {
    lng: -41.9458783,
    lat: -21.7359995
  },
  {
    lng: -41.9458038,
    lat: -21.7360642
  },
  {
    lng: -41.9456372,
    lat: -21.7362022
  },
  {
    lng: -41.9455865,
    lat: -21.7362518
  },
  {
    lng: -41.9453576,
    lat: -21.7364757
  },
  {
    lng: -41.9453361,
    lat: -21.7364933
  },
  {
    lng: -41.9451517,
    lat: -21.7366314
  },
  {
    lng: -41.9450234,
    lat: -21.736805
  },
  {
    lng: -41.9448676,
    lat: -21.7368514
  },
  {
    lng: -41.9447363,
    lat: -21.7369579
  },
  {
    lng: -41.9445835,
    lat: -21.7371569
  },
  {
    lng: -41.9444155,
    lat: -21.7372574
  },
  {
    lng: -41.944393,
    lat: -21.7372769
  },
  {
    lng: -41.9442859,
    lat: -21.7373291
  },
  {
    lng: -41.9441518,
    lat: -21.737499
  },
  {
    lng: -41.9440705,
    lat: -21.7375697
  },
  {
    lng: -41.9440272,
    lat: -21.7376072
  },
  {
    lng: -41.9438847,
    lat: -21.7377066
  },
  {
    lng: -41.9437054,
    lat: -21.7377673
  },
  {
    lng: -41.9434771,
    lat: -21.7378664
  },
  {
    lng: -41.9433128,
    lat: -21.7380362
  },
  {
    lng: -41.9430083,
    lat: -21.7382945
  },
  {
    lng: -41.9429852,
    lat: -21.7383145
  },
  {
    lng: -41.9428511,
    lat: -21.7384296
  },
  {
    lng: -41.9427077,
    lat: -21.7385947
  },
  {
    lng: -41.9426157,
    lat: -21.7387977
  },
  {
    lng: -41.9425284,
    lat: -21.7388708
  },
  {
    lng: -41.9424029,
    lat: -21.7392212
  },
  {
    lng: -41.9423863,
    lat: -21.7392476
  },
  {
    lng: -41.9423517,
    lat: -21.7393027
  },
  {
    lng: -41.9422339,
    lat: -21.7394668
  },
  {
    lng: -41.942145,
    lat: -21.7395083
  },
  {
    lng: -41.9419704,
    lat: -21.7395667
  },
  {
    lng: -41.9418166,
    lat: -21.7395755
  },
  {
    lng: -41.9416434,
    lat: -21.7396141
  },
  {
    lng: -41.9414346,
    lat: -21.7396462
  },
  {
    lng: -41.9413788,
    lat: -21.7396548
  },
  {
    lng: -41.9412689,
    lat: -21.7396519
  },
  {
    lng: -41.9411575,
    lat: -21.7396093
  },
  {
    lng: -41.9410612,
    lat: -21.7395249
  },
  {
    lng: -41.9409866,
    lat: -21.7394962
  },
  {
    lng: -41.9408585,
    lat: -21.7394351
  },
  {
    lng: -41.9406949,
    lat: -21.7393367
  },
  {
    lng: -41.9404951,
    lat: -21.7392415
  },
  {
    lng: -41.9401959,
    lat: -21.7390264
  },
  {
    lng: -41.9401591,
    lat: -21.7390134
  },
  {
    lng: -41.9400508,
    lat: -21.7389751
  },
  {
    lng: -41.9399106,
    lat: -21.7389229
  },
  {
    lng: -41.9398334,
    lat: -21.7389611
  },
  {
    lng: -41.9397957,
    lat: -21.7389975
  },
  {
    lng: -41.9397843,
    lat: -21.7390159
  },
  {
    lng: -41.9397547,
    lat: -21.7390703
  },
  {
    lng: -41.9397809,
    lat: -21.7392521
  },
  {
    lng: -41.9398356,
    lat: -21.7393538
  },
  {
    lng: -41.9397842,
    lat: -21.7394443
  },
  {
    lng: -41.9397116,
    lat: -21.7395477
  },
  {
    lng: -41.9396074,
    lat: -21.739676
  },
  {
    lng: -41.9395318,
    lat: -21.7398795
  },
  {
    lng: -41.939657,
    lat: -21.7400446
  },
  {
    lng: -41.9398904,
    lat: -21.7403348
  },
  {
    lng: -41.9398894,
    lat: -21.7403357
  },
  {
    lng: -41.9400673,
    lat: -21.7405674
  },
  {
    lng: -41.9401621,
    lat: -21.7409594
  },
  {
    lng: -41.9401523,
    lat: -21.7410821
  },
  {
    lng: -41.9398234,
    lat: -21.7414097
  },
  {
    lng: -41.9398017,
    lat: -21.7414126
  },
  {
    lng: -41.9396744,
    lat: -21.7414086
  },
  {
    lng: -41.9391287,
    lat: -21.7415014
  },
  {
    lng: -41.9388026,
    lat: -21.7415685
  },
  {
    lng: -41.938586,
    lat: -21.7415849
  },
  {
    lng: -41.9383796,
    lat: -21.7415723
  },
  {
    lng: -41.9381861,
    lat: -21.7415672
  },
  {
    lng: -41.9376762,
    lat: -21.7414387
  },
  {
    lng: -41.9376514,
    lat: -21.7414325
  },
  {
    lng: -41.9373555,
    lat: -21.7413673
  },
  {
    lng: -41.9373178,
    lat: -21.7413455
  },
  {
    lng: -41.9371006,
    lat: -21.7412201
  },
  {
    lng: -41.9371224,
    lat: -21.7411953
  },
  {
    lng: -41.9371106,
    lat: -21.734726
  },
  {
    lng: -41.937008,
    lat: -21.6982462
  },
  {
    lng: -41.9368687,
    lat: -21.6458634
  },
  {
    lng: -41.9368294,
    lat: -21.6310787
  },
  {
    lng: -41.9367381,
    lat: -21.5967529
  },
  {
    lng: -41.9368885,
    lat: -21.5970496
  },
  {
    lng: -41.9369639,
    lat: -21.597323
  },
  {
    lng: -41.9379545,
    lat: -21.5979917
  },
  {
    lng: -41.9396653,
    lat: -21.5983001
  },
  {
    lng: -41.9418532,
    lat: -21.5998633
  },
  {
    lng: -41.9425064,
    lat: -21.6002692
  },
  {
    lng: -41.9428837,
    lat: -21.6005036
  },
  {
    lng: -41.9444252,
    lat: -21.6014613
  },
  {
    lng: -41.9448523,
    lat: -21.6017338
  },
  {
    lng: -41.9455131,
    lat: -21.6021554
  },
  {
    lng: -41.947464,
    lat: -21.6034001
  },
  {
    lng: -41.9480297,
    lat: -21.6037511
  },
  {
    lng: -41.9521915,
    lat: -21.6063331
  },
  {
    lng: -41.9537193,
    lat: -21.6072808
  },
  {
    lng: -41.9556202,
    lat: -21.6084233
  },
  {
    lng: -41.955746,
    lat: -21.6085143
  },
  {
    lng: -41.958333,
    lat: -21.6103837
  },
  {
    lng: -41.960447,
    lat: -21.6126653
  },
  {
    lng: -41.9613206,
    lat: -21.6133736
  },
  {
    lng: -41.9636116,
    lat: -21.6142739
  },
  {
    lng: -41.9676616,
    lat: -21.6163223
  },
  {
    lng: -41.9728172,
    lat: -21.618734
  },
  {
    lng: -41.9751701,
    lat: -21.6209368
  },
  {
    lng: -41.9765428,
    lat: -21.6226263
  },
  {
    lng: -41.9776822,
    lat: -21.6240286
  },
  {
    lng: -41.980776,
    lat: -21.62606
  },
  {
    lng: -41.9818894,
    lat: -21.6267911
  },
  {
    lng: -41.9866515,
    lat: -21.6285114
  },
  {
    lng: -41.9897763,
    lat: -21.6306449
  },
  {
    lng: -41.9911927,
    lat: -21.6312616
  },
  {
    lng: -41.9913586,
    lat: -21.6313339
  },
  {
    lng: -41.9927426,
    lat: -21.6319365
  },
  {
    lng: -41.993028,
    lat: -21.6321979
  },
  {
    lng: -41.9931711,
    lat: -21.632329
  },
  {
    lng: -41.9950952,
    lat: -21.6340919
  },
  {
    lng: -41.9973012,
    lat: -21.6351735
  },
  {
    lng: -41.9974409,
    lat: -21.635242
  },
  {
    lng: -41.99791,
    lat: -21.635393
  },
  {
    lng: -41.9996008,
    lat: -21.6359372
  },
  {
    lng: -41.999877,
    lat: -21.636026
  },
  {
    lng: -42.0001144,
    lat: -21.636213
  },
  {
    lng: -42.0014163,
    lat: -21.6362423
  },
  {
    lng: -42.0022283,
    lat: -21.6364105
  },
  {
    lng: -42.0030879,
    lat: -21.6367273
  },
  {
    lng: -42.0039332,
    lat: -21.6371206
  },
  {
    lng: -42.0045353,
    lat: -21.6374446
  },
  {
    lng: -42.0049262,
    lat: -21.637582
  },
  {
    lng: -42.0053468,
    lat: -21.6378732
  },
  {
    lng: -42.0059141,
    lat: -21.638213
  },
  {
    lng: -42.0066575,
    lat: -21.6385573
  },
  {
    lng: -42.0078501,
    lat: -21.6390925
  },
  {
    lng: -42.0086526,
    lat: -21.6395453
  },
  {
    lng: -42.0093259,
    lat: -21.6399058
  },
  {
    lng: -42.0098633,
    lat: -21.6400383
  },
  {
    lng: -42.0105362,
    lat: -21.6399754
  },
  {
    lng: -42.0113135,
    lat: -21.6398052
  },
  {
    lng: -42.0116352,
    lat: -21.6396789
  },
  {
    lng: -42.0120273,
    lat: -21.6395248
  },
  {
    lng: -42.0125513,
    lat: -21.6392359
  },
  {
    lng: -42.0128207,
    lat: -21.6390692
  },
  {
    lng: -42.0131969,
    lat: -21.6388331
  },
  {
    lng: -42.0133629,
    lat: -21.6387112
  },
  {
    lng: -42.01356,
    lat: -21.6386341
  },
  {
    lng: -42.013902,
    lat: -21.638543
  },
  {
    lng: -42.0140007,
    lat: -21.6384357
  },
  {
    lng: -42.0141877,
    lat: -21.6381692
  },
  {
    lng: -42.0143523,
    lat: -21.6380185
  },
  {
    lng: -42.0146762,
    lat: -21.637783
  },
  {
    lng: -42.014979,
    lat: -21.6376433
  },
  {
    lng: -42.0152746,
    lat: -21.6374185
  },
  {
    lng: -42.0154649,
    lat: -21.6371985
  },
  {
    lng: -42.0155973,
    lat: -21.6370454
  },
  {
    lng: -42.015727,
    lat: -21.636801
  },
  {
    lng: -42.0159171,
    lat: -21.6364426
  },
  {
    lng: -42.016069,
    lat: -21.6358638
  },
  {
    lng: -42.0161464,
    lat: -21.6354494
  },
  {
    lng: -42.0161539,
    lat: -21.635081
  },
  {
    lng: -42.0161876,
    lat: -21.6347816
  },
  {
    lng: -42.0164846,
    lat: -21.6340872
  },
  {
    lng: -42.0171241,
    lat: -21.632415
  },
  {
    lng: -42.017344,
    lat: -21.6319328
  },
  {
    lng: -42.0172723,
    lat: -21.6314309
  },
  {
    lng: -42.0172777,
    lat: -21.631168
  },
  {
    lng: -42.0173901,
    lat: -21.630797
  },
  {
    lng: -42.0176447,
    lat: -21.630508
  },
  {
    lng: -42.0179616,
    lat: -21.6303731
  },
  {
    lng: -42.0182103,
    lat: -21.6303714
  },
  {
    lng: -42.0185307,
    lat: -21.6303894
  },
  {
    lng: -42.0189739,
    lat: -21.6304769
  },
  {
    lng: -42.0194776,
    lat: -21.6304859
  },
  {
    lng: -42.0200039,
    lat: -21.6303547
  },
  {
    lng: -42.0203859,
    lat: -21.6301623
  },
  {
    lng: -42.0205399,
    lat: -21.6300517
  },
  {
    lng: -42.0208303,
    lat: -21.629843
  },
  {
    lng: -42.0211822,
    lat: -21.6294838
  },
  {
    lng: -42.0215553,
    lat: -21.6289395
  },
  {
    lng: -42.0218363,
    lat: -21.6286173
  },
  {
    lng: -42.0220594,
    lat: -21.6285558
  },
  {
    lng: -42.0223278,
    lat: -21.6285606
  },
  {
    lng: -42.0227762,
    lat: -21.6286178
  },
  {
    lng: -42.0234193,
    lat: -21.6288687
  },
  {
    lng: -42.0240474,
    lat: -21.6290336
  },
  {
    lng: -42.0244084,
    lat: -21.6290708
  },
  {
    lng: -42.0247515,
    lat: -21.6290216
  },
  {
    lng: -42.0254345,
    lat: -21.6287511
  },
  {
    lng: -42.0259173,
    lat: -21.6286246
  },
  {
    lng: -42.0264555,
    lat: -21.6286834
  },
  {
    lng: -42.0269297,
    lat: -21.6289128
  },
  {
    lng: -42.0276213,
    lat: -21.6293114
  },
  {
    lng: -42.0285722,
    lat: -21.6299215
  },
  {
    lng: -42.0290037,
    lat: -21.630217
  },
  {
    lng: -42.0294259,
    lat: -21.6304532
  },
  {
    lng: -42.0300414,
    lat: -21.6305008
  },
  {
    lng: -42.0307022,
    lat: -21.6304502
  },
  {
    lng: -42.0313549,
    lat: -21.6303839
  },
  {
    lng: -42.0319223,
    lat: -21.6304096
  },
  {
    lng: -42.0326004,
    lat: -21.6303281
  },
  {
    lng: -42.0333327,
    lat: -21.6307224
  },
  {
    lng: -42.0338018,
    lat: -21.6309128
  },
  {
    lng: -42.0338823,
    lat: -21.6309454
  },
  {
    lng: -42.0344263,
    lat: -21.6311318
  },
  {
    lng: -42.0351602,
    lat: -21.6313708
  },
  {
    lng: -42.035614,
    lat: -21.6315281
  },
  {
    lng: -42.0363293,
    lat: -21.631673
  },
  {
    lng: -42.0366795,
    lat: -21.6317674
  },
  {
    lng: -42.0370299,
    lat: -21.6319105
  },
  {
    lng: -42.0373499,
    lat: -21.6319887
  },
  {
    lng: -42.0377879,
    lat: -21.6320555
  },
  {
    lng: -42.0380316,
    lat: -21.6321142
  },
  {
    lng: -42.0381252,
    lat: -21.6321367
  },
  {
    lng: -42.0383749,
    lat: -21.6321411
  },
  {
    lng: -42.0386782,
    lat: -21.632058
  },
  {
    lng: -42.0390355,
    lat: -21.6319012
  },
  {
    lng: -42.0394559,
    lat: -21.6324137
  },
  {
    lng: -42.0395187,
    lat: -21.6324902
  },
  {
    lng: -42.0398749,
    lat: -21.6331318
  },
  {
    lng: -42.0401395,
    lat: -21.6336639
  },
  {
    lng: -42.0405767,
    lat: -21.6341432
  },
  {
    lng: -42.0408969,
    lat: -21.6340878
  },
  {
    lng: -42.0409945,
    lat: -21.6340709
  },
  {
    lng: -42.0413013,
    lat: -21.6340404
  },
  {
    lng: -42.0415248,
    lat: -21.6340474
  },
  {
    lng: -42.0417093,
    lat: -21.6340721
  },
  {
    lng: -42.0417943,
    lat: -21.6341012
  },
  {
    lng: -42.0418504,
    lat: -21.6341022
  },
  {
    lng: -42.0418969,
    lat: -21.6340716
  },
  {
    lng: -42.0419436,
    lat: -21.6340044
  },
  {
    lng: -42.0419557,
    lat: -21.6339121
  },
  {
    lng: -42.0419616,
    lat: -21.6337824
  },
  {
    lng: -42.0420195,
    lat: -21.6336754
  },
  {
    lng: -42.0421142,
    lat: -21.6335921
  },
  {
    lng: -42.0422403,
    lat: -21.6335847
  },
  {
    lng: -42.0423069,
    lat: -21.6335988
  },
  {
    lng: -42.0424193,
    lat: -21.6336227
  },
  {
    lng: -42.0425854,
    lat: -21.6336943
  },
  {
    lng: -42.042808,
    lat: -21.6337367
  },
  {
    lng: -42.0431191,
    lat: -21.6336947
  },
  {
    lng: -42.0438734,
    lat: -21.6334678
  },
  {
    lng: -42.0440956,
    lat: -21.6333797
  },
  {
    lng: -42.0442274,
    lat: -21.6332585
  },
  {
    lng: -42.0444868,
    lat: -21.633079
  },
  {
    lng: -42.0447002,
    lat: -21.6329949
  },
  {
    lng: -42.044816,
    lat: -21.6329646
  },
  {
    lng: -42.0450046,
    lat: -21.6329152
  },
  {
    lng: -42.0453916,
    lat: -21.6328515
  },
  {
    lng: -42.045862,
    lat: -21.633043
  },
  {
    lng: -42.0470498,
    lat: -21.633513
  },
  {
    lng: -42.047574,
    lat: -21.6337161
  },
  {
    lng: -42.0483499,
    lat: -21.6339812
  },
  {
    lng: -42.0486938,
    lat: -21.6341965
  },
  {
    lng: -42.0489922,
    lat: -21.6344425
  },
  {
    lng: -42.0493128,
    lat: -21.6346492
  },
  {
    lng: -42.0497014,
    lat: -21.6348072
  },
  {
    lng: -42.0501521,
    lat: -21.6349721
  },
  {
    lng: -42.0504969,
    lat: -21.6351468
  },
  {
    lng: -42.0506423,
    lat: -21.6352768
  },
  {
    lng: -42.0512192,
    lat: -21.6357943
  },
  {
    lng: -42.0516286,
    lat: -21.6360553
  },
  {
    lng: -42.0519779,
    lat: -21.6361169
  },
  {
    lng: -42.0522339,
    lat: -21.6361068
  },
  {
    lng: -42.0529,
    lat: -21.6360235
  },
  {
    lng: -42.05335,
    lat: -21.6360231
  },
  {
    lng: -42.0540166,
    lat: -21.6360953
  },
  {
    lng: -42.0550111,
    lat: -21.6362471
  },
  {
    lng: -42.0555924,
    lat: -21.6363134
  },
  {
    lng: -42.0560798,
    lat: -21.6363969
  },
  {
    lng: -42.0564545,
    lat: -21.6365751
  },
  {
    lng: -42.0568487,
    lat: -21.6368196
  },
  {
    lng: -42.0572125,
    lat: -21.6371864
  },
  {
    lng: -42.0576502,
    lat: -21.6375676
  },
  {
    lng: -42.0581692,
    lat: -21.6380057
  },
  {
    lng: -42.0597564,
    lat: -21.6391668
  },
  {
    lng: -42.0604338,
    lat: -21.6400574
  },
  {
    lng: -42.0607149,
    lat: -21.6402042
  },
  {
    lng: -42.0613365,
    lat: -21.640405
  },
  {
    lng: -42.0626258,
    lat: -21.640901
  },
  {
    lng: -42.0630747,
    lat: -21.6417787
  },
  {
    lng: -42.0631077,
    lat: -21.6419726
  },
  {
    lng: -42.0628448,
    lat: -21.6428021
  },
  {
    lng: -42.0627197,
    lat: -21.6434667
  },
  {
    lng: -42.06266,
    lat: -21.6437948
  },
  {
    lng: -42.0626558,
    lat: -21.6441892
  },
  {
    lng: -42.0627116,
    lat: -21.6445397
  },
  {
    lng: -42.0627998,
    lat: -21.6447557
  },
  {
    lng: -42.0629927,
    lat: -21.6450213
  },
  {
    lng: -42.0634673,
    lat: -21.6456308
  },
  {
    lng: -42.0644401,
    lat: -21.6466068
  },
  {
    lng: -42.0646466,
    lat: -21.6467511
  },
  {
    lng: -42.0648232,
    lat: -21.6468746
  },
  {
    lng: -42.0655604,
    lat: -21.647267
  },
  {
    lng: -42.0658151,
    lat: -21.6475424
  },
  {
    lng: -42.0661888,
    lat: -21.6480285
  },
  {
    lng: -42.0664272,
    lat: -21.6483006
  },
  {
    lng: -42.0667644,
    lat: -21.6485713
  },
  {
    lng: -42.0672035,
    lat: -21.6488592
  },
  {
    lng: -42.0679994,
    lat: -21.6492542
  },
  {
    lng: -42.068205,
    lat: -21.6493815
  },
  {
    lng: -42.0685249,
    lat: -21.6496065
  },
  {
    lng: -42.0687789,
    lat: -21.6498606
  },
  {
    lng: -42.0690381,
    lat: -21.6500727
  },
  {
    lng: -42.0694561,
    lat: -21.6504759
  },
  {
    lng: -42.0696967,
    lat: -21.6507918
  },
  {
    lng: -42.0700563,
    lat: -21.6511479
  },
  {
    lng: -42.070398,
    lat: -21.6512685
  },
  {
    lng: -42.0708585,
    lat: -21.6513383
  },
  {
    lng: -42.0707258,
    lat: -21.6516523
  },
  {
    lng: -42.0705713,
    lat: -21.6518755
  },
  {
    lng: -42.0702766,
    lat: -21.6520407
  },
  {
    lng: -42.0698849,
    lat: -21.6521655
  },
  {
    lng: -42.069325,
    lat: -21.6522926
  },
  {
    lng: -42.0689981,
    lat: -21.652439
  },
  {
    lng: -42.0687586,
    lat: -21.6526212
  },
  {
    lng: -42.0684933,
    lat: -21.6529211
  },
  {
    lng: -42.0681606,
    lat: -21.6532033
  },
  {
    lng: -42.0679243,
    lat: -21.6532918
  },
  {
    lng: -42.0678263,
    lat: -21.6533052
  },
  {
    lng: -42.0676137,
    lat: -21.6533341
  },
  {
    lng: -42.0668886,
    lat: -21.6533019
  },
  {
    lng: -42.0670544,
    lat: -21.6534323
  },
  {
    lng: -42.0672452,
    lat: -21.6536806
  },
  {
    lng: -42.0674551,
    lat: -21.6539857
  },
  {
    lng: -42.0678084,
    lat: -21.6543429
  },
  {
    lng: -42.0678532,
    lat: -21.6543826
  },
  {
    lng: -42.0681805,
    lat: -21.6546731
  },
  {
    lng: -42.0685207,
    lat: -21.6549947
  },
  {
    lng: -42.0686337,
    lat: -21.6551358
  },
  {
    lng: -42.068773,
    lat: -21.6553098
  },
  {
    lng: -42.0692321,
    lat: -21.6555654
  },
  {
    lng: -42.0696117,
    lat: -21.655695
  },
  {
    lng: -42.0699494,
    lat: -21.6558622
  },
  {
    lng: -42.0706722,
    lat: -21.6562973
  },
  {
    lng: -42.0707866,
    lat: -21.6563618
  },
  {
    lng: -42.0712695,
    lat: -21.6566342
  },
  {
    lng: -42.0719154,
    lat: -21.6568355
  },
  {
    lng: -42.0722448,
    lat: -21.657036
  },
  {
    lng: -42.0729124,
    lat: -21.6574544
  },
  {
    lng: -42.0735245,
    lat: -21.6578719
  },
  {
    lng: -42.0740301,
    lat: -21.6580582
  },
  {
    lng: -42.074473,
    lat: -21.6581438
  },
  {
    lng: -42.0749913,
    lat: -21.6583909
  },
  {
    lng: -42.0755526,
    lat: -21.6587946
  },
  {
    lng: -42.0758867,
    lat: -21.6591361
  },
  {
    lng: -42.0765418,
    lat: -21.6596116
  },
  {
    lng: -42.0767695,
    lat: -21.6597731
  },
  {
    lng: -42.0771361,
    lat: -21.6599543
  },
  {
    lng: -42.0773083,
    lat: -21.6601423
  },
  {
    lng: -42.0773638,
    lat: -21.6603008
  },
  {
    lng: -42.0776327,
    lat: -21.6604439
  },
  {
    lng: -42.0778347,
    lat: -21.6605353
  },
  {
    lng: -42.0779972,
    lat: -21.6606187
  },
  {
    lng: -42.0781386,
    lat: -21.660749
  },
  {
    lng: -42.0782443,
    lat: -21.6608957
  },
  {
    lng: -42.0783357,
    lat: -21.6610206
  },
  {
    lng: -42.0786313,
    lat: -21.6610961
  },
  {
    lng: -42.078893,
    lat: -21.6612125
  },
  {
    lng: -42.0791006,
    lat: -21.6614311
  },
  {
    lng: -42.0793012,
    lat: -21.6617832
  },
  {
    lng: -42.0794875,
    lat: -21.6619673
  },
  {
    lng: -42.0798768,
    lat: -21.6622279
  },
  {
    lng: -42.0803392,
    lat: -21.6624151
  },
  {
    lng: -42.0807481,
    lat: -21.6625637
  },
  {
    lng: -42.0809767,
    lat: -21.6627453
  },
  {
    lng: -42.081162,
    lat: -21.6630159
  },
  {
    lng: -42.0812161,
    lat: -21.6630948
  },
  {
    lng: -42.0813801,
    lat: -21.6634845
  },
  {
    lng: -42.0816298,
    lat: -21.6637774
  },
  {
    lng: -42.0821752,
    lat: -21.6638875
  },
  {
    lng: -42.0824416,
    lat: -21.6638901
  },
  {
    lng: -42.0827619,
    lat: -21.6638932
  },
  {
    lng: -42.0830325,
    lat: -21.6638638
  },
  {
    lng: -42.0833122,
    lat: -21.6639688
  },
  {
    lng: -42.0835217,
    lat: -21.6641291
  },
  {
    lng: -42.0836571,
    lat: -21.6643231
  },
  {
    lng: -42.0836773,
    lat: -21.664352
  },
  {
    lng: -42.0836984,
    lat: -21.6643822
  },
  {
    lng: -42.0837757,
    lat: -21.6645293
  },
  {
    lng: -42.0838532,
    lat: -21.6646369
  },
  {
    lng: -42.0840491,
    lat: -21.664853
  },
  {
    lng: -42.0843409,
    lat: -21.6651971
  },
  {
    lng: -42.0847799,
    lat: -21.6656619
  },
  {
    lng: -42.0850709,
    lat: -21.6659357
  },
  {
    lng: -42.0857266,
    lat: -21.666352
  },
  {
    lng: -42.0859379,
    lat: -21.6665205
  },
  {
    lng: -42.0859411,
    lat: -21.6665231
  },
  {
    lng: -42.0861918,
    lat: -21.6667232
  },
  {
    lng: -42.0864927,
    lat: -21.6669368
  },
  {
    lng: -42.0871368,
    lat: -21.6674691
  },
  {
    lng: -42.0876314,
    lat: -21.6678719
  },
  {
    lng: -42.087947,
    lat: -21.668123
  },
  {
    lng: -42.0881942,
    lat: -21.6684124
  },
  {
    lng: -42.088329,
    lat: -21.668461
  },
  {
    lng: -42.0887067,
    lat: -21.6686429
  },
  {
    lng: -42.0891296,
    lat: -21.6688333
  },
  {
    lng: -42.0895277,
    lat: -21.6689485
  },
  {
    lng: -42.0896816,
    lat: -21.6690157
  },
  {
    lng: -42.0898552,
    lat: -21.6690724
  },
  {
    lng: -42.0900177,
    lat: -21.6691118
  },
  {
    lng: -42.0902085,
    lat: -21.6691699
  },
  {
    lng: -42.0904438,
    lat: -21.6692768
  },
  {
    lng: -42.0905889,
    lat: -21.6693447
  },
  {
    lng: -42.090712,
    lat: -21.6694061
  },
  {
    lng: -42.0908457,
    lat: -21.6695222
  },
  {
    lng: -42.0910057,
    lat: -21.6696217
  },
  {
    lng: -42.0910187,
    lat: -21.6696232
  },
  {
    lng: -42.0914477,
    lat: -21.6697093
  },
  {
    lng: -42.0918398,
    lat: -21.6697916
  },
  {
    lng: -42.0921528,
    lat: -21.6699542
  },
  {
    lng: -42.092648,
    lat: -21.6702615
  },
  {
    lng: -42.0932644,
    lat: -21.6705678
  },
  {
    lng: -42.093788,
    lat: -21.6708186
  },
  {
    lng: -42.0941329,
    lat: -21.6712954
  },
  {
    lng: -42.0943725,
    lat: -21.6716208
  },
  {
    lng: -42.0946409,
    lat: -21.6719853
  },
  {
    lng: -42.0950075,
    lat: -21.6726191
  },
  {
    lng: -42.0955133,
    lat: -21.6734029
  },
  {
    lng: -42.0955635,
    lat: -21.6734701
  },
  {
    lng: -42.0959442,
    lat: -21.6739788
  },
  {
    lng: -42.0962124,
    lat: -21.6742782
  },
  {
    lng: -42.0965725,
    lat: -21.6746802
  },
  {
    lng: -42.0970044,
    lat: -21.6751227
  },
  {
    lng: -42.0973702,
    lat: -21.6754066
  },
  {
    lng: -42.0976562,
    lat: -21.6754718
  },
  {
    lng: -42.0979729,
    lat: -21.6754866
  },
  {
    lng: -42.098328,
    lat: -21.6755576
  },
  {
    lng: -42.0986862,
    lat: -21.6757304
  },
  {
    lng: -42.0991141,
    lat: -21.6760888
  },
  {
    lng: -42.0996793,
    lat: -21.6766787
  },
  {
    lng: -42.1002341,
    lat: -21.6771629
  },
  {
    lng: -42.1007025,
    lat: -21.6775753
  },
  {
    lng: -42.1008123,
    lat: -21.67765
  },
  {
    lng: -42.1013342,
    lat: -21.6780049
  },
  {
    lng: -42.1017695,
    lat: -21.6782794
  },
  {
    lng: -42.1020589,
    lat: -21.6784033
  },
  {
    lng: -42.102361,
    lat: -21.6785101
  },
  {
    lng: -42.1025781,
    lat: -21.6785766
  },
  {
    lng: -42.102903,
    lat: -21.678759
  },
  {
    lng: -42.1033742,
    lat: -21.6790534
  },
  {
    lng: -42.1036803,
    lat: -21.6792532
  },
  {
    lng: -42.1038671,
    lat: -21.6793664
  },
  {
    lng: -42.1039122,
    lat: -21.6793938
  },
  {
    lng: -42.1040829,
    lat: -21.6795002
  },
  {
    lng: -42.104322,
    lat: -21.6797278
  },
  {
    lng: -42.1045391,
    lat: -21.6799426
  },
  {
    lng: -42.1048715,
    lat: -21.6801594
  },
  {
    lng: -42.1052091,
    lat: -21.6803308
  },
  {
    lng: -42.1054322,
    lat: -21.6804754
  },
  {
    lng: -42.1056658,
    lat: -21.6807526
  },
  {
    lng: -42.1058909,
    lat: -21.6807675
  },
  {
    lng: -42.106225,
    lat: -21.6807635
  },
  {
    lng: -42.1065308,
    lat: -21.6807754
  },
  {
    lng: -42.1069546,
    lat: -21.6808632
  },
  {
    lng: -42.1074387,
    lat: -21.6809892
  },
  {
    lng: -42.1079239,
    lat: -21.6812381
  },
  {
    lng: -42.1080824,
    lat: -21.6814745
  },
  {
    lng: -42.1082472,
    lat: -21.6816482
  },
  {
    lng: -42.1084113,
    lat: -21.6818515
  },
  {
    lng: -42.1085448,
    lat: -21.6820352
  },
  {
    lng: -42.1092179,
    lat: -21.682444
  },
  {
    lng: -42.1093508,
    lat: -21.6826328
  },
  {
    lng: -42.1094257,
    lat: -21.6829191
  },
  {
    lng: -42.1094905,
    lat: -21.6834774
  },
  {
    lng: -42.1096067,
    lat: -21.6838161
  },
  {
    lng: -42.1098121,
    lat: -21.6842201
  },
  {
    lng: -42.1103609,
    lat: -21.684493
  },
  {
    lng: -42.1109009,
    lat: -21.6846677
  },
  {
    lng: -42.1114064,
    lat: -21.6848176
  },
  {
    lng: -42.1116087,
    lat: -21.6849417
  },
  {
    lng: -42.1117252,
    lat: -21.6851267
  },
  {
    lng: -42.1118176,
    lat: -21.6854048
  },
  {
    lng: -42.1119229,
    lat: -21.6857082
  },
  {
    lng: -42.1120441,
    lat: -21.6858808
  },
  {
    lng: -42.1122854,
    lat: -21.6860639
  },
  {
    lng: -42.1125968,
    lat: -21.6862445
  },
  {
    lng: -42.1130099,
    lat: -21.6864063
  },
  {
    lng: -42.1133745,
    lat: -21.6866728
  },
  {
    lng: -42.113664,
    lat: -21.6869612
  },
  {
    lng: -42.1137099,
    lat: -21.6870069
  },
  {
    lng: -42.1139716,
    lat: -21.6872633
  },
  {
    lng: -42.1144882,
    lat: -21.6877525
  },
  {
    lng: -42.1147901,
    lat: -21.6880317
  },
  {
    lng: -42.1156018,
    lat: -21.688738
  },
  {
    lng: -42.1158364,
    lat: -21.6889209
  },
  {
    lng: -42.1162726,
    lat: -21.6892535
  },
  {
    lng: -42.1164532,
    lat: -21.68951
  },
  {
    lng: -42.1166125,
    lat: -21.6897364
  },
  {
    lng: -42.1168623,
    lat: -21.6902529
  },
  {
    lng: -42.1169818,
    lat: -21.6907777
  },
  {
    lng: -42.1170115,
    lat: -21.6913048
  },
  {
    lng: -42.1169688,
    lat: -21.6919763
  },
  {
    lng: -42.1168388,
    lat: -21.6927069
  },
  {
    lng: -42.1164318,
    lat: -21.6942922
  },
  {
    lng: -42.1164659,
    lat: -21.6944951
  },
  {
    lng: -42.1169676,
    lat: -21.6948905
  },
  {
    lng: -42.1173437,
    lat: -21.6951945
  },
  {
    lng: -42.1176362,
    lat: -21.6955387
  },
  {
    lng: -42.1177782,
    lat: -21.6959516
  },
  {
    lng: -42.1178589,
    lat: -21.6966285
  },
  {
    lng: -42.1178754,
    lat: -21.6969743
  },
  {
    lng: -42.1179955,
    lat: -21.6973581
  },
  {
    lng: -42.1181706,
    lat: -21.6975777
  },
  {
    lng: -42.1185818,
    lat: -21.6977698
  },
  {
    lng: -42.1190728,
    lat: -21.6978081
  },
  {
    lng: -42.1198215,
    lat: -21.6976895
  },
  {
    lng: -42.1200963,
    lat: -21.6977186
  },
  {
    lng: -42.1204217,
    lat: -21.6978254
  },
  {
    lng: -42.1217762,
    lat: -21.698592
  },
  {
    lng: -42.1227331,
    lat: -21.6991164
  },
  {
    lng: -42.1233693,
    lat: -21.6995109
  },
  {
    lng: -42.1250016,
    lat: -21.7006281
  },
  {
    lng: -42.1256137,
    lat: -21.7008633
  },
  {
    lng: -42.1264775,
    lat: -21.7009287
  },
  {
    lng: -42.1270883,
    lat: -21.701227
  },
  {
    lng: -42.1276783,
    lat: -21.701606
  },
  {
    lng: -42.1283213,
    lat: -21.7021622
  },
  {
    lng: -42.1285371,
    lat: -21.702401
  },
  {
    lng: -42.1287397,
    lat: -21.7027604
  },
  {
    lng: -42.1292275,
    lat: -21.7029959
  },
  {
    lng: -42.1295873,
    lat: -21.7032128
  },
  {
    lng: -42.1299235,
    lat: -21.7034155
  },
  {
    lng: -42.1303415,
    lat: -21.7036265
  },
  {
    lng: -42.1308559,
    lat: -21.7038863
  },
  {
    lng: -42.1313621,
    lat: -21.7040694
  },
  {
    lng: -42.1319688,
    lat: -21.7042889
  },
  {
    lng: -42.1329355,
    lat: -21.7044973
  },
  {
    lng: -42.1338592,
    lat: -21.7044911
  },
  {
    lng: -42.1346121,
    lat: -21.7043346
  },
  {
    lng: -42.1363158,
    lat: -21.7048567
  },
  {
    lng: -42.1368461,
    lat: -21.7049847
  },
  {
    lng: -42.1371501,
    lat: -21.7050475
  },
  {
    lng: -42.1376428,
    lat: -21.7049929
  },
  {
    lng: -42.1379531,
    lat: -21.7047882
  },
  {
    lng: -42.1385646,
    lat: -21.7040497
  },
  {
    lng: -42.1388397,
    lat: -21.7037052
  },
  {
    lng: -42.1392585,
    lat: -21.7031079
  },
  {
    lng: -42.1395077,
    lat: -21.7026125
  },
  {
    lng: -42.1397607,
    lat: -21.7022815
  },
  {
    lng: -42.1401492,
    lat: -21.7019366
  },
  {
    lng: -42.1408005,
    lat: -21.7013696
  },
  {
    lng: -42.1414936,
    lat: -21.7005329
  },
  {
    lng: -42.1426009,
    lat: -21.6993362
  },
  {
    lng: -42.1430676,
    lat: -21.6988319
  },
  {
    lng: -42.1434171,
    lat: -21.6984205
  },
  {
    lng: -42.1435903,
    lat: -21.6980667
  },
  {
    lng: -42.1438401,
    lat: -21.6978323
  },
  {
    lng: -42.1445916,
    lat: -21.69718
  },
  {
    lng: -42.1451562,
    lat: -21.6967081
  },
  {
    lng: -42.1455523,
    lat: -21.6963371
  },
  {
    lng: -42.1463513,
    lat: -21.6959374
  },
  {
    lng: -42.146617,
    lat: -21.6956699
  },
  {
    lng: -42.1467135,
    lat: -21.6955335
  },
  {
    lng: -42.1467985,
    lat: -21.6954133
  },
  {
    lng: -42.1469089,
    lat: -21.6951885
  },
  {
    lng: -42.1470607,
    lat: -21.6950691
  },
  {
    lng: -42.14729,
    lat: -21.694954
  },
  {
    lng: -42.1474456,
    lat: -21.6947853
  },
  {
    lng: -42.1475797,
    lat: -21.6945356
  },
  {
    lng: -42.147653,
    lat: -21.694325
  },
  {
    lng: -42.1477779,
    lat: -21.6941669
  },
  {
    lng: -42.1478752,
    lat: -21.6940916
  },
  {
    lng: -42.1481141,
    lat: -21.6939505
  },
  {
    lng: -42.1482726,
    lat: -21.6937947
  },
  {
    lng: -42.1485396,
    lat: -21.6934427
  },
  {
    lng: -42.1489734,
    lat: -21.6931369
  },
  {
    lng: -42.1491537,
    lat: -21.692962
  },
  {
    lng: -42.1495721,
    lat: -21.6925325
  },
  {
    lng: -42.1499518,
    lat: -21.6920748
  },
  {
    lng: -42.1502669,
    lat: -21.6917795
  },
  {
    lng: -42.1506054,
    lat: -21.691579
  },
  {
    lng: -42.1508592,
    lat: -21.6915126
  },
  {
    lng: -42.1512062,
    lat: -21.6915244
  },
  {
    lng: -42.1516649,
    lat: -21.6916326
  },
  {
    lng: -42.1523236,
    lat: -21.6918443
  },
  {
    lng: -42.1531882,
    lat: -21.6921776
  },
  {
    lng: -42.1542089,
    lat: -21.692388
  },
  {
    lng: -42.1547071,
    lat: -21.6924218
  },
  {
    lng: -42.1556262,
    lat: -21.6924673
  },
  {
    lng: -42.1566147,
    lat: -21.692488
  },
  {
    lng: -42.1574871,
    lat: -21.6925931
  },
  {
    lng: -42.1578967,
    lat: -21.6926275
  },
  {
    lng: -42.1590589,
    lat: -21.6924628
  },
  {
    lng: -42.1594809,
    lat: -21.6923641
  },
  {
    lng: -42.160236,
    lat: -21.6921874
  },
  {
    lng: -42.1606277,
    lat: -21.6920764
  },
  {
    lng: -42.1625973,
    lat: -21.6914945
  },
  {
    lng: -42.1636551,
    lat: -21.6911184
  },
  {
    lng: -42.1643663,
    lat: -21.6909946
  },
  {
    lng: -42.1648104,
    lat: -21.6910326
  },
  {
    lng: -42.1648844,
    lat: -21.6910389
  },
  {
    lng: -42.1654751,
    lat: -21.6909308
  },
  {
    lng: -42.1657906,
    lat: -21.6906584
  },
  {
    lng: -42.1662181,
    lat: -21.6901573
  },
  {
    lng: -42.1671563,
    lat: -21.6894438
  },
  {
    lng: -42.167512,
    lat: -21.6891672
  },
  {
    lng: -42.1677769,
    lat: -21.6890717
  },
  {
    lng: -42.1681544,
    lat: -21.6889158
  },
  {
    lng: -42.1684398,
    lat: -21.6886875
  },
  {
    lng: -42.1685967,
    lat: -21.6884153
  },
  {
    lng: -42.1686603,
    lat: -21.6881249
  },
  {
    lng: -42.1687641,
    lat: -21.6875258
  },
  {
    lng: -42.168904,
    lat: -21.6872759
  },
  {
    lng: -42.1690447,
    lat: -21.6871493
  },
  {
    lng: -42.1694535,
    lat: -21.6870012
  },
  {
    lng: -42.1696833,
    lat: -21.686966
  },
  {
    lng: -42.1698397,
    lat: -21.6869687
  },
  {
    lng: -42.1702815,
    lat: -21.6870989
  },
  {
    lng: -42.1705589,
    lat: -21.6870593
  },
  {
    lng: -42.1707052,
    lat: -21.6869971
  },
  {
    lng: -42.1710268,
    lat: -21.6868558
  },
  {
    lng: -42.1712577,
    lat: -21.6867684
  },
  {
    lng: -42.1714471,
    lat: -21.6867479
  },
  {
    lng: -42.1719666,
    lat: -21.686761
  },
  {
    lng: -42.1723857,
    lat: -21.6868728
  },
  {
    lng: -42.1726602,
    lat: -21.6870407
  },
  {
    lng: -42.1729503,
    lat: -21.6872012
  },
  {
    lng: -42.1733273,
    lat: -21.6874099
  },
  {
    lng: -42.1736283,
    lat: -21.6875299
  },
  {
    lng: -42.1740918,
    lat: -21.6877326
  },
  {
    lng: -42.1743385,
    lat: -21.6879503
  },
  {
    lng: -42.1747364,
    lat: -21.6879392
  },
  {
    lng: -42.1751346,
    lat: -21.6878799
  },
  {
    lng: -42.1758657,
    lat: -21.6875475
  },
  {
    lng: -42.1766032,
    lat: -21.6871491
  },
  {
    lng: -42.177133,
    lat: -21.6869185
  },
  {
    lng: -42.177493,
    lat: -21.6867803
  },
  {
    lng: -42.1780018,
    lat: -21.6865798
  },
  {
    lng: -42.1783119,
    lat: -21.6863892
  },
  {
    lng: -42.178442,
    lat: -21.6861132
  },
  {
    lng: -42.1784847,
    lat: -21.6858901
  },
  {
    lng: -42.1784786,
    lat: -21.6854516
  },
  {
    lng: -42.1783991,
    lat: -21.6851255
  },
  {
    lng: -42.1783687,
    lat: -21.6848563
  },
  {
    lng: -42.1784118,
    lat: -21.6845218
  },
  {
    lng: -42.1784367,
    lat: -21.6843847
  },
  {
    lng: -42.1785372,
    lat: -21.6841697
  },
  {
    lng: -42.1785999,
    lat: -21.684038
  },
  {
    lng: -42.178675,
    lat: -21.6837933
  },
  {
    lng: -42.1786716,
    lat: -21.6837042
  },
  {
    lng: -42.1786236,
    lat: -21.6835844
  },
  {
    lng: -42.1785806,
    lat: -21.6834186
  },
  {
    lng: -42.1785916,
    lat: -21.6832637
  },
  {
    lng: -42.178617,
    lat: -21.6832228
  },
  {
    lng: -42.1786568,
    lat: -21.683159
  },
  {
    lng: -42.1788072,
    lat: -21.6830092
  },
  {
    lng: -42.1790623,
    lat: -21.6827172
  },
  {
    lng: -42.179362,
    lat: -21.6825561
  },
  {
    lng: -42.1797446,
    lat: -21.6824703
  },
  {
    lng: -42.1800824,
    lat: -21.6824078
  },
  {
    lng: -42.1805092,
    lat: -21.6823652
  },
  {
    lng: -42.1809537,
    lat: -21.6823783
  },
  {
    lng: -42.1812279,
    lat: -21.6823081
  },
  {
    lng: -42.1813701,
    lat: -21.6823106
  },
  {
    lng: -42.1814811,
    lat: -21.6823845
  },
  {
    lng: -42.1816788,
    lat: -21.6822939
  },
  {
    lng: -42.1818134,
    lat: -21.6822343
  },
  {
    lng: -42.1820573,
    lat: -21.6821279
  },
  {
    lng: -42.1822831,
    lat: -21.6820276
  },
  {
    lng: -42.182508,
    lat: -21.6819187
  },
  {
    lng: -42.1827434,
    lat: -21.6818534
  },
  {
    lng: -42.1829733,
    lat: -21.6818531
  },
  {
    lng: -42.1833002,
    lat: -21.6818726
  },
  {
    lng: -42.1836035,
    lat: -21.6817496
  },
  {
    lng: -42.1839532,
    lat: -21.6816528
  },
  {
    lng: -42.1842343,
    lat: -21.681566
  },
  {
    lng: -42.1844178,
    lat: -21.681473
  },
  {
    lng: -42.1845843,
    lat: -21.6813887
  },
  {
    lng: -42.1848652,
    lat: -21.6813129
  },
  {
    lng: -42.1851299,
    lat: -21.6813091
  },
  {
    lng: -42.1853211,
    lat: -21.6812568
  },
  {
    lng: -42.1856075,
    lat: -21.6812034
  },
  {
    lng: -42.1857498,
    lat: -21.6812252
  },
  {
    lng: -42.1859477,
    lat: -21.681344
  },
  {
    lng: -42.1860628,
    lat: -21.6814108
  },
  {
    lng: -42.1863231,
    lat: -21.6815515
  },
  {
    lng: -42.1865461,
    lat: -21.6817024
  },
  {
    lng: -42.1866705,
    lat: -21.6818795
  },
  {
    lng: -42.1868141,
    lat: -21.6821373
  },
  {
    lng: -42.1870193,
    lat: -21.6823016
  },
  {
    lng: -42.187454,
    lat: -21.6826623
  },
  {
    lng: -42.1881736,
    lat: -21.6831218
  },
  {
    lng: -42.1884993,
    lat: -21.6833199
  },
  {
    lng: -42.1889234,
    lat: -21.6835909
  },
  {
    lng: -42.1890572,
    lat: -21.6836824
  },
  {
    lng: -42.1893055,
    lat: -21.6838571
  },
  {
    lng: -42.1894954,
    lat: -21.6840184
  },
  {
    lng: -42.1900585,
    lat: -21.6842899
  },
  {
    lng: -42.1905388,
    lat: -21.6845006
  },
  {
    lng: -42.1908301,
    lat: -21.6846403
  },
  {
    lng: -42.1910539,
    lat: -21.6845076
  },
  {
    lng: -42.1913305,
    lat: -21.6844499
  },
  {
    lng: -42.1917428,
    lat: -21.6844321
  },
  {
    lng: -42.1922381,
    lat: -21.6844767
  },
  {
    lng: -42.1925507,
    lat: -21.6844705
  },
  {
    lng: -42.1928573,
    lat: -21.684429
  },
  {
    lng: -42.1931251,
    lat: -21.6843364
  },
  {
    lng: -42.1934909,
    lat: -21.6840919
  },
  {
    lng: -42.1937529,
    lat: -21.6839107
  },
  {
    lng: -42.194017,
    lat: -21.6837852
  },
  {
    lng: -42.194203,
    lat: -21.6837636
  },
  {
    lng: -42.1944769,
    lat: -21.6838208
  },
  {
    lng: -42.1948709,
    lat: -21.6839068
  },
  {
    lng: -42.1949132,
    lat: -21.6839173
  },
  {
    lng: -42.1953251,
    lat: -21.6840198
  },
  {
    lng: -42.1956565,
    lat: -21.6841112
  },
  {
    lng: -42.1959011,
    lat: -21.6842108
  },
  {
    lng: -42.1961738,
    lat: -21.6843527
  },
  {
    lng: -42.1965181,
    lat: -21.6844693
  },
  {
    lng: -42.1970422,
    lat: -21.6845674
  },
  {
    lng: -42.1974071,
    lat: -21.6846576
  },
  {
    lng: -42.1976027,
    lat: -21.6847059
  },
  {
    lng: -42.1977836,
    lat: -21.6847826
  },
  {
    lng: -42.1980295,
    lat: -21.6848868
  },
  {
    lng: -42.1984405,
    lat: -21.6850625
  },
  {
    lng: -42.1985909,
    lat: -21.6851003
  },
  {
    lng: -42.1987366,
    lat: -21.685137
  },
  {
    lng: -42.1992015,
    lat: -21.6852739
  },
  {
    lng: -42.1996861,
    lat: -21.6854905
  },
  {
    lng: -42.1999637,
    lat: -21.6856342
  },
  {
    lng: -42.2002724,
    lat: -21.6857939
  },
  {
    lng: -42.20083,
    lat: -21.6861059
  },
  {
    lng: -42.2008627,
    lat: -21.6861245
  },
  {
    lng: -42.2013709,
    lat: -21.6864136
  },
  {
    lng: -42.201892,
    lat: -21.6866542
  },
  {
    lng: -42.2024852,
    lat: -21.6869767
  },
  {
    lng: -42.2029539,
    lat: -21.6873186
  },
  {
    lng: -42.203153,
    lat: -21.6875064
  },
  {
    lng: -42.2037525,
    lat: -21.6880809
  },
  {
    lng: -42.203989,
    lat: -21.6883018
  },
  {
    lng: -42.2043297,
    lat: -21.6885439
  },
  {
    lng: -42.2054267,
    lat: -21.6893658
  },
  {
    lng: -42.2057799,
    lat: -21.6896076
  },
  {
    lng: -42.2061888,
    lat: -21.6897872
  },
  {
    lng: -42.2066828,
    lat: -21.689977
  },
  {
    lng: -42.2071443,
    lat: -21.6901309
  },
  {
    lng: -42.2076502,
    lat: -21.6901925
  },
  {
    lng: -42.2082184,
    lat: -21.6901867
  },
  {
    lng: -42.2087324,
    lat: -21.6901156
  },
  {
    lng: -42.2090526,
    lat: -21.690126
  },
  {
    lng: -42.2093331,
    lat: -21.6902554
  },
  {
    lng: -42.2097143,
    lat: -21.6904314
  },
  {
    lng: -42.2104092,
    lat: -21.6903932
  },
  {
    lng: -42.2107438,
    lat: -21.6902093
  },
  {
    lng: -42.2110078,
    lat: -21.690089
  },
  {
    lng: -42.211184,
    lat: -21.690092
  },
  {
    lng: -42.2114883,
    lat: -21.6900971
  },
  {
    lng: -42.2119192,
    lat: -21.6900894
  },
  {
    lng: -42.2126926,
    lat: -21.6900623
  },
  {
    lng: -42.2130011,
    lat: -21.6900077
  },
  {
    lng: -42.2136763,
    lat: -21.6898881
  },
  {
    lng: -42.2139043,
    lat: -21.6898365
  },
  {
    lng: -42.2143771,
    lat: -21.6897294
  },
  {
    lng: -42.2148825,
    lat: -21.6896828
  },
  {
    lng: -42.2150252,
    lat: -21.6896921
  },
  {
    lng: -42.2154786,
    lat: -21.6897218
  },
  {
    lng: -42.2158217,
    lat: -21.6897735
  },
  {
    lng: -42.216144,
    lat: -21.6899237
  },
  {
    lng: -42.2165428,
    lat: -21.6902235
  },
  {
    lng: -42.2173515,
    lat: -21.6906864
  },
  {
    lng: -42.2178542,
    lat: -21.6909165
  },
  {
    lng: -42.2183586,
    lat: -21.6911481
  },
  {
    lng: -42.2183972,
    lat: -21.6911662
  },
  {
    lng: -42.218904,
    lat: -21.6914041
  },
  {
    lng: -42.2193266,
    lat: -21.6915926
  },
  {
    lng: -42.2195013,
    lat: -21.6916683
  },
  {
    lng: -42.2197867,
    lat: -21.6917918
  },
  {
    lng: -42.2204103,
    lat: -21.6922613
  },
  {
    lng: -42.2204781,
    lat: -21.6923123
  },
  {
    lng: -42.2208144,
    lat: -21.692503
  },
  {
    lng: -42.2211593,
    lat: -21.6926986
  },
  {
    lng: -42.221476,
    lat: -21.6928898
  },
  {
    lng: -42.2217494,
    lat: -21.693055
  },
  {
    lng: -42.2220128,
    lat: -21.6932201
  },
  {
    lng: -42.2223316,
    lat: -21.6934806
  },
  {
    lng: -42.2227801,
    lat: -21.6938605
  },
  {
    lng: -42.222921,
    lat: -21.693973
  },
  {
    lng: -42.2231998,
    lat: -21.6941958
  },
  {
    lng: -42.2238798,
    lat: -21.6946253
  },
  {
    lng: -42.2242847,
    lat: -21.6948433
  },
  {
    lng: -42.2248059,
    lat: -21.6951805
  },
  {
    lng: -42.2254142,
    lat: -21.695652
  },
  {
    lng: -42.2261927,
    lat: -21.6961047
  },
  {
    lng: -42.2269045,
    lat: -21.696432
  },
  {
    lng: -42.2272964,
    lat: -21.6965305
  },
  {
    lng: -42.2274239,
    lat: -21.6965626
  },
  {
    lng: -42.2278778,
    lat: -21.6965253
  },
  {
    lng: -42.2282364,
    lat: -21.6964479
  },
  {
    lng: -42.2283445,
    lat: -21.6961804
  },
  {
    lng: -42.2283502,
    lat: -21.6958854
  },
  {
    lng: -42.2285191,
    lat: -21.6956702
  },
  {
    lng: -42.228829,
    lat: -21.6956241
  },
  {
    lng: -42.2291516,
    lat: -21.6956295
  },
  {
    lng: -42.22941,
    lat: -21.6957621
  },
  {
    lng: -42.2304123,
    lat: -21.6964907
  },
  {
    lng: -42.2308139,
    lat: -21.696677
  },
  {
    lng: -42.2325554,
    lat: -21.6966933
  },
  {
    lng: -42.2330008,
    lat: -21.6967456
  },
  {
    lng: -42.2336832,
    lat: -21.6969686
  },
  {
    lng: -42.2341554,
    lat: -21.6970535
  },
  {
    lng: -42.2345733,
    lat: -21.6971557
  },
  {
    lng: -42.2347634,
    lat: -21.6972523
  },
  {
    lng: -42.2349319,
    lat: -21.6973625
  },
  {
    lng: -42.2350475,
    lat: -21.6974451
  },
  {
    lng: -42.2351777,
    lat: -21.6975392
  },
  {
    lng: -42.2354115,
    lat: -21.6976439
  },
  {
    lng: -42.2356985,
    lat: -21.6976898
  },
  {
    lng: -42.2360157,
    lat: -21.6977186
  },
  {
    lng: -42.2366145,
    lat: -21.6973398
  },
  {
    lng: -42.2368739,
    lat: -21.6972451
  },
  {
    lng: -42.2370801,
    lat: -21.6972095
  }
];

export default polygonCoords_Itaocara;